(function () {
  'use strict';

  angular
    .module('app.chartmonthly', ['nvd3'])
    .controller('UsagechartmonthlyController', ['$state', 'genericService', '$filter', 'commonService', '$mdDialog', '$rootScope', 'authService', '$window', UsagechartmonthlyController]);


  //.module('app.msportal')
  //.controller('UsageChartController', ['$state', 'genericService', '$filter', UsageChartController]);
  /** @ngInject
  * @ngdoc controller
  * @name MDM_ChartController
  * @description Controller used to interact with Usage Chart.
  */

  function UsagechartmonthlyController($state, genericService, $filter, commonService, $mdDialog, $rootScope, authService, $window) {
    authService.CheckIsPortalEnabled(true, null, null);
    $window.document.title = "Usage Charts - " + document.getElementById("title").title;

    /// Variables.
    var dataArray = [];
    var searchServices = {};
    var serviceController = 'Account/Services/';
    var usageController = 'Usage/';
    var vm = this;
    var waterUOM = "";

    /// Binding Data.
    vm.AccountService = {};
    vm.accountServiceSelected = {};
    vm.calendarEvent = { start: "", end: "", memberSep: "" };
    vm.chart = {
      options: {
        chart: {
          type: 'linePlusBarChart',
          height: 500,
          margin: {
            top: 30,
            right: 75,
            bottom: 70,
            left: 75
          },
          bars: {
            forceY: [0]
            , forceX: [-0.5]
          },
          bars2: {
            forceY: [0]
            , forceX: [-0.5]
          },
          color: ['#880000', 'darkred'],
          x: function (d, i) { return i },
          xAxis: {
            axisLabel: 'Date',
            rotateLabels: 30,
            tickFormat: function (d) {
              var dx = vm.chart.data[0].values[d] && vm.chart.data[0].values[d].x || null;
              //if (dx) {
              //    return d3.time.format('%x')(new Date(dx))
              //}
              return dx;
              //return null;
            }
          },
          x2Axis: {
            tickFormat: function (d) {
              var dx = vm.chart.data[0].values[d] && vm.chart.data[0].values[d].x || 0;
              return d3.time.format('%m-%d-%Y')(new Date(dx))
            },
            showMaxMin: false
          },
          y1Axis: {
            axisLabel: 'kWh',
            tickFormat: function (d) {
              return d3.format('.02f')(d);
            },
            axisLabelDistance: 0
          },
          y2Axis: {
            axisLabel: 'Y2 Axis',
            tickFormat: function (d) {
              return '$' + d3.format(',.2f')(d)
            }
          },
          y3Axis: {
            tickFormat: function (d) {
              return d3.format(',f')(d);
            }
          },
          y4Axis: {
            tickFormat: function (d) {
              return '$' + d3.format(',.2f')(d)
            }
          },
          focusEnable: false,
          showLegend: false,
          useInteractiveGuideline: false,
          tooltip: {
            contentGenerator: function (key, x, y, e, graph) {
              if (vm.UsageRequest.SearchDetails.TypeService == "ELECTRIC") {
                return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' kWh</strong> (' + key.data.x + ')</p></div>';
              }
              else if (vm.UsageRequest.SearchDetails.TypeService == "WATER") {
                //return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' GAL</strong> (' + key.data.x + ')</p></div>';
                if (waterUOM === "GAL") {
                  return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' GAL</strong> (' + key.data.x + ')</p></div>';
                }
                else {
                  return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' FT3</strong> (' + key.data.x + ')</p></div>';
                }
              }

            }
          }
        }
      },
      data: dataChart(),
      api: {}
    }
    vm.chartHeight = (vm.isSingleService) ? 500 : 370;
    vm.dateLocale = commonService.dateLocaleByMonth;
    vm.dtOptions = { dom: 'lrtip', paging: false, autoWidth: true, responsive: true, scroller: false, processing: true, info: false };
    vm.flipped = false;
    vm.hideme = true;
    vm.isClicked = false;
    vm.isSingleService = false;
    vm.maxDate = new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0);
    vm.MemberNo = $state.params.id;
    vm.ModUsageRequest = {
      Model: null,
      RoleType: authService.adminAuthentication.roleType,
      AdminUsername: authService.adminAuthentication.userName
    };
    vm.progress = { activated: false };
    vm.searchServices = {};
    vm.services = {};
    vm.statusMessage = "loading in progress!";
    vm.UsageRequest = {
      SearchDetails:
      {
        ID: vm.calendarEvent.memberSep,
        //ID: "3009001",
        IdType: 0,
        StartDate: vm.calendarEvent.start,
        EndDate: vm.calendarEvent.end
      },
      Device: {
        DeviceType: "",
        HardwareId: ""
      },
      IsPPM: 0,
      IsCostEnable: "0"
    };


    /// Methods.
    /**
    * @ngdoc method
    * @name initializeChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set initial date parameters and update the chart.
    */
    //vm.initializeChart = function () {
    //  vm.progress.activated = true;
    //  dataArray = [];
    //  vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1);
    //  vm.calendarEvent.end = new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0);
    //  vm.updateChart();
    //};
    /**
    * @ngdoc method
    * @name updateChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to update the chart with a new data from the server.
    */
    //vm.updateChart = function () {

    //  if (vm.calendarEvent.start > vm.calendarEvent.end) {
    //    showDateRangeError()
    //    return
    //  }
    //  vm.progress.activated = true;
    //  $rootScope.rootscopeLoading = true;
    //  vm.UsageRequest.SearchDetails.StartDate = angular.copy(vm.calendarEvent.start);
    //  vm.UsageRequest.SearchDetails.EndDate = vm.calendarEvent.end;
    //  vm.UsageRequest.SearchDetails.StartDate.setDate(vm.UsageRequest.SearchDetails.StartDate.getDate())
    //  vm.UsageRequest.SearchDetails.ID = vm.calendarEvent.memberSep;
    //  vm.UsageRequest.SearchDetails.FrecuencyMode = "Monthly";
    //  vm.UsageRequest.SearchDetails.TypeService = "Electric"; // vm.searchServices.Description;


    //  var getChartDataPost = genericService
    //    .post(usageController, vm.UsageRequest)
    //    .then(function (pl) {
    //      $rootScope.rootscopeLoading = false;
    //      vm.progress.activated = false;
    //      var response = pl.data;

    //      dataArray = [];

    //      for (var i = 0; i < response.length; i++) {
    //        dataArray.push([response[i].statusIdField, parseFloat(response[i].totalEnergyField)]);
    //        //////dataArray.push([response[i].dailyTimeStanpField, parseFloat(response[i].totalEnergyField)]);
    //      }
    //      vm.chart.api.updateWithData(dataChart());
    //    },
    //      function (errorPl) {
    //        $rootScope.rootscopeLoading = false;
    //        commonService.handleError(errorPl);
    //        vm.progress.activated = false;
    //        dataArray = [];
    //      })
    //};
    function showDateRangeError() {
      // Appending dialog to document.body to cover sidenav in docs app
      var alert = $mdDialog.alert(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title('Invalid Date Range')
        .textContent('Start Date cannot be later than End Date.')
        .ariaLabel('Invalid Date Range')
        .ok('Ok')
        .multiple(true)

      return $mdDialog.show(alert);
    }

    function showNoSelectedServiceError() {
      var alert = $mdDialog.alert(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title('No Selected Service')
        .textContent('Please select a service.')
        .ariaLabel('No Selected Service')
        .ok('Ok')
        .multiple(true)

      return $mdDialog.show(alert);
    }

    function validateMaxInquire(start, end) {
      var diff = Math.abs(start - end) / 86400000;
      if (diff <= 396) {
        return true;
      }
      else {
        var alert = $mdDialog.alert(
          {
            clickOutsideToClose: false,
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
          .title('Invalid Date Range')
          .textContent('The interval of data consulted can not be more than 13 months.')
          .ariaLabel('Invalid Date Range')
          .ok('Ok')
          .multiple(true)
        $mdDialog.show(alert);
        return false;
      }
    }

    /**
    * @ngdoc method
    * @name closeChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set close the chart screen and go to the List service screen.
    */
    vm.closeChart = function () {
      dataArray = [];
      vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1);
      vm.calendarEvent.end = new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0);
      vm.chart.api.updateWithData(dataChart());
      flip();
    };

    /**
    * @ngdoc method
    * @name getSelectedServiceText
    * @author  
    * @description  .
    */
    vm.getSelectedServiceText = function () {

      if (vm.searchServices !== undefined) {
        return "You have selected: Item " + vm.searchServices;
      } else {
        return "Please select an item";
      }
    };

    /**
    * @ngdoc method
    * @name getServiceDetails
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to bring the list of user service.
    */
    vm.getServiceDetails = function () {
      vm.progress.activated = true;
      $rootScope.rootscopeLoading = true;

      vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1);
      vm.calendarEvent.end = new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0);

      genericService.get(serviceController + vm.MemberNo)
        .then(function (pl) {
          $rootScope.rootscopeLoading = false;
          vm.progress.activated = false;
          vm.searchServices = pl.data.Services;
          //////searchServices = vm.searchServices;
          vm.searchServices = filterServicesForGraphs(vm.searchServices);
          vm.services = vm.searchServices;
          vm.AccountService.Services = $filter('filter')(pl.data.Services, filterServices);

          vm.isSingleService = (vm.AccountService.Services.length == 1);

          vm.statusMessage = "Please select one service to check the usage by range of date.";

          if (vm.isSingleService) {
            vm.selectServiceFlip(vm.AccountService.Services[0]);
            d3.select('#chart svg').style({ 'height': 500 });
          } else {
            d3.select('#chart svg').style({ 'height': 370 });
          }
        },
          function (errorPl) {
            $rootScope.rootscopeLoading = false;
            commonService.handleError(errorPl);
            vm.progress.activated = false;
            vm.AccountService = {};
            vm.flipped = false;
          })
    };

    /**
    * @ngdoc method
    * @name LoadRecordsByDateRange
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set the service selected and load the chart with new data.
    */
    //vm.LoadRecordsByDateRange = function () {

    //  //vm.updateChart();
    //  vm.ReloadChart();
    //};
    
    /**
    * @ngdoc method
    * @name ReloadChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set the service selected and load the chart with new data.
    */
    vm.ReloadChart = function () {
      authService.CheckIsPortalEnabled(true, null, function () {
        var enddate = new Date(vm.calendarEvent.end.getFullYear(), vm.calendarEvent.end.getMonth() + 1, 0);
        vm.calendarEvent.end = enddate;

        searchServices;
        vm.searchServices;
        vm.services;
        var itemSelected = vm.searchServices;

        if (vm.searchServices.MemberSep === undefined) {
          showNoSelectedServiceError()
          return
        }
        if (vm.calendarEvent.start > vm.calendarEvent.end) {
          showDateRangeError()
          return
        }

        if (!validateMaxInquire(vm.calendarEvent.start, vm.calendarEvent.end)) {
          return
        }

        vm.isClicked = true;
        vm.UsageRequest.SearchDetails.StartDate = angular.copy(vm.calendarEvent.start);
        vm.UsageRequest.SearchDetails.EndDate = vm.calendarEvent.end;
        vm.UsageRequest.SearchDetails.StartDate.setDate(vm.UsageRequest.SearchDetails.StartDate.getDate() + 1)
        vm.UsageRequest.SearchDetails.FrecuencyMode = "Monthly";
        vm.UsageRequest.SearchDetails.TypeService = vm.searchServices.Description;
        vm.UsageRequest.SearchDetails.ID = vm.searchServices.MemberSep;
        vm.ModUsageRequest.Model = vm.UsageRequest;
        vm.searchServices = vm.services;
        vm.searchServices = itemSelected;
        vm.hideme = false;
        vm.progress.activated = true;
        $rootScope.rootscopeLoading = true;
        var getChartDataPost = genericService.post(usageController, vm.ModUsageRequest).then(function (pl) {
          $rootScope.rootscopeLoading = false;
          vm.progress.activated = false;
          var response = pl.data;

          dataArray = [];

          if (response.length > 0) {
            if (vm.UsageRequest.SearchDetails.TypeService == "ELECTRIC") {
              for (var i = 0; i < response.length; i++) {
                dataArray.push([response[i].statusIdField, parseFloat(response[i].totalEnergyField)]);
              }
              vm.chart.options.chart.y1Axis.axisLabel = "KWH";
            }
            else if (vm.UsageRequest.SearchDetails.TypeService == "WATER") {
              var exist = response.some(function (item) {
                return item.totalEnergyGalField !== null && item.totalEnergyGalField !== "" && item.totalEnergyGalField !== "NaN";
              });

              if (exist) {
                waterUOM = "GAL";
                for (var i = 0; i < response.length; i++) {
                  dataArray.push([response[i].statusIdField, parseFloat(response[i].totalEnergyGalField)]);
                }
                vm.chart.options.chart.y1Axis.axisLabel = "GAL";
              }
              else {
                waterUOM = "FT3";
                for (var i = 0; i < response.length; i++) {
                  dataArray.push([response[i].statusIdField, parseFloat(response[i].totalEnergyFT3Field)]);
                }
                vm.chart.options.chart.y1Axis.axisLabel = "FT3";
              }
              //vm.chart.options.chart.y1Axis.axisLabel = "GAL";
            }
          }
          vm.chart.api.updateWithData(dataChart());
        }, function (errorPl) {
          commonService.handleError(errorPl);
          vm.progress.activated = false;
          dataArray = [];
        })
      });
    };

    /**
    * @ngdoc method
    * @name selectServiceFlip
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set the service selected and load the chart with new data.
    */
    vm.selectServiceFlip = function (accountServiceSelected) {
      vm.accountServiceSelected = accountServiceSelected;
      vm.calendarEvent.memberSep = accountServiceSelected.MemberSep;
      //////vm.initializeChart();
      flip();
    };


    /// Internal Functions.
    /**
    * @ngdoc internal function
    * @name dataChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to format the data that the chart are going to use.
    **/
    function dataChart() {

      var data = [
        { "key": "Total Energy", "bar": true, "values": dataArray }
      ].map(function (series) {
        series.values = series.values.map(function (d) { return { x: d[0], y: d[1] } });
        return series;
      });

      return data;
    }
    /**
    * @ngdoc internal function
    * @name filterServices
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to filter the data of serviceAccount.
    **/
    function filterServices(service) {
      //return service.Type == "00" || service.Type == "01";
      return service.Type == "00";
    }

    function filterServicesForGraphs(services) {
      var filteredServices = [];
      for (var i = 0; i < services.length; i++) {
        if (services[i].Description.toUpperCase() == "ELECTRIC" || services[i].Description.toUpperCase() == "WATER") {
          filteredServices.push(services[i]);
        }
      }
      return filteredServices;

    }
    /**
    * @ngdoc internal function
    * @name flip
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to flip the screen to front or back.
    **/
    function flip() {
      vm.flipped = !vm.flipped;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.chartdaily', ['nvd3'])
    .controller('UsagechartdailyController', ['$state', 'genericService', '$filter', 'commonService', '$mdDialog', '$rootScope', 'authService', '$window', UsagechartdailyController]);


  //.module('app.msportal')
  //.controller('UsageChartController', ['$state', 'genericService', '$filter', UsageChartController]);
  /** @ngInject
  * @ngdoc controller
  * @name MDM_ChartController
  * @description Controller used to interact with Usage Chart.
  */

  function UsagechartdailyController($state, genericService, $filter, commonService, $mdDialog, $rootScope, authService, $window) {
    authService.CheckIsPortalEnabled(true, null, null);
    $window.document.title = "Usage Charts - " + document.getElementById("title").title;

    /// Variables.
    var dataArray = [];
    var searchServices = {};
    var serviceController = 'Account/Services/';
    var usageController = 'Usage/';
    var vm = this;
    var waterUOM = "";

    /// Binding Data.
    vm.AccountService = {};
    vm.accountServiceSelected = {};
    vm.calendarEvent = { start: "", end: "", memberSep: "" };
    vm.chart = {
      options: {
        chart: {
          type: 'linePlusBarChart',
          height: 500,
          margin: {
            top: 30,
            right: 75,
            bottom: 70,
            left: 75
          },
          bars: {
            forceY: [0]
            , forceX: [-0.5]
          },
          bars2: {
            forceY: [0]
            , forceX: [-0.5]
          },
          color: ['#880000', 'darkred'],
          x: function (d, i) { return i },
          xAxis: {
            axisLabel: 'Date',
            rotateLabels: 30,
            tickFormat: function (d) {
              var dx = vm.chart.data[0].values[d] && vm.chart.data[0].values[d].x || null;
              if (dx) {
                return d3.time.format('%x')(new Date(dx))
              }
              return null;
            }
          },
          x2Axis: {
            tickFormat: function (d) {
              var dx = vm.chart.data[0].values[d] && vm.chart.data[0].values[d].x || 0;
              return d3.time.format('%m-%d-%Y')(new Date(dx))
            },
            showMaxMin: false
          },
          y1Axis: {
            axisLabel: 'kWh',
            tickFormat: function (d) {
              return d3.format('.02f')(d);
            },
            axisLabelDistance: 0
          },
          y2Axis: {
            axisLabel: 'Y2 Axis',
            tickFormat: function (d) {
              return '$' + d3.format(',.2f')(d)
            }
          },
          y3Axis: {
            tickFormat: function (d) {
              return d3.format(',f')(d);
            }
          },
          y4Axis: {
            tickFormat: function (d) {
              return '$' + d3.format(',.2f')(d)
            }
          },
          focusEnable: false,
          showLegend: false,
          useInteractiveGuideline: false,
          tooltip: {
            contentGenerator: function (key, x, y, e, graph) {
              if (vm.UsageRequest.SearchDetails.TypeService == "ELECTRIC") {
                return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' kWh</strong> (' + key.data.x + ')</p></div>';
              }
              else if (vm.UsageRequest.SearchDetails.TypeService == "WATER") {
                if (waterUOM === "GAL") {
                  return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' GAL</strong> (' + key.data.x + ')</p></div>';
                }
                else {
                  return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' FT3</strong> (' + key.data.x + ')</p></div>';
                }

              }
            }
          }
        }
      },
      data: dataChart(),
      api: {}
    }
    vm.chartHeight = (vm.isSingleService) ? 500 : 370;
    vm.dateLocale = commonService.dateLocaleByDay;
    vm.dtOptions = { dom: 'lrtip', paging: false, autoWidth: true, responsive: true, scroller: false, processing: true, info: false };
    vm.flipped = false;
    vm.hideme = true;
    vm.isClicked = false;
    vm.isSingleService = false;
    vm.maxDate = new Date();
    vm.MemberNo = $state.params.id;
    vm.ModUsageRequest = {
      Model: null,
      RoleType: authService.adminAuthentication.roleType,
      AdminUsername: authService.adminAuthentication.userName
    };
    vm.progress = { activated: false };
    vm.searchServices = {};
    vm.services = {};
    vm.statusMessage = "loading in progress!";
    vm.UsageRequest = {
      SearchDetails:
      {
        ID: vm.calendarEvent.memberSep,
        //ID: "3009001",
        IdType: 0,
        StartDate: vm.calendarEvent.start,
        EndDate: vm.calendarEvent.end
      },
      Device: {
        DeviceType: "",
        HardwareId: ""
      },
      IsPPM: 0,
      IsCostEnable: "0"
    };

    /// Methods.
    /**
    * @ngdoc method
    * @name initializeChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set initial date parameters and update the chart.
    */
    //vm.initializeChart = function () {
    //  vm.progress.activated = true;
    //  dataArray = [];
    //  vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 7);
    //  vm.calendarEvent.end = new Date();
    //  vm.updateChart();
    //};
    /**
    * @ngdoc method
    * @name updateChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to update the chart with a new data from the server.
    */
    //vm.updateChart = function () {
    //  $rootScope.rootscopeLoading = true;
    //  if (vm.calendarEvent.start > vm.calendarEvent.end) {
    //    showDateRangeError()
    //    return
    //  }
    //  vm.progress.activated = true;
    //  vm.UsageRequest.SearchDetails.StartDate = angular.copy(vm.calendarEvent.start);
    //  vm.UsageRequest.SearchDetails.EndDate = vm.calendarEvent.end;
    //  vm.UsageRequest.SearchDetails.StartDate.setDate(vm.UsageRequest.SearchDetails.StartDate.getDate())
    //  vm.UsageRequest.SearchDetails.ID = vm.calendarEvent.memberSep;
    //  vm.UsageRequest.SearchDetails.FrecuencyMode = "Daily";
    //  vm.UsageRequest.SearchDetails.TypeService = "Electric";// vm.searchServices.Description;
    //  vm.ModUsageRequest.Model = vm.UsageRequest;

    //  var getChartDataPost = genericService
    //    .post(usageController, vm.ModUsageRequest)
    //    .then(function (pl) {
    //      $rootScope.rootscopeLoading = false;
    //      vm.progress.activated = false;
    //      var response = pl.data;

    //      dataArray = [];

    //      for (var i = 0; i < response.length; i++) {
    //        dataArray.push([response[i].dailyTimeStanpField, parseFloat(response[i].totalEnergyField)]);
    //      }
    //      vm.chart.api.updateWithData(dataChart());
    //    },
    //      function (errorPl) {
    //        $rootScope.rootscopeLoading = false;
    //        commonService.handleError(errorPl);
    //        vm.progress.activated = false;
    //        dataArray = [];
    //      })
    //};

    function showDateRangeError() {
      // Appending dialog to document.body to cover sidenav in docs app
      var alert = $mdDialog.alert(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title('Invalid Date Range')
        .textContent('Start Date cannot be later than End Date.')
        .ariaLabel('Invalid Date Range')
        .ok('Ok')
        .multiple(true)

      return $mdDialog.show(alert);
    }

    function showNoSelectedServiceError() {
      var alert = $mdDialog.alert(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title('No Selected Service')
        .textContent('Please select a service.')
        .ariaLabel('No Selected Service')
        .ok('Ok')
        .multiple(true)


      return $mdDialog.show(alert);
    }
    
    function validateMaxInquire(start, end) {
      var diff = Math.abs(start - end) / 86400000;
      if (diff <= 61) {
        return true;
      }
      else {
        var alert = $mdDialog.alert(
          {
            clickOutsideToClose: false,
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
          .title('Invalid Date Range')
          .textContent('The interval of data consulted can not be more than two months.')
          .ariaLabel('Invalid Date Range')
          .ok('Ok')
          .multiple(true)
        $mdDialog.show(alert);
        return false;
      }
    }

    /**
    * @ngdoc method
    * @name closeChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set close the chart screen and go to the List service screen.
    */
    vm.closeChart = function () {
      dataArray = [];
      vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 7);
      vm.calendarEvent.end = new Date();
      vm.chart.api.updateWithData(dataChart());
      flip();
    };
    
    /**
    * @ngdoc method
    * @name getSelectedServiceText
    * @author  
    * @description  .
    */
    vm.getSelectedServiceText = function () {

      if (vm.searchServices !== undefined) {
        return "You have selected: Item " + vm.searchServices;
      } else {
        return "Please select an item";
      }
    };

    /**
    * @ngdoc method
    * @name getServiceDetails
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to bring the list of user service.
    */
    vm.getServiceDetails = function () {
      $rootScope.rootscopeLoading = true;
      vm.progress.activated = true;

      vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 7);
      vm.calendarEvent.end = new Date();

      genericService.get(serviceController + vm.MemberNo)
        .then(function (pl) {
          $rootScope.rootscopeLoading = false;
          vm.progress.activated = false;
          vm.searchServices = pl.data.Services;
          vm.searchServices = filterServicesForGraphs(vm.searchServices);
          searchServices = vm.searchServices;
          vm.services = vm.searchServices;
          vm.AccountService.Services = $filter('filter')(pl.data.Services, filterServices);
          vm.isSingleService = (vm.AccountService.Services.length == 1);
          vm.statusMessage = "Please select one service to check the usage by range of date.";

          if (vm.isSingleService) {
            vm.selectServiceFlip(vm.AccountService.Services[0]);
            d3.select('#chart svg').style({ 'height': 500 });
          } else {
            d3.select('#chart svg').style({ 'height': 370 });
          }
        },
          function (errorPl) {
            $rootScope.rootscopeLoading = false;
            commonService.handleError(errorPl);
            vm.progress.activated = false;
            vm.AccountService = {};
            vm.flipped = false;
          })
    };

    /**
    * @ngdoc method
    * @name LoadRecordsByDateRange
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set the service selected and load the chart with new data.
    */
    //vm.LoadRecordsByDateRange = function () {
    //  vm.ReloadChart();
    //};
       
    /**
    * @ngdoc method
    * @name ReloadChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set the service selected and load the chart with new data.
    */
    vm.ReloadChart = function () {
      authService.CheckIsPortalEnabled(true, null, function () {
        searchServices;
        vm.searchServices;
        vm.services;
        var itemSelected = vm.searchServices;

        if (vm.searchServices.MemberSep === undefined) {
          showNoSelectedServiceError()
          return
        }
        if (vm.calendarEvent.start > vm.calendarEvent.end) {
          showDateRangeError()
          return
        }

        if (!validateMaxInquire(vm.calendarEvent.start, vm.calendarEvent.end)) {
          return
        }

        vm.isClicked = true;
        vm.UsageRequest.SearchDetails.StartDate = angular.copy(vm.calendarEvent.start);
        vm.UsageRequest.SearchDetails.EndDate = vm.calendarEvent.end;
        //vm.UsageRequest.SearchDetails.StartDate.setDate(
        //  Intl.DateTimeFormat().resolvedOptions().timeZone.includes("America") ? vm.UsageRequest.SearchDetails.StartDate.getDate() : vm.UsageRequest.SearchDetails.StartDate.getDate()+1
        //)
        if (Intl.DateTimeFormat().resolvedOptions().timeZone.includes("America") || Intl.DateTimeFormat().resolvedOptions().timeZone.includes("Pacific") || Intl.DateTimeFormat().resolvedOptions().timeZone.includes("Etc") || Intl.DateTimeFormat().resolvedOptions().timeZone.includes("Atlantic")) {
          vm.UsageRequest.SearchDetails.StartDate.setDate(vm.UsageRequest.SearchDetails.StartDate.getDate());
        }
        else {
          vm.UsageRequest.SearchDetails.StartDate.setDate(vm.UsageRequest.SearchDetails.StartDate.getDate() + 1);
        }
        vm.UsageRequest.SearchDetails.FrecuencyMode = "Daily";
        vm.UsageRequest.SearchDetails.TypeService = vm.searchServices.Description;
        vm.UsageRequest.SearchDetails.ID = vm.searchServices.MemberSep;
        vm.ModUsageRequest.Model = vm.UsageRequest;
        vm.searchServices = vm.services;
        vm.searchServices = itemSelected;
        vm.hideme = false;
        vm.progress.activated = true;
        $rootScope.rootscopeLoading = true;
        var getChartDataPost = genericService.post(usageController, vm.ModUsageRequest).then(function (pl) {
          $rootScope.rootscopeLoading = false;
          vm.progress.activated = false;
          var response = pl.data;
          dataArray = [];

          if (response.length > 0) {
            if (vm.UsageRequest.SearchDetails.TypeService == "ELECTRIC") {
              for (var i = 0; i < response.length; i++) {
                dataArray.push([response[i].dailyTimeStanpField, parseFloat(response[i].totalEnergyField)]);
              }
              vm.chart.options.chart.y1Axis.axisLabel = "KWH";
            }
            else if (vm.UsageRequest.SearchDetails.TypeService == "WATER") {
              var exist = response.some(function (item) {
                return !item.totalEnergyGalField.includes("NaN");
              });

              if (exist) {
                waterUOM = "GAL";
                for (var i = 0; i < response.length; i++) {
                  dataArray.push([response[i].dailyTimeStanpField, parseFloat(response[i].totalEnergyGalField)]);
                }
                vm.chart.options.chart.y1Axis.axisLabel = "GAL";
              }
              else {
                waterUOM = "FT3";
                for (var i = 0; i < response.length; i++) {
                  dataArray.push([response[i].dailyTimeStanpField, parseFloat(response[i].totalEnergyFT3Field)]);
                }
                vm.chart.options.chart.y1Axis.axisLabel = "FT3";
              }
            }
          }
          vm.chart.api.updateWithData(dataChart());
        }, function (errorPl) {
          $rootScope.rootscopeLoading = false;
          commonService.handleError(errorPl);
          vm.progress.activated = false;
          dataArray = [];
        })
      });
    };

    /**
    * @ngdoc method
    * @name selectServiceFlip
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set the service selected and load the chart with new data.
    */
    vm.selectServiceFlip = function (accountServiceSelected) {
      vm.accountServiceSelected = accountServiceSelected;
      vm.calendarEvent.memberSep = accountServiceSelected.MemberSep;
      //////vm.initializeChart();
      flip();
    };



    /// Internal Functions.
    /**
    * @ngdoc internal function
    * @name dataChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to format the data that the chart are going to use.
    **/
    function dataChart() {

      var data = [
        { "key": "Total Energy", "bar": true, "values": dataArray }
      ].map(function (series) {
        series.values = series.values.map(function (d) { return { x: d[0], y: d[1] } });
        return series;
      });

      return data;
    }
    /**
    * @ngdoc internal function
    * @name filterServices
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to filter the data of serviceAccount.
    **/
    function filterServices(service) {
      //return service.Type == "00" || service.Type == "01";
      return service.Type == "00";
    }
    
    function filterServicesForGraphs(services) {
      var filteredServices = [];
      for (var i = 0; i < services.length; i++) {
        if (services[i].Description.toUpperCase() == "ELECTRIC" || services[i].Description.toUpperCase() == "WATER") {
          filteredServices.push(services[i]);
        }
      }
      return filteredServices;

    }
    /**
    * @ngdoc internal function
    * @name flip
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to flip the screen to front or back.
    **/
    function flip() {
      vm.flipped = !vm.flipped;
    }    
  }
})();

(function () {
  'use strict';

  angular
    .module('app.chartinterval', ['nvd3'])
    .controller('UsagechartintervalController', ['$state', 'genericService', '$filter', 'commonService', '$mdDialog', '$rootScope', 'authService', '$window', UsagechartintervalController]);


  //.module('app.msportal')
  //.controller('UsageChartController', ['$state', 'genericService', '$filter', UsageChartController]);
  /** @ngInject
  * @ngdoc controller
  * @name MDM_ChartController
  * @description Controller used to interact with Usage Chart.
  */

  function UsagechartintervalController($state, genericService, $filter, commonService, $mdDialog, $rootScope, authService, $window) {
    authService.CheckIsPortalEnabled(true, null, null);
    $window.document.title = "Usage Charts - " + document.getElementById("title").title;

    /// Variables.
    var dataArray = [];
    var vm = this;
    var searchServices = {};
    var serviceController = 'Account/Services/';
    var usageController = 'Usage/';
    var waterUOM = "";

    /// Binding Data.
    vm.AccountService = {};
    vm.accountServiceSelected = {};
    vm.calendarEvent = { start: "", end: "", memberSep: "" };
    vm.chart = {
      options: {
        chart: {
          type: 'linePlusBarChart',
          height: 500,
          margin: {
            top: 30,
            right: 75,
            bottom: 70,
            left: 75
          },
          bars: {
            forceY: [0]
            , forceX: [-0.5]
          },
          bars2: {
            forceY: [0]
            , forceX: [-0.5]
          },
          color: ['#880000', 'darkred'],
          x: function (d, i) { return i },
          xAxis: {
            axisLabel: 'Hours',
            rotateLabels: 30,
            tickFormat: function (d) {
              var dx = vm.chart.data[0].values[d] && vm.chart.data[0].values[d].x || null;
              //if (dx) {
              //    return d3.time.format('%x')(new Date(dx))
              //}
              return dx;
              //return null;
            },
          },

          x2Axis: {
            tickFormat: function (d) {
              var dx = vm.chart.data[0].values[d] && vm.chart.data[0].values[d].x || 0;
              return d3.time.format('%m-%d-%Y')(new Date(dx))
            },
            showMaxMin: false
          },
          y1Axis: {
            axisLabel: 'kWh',
            tickFormat: function (d) {
              return d3.format('.02f')(d);
            },
            axisLabelDistance: 0
          },
          y2Axis: {
            axisLabel: 'Y2 Axis',
            tickFormat: function (d) {
              return '$' + d3.format(',.2f')(d)
            }
          },
          y3Axis: {
            tickFormat: function (d) {
              return d3.format(',f')(d);
            }
          },
          y4Axis: {
            tickFormat: function (d) {
              return '$' + d3.format(',.2f')(d)
            }
          },
          focusEnable: false,
          showLegend: false,
          useInteractiveGuideline: false,
          tooltip: {
            contentGenerator: function (key, x, y, e, graph) {
              if (vm.UsageRequest.SearchDetails.TypeService == "ELECTRIC") {
                return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' kWh</strong> (' + key.data.x + ')</p></div>';
              }
              else if (vm.UsageRequest.SearchDetails.TypeService == "WATER") {
                //return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' GAL</strong> (' + key.data.x + ')</p></div>';
                if (waterUOM === "GAL") {
                  return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' GAL</strong> (' + key.data.x + ')</p></div>';
                }
                else {
                  return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' FT3</strong> (' + key.data.x + ')</p></div>';
                }
              }
            }
          }
        }
      },
      data: dataChart(),
      api: {}
    }
    vm.chartHeight = (vm.isSingleService) ? 500 : 370;
    vm.dateLocale = commonService.dateLocaleByDay;
    vm.dtOptions = { dom: 'lrtip', paging: false, autoWidth: true, responsive: true, scroller: false, processing: true, info: false };
    vm.flipped = false;
    vm.hideme = true;
    vm.isClicked = false;
    vm.isSingleService = false;
    vm.maxDate = new Date();
    vm.ModUsageRequest = {
      Model: null,
      RoleType: authService.adminAuthentication.roleType,
      AdminUsername: authService.adminAuthentication.userName
    };
    vm.MemberNo = $state.params.id;
    vm.progress = { activated: false };
    vm.searchServices = {};
    vm.services = {};
    vm.statusMessage = "loading in progress!";
    vm.UsageRequest = {
      SearchDetails:
      {
        ID: vm.calendarEvent.memberSep,
        //ID: "3009001",
        IdType: 0,
        StartDate: vm.calendarEvent.start,
        EndDate: vm.calendarEvent.start + 1
        //////EndDate: vm.calendarEvent.end
      },
      Device: {
        DeviceType: "",
        HardwareId: ""
      },
      IsPPM: 0,
      IsCostEnable: "0"
    };


    /// Methods.
    /**
    * @ngdoc method
    * @name initializeChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set initial date parameters and update the chart.
    */
    vm.initializeChart = function () {
      vm.progress.activated = true;
      dataArray = [];
      vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 7);
      //////vm.calendarEvent.end = new Date();
      vm.calendarEvent.end = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() + 1);
      //////vm.updateChart();
    };
    /**
    * @ngdoc method
    * @name updateChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to update the chart with a new data from the server.
    */
    //vm.updateChart = function () {
    //  vm.UsageRequest.SearchDetails.StartDate = angular.copy(vm.calendarEvent.start);
    //  vm.UsageRequest.SearchDetails.StartDate.setDate(vm.UsageRequest.SearchDetails.StartDate.getDate())
    //  vm.UsageRequest.SearchDetails.EndDate = new Date(vm.UsageRequest.SearchDetails.StartDate.getFullYear(), vm.UsageRequest.SearchDetails.StartDate.getMonth(), vm.UsageRequest.SearchDetails.StartDate.getDate() + 1);
    //  vm.UsageRequest.SearchDetails.ID = vm.calendarEvent.memberSep;
    //  vm.UsageRequest.SearchDetails.FrecuencyMode = "Interval";
    //  vm.UsageRequest.SearchDetails.TypeService = "Electric"; // vm.searchServices.Description;
    //  vm.progress.activated = true;

    //  var getChartDataPost = genericService
    //    .post(usageController, vm.UsageRequest)
    //    .then(function (pl) {
    //      vm.progress.activated = false;
    //      var response = pl.data;

    //      dataArray = [];

    //      for (var i = 0; i < response.length; i++) {
    //        dataArray.push([response[i].statusIdField, parseFloat(response[i].totalEnergyField)]);
    //      }
    //      vm.chart.api.updateWithData(dataChart());
    //    },
    //      function (errorPl) {
    //        commonService.handleError(errorPl);
    //        vm.progress.activated = false;
    //        dataArray = [];
    //      })
    //};

    function showDateRangeError() {
      // Appending dialog to document.body to cover sidenav in docs app
      var alert = $mdDialog.alert(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title('Invalid Date Range')
        .textContent('Start Date cannot be later than End Date.')
        .ariaLabel('Invalid Date Range')
        .ok('Ok')
        .multiple(true)

      return $mdDialog.show(alert);
    }

    function showNoSelectedServiceError() {
      var alert = $mdDialog.alert(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title('No Selected Service')
        .textContent('Please select a service.')
        .ariaLabel('No Selected Service')
        .ok('Ok')
        .multiple(true)

      return $mdDialog.show(alert);
    }

    /**
    * @ngdoc method
    * @name closeChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set close the chart screen and go to the List service screen.
    */
    vm.closeChart = function () {
      dataArray = [];
      vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 7);
      vm.calendarEvent.end = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() + 1);
      vm.chart.api.updateWithData(dataChart());
      flip();
    };

    /**
    * @ngdoc method
    * @name getSelectedServiceText
    * @author  
    * @description  .
    */
    vm.getSelectedServiceText = function () {

      if (vm.searchServices !== undefined) {
        return "You have selected: Item " + vm.searchServices;
      } else {
        return "Please select an item";
      }
    };

    /**
    * @ngdoc method
    * @name getServiceDetails
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to bring the list of user service.
    */
    vm.getServiceDetails = function () {
      $rootScope.rootscopeLoading = true;
      vm.progress.activated = true;

      vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 7);
      //////vm.calendarEvent.end = new Date();
      vm.calendarEvent.end = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() + 1);

      genericService.get(serviceController + vm.MemberNo)
        .then(function (pl) {
          $rootScope.rootscopeLoading = false;
          vm.progress.activated = false;
          vm.searchServices = pl.data.Services;
          vm.searchServices = filterServicesForGraphs(vm.searchServices);
          searchServices = vm.searchServices;
          vm.services = vm.searchServices;
          vm.AccountService.Services = $filter('filter')(pl.data.Services, filterServices);

          vm.isSingleService = (vm.AccountService.Services.length == 1);

          vm.statusMessage = "Please select one service to check the usage by range of date.";

          if (vm.isSingleService) {
            vm.selectServiceFlip(vm.AccountService.Services[0]);
            d3.select('#chart svg').style({ 'height': 500 });
          } else {
            d3.select('#chart svg').style({ 'height': 370 });
          }
        },
          function (errorPl) {
            $rootScope.rootscopeLoading = false;
            commonService.handleError(errorPl);
            vm.progress.activated = false;
            vm.AccountService = {};
            vm.flipped = false;
          })
    };

    /**
    * @ngdoc method
    * @name LoadRecordsByDateRange
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set the service selected and load the chart with new data.
    */
    //vm.LoadRecordsByDateRange = function () {

    //  //vm.updateChart();
    //  vm.ReloadChart();
    //};

    /**
    * @ngdoc method
    * @name ReloadChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set the service selected and load the chart with new data.
    */
    vm.ReloadChart = function () {
      authService.CheckIsPortalEnabled(true, null, function () {
        searchServices;
        vm.searchServices;
        vm.services;
        var itemSelected = vm.searchServices;

        if (vm.searchServices.MemberSep === undefined) {
          showNoSelectedServiceError()
          return
        }

        vm.isClicked = true;
        vm.UsageRequest.SearchDetails.StartDate = angular.copy(vm.calendarEvent.start);
        vm.UsageRequest.SearchDetails.StartDate.setDate(
          Intl.DateTimeFormat().resolvedOptions().timeZone.includes("America") ? vm.UsageRequest.SearchDetails.StartDate.getDate() : vm.UsageRequest.SearchDetails.StartDate.getDate()+1
        )
        vm.UsageRequest.SearchDetails.EndDate = new Date(vm.UsageRequest.SearchDetails.StartDate.getFullYear(), vm.UsageRequest.SearchDetails.StartDate.getMonth(), vm.UsageRequest.SearchDetails.StartDate.getDate() + 1);
        vm.UsageRequest.SearchDetails.FrecuencyMode = "Interval";
        vm.UsageRequest.SearchDetails.TypeService = vm.searchServices.Description;
        vm.UsageRequest.SearchDetails.ID = vm.searchServices.MemberSep;
        vm.ModUsageRequest.Model = vm.UsageRequest;
        vm.searchServices = vm.services;
        vm.searchServices = itemSelected;
        vm.hideme = false;
        vm.progress.activated = true;
        $rootScope.rootscopeLoading = true;
        var getChartDataPost = genericService.post(usageController, vm.ModUsageRequest).then(function (pl) {
          vm.progress.activated = false;
          $rootScope.rootscopeLoading = false;
          var response = pl.data;
          dataArray = [];

          if (response.length > 0) {
            if (vm.UsageRequest.SearchDetails.TypeService == "ELECTRIC") {
              for (var i = 0; i < response.length; i++) {
                dataArray.push([response[i].statusIdField, parseFloat(response[i].totalEnergyField)]);
              }
              vm.chart.options.chart.y1Axis.axisLabel = "KWH";
            }
            else if (vm.UsageRequest.SearchDetails.TypeService == "WATER") {
              var exist = response.some(function (item) {
                return item.totalEnergyGalField !== null && item.totalEnergyGalField !== "";
              });

              if (exist) {
                waterUOM = "GAL";
                for (var i = 0; i < response.length; i++) {
                  dataArray.push([response[i].statusIdField, parseFloat(response[i].totalEnergyGalField)]);
                }
                vm.chart.options.chart.y1Axis.axisLabel = "GAL";
              }
              else {
                waterUOM = "FT3";
                for (var i = 0; i < response.length; i++) {
                  dataArray.push([response[i].statusIdField, parseFloat(response[i].totalEnergyFT3Field)]);
                }
                vm.chart.options.chart.y1Axis.axisLabel = "FT3";
              }
              //vm.chart.options.chart.y1Axis.axisLabel = "GAL";

            }
          }


          vm.chart.api.updateWithData(dataChart());
        }, function (errorPl) {
          $rootScope.rootscopeLoading = false;
          commonService.handleError(errorPl);
          vm.progress.activated = false;
          dataArray = [];
        })
      });
    };

    /**
    * @ngdoc method
    * @name selectServiceFlip
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to set the service selected and load the chart with new data.
    */
    vm.selectServiceFlip = function (accountServiceSelected) {
      vm.accountServiceSelected = accountServiceSelected;
      vm.calendarEvent.memberSep = accountServiceSelected.MemberSep;
      //////vm.initializeChart();
      flip();
    };


    /// Internal Functions.
    /**
    * @ngdoc internal function
    * @name dataChart
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to format the data that the chart are going to use.
    **/
    function dataChart() {

      var data = [
        { "key": "Total Energy", "bar": true, "values": dataArray }
      ].map(function (series) {
        series.values = series.values.map(function (d) { return { x: d[0], y: d[1] } });
        return series;
      });

      return data;
    }
    /**
      * @ngdoc internal function
      * @name filterServices
      * @author Juan Leon <juanl@sedata.com>
      * @description Method used to filter the data of serviceAccount.
    **/
    function filterServices(service) {
      //return service.Type == "00" || service.Type == "01";
      return service.Type == "00";
    }

    function filterServicesForGraphs(services) {
      var filteredServices = [];
      for (var i = 0; i < services.length; i++) {
        if (services[i].Description.toUpperCase() == "ELECTRIC" || services[i].Description.toUpperCase() == "WATER") {
          filteredServices.push(services[i]);
        }
      }
      return filteredServices;

    }
    /**
    * @ngdoc internal function
    * @name flip
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to flip the screen to front or back.
    **/
    function flip() {
      vm.flipped = !vm.flipped;
    }


  }
})();

(function () {
    'use strict';

    angular
        .module('app.msportal',
            [
                'flow'
            ]
        )
        .config(config);

    /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.msportal', {
                abstract: true,
                url: '/portal'
            })
            .state('app.msportal.admin', {
                abstract: true,
                url: '/admin'
            })
            .state('app.msportal.admin.customers', {
                url: '/customers',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/adminpages/views/customer_list/customer_list.html',
                        controller: 'CustomerListController as vm'
                    }
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })

        .state('app.msportal.admin.customization', {
            url: '/customizePortal',
            views: {
                'content@app': {
                    templateUrl: 'app/main/adminpages/views/customizePortal/customizePortal.html',
                    controller: 'CustomizePortalController as vm'
                }
            },
            bodyClass: 'msportal',
            data: {
                authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        })
            .state('app.msportal.accounts', {
                url: '/accounts',
                params: {
                    CID: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/msportal/views/accounts/accounts.html',
                        controller: 'AccountsController as vm'
                    }
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })

            .state('app.msportal.subscription', {
                url: '/subscription-details',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/msportal/views/alerts/subscription_details.html',
                        controller: 'SubscriptionDetailsController as vm'
                    }
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })
           
            .state('app.msportal.alerts', {
                url: '/alerts/:id',
                params: {
                    id: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/msportal/views/alerts/alerts.html',
                        controller: 'AlertsController as vm'
                    }
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })

            .state('app.msportal.service_detail', {
                url: '/service-details/:id',
                params: {
                    id: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/msportal/views/service_details/service_details.html',
                        controller: 'ServiceDetailsController as vm'
                    }
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })

            .state('app.msportal.profile', {
                url: '/profile/:id',
                params: {
                    id: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/msportal/views/profile/profile.html',
                        controller: "ProfileController as vm"
                    }
                },
                resolve: {
                    EntitiesValidators: ["ProfileContext", function (ProfileContext) {
                        var EntityValidators = ProfileContext.GetEntityValidators('AccountProfileDTO', 'Model');
                        return EntityValidators;
                    }]
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })

            .state('app.msportal.draft', {
                url: '/payment-drafts/:id',
                params: {
                    id: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/msportal/views/draft/drafts.html',
                        controller: "BankDraftController as vm"
                    }
                },
                resolve: {
                    CCValidators: ["BankDraftContext", function (BankDraftContext) {
                        return BankDraftContext.getValidators('CreditCardProfileDTO', 'CreditCardProfile');
                    }],
                    ECValidators: ["BankDraftContext", function (BankDraftContext) {
                        return BankDraftContext.getValidators('ECheckProfileDTO', 'ECheckProfile');
                    }],
                    checkSmartAppConfig: ["commonService", function (commonService) {
                        return commonService.loadSmartAppConfig();
                    }]
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })
           
            .state('app.msportal.payment', {
                url: '/payment/:id',
                params: {
                    id: null
                },
                views: {
                    'content@app': {

                        templateUrl: 'app/main/msportal/views/payment/payment.html',
                        controller: "PaymentController as vm"
                    }
                },
                resolve: {
                    CCValidators: ["PaymentContext", function (PaymentContext) {
                        return PaymentContext.getPaymentValidators('CreditCardProfileDTO', 'CreditCardProfile');
                    }],
                    ECValidators: ["PaymentContext", function (PaymentContext) {
                        return PaymentContext.getPaymentValidators('ECheckProfileDTO', 'ECheckProfile');
                    }],
                    checkSmartAppConfig: ["commonService", function (commonService) {
                        return commonService.loadSmartAppConfig();
                    }]
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })

            .state('app.msportal.deposits', {
                url: '/deposits/:id',
                params: {
                    id: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/msportal/views/deposits/deposits.html',
                        controller: 'DepositsController as vm'
                    }
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })
            // PPM Account HIstory
          .state('app.msportal.ppmAcctHist', {
            url: '/ppm-history/:id',
            params: {
              id: null
            },
            views: {
              'content@app': {
                templateUrl: 'app/main/msportal/views/ppm_history/ppm_history.html',
                controller: 'PPMHistoryController'
              }
            },
            resolve: {
              checkSmartAppConfig: ["commonService", function (commonService) {
                return commonService.loadSmartAppConfig();
              }]
            },
            bodyClass: 'msportal',
            data: {
              authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
          })
          // Contact Us
          .state('app.msportal.contactUs', {
            url: '/contact-us/',
            views: {
              'content@app': {
                templateUrl: 'app/main/msportal/views/contact_us/contact_us.html',
                controller: 'ContactUsController'
              }
            },
            bodyClass: 'msportal',
            data: {
              authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
          })
            //My Usage
            .state('app.msportal.billHist', {
                url: '/bill-history/:id',
                params: {
                    id: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/msportal/views/usage/usage.html',
                        controller: 'UsageController'
                    }
                },
                resolve: {
                    checkSmartAppConfig: ["commonService", function (commonService) {
                        return commonService.loadSmartAppConfig();
                    }]
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })

            .state('app.msportal.paymentHist', {
                url: '/payment-history/:id',
                params: {
                    id: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/msportal/views/payment_history/payment_history.html',
                        controller: 'PaymentHistoryController'
                    }
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })

        .state('app.msportal.usageCharts', {
            url: '/usage-charts/:id',
            params: {
                id: null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/msportal/views/usage_charts/usagecharts.html',
                    controller: 'UsagechartsController as vm'
                }
            },
            bodyClass: 'msportal',
            data: {
                authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        })

        //E-Notifications
        .state('app.msportal.billTypePreference', {
            url: '/e-bill/:id',
            params: {
                id: null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/msportal/views/bill_preference/bill_preference.html',
                    controller: 'BillPreferenceController'
                }
            },
            bodyClass: 'msportal',
            data: {
                authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        })

        .state('app.msportal.delinquentNotice', {
            url: '/e-delinquent/:id',
            params: {
                id: null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/msportal/views/delinquent/delinquent.html',
                    controller: 'DelinquentController'
                }
            },
            bodyClass: 'msportal',
            data: {
                authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        })

        //Budget/Levelized Billing
        .state('app.msportal.budget-levelized', {
            url: '/budget-levelized-billing/:id',
            params: {
                id: null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/msportal/views/budget_levelized/budgetLevelized.html',
                    controller: "BudgetLevelizedController as vm"
                }
            },
            resolve: {
                checkSmartAppConfig: ["commonService", function (commonService) {
                    return commonService.loadSmartAppConfig();
                }]
            },
            bodyClass: 'msportal',
            data: {
                authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        })
        ;

        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/msportal');

        // Api
        msApiProvider.register('msportal.accounts', ['app/data/msportal/accounts.json']);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.msportal')
        .controller('PaymentReceiptController', ['$mdDialog', 'detail', PaymentReceiptController]);

    /** @ngInject 
    * @type: controller
    * @name: PaymentDetailController
    * @description: Used to control the functionality of detail payment proccess.
    **/
    function PaymentReceiptController($mdDialog, detail) {

        var ret = false;

        angular.extend(this, new function () {
            /// Bind Data from Payment Review
            this.detail = detail;
            this.dtOptions = { dom: 'lrtip', paging: false, responsive: false, scroller: false, processing: true, info: false, };

            this.closeDialog = function () {
                $mdDialog.cancel();
            };
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('PaymentProfileController', ['genericService', '$rootScope', 'commonService', 'PaymentDetailService', '$timeout', 'PaymentContext', '$element', 'ProfileContext', '$mdDialog', '$scope', 'authService', PaymentProfileController])
    .factory('PaymentDetailService', function () {
      this.PaymentDetailData = {};
      this.PaymentProfileData = {};
      this.isValid = function () { return this.PaymentProfileData.isValid; };

      String.prototype.toMask = function () {
        return String("************************" + this.substr(this.length - 4)).slice(-16);
      };

      String.prototype.padLeft = function (len, charac) {
        return Array(len - this.length + 1).join(charac || " ") + this;
      }

      String.prototype.toActualYear = function () {
        var actualYear = new Date().getFullYear().toString();
        var dataYear = this.toString();

        if (this.length == 2)
          dataYear = actualYear.substring(0, 2) + dataYear;

        return String(dataYear);
      }

      String.prototype.toTwoDigitsYear = function () {
        var dataYear = this.toString();

        if (this.length > 2)
          dataYear = dataYear.substring((dataYear.length - 2), dataYear.length);

        return String(dataYear);
      }

      this.getPaymentDetail = function () {
        return this.PaymentDetailData;
      };
      this.setPaymentDetail = function (obj) {
        this.PaymentDetailData = angular.copy(obj);
      };

      this.getPaymentProfile = function () {
        return this.PaymentProfileData;
      };

      this.setPaymentProfile = function (obj) {
        this.PaymentProfileData = angular.copy(obj);

        this.getPaymentProfile();
      };

      return this;
    });

  /** @ngInject 
  * @type: controller
  * @name: PaymentProfileController
  * @description: Used to control the functionality of detail payment proccess.
  **/
  function PaymentProfileController(genericService, $rootScope, commonService, PaymentDetailService, $timeout, PaymentContext, $element, ProfileContext, $mdDialog, $scope, authService) {

    /// Assigning COOPARMND(403) to variable saveProfileEnabled
    $scope.saveProfileEnabled = $rootScope.Parameters.ThirdParameters.THIRDPARM_3;

    /// Services Binding.
    var PaymentDetailData = function () { return PaymentDetailService.getPaymentDetail() };
    var setProfileDetail = function (ProfileDetail) {
      PaymentDetailService.setPaymentProfile(ProfileDetail);
    };

    this.paymentContext = PaymentContext;
    this.paymentAmount = PaymentContext.AccountServicesObject["PaymentDetails"].totalPaymentAmount;
    //this.paymentController = PaymentController;


    /// Use angular.extend to encapsulate the logic of the controller into a class.
    angular.extend(this, (new function () {
      /// Variables.
      var baseClass = this;
      var hasProfile = false;
      var hasChanges = false;
      var tempExpMonth;
      var tempExpYear;
      var cardExpMonth;
      var cardExpYear;

      this.tempCardProfile = {};

      /// Data Binding.
      this.dateLocale = commonService.dateLocaleExpDate;
      this.isAdmin = authService.adminAuthentication.roleType === 'Admin';
      this.Parameters = PaymentContext.Parameters();
      this.NameSuffixes = {};
      this.CCValidators = PaymentContext.getCCValidation();
      this.ECValidators = PaymentContext.getECValidation();
      this.ECheckProfile = {};
      this.CreditCardProfile = {};
      this.detail = function () { return PaymentDetailData(); };
      this.AccountServices = this.detail().AccountServices;
      this.DeviceDetails = { DeviceType: "BPP", HardwareId: "" };
      this.fetchProfile = {
        MemberSep: (this.AccountServices.length > 0 ? this.AccountServices[0].MemberSep : ''),
        DeviceDetails: this.DeviceDetails,
        PaymentType: (this.detail().type == 1) ? "CC" : "EC"
      }
      this.ModFetchProfile = {
        Model: this.fetchProfile,
        RoleType: authService.adminAuthentication.roleType,
        AdminUsername: authService.adminAuthentication.userName
      };
      this.setProfile = function (Prof) { return setProfileDetail(Prof); };
      this.RoutingNumberPattern = (function () {
        var regexp = /^\*?[0-9]+$/;

        return {
          test: function (value) {
            return regexp.test(value);
          }
        };
      })();


      /// Methods.
      this.blurInput = BlurInput;
      this.getSaveProfileLabel = GetSaveProfileLabel;
      this.editInput = EditInput;
      this.GetNameSuffixes = function () {
        ProfileContext.GetLookUpList("nameSuffixes").get(function (data) {
          baseClass.NameSuffixes = data.data;
        });
      }

      this.PopulateProfile = function () {
        this.GetNameSuffixes();
        this.setProfile({});

        genericService
          .post('Payments/PaymentProfile/', this.ModFetchProfile)
          .then(function (pl) {
            /*if (pl.data == undefined)
                return;*/

            /*if (pl.data == undefined)
                return;*/

            if (baseClass.fetchProfile.PaymentType === "CC") {
              $rootScope.MaxPaymentAmount = pl.data.AdditionalSettings.MaxCreditCardPayment;
            } else if (baseClass.fetchProfile.PaymentType === "EC") {
              $rootScope.MaxPaymentAmount = pl.data.AdditionalSettings.MaxECheckPayment;
            }

            if (pl.data.BankAccountNumber || pl.data.CreditCardInfo) {
              $scope.hasPaymentProfile = true;
              $scope.hasChanges = false;

              switch (baseClass.fetchProfile.PaymentType) {
                case "CC":
                  /// Set the data in profile variable.
                  angular.copy(pl.data, baseClass.CreditCardProfile);
                  angular.copy(pl.data, baseClass.tempCardProfile)

                  $rootScope.MaxPaymentAmount = pl.data.AdditionalSettings.MaxCreditCardPayment;

                  /// Extend the data object to personalize fields.
                  angular.extend(baseClass.CreditCardProfile, new function CreditCardProfile() {
                    this.ExpirationDate = new Date(pl.data.CreditCardInfo.CCExpYear.toActualYear(), pl.data.CreditCardInfo.CCExpMonth - 1, 1);
                    this.ZipCode = pl.data.CreditCardInfo.CCZipCode;
                    if (this.ZipCode.length > 5) {
                      this.ZipCode = this.ZipCode.replace("-", "");
                      this.ZipCodeExtension = this.ZipCode.substr(5);
                      //this.ZipCode = this.ZipCode.substr(0, 5);
                    }
                    //this.ZipCodeExtension = this.ZipCode.substr(5);
                    this.CardType = GetNameCCType(pl.data.CardType);
                  });
                  // Store Credit Card Current Details into temporary variables
                  angular.extend(baseClass.tempCardProfile, new function tempCardProfile() {
                    this.ExpirationDate = new Date(pl.data.CreditCardInfo.CCExpYear.toActualYear(), pl.data.CreditCardInfo.CCExpMonth - 1, 1);
                    this.ZipCode = pl.data.CreditCardInfo.CCZipCode;
                    if (this.ZipCode.length > 5) {
                      this.ZipCode = this.ZipCode.replace("-", "");
                      this.ZipCodeExtension = this.ZipCode.substr(5);
                    }
                  });

                  baseClass.SaveProfile('TDC', true);

                  break;
                case "EC":
                  /// Set the data in profile variable.
                  angular.copy(pl.data, baseClass.ECheckProfile);

                  $rootScope.MaxPaymentAmount = pl.data.AdditionalSettings.MaxECheckPayment;

                  /// Extend the data object to personalize fields.
                  angular.extend(baseClass.ECheckProfile, new function ECheckProfile() {
                    this.NameSuffixes = baseClass.NameSuffixes;
                    this.ZipCode = pl.data.ECheckZipCode;
                    if (this.ZipCode.length > 5) {
                      this.ZipCode = this.ZipCode.replace("-", "");
                      this.ZipCodeExtension = this.ZipCode.substr(5);
                      //this.ZipCode = this.ZipCode.substr(0, 5);
                    }

                    this.AccountName = genericService.nullToBlank(pl.data.FirstName, false) + genericService.nullToBlank(pl.data.MiddleName, false) + genericService.nullToBlank(pl.data.LastName, false) + genericService.nullToBlank(pl.data.Suffix, false);

                  });

                  baseClass.SaveProfile('ECard', true);

                  break;
              }
              // Add this delay to allow the ng-models to have all data
              // before executing the trigger blur
              $timeout(function () {
                $('[name="editableForm"]').trigger('blur');
              }, 200);
            }
            else {
              if (baseClass.fetchProfile.PaymentType == "EC") {
                baseClass.ECheckProfile.NameSuffixes = baseClass.NameSuffixes;
              } else {
                baseClass.CreditCardProfile.ExpirationDate = new Date();
                baseClass.tempCardProfile.ExpirationDate = new Date();
              }
              $('[name="hidePaymentLoading"]').trigger('blur');
            }

          }, function (errorpl) {
            commonService.handleError(errorpl)
            $mdDialog.hide();
          });
      }

      this.UpdateBankAccountName = function () {
        this.ECheckProfile.AccountName = genericService.nullToBlank(this.ECheckProfile.FirstName, false) + genericService.nullToBlank(this.ECheckProfile.MiddleName, false) + genericService.nullToBlank(this.ECheckProfile.LastName, false) + genericService.nullToBlank(this.ECheckProfile.Suffix, false);
      }

      this.GetCCTypeDesc = function (cctype) {
        var result = 'that';

        if (cctype == 'visa') {
          result = 'Visa';
        }
        else if (cctype == 'mastercard') {
          result = 'Master Card';
        }
        else if (cctype == 'discover') {
          result = 'Discover';
        }
        else if (cctype == 'amex') {
          result = 'American Express';
        }

        return result;
      }
      this.checkHasChanges = function () {
        // Check if changes has been made
        $scope.tempExpMonth = (this.tempCardProfile.ExpirationDate === undefined) ? "01" : (this.tempCardProfile.ExpirationDate.getMonth() + 1).toString().padLeft(2, "0");
        $scope.tempExpYear = (this.tempCardProfile.ExpirationDate === undefined) ? ((new Date()).getFullYear() + 1).toString().toTwoDigitsYear() : this.tempCardProfile.ExpirationDate.getFullYear().toString().toTwoDigitsYear();
        $scope.cardExpMonth = (this.CreditCardProfile.ExpirationDate === undefined) ? "01" : (this.CreditCardProfile.ExpirationDate.getMonth() + 1).toString().padLeft(2, "0");
        $scope.cardExpYear = (this.CreditCardProfile.ExpirationDate === undefined) ? ((new Date()).getFullYear() + 1).toString().toTwoDigitsYear() : this.CreditCardProfile.ExpirationDate.getFullYear().toString().toTwoDigitsYear();

        if ((this.CreditCardProfile.CardName === this.tempCardProfile.CardName) &&
          (this.CreditCardProfile.CCNumber === this.tempCardProfile.CCNumber) &&
          (this.CreditCardProfile.ZipCode === this.tempCardProfile.ZipCode) &&
          ($scope.cardExpMonth === $scope.tempExpMonth) &&
          ($scope.cardExpYear === $scope.tempExpYear)) {
          this.CreditCardProfile.UpdateProfile = '0';
          $scope.hasChanges = false;
        } else {
          $scope.hasChanges = true;
        }
      }

      this.SaveProfile = function (pType, isValid) {
        this.checkHasChanges();
        switch (pType) {
          case 'TDC':
            var CreditCardDetails = {
              Number: (this.CreditCardProfile.CCNumber === undefined) ? 0 : this.CreditCardProfile.CCNumber,
              Name: (this.CreditCardProfile.CardName === undefined) ? "" : this.CreditCardProfile.CardName,
              Type: (this.CreditCardProfile.CardType === undefined) ? "" : GetNumberCCType(this.CreditCardProfile.CardType),
              ExpirationMonth: (this.CreditCardProfile.ExpirationDate === undefined) ? "01" : (this.CreditCardProfile.ExpirationDate.getMonth() + 1).toString().padLeft(2, "0"),
              ExpirationYear: (this.CreditCardProfile.ExpirationDate === undefined) ? ((new Date()).getFullYear() + 1).toString().toTwoDigitsYear() : this.CreditCardProfile.ExpirationDate.getFullYear().toString().toTwoDigitsYear(),
              ZipCode: (this.CreditCardProfile.ZipCode === undefined) ? "" : this.CreditCardProfile.ZipCode.substr(0, 5),
              ZipCodeExtension: (this.CreditCardProfile.ZipCode === undefined) ? "" : (this.CreditCardProfile.ZipCode.length > 5) ? this.CreditCardProfile.ZipCode.substr(6) : "",
              Address1: (this.CreditCardProfile.CCAddress1 === undefined) ? "" : this.CreditCardProfile.CCAddress1,
              Address2: "",
              City: (this.CreditCardProfile.CCCity === undefined) ? "" : this.CreditCardProfile.CCCity,
              State: (this.CreditCardProfile.CCState === undefined) ? "" : this.CreditCardProfile.CCState,
              CVV: (this.CreditCardProfile.CCVerifCode === undefined) ? "" : this.CreditCardProfile.CCVerifCode,
              UpdateProfile: (this.CreditCardProfile.UpdateProfile === undefined) ? '0' : this.CreditCardProfile.UpdateProfile,
              isValid: isValid
            };

            this.setProfile(CreditCardDetails);
            break;
          case 'ECard':
            this.ECheckProfile.isValid = isValid;
            this.setProfile(this.ECheckProfile);
            break;
        }
      }

      function confirmDelete() {
        var confirm = $mdDialog.confirm(
          {
            clickOutsideToClose: false,
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
          .title('Delete Payment Profile')
          .textContent('Are you sure you want to delete this Payment Profile?')
          .ariaLabel('Delete Payment Profile')
          .ok('Yes')
          .cancel('No')
          .multiple(true);
        return $mdDialog.show(confirm);
      }

      this.deleteProfile = function (paymentType) {
        authService.CheckIsPortalEnabled(true, null, function () {
          confirmDelete().then(function () {
            baseClass.continueDeleteProfile(paymentType);
          }, function () {

          });
        });
      }

      this.continueDeleteProfile = function (paymentType) {
        genericService.post('Payments/PaymentProfile/Delete', this.ModFetchProfile)
          .then(function (pl) {
            $scope.hasPaymentProfile = false;

            if (paymentType == "EC") {
              $mdDialog.show(
                $mdDialog.alert({
                  clickOutsideToClose: false,
                  title: "Delete Payment Profile",
                  textContent: "ECheck Payment Profile has been successfully deleted.",
                  ok: "OK",
                  onComplete: function () {
                    $rootScope.$broadcast('msDialogIsOpened');
                  },
                  onRemoving: function () {
                    $rootScope.$broadcast('msDialogIsClosed');
                  }
                })
              );
            }
            else if (paymentType == "CC") {
              $mdDialog.show(
                $mdDialog.alert({
                  clickOutsideToClose: false,
                  title: "Delete Payment Profile",
                  textContent: "Credit Card Payment Profile has been successfully deleted.",
                  ok: "OK",
                  onComplete: function () {
                    $rootScope.$broadcast('msDialogIsOpened');
                  },
                  onRemoving: function () {
                    $rootScope.$broadcast('msDialogIsClosed');
                  }
                })
              );
            }
          },
            function (errorpl) {
              console.log("error: " + errorpl);
            });
      }


      /**
      * @ngdoc method
      * @name validateErrorForm
      * @author Juan Leon <juanl@sedata.com>
      * @description Method used to popup a dialogbox with the detail of
      *                the selected services that the client want to pay.
      **/
      this.validateErrorForm = function (editableForm) {
        editableForm.$setSubmitted();

        return angular.equals(editableForm.$error, {});
      };

      function GetNumberCCType(typeName) {
        var typeNumber;

        switch (typeName) {
          case "visa":
            typeNumber = "01";
            break;
          case "mastercard":
            typeNumber = "02";
            break;
          case "discover":
            typeNumber = "03";
            break;
          case "amex":
            typeNumber = "04";
            break;
          default:
            typeNumber = typeName;
        }

        return typeNumber;
      }
      function GetNameCCType(typeNumber) {
        var typeName;

        switch (typeNumber) {
          case "01":
            typeName = "visa";
            break;
          case "02":
            typeName = "mastercard";
            break;
          case "03":
            typeName = "discover";
            break;
          case "04":
            typeName = "amex";
            break;
          default:
            typeName = typeNumber;
        }

        return typeName;
      }

    }));

    function BlurInput(elementId) {
      var element = document.getElementById(elementId);
      if (this.isAdmin && element.value !== '') {
        element.disabled = true;
      }
    }
    function GetSaveProfileLabel() {
      var action = $scope.hasPaymentProfile ? "Update" : "Store";
      var paymentType = this.fetchProfile.PaymentType === "CC" ? "Credit Card" : "Bank Account";
      var label = action + " " + paymentType + " " + "Information";
      return label;
    }
    function EditInput(elementId) {
      var element = document.getElementById(elementId);
      var maskedInput = element.value;

      element.onfocus = function () { element.value = maskedInput; };
      element.disabled = false;
      element.focus();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('PaymentDetailController', ['$mdDialog', '$state', '$mdMedia', 'paymentData', 'PaymentDetailService', 'PaymentContext', 'commonService', '$interval', '$rootScope', 'authService', PaymentDetailController]);

  /** @ngInject 
  * @type: controller
  * @name: PaymentDetailController
  * @description: Used to control the functionality of detail payment proccess.
  **/

  function PaymentDetailController($mdDialog, $state, $mdMedia, paymentData, PaymentDetailService, PaymentContext, commonService, $interval, $rootScope, authService) {
    /// Variables
    var __this = this;

    /// Services Binding.
    PaymentDetailService.setPaymentDetail(paymentData);

    var isValidProfile = function () { return PaymentDetailService.isValid() };
    var getProfileDetail = function () { return PaymentDetailService.getPaymentProfile(); };
    var getIePad = function () { return calculateIEPad(); };

    /// Use angular.extend to encapsulate the logic of the controller into a class.
    angular.extend(this, {
      /// Bind Data.
      AccountServices: paymentData.AccountServices.getSelectedService(),
      BudgetLevelized: paymentData.BudgetLevelized,
      IsPPM: paymentData.IsPPM,
      showNote: paymentData.showNote,

      /// Configuration Data.
      CCParameters: PaymentContext.Parameters,
      dtOptions: { dom: 'lrtip', paging: false, responsive: false, scroller: false, processing: true, info: false, },
      customFullscreen: $mdMedia('xs') || $mdMedia('sm'),
      deviceDetails: { DeviceType: "BPP", HardwareId: "" },
      paymentType: (paymentData.type == 1 ? "CC" : "EC"),
      profileURL: (paymentData.type == 1) ? "creditCard.html" : "eCheck.html",
      title: paymentData.title,
      activated: false,
      PastDueOn: false,

      /// Methods.
      isValid: function () {
        return isValidProfile() && (this.AccountServices != null && this.AccountServices.PaymentDetails != null && this.AccountServices.PaymentDetails.totalAmount > 0);
      },
      isPaymentProcessing: false,
      paymentLabel: 'Pay Now',
      closeDialog: CloseDialog,
      loadForm: LoadForm,
      calculateConvFee: CalculateConvFee,
      reCalculateConvFee: ReCalculateConvFee,
      payBill: PayBill,
      getProfileData: function () { return getProfileDetail() },
      model: { paymentDetailLoading: true, isCalculating: true },
      ieCss: "1px !important",
      validateKey: validateKey
    });

    __this.applyChange = function () {
      PaymentAmountChanged();
      ReCalculateConvFee();
    }

    //__this.model = { paymentDetailLoading: true };
    /* THIS IS TO DYNAMICALLY SET THE CSS FOR IE DEPENDING ON NUMBER OF SERVICES */
    function calculateIEPad(multiplier) {
      __this.ieCss = (multiplier * 50 + 60) + "px !important"
    }
    /// Internal Functions.
    /**
    * @ngdoc method
    * @name CloseDialog
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get the data from the principal data.
    */
    function CloseDialog() {
      __this.AccountServices = [];
      $mdDialog.cancel();
    }
    /**
    * @ngdoc method
    * @name LoadForm
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get the data from the principal data.
    */
    function LoadForm() {
      if ($rootScope.Parameters.FourthParameters.FOURTHPARM_62 == 1) {
        __this.PastDueOn = true;
      }
      CalculatePPMPayment();
      CalculateConvFee();
      __this.balanceWidth = commonService.getNumericColumnWidth(__this.AccountServices, "Balance", 0, 46.08);
      __this.pastDueWidth = commonService.getNumericColumnWidth(__this.AccountServices, "PastDue", 0, 51.55);
    }

    function CalculatePPMPayment() {
      if (__this.IsPPM) {

        var total = 0;
        angular.forEach(__this.AccountServices, function (service, key) {
          if (service.PPMPaymentNeeded !== 0 && service.PPMPaymentNeeded !== null) {
            service.SubTotal = service.PPMPaymentNeeded;
          }
          else if (service.PPMPaymentNeeded === 0 || service.PPMPaymentNeeded === null) {
            service.SubTotal = 0.00;
          }
          total += service.SubTotal;
        });
        __this.AccountServices.PaymentDetails.totalAmount = total;
      }
    }

    /**
    * @ngdoc method
    * @name CalculateConvFee
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get the data from the principal data.
    */
    function CalculateConvFee() {
      var AccountDetail = __this.AccountServices.getAccountDetails();
      __this.AccountServices.loadConvenienceFee(AccountDetail, __this.deviceDetails, __this.paymentType);
      calculateIEPad(__this.AccountServices.length);
    }
    function ReCalculateConvFee(isPaymentProcessing) {
      __this.model.paymentDetailLoading = true;
      CalculateConvFee();

      // This checks if the calculation for conv fee is done.
      // Also checks if the DOM has been updated to finish loading screen.
      var forLoading = $interval(function () {
        if (!isPaymentProcessing) {
          __this.model.paymentDetailLoading = false;
          __this.model.isCalculating = false;
          $interval.cancel(forLoading);
        }
      }, 500);
    }

    /**
    * @ngdoc method
    * @name PayBill
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get the data from the principal data.
    */
    function PayBill() {
      __this.isPaymentProcessing = true;
      __this.model.paymentDetailLoading = true;
      authService.CheckIsPortalEnabled(true, null, function () {
        if (__this.isValid()) {
          var accountNumber = (__this.getProfileData().Number) ? __this.getProfileData().Number.toMask() : __this.getProfileData().RoutingNumber.toMask();
          ReCalculateConvFee(__this.isPaymentProcessing = true);

          if (accountNumber == "") {
            showAlert('Warning', 'You must insert an account number to proceed to pay, please check your user profile data and try again.');
            StopPaymentProcessState();
          }
          else if (parseFloat(__this.AccountServices.PaymentDetails.totalAmount) > parseFloat($rootScope.MaxPaymentAmount)) {
            showValidation('Invalid Amount', 'Payment Amount should not exceed $' + $rootScope.MaxPaymentAmount);
            StopPaymentProcessState();
          }
          else {
            showConfirm("Confirm payment process", (__this.AccountServices.PaymentDetails.convenienceFee == 0 ? "" : "A convenience fee of $" + __this.AccountServices.PaymentDetails.convenienceFee + " will be added to your $" + parseFloat(__this.AccountServices.PaymentDetails.totalAmount).toFixed(2) + " payment amount. ") + "Are you sure you want to pay the total amount of $" + parseFloat(__this.AccountServices.PaymentDetails.totalPaymentAmount).toFixed(2) + "?").then(function () {
              var objData = {
                Accounts: __this.AccountServices.getAccounts(),
                PaymentDetails: __this.AccountServices.PaymentDetails,
                CreditCardDetails: getProfileDetail(),
                ECheckDetails: getProfileDetail(),
                DeviceDetails: __this.deviceDetails,
              };
              __this.paymentLabel = 'Processing...';
              PaymentContext.payBill(objData, __this.paymentType).then(function (data) {
                var PaymentResult = data.data;

                if (PaymentResult.ApprovalCode && PaymentResult.ApprovalCode.toString().replace('~~', '') != '') {
                  $mdDialog.hide(PaymentResult.ApprovalCode);
                  showReceipt(PaymentResult.ApprovalCode);
                } else {
                  if (!PaymentResult.Status) {
                    showAlert('Payment Failed', 'Your payment did not complete successfully. Please try again.');
                  }
                  else {
                    if (PaymentResult.Status.toUpperCase() == "FAILED" || PaymentResult.Status.toUpperCase() == "ERROR") {
                      if (__this.paymentType == 'CC') {
                        showAlert('Payment Failed', 'Your payment did not complete successfully. Please try again.');
                      }
                      else {
                        showAlert('Payment Failed', 'Unable to Process E-check Payment. Please contact the utility for assistance.');
                      }
                    }
                    else {
                      if (__this.paymentType == 'CC') {
                        showAlert('Payment Failed', 'Your credit card was declined.  Please ensure that the information is correct and try again, or enter new card information.');
                      }
                      else {
                        showAlert('Payment Failed', 'Your E-Check was declined.  Please ensure that the information is correct and try again, or enter new E-Check information.');
                      }
                    }
                  }
                  StopPaymentProcessState();
                }
              }, function (errorPl) {
                commonService.handleError(errorPl);
                StopPaymentProcessState();
              });
            }, function () {
              StopPaymentProcessState();
            });
          }
        }
      });
    }

    function showAlert(title, messages, ev) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .title(title)
          .textContent(messages)
          .ariaLabel(title)
          .ok('Ok')
          .targetEvent(ev)
      );
    }

    function showConfirm(title, messages, ev) {
      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.confirm(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title(title)
        .textContent(messages)
        .ariaLabel(title)
        .targetEvent(ev)
        .ok('Ok')
        .cancel('Cancel')
        .multiple(true);

      return $mdDialog.show(confirm);
    }

    function showValidation(title, messages, ev) {
      // Appending dialog to document.body to cover sidenav in docs app
      var alert = $mdDialog.alert(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title(title)
        .textContent(messages)
        .ariaLabel(title)
        .targetEvent(ev)
        .ok('Ok')
        .multiple(true);

      return $mdDialog.show(alert);
    }

    function showReceipt(ApprovalCode, ev) {
      var data = {
        title: ApprovalCode,
        PaymentDetails: __this.AccountServices.PaymentDetails,
        AccountDetails: __this.AccountServices.getAccountDetails(),
        isByService: __this.AccountServices.isByService,
      };

      $mdDialog.show({
        templateUrl: 'app/main/msportal/views/payment/receipt/payment_receipt.html',
        controller: "PaymentReceiptController as vm",
        locals: { detail: data },
        fullscreen: ($mdMedia('sm') || $mdMedia('xs')) && __this.customFullscreen,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        onComplete: function () {
          $rootScope.$broadcast('msDialogIsOpened');
        },
        onRemoving: function () {
          $rootScope.$broadcast('msDialogIsClosed');
        }
      });
    }
    function StopPaymentProcessState() {
      if (__this.model.paymentDetailLoading === true) {
        __this.model.paymentDetailLoading = false;
      }
      if (__this.isPaymentProcessing === true) {
        __this.isPaymentProcessing = false;
      }
      if (__this.paymentLabel !== 'Pay Now') {
        __this.paymentLabel = 'Pay Now';
      }
    }

    function validateKey(e, objectId) {
      if (e.keyCode === 13) {
        if (objectId == 0) {
          $('[name="byService"]').trigger('blur');
        } else {
          $('[name="byAccount"]').trigger('blur');
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('UsagechartsController', UsagechartsController);

  /** @ngInject */
  //function UsagechartsController() {
  function UsagechartsController($mdSidenav, $window) {
    $window.document.title = "Usage Charts - " + document.getElementById("title").title;

    var vm = this;

    vm.menuItems = [
      "Daily",
      "Monthly",
      "Interval"
    ];

    vm.selectedItem = vm.menuItems[0];

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    // Functions
    vm.switchItem = switchItem;
    vm.toggleSidenav = toggleSidenav;

    function switchItem(item) {
      vm.selectedItem = item;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('UsageController', UsageController, function ($scope) { });


  /** @ngInject */
  function UsageController($scope, genericService, $state, DTOptionsBuilder, $mdDialog, $rootScope, $sce, $window, $log, commonService, authService) {
    var serviceController = 'Bills/';
    $window.document.title = "Bill History - " + document.getElementById("title").title;
    $scope.BillHistory = [];
    $scope.MemberNo = $state.params.id;
    $scope.EDelinquentEnabled = '0';
    var curYear = new Date().getFullYear();
    var curMon = new Date().getMonth() + 1;
    $scope.getMaxDate = new Date(curYear, curMon, 0);
    $scope.IsPPM = false;
    $scope.dateLocale = commonService.dateLocaleByMonth;
    $scope.StartDate = new Date();
    $scope.EndDate = new Date();
    var mobileDirectory;

    CheckEDelinquentEnabled();
    CheckPPMStatus();
    LoadRecordsBills();
    authService.CheckIsPortalEnabled(true, null, null);

    function LoadRecordsBills() {
      $rootScope.rootscopeLoading = true;
      var promiseGet_bills = genericService.get(serviceController + $scope.MemberNo);

      promiseGet_bills.then(function (pl) {
        $scope.BillHistory = pl.data;
        if ($scope.BillHistory.length > 0) {

          var sBillMoYr = $scope.BillHistory[$scope.BillHistory.length - 1].BillDate;
          $scope.StartDate = ConstructDate(sBillMoYr);
          var eBillMoYr = $scope.BillHistory[0].BillDate;
          $scope.EndDate = ConstructDate(eBillMoYr);
        }
        $scope.balanceWidth = commonService.getNumericColumnWidth($scope.BillHistory, "Balance", 0, 67);
        $rootScope.rootscopeLoading = false;
      },
        function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading Bill History', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    };
    function CheckPPMStatus() {
      var promiseGet = genericService.get('Account/Services/' + $scope.MemberNo);
      promiseGet.then(function (pl) {

        if (pl.data.IsPPM === "P") {
          $scope.IsPPM = true;
        } else {
          $scope.IsPPM = false;
        }
      },
        function (errorPl) {
          commonService.handleError(errorPl);
          $log.error('failure loading Services', errorPl);
        })
    }

    function ConstructDate(BillMoYr) {
      var result = null;
      if (BillMoYr.substr(BillMoYr.length - 2, 2) > curYear.toString().substr(2, 2)) {
        result = new Date('19' + BillMoYr.substr(BillMoYr.length - 2, 2), BillMoYr.substr(0, 2) - 1, 1);
      }
      else {
        result = new Date('20' + BillMoYr.substr(BillMoYr.length - 2, 2), BillMoYr.substr(0, 2) - 1, 1);
      }
      return result;
    }


    function alertDialog(title, content) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .title(title)
          .textContent(content)
          .ariaLabel(title)
          .ok('Ok')
      );
    }

    $scope.ReloadRecords = function () {
      LoadRecordsBills();
    }

    $scope.LoadRecordsByDateRangeBills = function (startDate, endDate) {
      if (startDate == "" || endDate == "" || !(startDate) || !(endDate)) {
        alertDialog('Invalid Input', 'Please enter value for both Start and End dates and Start/End Date must be less than the Date today.');
      }
      else {
        var startYear = startDate.getFullYear().toString();
        var sYear = startYear.substr(startYear.length - 2, 2);
        var dateFrom = sYear + ('00' + (startDate.getMonth() + 1)).slice(-2);
        var endYear = endDate.getFullYear().toString();
        var eYear = endYear.substr(endYear.length - 2, 2);
        var dateTo = eYear + ('00' + (endDate.getMonth() + 1)).slice(-2);

        var dateToday = new Date();
        var yearToday = dateToday.getFullYear().toString();
        var tYear = yearToday.substr(yearToday.length - 2, 2);
        var dateNow = tYear + ('00' + (dateToday.getMonth() + 1)).slice(-2);

        if ((dateFrom > dateTo && startYear >= endYear) || startYear > endYear) {
          alertDialog('Invalid Input', 'Start date must be less than the End date.');
        }
        else if (dateTo > dateNow && endYear >= yearToday) {
          alertDialog('Invalid Input', 'End date must be less than the Date today.');
        }
        else {
          $rootScope.rootscopeLoading = true;
          var promiseGet = genericService.get(serviceController + $scope.MemberNo + '/' + dateFrom + dateTo);
          promiseGet.then(function (pl) {
            $scope.BillHistory = pl.data;
            if ($scope.BillHistory.length <= 0) {
              alertDialog('No results found', 'No billing history found for the specified dates.');
            }
            $rootScope.rootscopeLoading = false;
          },
            function (errorPl) {
              commonService.handleError(errorPl)
              $log.error('failure loading Bill History', errorPl);
              $rootScope.rootscopeLoading = false;
            })
        }
      }
    };

    $scope.dtOptions = {
      dom: 'Irtip',
      paging: false,
      responsive: false,
      scroller: false,
      processing: true,
      info: false,
      order: [0, 'desc'],
      columnDefs: [
        {
          // Target the id column
          targets: 0,
          responsivePriority: 1
        },
        {
          // Target the actions column
          targets: 3,
          responsivePriority: 2
        }],

      

      //For more options, look here: https://datatables.net/reference/option/
    };
    function CheckEDelinquentEnabled() {

      for (var x = 0; x < $rootScope.smartAppConfig.length; x++) {
        if ($rootScope.smartAppConfig[x].ConfigId == '51') {
          $scope.EDelinquentEnabled = $rootScope.smartAppConfig[x].Value;
        }
      }
    }

    $scope.ViewPDF = function (billdate, suffix) {
      authService.CheckIsPortalEnabled(true, null, function () {
        $rootScope.rootscopeLoading = true;
        $scope.isLoading = true;

        var promiseGet = genericService.get('Bills/' + parseInt($scope.BillHistory[0].MbrSep) + suffix + '/PDF/' + billdate.replace(/\//g, '-'));
        promiseGet.then(function (pl) {
          var pdfResult = pl.data;
          if (pdfResult.successFlag === false) {
            $scope.isLoading = false;
            $rootScope.rootscopeLoading = false;
            showAlert('Cannot Load PDF!', pdfResult.DisplayMessage);
          }

          else {
            if (!pdfResult.pdfBytes) {
              $scope.isLoading = false;
              $rootScope.rootscopeLoading = false;
              showAlert('Cannot Load PDF!', "PDF is not yet available for the selected billdate.");
            }
            else {
              // Decode the 64string
              var byteCharacters = atob(pdfResult.pdfBytes);
              // Convert to bytes
              var byteNumbers = new Array(byteCharacters.length);
              for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              var byteArray = new Uint8Array(byteNumbers);

              // become a blob. :O
              var actualPdfFile = new Blob([byteArray], { type: "application/pdf" });
              var fileURL = URL.createObjectURL(actualPdfFile);
              $scope.isLoading = false;
              $rootScope.rootscopeLoading = false;

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(actualPdfFile); //FOR IE
              }
              else {
                window.open(fileURL);
              }

              $scope.content = $sce.trustAsResourceUrl(fileURL);
            }
          }
        }, function (errorPl) { //If something occured while loading the PDF
          $log.error('failure loading Bill History', errorPl);
          commonService.handleError(errorPl)
        })
      });
    };

    function showAlert(title, messages, ev) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .title(title)
          .textContent(messages)
          .ariaLabel(title)
          .ok('Ok')
          .targetEvent(ev)
      );
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('ServiceDetailsController', ServiceDetailsController)
    .config(['$httpProvider', function ($httpProvider) {
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    }]);

  /** @ngInject */
  function ServiceDetailsController($scope, genericService, $http, $state, DTOptionsBuilder, $log, $mdDialog, $cacheFactory, $rootScope, commonService, authService, $window) {
    $window.document.title = "Service Details - " + document.getElementById("title").title;
    var serviceController = 'Account/Services/';
    var httpCache = $cacheFactory.get('$http');
    var roundupOptInMessage = 'Confirm your enrollment into the Round Up Billing Program. ' +
      'Changes will be reflected on your next bill. You can opt-out again at any time.';
    var roundupOptOutMessage = 'Confirm your withdrawal from the Round Up Billing Program. ' +
      'Changes will be reflected on your next bill. You can opt-in again at any time.';
    var __this = this;

    ///$scope variables
    $scope.roundupInformation = 'By enrolling in round up billing, all bills on this ' +
      'account will be rounded to the nearest whole dollar amount. To opt-in or opt-out ' +
      'of the program at any time, select the \'Enroll in Round Up\' or \'Opt out of Round Up\' hyperlinks. ' +
      'Changes will be reflected on your next bill.';

    $scope.param98 = false;

    angular.extend(this, {
      /// Binding Data.
      Service: {},
      MemberNo: $state.params.id,
      IsPPM: false,
      PastDueOn: false,
      dtOptions: {
        dom: 'lrtip', paging: false, scroller: false, processing: true, info: false,
        language: {
          "emptyTable": "Loading",
          "zeroRecords": "No matching records found"
        }
      },

      /// Methods.
      displayMessage: DisplayMessage,
      roundupBillingProcess: RoundupBillingProcess,
      LoadRecordsServ: LoadRecordsServ
    });

    // #region Functions
    function confirmMessage(title, content, OkButton) {

      var confirm = $mdDialog.confirm(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(false)
        .title(title)
        .textContent(content)
        .ariaLabel(title)
        .ok(OkButton)
        .cancel('Cancel')
        .multiple(true);

      return $mdDialog.show(confirm);
    }
    function DisplayMessage(title, text, command) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(false)
          .title(title)
          .textContent(text)
          .ariaLabel(title)
          .ok(command));
    }
    function LoadRecordsServ() {
      $rootScope.rootscopeLoading = true;
      authService.CheckIsPortalEnabled(true, null, null);
      authService.authentication.isCalled = true;
      httpCache.remove($rootScope.serviceBase + "Account/Services/" + __this.MemberNo);

      genericService.get(serviceController + __this.MemberNo).then(function (pl) {
        __this.Service = pl.data;
        __this.IsPPM = pl.data.IsPPM === 'P';
        __this.BudgetLevelized = pl.data.BillCode;
        if (pl.data.ppmLabel != "" && pl.data.ppmMinPayment != 0) {
          __this.ppmLabel = RephrasePPMPaymentLabel(pl.data.ppmLabel);
          __this.ppmMinPayment = pl.data.ppmMinPayment;
        }
        if (pl.data.Services) {
          if (pl.data.Services.length < 1) {
            __this.dtOptions.language.emptyTable = "No records have been found";
          }
        }
        if ($rootScope.Parameters != undefined && $rootScope.Parameters.FourthParameters != undefined && $rootScope.Parameters.FourthParameters.FOURTHPARM_62 != undefined && $rootScope.Parameters.FourthParameters.FOURTHPARM_62 == 1) {
          __this.PastDueOn = true;
        }
        __this.roundupBill = __this.Service.RoundUpBill === '00' ? true : false;
        __this.roundupBillContent = __this.roundupBill === true ? 'Opt out of Round Up' : 'Enroll in Round Up';
        $scope.param98 = $rootScope.Parameters.Parameters.COOPPARM_98 !== 0 ? true : false;

        $scope.balanceWidth = commonService.getNumericColumnWidth(__this.Service.Services, "Balance", 0, 68);
        $scope.pastDueWidth = commonService.getNumericColumnWidth(__this.Service.Services, "PastDue", 0, 73);
        $rootScope.rootscopeLoading = false;
      }, function (errorPl) {
        if (errorPl) {
          if (errorPl.status != 500) {
            __this.dtOptions.language.emptyTable = "Error loading records.";
          }
        }
        commonService.handleError(errorPl);
        $rootScope.rootscopeLoading = false;
      });
    }
    function RoundupBillingProcess() {
      $rootScope.rootscopeLoading = true;
      if (__this.roundupBill === true) {
        confirmMessage('Round Up Billing Opt-Out Confirmation', roundupOptOutMessage, 'OK').then(function () {
          __this.PayType = '01';
          genericService.post('Account/ModifyRoundUpBilling/' + __this.MemberNo + '/' + __this.PayType + __this.Service.Services.length).then(function (pl) {
            if (pl.data) {
              $state.go($state.current, {}, { reload: true });
            }
            $rootScope.rootscopeLoading = false;
          })
        }, function () {
          $rootScope.rootscopeLoading = false;
        })
      }
      else {
        confirmMessage('Round Up Billing Enrollment Confirmation', roundupOptInMessage, 'OK').then(function () {
          __this.PayType = '00';
          genericService.post('Account/ModifyRoundUpBilling/' + __this.MemberNo + '/' + __this.PayType + __this.Service.Services.length).then(function (pl) {
            if (pl.data) {
              $state.go($state.current, {}, { reload: true });
            }
            $rootScope.rootscopeLoading = false;
          })
        }, function () {
          $rootScope.rootscopeLoading = false;
        })
      }
    }
    function RephrasePPMPaymentLabel(label) {
      var newLabel = "";
      if (label == "Min Payment to Stay connected:") {
        newLabel = "Minimum Payment to Stay Connected on Prepaid:";
      } else if (label == "Min Payment to Get Reconnected:") {
        newLabel = "Minimum Payment to Get Reconnected:";
      } else if (label == "Payment to Reach Min PPM Bal:") {
        newLabel = "Payment to Reach Minimum Prepaid Balance:";
      } else if (label == "Min Payment to Stay connected on PPM:") {
        newLabel = "Minimum Payment to Stay Connected on Prepaid:";
      }
      return newLabel;
    }
    // #endregion Functions
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.msportal')
        .controller('ServicesController', ServicesController, function ($scope) { });

    /** @ngInject */
    

    function ServicesController($scope, genericService, $http, $state, $rootScope, authService, $log)
    {
        var __this = this;
        var vm = this;
        vm.ccDraft = ccDraft
        vm.bankDraft = bankDraft;

        angular.extend(this, {
            /// Binding Data.
            ProfileStat: 0,
            BillHistStat:0,
            PaymentHistStat: 0,
            UsageGraphStat: 0,
            EbillEnabled: 0,
            AlertsEnabled: 0,
            CCDraftsEnabled: 0,
            BankDraftsEnabled: 0,
            EDelinquentEnabled: 0,
            DepositsEnabled: 0,
            BudgetBillEnabled: 0,
            LevelizedBillEnabled: 0,

            /// Methods.
            GetSettings: getSettings,
            SetSmartAppConfig: SetSmartAppConfig,
            SelectedAccount: authService.accountsList,
            hasAlert: $rootScope.hasAlert
        })

        $rootScope.$on('setCurrentTabIndex', function (event, tabIndex) {
            __this.tabIndex = tabIndex;
        })

        function SetSmartAppConfig() {
          
                for (var x = 0; x < $rootScope.smartAppConfig.length; x++) {
                    if ($rootScope.smartAppConfig[x].ConfigId == '52') {
                        __this.ProfileStat = $rootScope.smartAppConfig[x].Value;
                    }
                    else if ($rootScope.smartAppConfig[x].ConfigId == '8') {
                        __this.BillHistStat = $rootScope.smartAppConfig[x].Value;
                    }
                    else if ($rootScope.smartAppConfig[x].ConfigId == '53') {
                        __this.PaymentHistStat = $rootScope.smartAppConfig[x].Value;
                    }
                    else if ($rootScope.smartAppConfig[x].ConfigId == '58') {
                        __this.UsageGraphStat = $rootScope.smartAppConfig[x].Value;
                    }
                    else if ($rootScope.smartAppConfig[x].ConfigId == '50') {
                        __this.EbillEnabled = $rootScope.smartAppConfig[x].Value;
                    }
                    else if ($rootScope.smartAppConfig[x].ConfigId == '51') {
                        __this.EDelinquentEnabled = $rootScope.smartAppConfig[x].Value;
                    }
                    else if ($rootScope.smartAppConfig[x].ConfigId == '59') {
                        __this.AlertsEnabled = $rootScope.smartAppConfig[x].Value;
                    }
                    else if ($rootScope.smartAppConfig[x].ConfigId == '87') {
                        __this.CCDraftsEnabled = $rootScope.smartAppConfig[x].Value;
                    }
                    else if ($rootScope.smartAppConfig[x].ConfigId == '88') {
                        __this.BankDraftsEnabled = $rootScope.smartAppConfig[x].Value;
                    }
                    else if ($rootScope.smartAppConfig[x].ConfigId == '107') {
                        __this.DepositsEnabled = $rootScope.smartAppConfig[x].Value;
                    }
                   else  if ($rootScope.smartAppConfig[x].ConfigId == '48') {
                       __this.LevelizedBillEnabled = $rootScope.smartAppConfig[x].Value;
                    }
                    else if ($rootScope.smartAppConfig[x].ConfigId == '49') {
                        __this.BudgetBillEnabled = $rootScope.smartAppConfig[x].Value;
                    }
                }            
        }
        function ccDraft() {
            $state.go('app.msportal.accounts.detail.ccDraft');
        }
        function bankDraft() {
            $state.go('app.msportal.accounts.detail.bankDraft');
        }
        function getSettings() {

            if (!$rootScope.smartAppConfig) {
                var promiseGet = genericService.get("Settings?DeviceType=WEBOS&HardwareId=");

                promiseGet.then(function (pl) {
                    $rootScope.Parameters = pl.data.Response;
                    $rootScope.Parameters['ShowConvCCFlag'] = pl.data.ShowConvCCFlag;
                    $rootScope.Parameters['ShowConvECFlag'] = pl.data.ShowConvECFlag;

                    var promiseGetConfig = genericService.get('SmartAppConfig/');
                    promiseGetConfig.then(function (pl) {
                        $rootScope.smartAppConfig = pl.data;
                        SetSmartAppConfig();
                    },
                        function (errorPl) {
                            $log.error('failure loading Offices', errorPl);
                        })
                },
                    function (errorPl) {
                        $log.error('failure loading Settings', errorPl);
                    })

            }
            else {
                SetSmartAppConfig();
            }
        }
    
 
        ///**
        // * Go to products page
        // */
        function gotoAccounts()
        {
            $state.go('app.msportal.accounts');
        }


    }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('ProfileController', ['$state', '$mdDialog', 'aaNotify', 'EntitiesValidators', '$window', '$scope', '$rootScope', 'ProfileContext', 'commonService', '$cacheFactory', 'authService', ProfileController])
    .config(['$httpProvider', function ($httpProvider) {
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    }]);


  /** @ngInject
  * @ngdoc controller
  * @name ProfileController
  * @requires $state
  * @requires $mdDialog
  * @requires EntitiesValidators
  * @requires ProfileContext
  * @description Controller used to interact with Account Profile screen.
  */
  function ProfileController($state, $mdDialog, aaNotify, EntitiesValidators, $window, $scope, $rootScope, ProfileContext, commonService, $cacheFactory, authService) {
    $window.document.title = "Profile - " + document.getElementById("title").title;

    /// Variables
    var __this = this;
    var httpCache = $cacheFactory.get('$http');
    
    RemoveMaskAttributes();

    /// Controller Definition.
    angular.extend(this, {
      /// Binding Objects.
      Model: {},
      ModifiedModel: {},
      stateDataList: [],
      streetDataList: [],
      nameSufDataList: [],
      dirCardinalsDataList: [],
      Validators: EntitiesValidators.data,
      memberSep: "",
      Form: {
        isSave: false,
      },
      MemberNo: $state.params.id,
      keyCode: null,

      /// Methods.
      initForm: LoadForm,
      saveChanges: SaveForm,
      cancelForm: CancelForm,
      editForm: EditForm,
      closeNotify: CloseNotify,
      checkNotify: CheckNotify,
      checkState: CheckState,
      checkSave: CheckSave,
      checkStrNo: CheckStrNo,
      errorList: ErrorList,
      formatValues: FormatValues,
      formatPhone: FormatPhone,
      formatZipCode: FormatZipCode,
      getKeyCode: GetKeyCode,
      reformatPhone: ReformatPhone,
      reformatZipCode: ReformatZipCode,
      removeMask: RemoveMaskAttributes,
      setFocus: SetFocus,
      trimValues: TrimValues,
      getAbbrev: GetAbbreviation
    });
    $scope.errorClose = false;
    $scope.saveCounter = 0;
    $scope.stateCounter = 0;
    $scope.POBoxExist = false;
    $scope.$watchGroup(['vm.Model.dirpref', 'vm.Model.dirsuf', 'vm.Model.state'], function () {
      if (__this.Model.dirpref !== undefined) {
        GetAbbreviation(__this.Model.dirpref, 'dirpref');
      }
      if (__this.Model.dirsuf !== undefined) {
        GetAbbreviation(__this.Model.dirsuf, 'dirsuf');
      }
      if (__this.Model.state !== undefined) {
        GetAbbreviation(__this.Model.state, 'state');
      }
    });

    /// Internal Functions
    /**
    * @ngdoc internal function
    * @name CancelForm
    * @author Juan Leon <juanl@sedata.com>
    * @param {BodyElement=form} 
    * @description Internal Function used to cancelling the operation from the screen.
    */
    function CancelForm(Form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        var _Form = Form;
        _Form.$aaFormExtensions.$reset().then(
          function Ok(resp) {
            if (resp) {
              _Form.$editMode = false;
              $scope.stateCounter = 0;
              $scope.saveCounter = 0;
              $scope.errorClose = false;
              LoadForm(Form);
            }
          }
        );
      });
    }
    function CheckNotify() {
      $scope.errorClose = false;
    }
    function CheckSave() {
      $scope.saveCounter = 1;
      $scope.errorClose = false;
    }
    function CheckState() {
      $scope.stateCounter += 1;
      $scope.errorClose = false;
    }
    function CloseNotify() {
      $scope.errorClose = true;
    }
    function CheckStrNo(street) {
      street = (street.replace(/[ ,.]/g, "")).toUpperCase();
      if (street.includes("POBOX")) {
        $scope.POBoxExist = true;
      }
      else {
        $scope.POBoxExist = false;
      }
    }
    function DisplayMessage(title, text, command) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(text)
          .ariaLabel(title)
          .ok(command));
    }
    function EditForm(form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        form.$editMode = true
      });
    }
    function ErrorList() {
      var name = document.getElementById('errorLi').innerText;
      if (!name) {
        return false;
      }
      else {
        return true;
      }
    }
    function EvaluateParam35() {
      // Exempt Portal Admin in Change Profile Request.
      var param35 = $rootScope.Parameters.InternetParameters.INT_COOPPARM_35;
      return authService.adminAuthentication.roleType === 'Admin' ? 2 : param35;
    }
    function FormatPhone(phoneNo) {
      var newValue = '';
      if (phoneNo === null || phoneNo.length === 0) {
        newValue = '';
      } else if (phoneNo.length <= 2) {
        newValue = '(' + phoneNo;
      } else if (phoneNo.length === 3) {
        newValue = '(' + phoneNo + ')';
      } else if (phoneNo.length > 3 && phoneNo.length <= 6) {
        newValue = '(' + phoneNo.substring(0, 3) + ')' + phoneNo.substring(3);
      } else if (phoneNo.length > 6) {
        newValue = '(' + phoneNo.substring(0, 3) + ')' + phoneNo.substring(3, 6) + '-' + phoneNo.substring(6);
      } else {
        newValue = model;
      }
      return newValue;
    }
    function FormatValues() {
      __this.Model.homePhone = __this.formatPhone(__this.Model.homePhone);
      __this.Model.businessPhone = __this.formatPhone(__this.Model.businessPhone);
      __this.Model.OtherPhoneNumber = __this.formatPhone(__this.Model.OtherPhoneNumber);
      __this.Model.cellPhoneNumber = __this.formatPhone(__this.Model.cellPhoneNumber);
      __this.Model.pagerNumber = __this.formatPhone(__this.Model.pagerNumber);
      __this.Model.faxNumber = __this.formatPhone(__this.Model.faxNumber);
      __this.Model.zip = __this.formatZipCode(__this.Model.zip);
      __this.Model.dirpref = __this.getAbbrev(__this.Model.dirpref, 'dirpref');
      __this.Model.dirsuf = __this.getAbbrev(__this.Model.dirsuf, 'dirsuf');
      __this.Model.state = __this.getAbbrev(__this.Model.state, 'state');
    }
    function FormatZipCode(zipCode) {
      var newValue = zipCode;
      if (zipCode === null) {
        newValue = '';
      } else if (zipCode.length !== 5) {
        if (zipCode.substring(6) === '0000') {
          newValue = zipCode.substring(0, 5);
        }
      }
      return newValue;
    }
    function GetAbbreviation(abbrev, id) {
      var fieldId = document.getElementById(id);
      var element = fieldId.firstChild.firstChild.firstChild.nextSibling.nextSibling.firstChild;
      element.textContent = abbrev;
      return element.textContent;
    }
    function GetKeyCode($event) {
      __this.keyCode = $event.keyCode;
    }
    /**
    * @ngdoc internal function
    * @name CancelForm
    * @author Juan Leon <juanl@sedata.com>
    * @description Internal Function used to load the account profile data from the back-end.
    */
    function LoadForm(Form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        var _Form = Form;
        $rootScope.rootscopeLoading = true;

        /// First it get the Member Sep.
        ProfileContext.GetMemberSep($state.params.id).then(function (data) {
          __this.memberSep = data.data.Services[0].MemberSep.replace($state.params.id, ($state.params.id + "-"));

          /// Then it find the Account Profile
          httpCache.remove($rootScope.serviceBase + 'AccountsProfiles/' + __this.memberSep);
          ProfileContext.GetAccountProfile(__this.memberSep).then(function (response) {
            __this.Model = response.data;
            __this.formatValues();
            __this.Model.param35 = EvaluateParam35().toString();
            CheckStrNo(__this.Model.street);
            _Form.$aaFormExtensions.$resetChanged();
            $rootScope.rootscopeLoading = false;
          }, function (error) {
            commonService.handleError(error);
            __this.Model = undefined;
            _Form.$aaFormExtensions.$resetChanged();
            $rootScope.rootscopeLoading = false;
          });
        }, function (error) {
          commonService.handleError(error);
          __this.memberSep = undefined;
          __this.Model = undefined;
          _Form.$aaFormExtensions.$resetChanged();
          $rootScope.rootscopeLoading = false;
        });

        ProfileContext.GetLookUpList("states").get(function (data) {
          angular.forEach(data.data, function (p) {
            p.Name = p.Name + ' ' + p.Abbreviation;
          })
          __this.stateDataList = data.data;
        });

        ProfileContext.GetLookUpList("streetSuffixes").get(function (data) {
          __this.streetDataList = data.data;
        });

        ProfileContext.GetLookUpList("nameSuffixes").get(function (data) {
          __this.nameSufDataList = data.data;
        });

        ProfileContext.GetLookUpList("dirCardinals").get(function (data) {
          __this.dirCardinalsDataList = data.data;
        });
      });
    }
    function ReformatPhone(phoneNo, elementId) {
      var input = document.getElementById(elementId);
      var newValue = "";
      var digits = input.value.replace('(', '').replace(')', '').replace('-', '');

      if (phoneNo === null || digits.length === 0) {
        newValue = '';
      }
      else if (digits.length === 1) {
        newValue = '(' + digits;
      }
      else if (digits.length === 3 && input.value.length === 4 && (__this.keyCode === 8 || __this.keyCode === 46)) {
        newValue = '(' + digits;
      }
      else if (digits.length === 3) {
        newValue = '(' + digits + ')';
      }
      else if (digits.length === 4 && input.value.length === 5) {
        newValue = '(' + digits.substring(0, 3) + ')' + digits.substring(3);
      }
      else if (digits.length === 6 && input.value.length === 9) {
        newValue = input.value.replace('-', '');
      }
      else if (digits.length === 6) {
        newValue = '(' + digits.substring(0, 3) + ')' + digits.substring(3, 6) + '-' + digits.substring(6);
      }
      else if (digits.length === 7 && input.value.length === 9) {
        newValue = '(' + digits.substring(0, 3) + ')' + digits.substring(3, 6) + '-' + digits.substring(6);
      }
      else {
        newValue = input.value;
      }

      phoneNo = newValue;
      input.value = phoneNo;
    }
    function ReformatZipCode(zipCode, elementId) {
      var input = document.getElementById(elementId);
      var newValue = "";
      var digits = input.value.replace("-", "");
      var area = input.value.substring(0, 5);

      if (input.value.length === 6 && digits.length === 6) {
        var route = input.value.substring(5);
        newValue = area + '-' + route;
        zipCode = newValue;
        input.value = newValue;
      } else if (input.value.length === 6 && digits.length === 5 && __this.keyCode !== 189) {
        newValue = area;
        zipCode = newValue;
        input.value = newValue;
      }
    }
    function RemoveMaskAttributes() {
      EntitiesValidators.data.validations.Model.homePhone.mask = null;
      EntitiesValidators.data.validations.Model.businessPhone.mask = null;
      EntitiesValidators.data.validations.Model.OtherPhoneNumber.mask = null;
      EntitiesValidators.data.validations.Model.cellPhoneNumber.mask = null;
      EntitiesValidators.data.validations.Model.pagerNumber.mask = null;
      EntitiesValidators.data.validations.Model.faxNumber.mask = null;
      EntitiesValidators.data.validations.Model.zip.mask = null;
    }
    /**
    * @ngdoc internal function
    * @name SaveForm
    * @author Juan Leon <juanl@sedata.com>
    * @param {BodyElement=form} 
    * @description Internal Function used to save the information from the screen to the back-end.
    */
    function SaveForm(Form) {
      authService.CheckIsPortalEnabled(true, null, function () {


        //Form.$editMode = false;
        CheckStrNo(__this.Model.street);
        $rootScope.rootscopeLoading = true;
        __this.trimValues();
        __this.ModifiedModel = {
          Model: __this.Model,
          RoleType: authService.adminAuthentication.roleType,
          AdminUsername: authService.adminAuthentication.userName
        };
        ProfileContext.SaveAccountProfile(__this.memberSep, __this.ModifiedModel).then(function (response) {

          var title = "";
          var text = "";
          var command = "";

          if (response.data.toLowerCase() == "true") {
            if (EvaluateParam35() === 2) {
              title = "Account Profile Updated";
              text = "Your account profile has been updated!";
              command = "Ok";
            }
            else {
              title = "Changes have been Submitted";
              text = "The requested changes to your Account Profile have been submitted to the utility for review before the update is completed.";
              command = "Ok";
            }

            Form.$editMode = false;
          }
          else {
            title = "Error Updating the Account Profile";
            text = "";
            command = "Continue";
          }


          Form.$aaFormExtensions.$resetChanged();
          $rootScope.rootscopeLoading = false;
          DisplayMessage(title, text, command);
          $state.reload();
        }, function (error) {
          commonService.handleError(error);
          $rootScope.rootscopeLoading = false;
        });
      });
    }
    function SetFocus(ElementID) {
      var elemId = $window.document.getElementById(ElementID);
      elemId.focus();
    }
    function TrimValues() {
      __this.Model.homePhone = __this.Model.homePhone.replace('(', '').replace(')', '').replace('-', '');
      __this.Model.businessPhone = __this.Model.businessPhone.replace('(', '').replace(')', '').replace('-', '');
      __this.Model.cellPhoneNumber = __this.Model.cellPhoneNumber.replace('(', '').replace(')', '').replace('-', '');
      __this.Model.OtherPhoneNumber = __this.Model.OtherPhoneNumber.replace('(', '').replace(')', '').replace('-', '');
      __this.Model.pagerNumber = __this.Model.pagerNumber.replace('(', '').replace(')', '').replace('-', '');
      __this.Model.faxNumber = __this.Model.faxNumber.replace('(', '').replace(')', '').replace('-', '');
      __this.Model.zip = __this.Model.zip.replace('-', '');
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.msportal')
        .factory('ProfileContext', ["genericService", "$resource", "authService", '$cacheFactory', '$rootScope', ProfileContext]);

    /** @ngInject
    * @ngdoc factory
    * @name ProfileContext
    * @requires genericService
    * @description Factory used to interact with Account Profile back-end.
    */
    function ProfileContext(genericService, $resource, authService) {

        /// Variables.
        var AccountsProfilesURL = 'AccountsProfiles/';
        var EntitiesValidatorsURL = 'EntityValidators/';
        var serviceController = 'Account/Services/';
        var __this = this;

        /// Service Return.
        return {
            /// Methods.
            GetAccountProfile: Find,
            SaveAccountProfile: Save,
            GetEntityValidators: GetEntityValidators,
            GetLookUpList: GetLookUpList,
            GetMemberSep: GetMemberSep,

            /// Properties.
            AccountsProfilesURL: AccountsProfilesURL,
            EntitiesValidatorsURL: EntitiesValidatorsURL,
        };


        /// Internal Functions.
        /**
        * @ngdoc internal function
        * @name Find
        * @author Juan Leon <juanl@sedata.com>
        * @param {String = MemberNo} Identifier Account Number.
        * @description Internal Function used to load the account profile data from the back-end.
        */
        function Find(MemberSep) {
            return genericService.get(this.AccountsProfilesURL + MemberSep);
        }
        /**
        * @ngdoc internal function
        * @name Save
        * @author Juan Leon <juanl@sedata.com>
        * @param {String = MemberSep}  Identifier Account Number.
        * @param {String = Model} The Data to be updated in the back-end.
        * @description Internal Function used to save the account profile data to the back-end.
        */
        function Save(MemberSep, Model) {
            return genericService.put(this.AccountsProfilesURL, MemberSep, Model);
        }
        /**
        * @ngdoc internal function
        * @name GetEntityValidators
        * @author Juan Leon <juanl@sedata.com>
        * @param {String = entityName}  Identifier Account Number.
        * @param {String = ModeljsonModelName} The Data to be updated in the back-end.
        * @description Internal Function used to get the Model validations.
        */
        function GetEntityValidators(entityName, jsonModelName) {
            return genericService.get(this.EntitiesValidatorsURL + "?entityName=" + entityName + "&jsonModelName=" + jsonModelName);
        }

        function GetLookUpList(lookUpType) {
            return $resource("app/data/msportal/" + lookUpType + ".json");
        }

        function GetMemberSep(MemberNo) {
            return genericService.get(serviceController + MemberNo)
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('PPMHistoryController', PPMHistoryController, function ($scope) { });

  /** @ngInject */
  function PPMHistoryController($scope, genericService, $state, DTOptionsBuilder, $mdDialog, $mdMedia, $rootScope, $sce, $window, $log, commonService, authService) {
    // Local Variables
    var curYear = new Date().getFullYear();
    var isModalShown = false;
    var serviceController = 'PPMAccount/';
    $window.document.title = "Prepaid Account History - " + document.getElementById("title").title;
    // Data Binding
    $scope.dateLocale = commonService.dateLocaleByMonth;
    $scope.dtOptions = {
      dom: 'Irtip',
      paging: false,
      responsive: true,
      scroller: false,
      processing: true,
      info: false,
      order: [0, 'desc'],
      columnDefs: [
        {
          targets: 0,
          responsivePriority: 1
        },
        {
          targets: -2,
          responsivePriority: 3
        },
        {
          // View History Breakdown
          targets: -1,
          responsivePriority: 2,
          sortable: false
        }],
      language: {
        "emptyTable": "No Records Available",
        "zeroRecords": "No matching records found"
      }
      //For more options, look here: https://datatables.net/reference/option/
    };
    $scope.dtOptionsDetails = {
      dom: 'Irtip',
      paging: false,
      responsive: true,
      scroller: false,
      processing: true,
      info: false,
      order: [0, 'asc'],
      columnDefs: [
        {
          // Service Details
          targets: 0,
          responsivePriority: 1
        },
        {
          // Balance
          targets: -1,
          responsivePriority: 2,
        }],
      language: {
        "emptyTable": "No Records Available",
        "zeroRecords": "No matching records found"
      }
      //For more options, look here: https://datatables.net/reference/option/
    };
    $scope.endDate = new Date();
    $scope.filteredPPMAcctHistory = [];
    $scope.getMaxDate = new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0);
    $scope.MemberNo = $state.params.id;
    $scope.PPMAccount = {};
    $scope.PPMAcctHistory = [];
    $scope.selectedTransactions = [];
    $scope.sort = {
      Column: 'SystemDate',
      Reverse: true
    };
    $scope.startDate = new Date();
    $scope.windowWidth = window.innerWidth;

    // Function Binding
    $scope.alertDialog = AlertDialog;
    $scope.filter = Filter;
    $scope.ReloadPPMRecords = ReloadPPMRecords;
    $scope.showDetails = ShowDetails;
    $scope.showHelp = ShowHelp;
    $scope.sortClass = SortClass;
    $scope.sortList = SortList;
    $scope.toggleDetails = ToggleDetails;

    // Initialization
    LoadRecordsPPMAcctHistory();
    authService.CheckIsPortalEnabled(true, null, null);

    // Functions
    function AlertDialog(title, content) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .title(title)
          .textContent(content)
          .ariaLabel(title)
          .ok('Ok')
      );
    }
    function Filter() {
      // Get the selected Start and End Date
      var lowestDate = GetMoYr($scope.startDate);
      var highestDate = GetMoYr($scope.endDate);

      var maxDate = angular.copy($scope.startDate);
      maxDate = GetMoYr(maxDate.setMonth(maxDate.getMonth() + 11));

      if (lowestDate > highestDate) {
        AlertDialog('Invalid Date Range', 'The End Date must be later than the Start Date.');
      } else if (highestDate > maxDate) {
        AlertDialog('Invalid Date Range', 'The Interval between Start and End Date can not be more than 12 months.');
      } else {
        // Remove item from list if date not in between the start and end date.
        $scope.filteredPPMAcctHistory = angular.copy($scope.PPMAcctHistory);
        for (var i = $scope.filteredPPMAcctHistory.length - 1; i >= 0; i--) {
          var itemDate = $scope.filteredPPMAcctHistory[i].SystemDate;
          itemDate = GetMoYr(new Date(itemDate));
          if (itemDate < lowestDate || itemDate > highestDate) {
            $scope.filteredPPMAcctHistory.splice(i, 1);
          }
        }

        for (var i = $scope.filteredPPMAcctHistory.length - 1; i >= 0; i--) {
          var itemDate = $scope.filteredPPMAcctHistory[i].SystemDate;
          var curDate = new Date();
          if (itemDate > curDate) {
            $scope.filteredPPMAcctHistory.splice(i, 1);
          }
        }
      }
    }
    function ReformatDate(date) {
      var day = commonService.padLeft((new Date(date).getDate()).toString(), 2, '0');
      var month = commonService.padLeft((new Date(date).getMonth() + 1).toString(), 2, '0');
      var year = "20" + (new Date(date).getFullYear().toString().substring(2));
      return (new Date(year, month, day));
    }
    function GetMoYr(date) {
      var mo = commonService.padLeft((new Date(date).getMonth() + 1).toString(), 2, '0');
      var yr = new Date(date).getFullYear().toString();
      return yr + mo;
    }
    function LoadRecordsPPMAcctHistory() {
      $rootScope.rootscopeLoading = true;
      var promiseGet = genericService.get(serviceController + $scope.MemberNo);
      promiseGet.then(function (pl) {
        InvertPPMValues(pl.data.PPMAccountHistory);
        for (var i = 0; i < pl.data.PPMAccountHistory.length; i++) {
          var item = pl.data.PPMAccountHistory[i];
          //item.SystemDate = new Date(item.SystemDate);
          item.SystemDate = ReformatDate(item.SystemDate);
          item.isCollapsed = true;
          for (var j = 0; j < item.Transactions.length; j++) {
            var transaction = item.Transactions[j];
            //transaction.SystemDate = new Date(transaction.SystemDate);
            transaction.SystemDate = ReformatDate(transaction.SystemDate);
            transaction.isCollapsed = true;
          }
        }
        $scope.PPMAccount = pl.data;
        $scope.PPMAcctHistory = pl.data.PPMAccountHistory;
        if ($scope.PPMAcctHistory.length > 0) {
          $scope.PPMAccount.PaymentNotice = RephrasePPMPaymentLabel($scope.PPMAccount.PaymentNotice);
          var eDateMoYr = new Date();
          $scope.startDate = new Date(eDateMoYr);
          $scope.endDate = new Date(eDateMoYr);
          Filter();
        }
        $rootScope.rootscopeLoading = false;
      }, function (errorPl) {
        commonService.handleError(errorPl);
        $rootScope.rootscopeLoading = false;
      })
    };
    function ReloadPPMRecords() {
      var eDateMoYr = $scope.PPMAcctHistory[0].SystemDate;
      $scope.startDate = new Date(eDateMoYr);
      $scope.endDate = new Date(eDateMoYr);
      Filter();
    }
    function RephrasePPMPaymentLabel(label) {
      if (label === "Min Payment to Stay connected:") {
        return "Minimum Payment to Stay Connected on Prepaid:";
      } else if (label === "Min Payment to Get Reconnected:") {
        return "Minimum Payment to Get Reconnected:";
      } else if (label === "Payment to Reach Min PPM Bal:") {
        return "Payment to Reach Minimum Prepaid Balance:";
      } else if (label === "Min Payment to Stay connected on PPM:") {
        return "Minimum Payment to Stay Connected on Prepaid:";
      } else {
        return label;
      }
    }
    function InvertPPMValues(accountHistory) {
      for (var i = 0; i < accountHistory.length; i++) {
        var item = accountHistory[i];
        item.Charges = item.Charges * -1;
        item.Payment = item.Payment * -1;
        item.Adjustment = item.Adjustment * -1;
        item.Reconciliation = item.Reconciliation * -1;
        item.Balance = item.Balance * -1;
        for (var j = 0; j < item.Transactions.length; j++) {
          var transaction = item.Transactions[j];
          transaction.Charges = transaction.Charges * -1;
          transaction.Payment = transaction.Payment * -1;
          transaction.Adjustment = transaction.Adjustment * -1;
          transaction.Reconciliation = transaction.Reconciliation * -1;
          transaction.Balance = transaction.Balance * -1;
        }
      }

    }
    function ShowDetails(item, ev) {
      var detailsDialog = {
        templateUrl: 'app/main/msportal/views/ppm_history/dailyTransactions.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: ($mdMedia('sm') || $mdMedia('xs')) && ($mdMedia('xs') || $mdMedia('sm')),
        locals: {
          data: {
            dtOption: $scope.dtOptionsDetails,
            item: item,
            showHelp: $scope.showHelp,
            sortClass: $scope.sortClass,
            sortList: $scope.sortList,
            toggleDetails: $scope.toggleDetails
          }
        },
        controller: "PPMServiceHistoryController",
        onComplete: function () {
          $rootScope.$broadcast('msDialogIsOpened');
        },
        onRemoving: function () {
          $rootScope.$broadcast('msDialogIsClosed');
        }
      };
      $mdDialog.show(detailsDialog);
    }
    function ShowHelp(item) {
      if (item === 'Charges') {
        var alert = $mdDialog.alert(
          {
            clickOutsideToClose: false,
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
          .title('Activity Help Message')
          .htmlContent(
            '<span>Charges Incurred/Amount Due as per Daily Usage.</span>'
          )
          .ariaLabel('Charges Help')
          .ok('Close')
          .multiple(true)

        return $mdDialog.show(alert);
      }
    }
    function SortClass(column) {
      var object = isModalShown ? $scope.sort2 : $scope.sort;
      var className = '';
      if (object.Column === column) {
        className = object.Reverse === false ? 'fa-sort-up' : 'fa-sort-down';
      } else {
        className = 'fa-sort';
      }
      return className;
    }
    function SortList(column) {
      var object = isModalShown ? $scope.sort2 : $scope.sort;
      if (object.Column === column) {
        object.Reverse = !object.Reverse;
      } else {
        object.Column = column;
        object.Reverse = false;
      }
    }
    function ToggleDetails(item) {
      item.isCollapsed = !item.isCollapsed;
      //if (window.innerWidth <= 575) {
      //  item.isCollapsed = !item.isCollapsed;
      //}
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('PPMServiceHistoryController', PPMServiceHistoryController);

  /** @ngInject */
  function PPMServiceHistoryController(data, $mdDialog, $scope) {
    $scope.item = data.item;
    $scope.closeDialog = function () {
      $mdDialog.cancel();
    }
    $scope.dtOptionsDetails = data.dtOption;
    $scope.showHelp = angular.copy(data.showHelp);

    $scope.sortClass = SortClass;
    $scope.sortList = SortList;
    $scope.toggleDetails = ToggleDetails;

    $scope.sort = {
      Column: 'MemberSep',
      Reverse: false
    };

    function SortClass(column) {
      var object = $scope.sort;
      var className = '';
      if (object.Column === column) {
        className = object.Reverse === false ? 'fa-sort-up' : 'fa-sort-down';
      } else {
        className = 'fa-sort';
      }
      return className;
    }
    function SortList(column) {
      var object = $scope.sort;
      if (object.Column === column) {
        object.Reverse = !object.Reverse;
      } else {
        object.Column = column;
        object.Reverse = false;
      }
    }
    function ToggleDetails(item) {
      item.isCollapsed = !item.isCollapsed;
      //if (window.innerWidth <= 575) {
      //  item.isCollapsed = !item.isCollapsed;
      //}
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('PaymentHistoryController', PaymentHistoryController, function ($scope) { })
    .config(['$httpProvider', function ($httpProvider) {
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    }]);
  /** @ngInject */
  function PaymentHistoryController($scope, genericService, $http, $state, DTOptionsBuilder, $mdDialog, $rootScope, $log, commonService, authService, $window) {
    var serviceController = 'PaymentHistory/';
    $window.document.title = "Payment History - " + document.getElementById("title").title;
    $scope.dateLocale = commonService.dateLocaleByMonth;
    $scope.PaymentHistory = {};
    $scope.MemberNo = $state.params.id;
    $scope.StartDate = new Date();
    $scope.EndDate = new Date();
    $scope.displayTrans = false;
    $scope.TransAmt = 0;


    var curYear = new Date().getFullYear();
    var curMon = new Date().getMonth() + 1;
    $scope.getMaxDate = new Date(curYear, curMon, 0);

    var mobileDirectory;

    LoadRecords();
    authService.CheckIsPortalEnabled(true, null, null);

    function LoadRecords() {

      $rootScope.rootscopeLoading = true;
      var promiseGet = genericService.get(serviceController + $scope.MemberNo);
      //alert($scope.MemberNo);
      promiseGet.then(function (pl) {
        $scope.PaymentHistory = pl.data;
        if ($scope.PaymentHistory.length > 0) {
          var sBillMoYr = $scope.PaymentHistory[$scope.PaymentHistory.length - 1].BillMoYr;
          $scope.StartDate = ConstructDate(sBillMoYr);
          var eBillMoYr = $scope.PaymentHistory[0].BillMoYr;
          $scope.EndDate = ConstructDate(eBillMoYr);
        }

        for (var i = 0; i < $scope.PaymentHistory.length; i++) {
          if ($scope.PaymentHistory[i].TransNbr == '0210') {
            $scope.displayTrans = true;
            $scope.TransAmt = $scope.PaymentHistory[i].Amount;
            break;
          }
        }


        $scope.amountWidth = commonService.getNumericColumnWidth($scope.PaymentHistory, "Amount", 0, 71);
        $rootScope.rootscopeLoading = false;
        //alert($scope.PaymentHistory.Balance);
      },
        function (errorPl) {
          //alert(2);
          commonService.handleError(errorPl);
          $log.error('failure loading Payment History', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    }

    function ConstructDate(BillMoYr) {
      var result = null;
      if (BillMoYr.substr(BillMoYr.length - 2, 2) > curYear.toString().substr(2, 2)) {
        result = new Date('19' + BillMoYr.substr(0, 2), BillMoYr.substr(2, 2) - 1, 1);
      }
      else {
        result = new Date('20' + BillMoYr.substr(0, 2), BillMoYr.substr(2, 2) - 1, 1);
      }
      return result;
    }

    function alertDialog(title, content) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .title(title)
          .textContent(content)
          .ariaLabel(title)
          .ok('Ok')
        //.targetEvent(ev)
      );
    }

    $scope.ReloadRecords = function () {
      LoadRecords();
    }

    $scope.LoadRecordsByDateRange = function (startDate, endDate) {
      $scope.displayTrans = false;

      if (startDate == "" || endDate == "" || !(startDate) || !(endDate)) {
        alertDialog('Invalid Input', 'Please enter value for both Start and End dates and Start/End Date must be less than the Date today.');

      }
      else {
        var startYear = startDate.getFullYear().toString();
        var sYear = startYear.substr(startYear.length - 2, 2);
        var dateFrom = sYear + ('00' + (startDate.getMonth() + 1)).slice(-2);
        var endYear = endDate.getFullYear().toString();
        var eYear = endYear.substr(endYear.length - 2, 2);
        var dateTo = eYear + ('00' + (endDate.getMonth() + 1)).slice(-2);

        var dateToday = new Date();
        var yearToday = dateToday.getFullYear().toString();
        var tYear = yearToday.substr(yearToday.length - 2, 2);
        var dateNow = tYear + ('00' + (dateToday.getMonth() + 1)).slice(-2);

        if ((dateFrom > dateTo && startYear >= endYear) || startYear > endYear) {
          alertDialog('Invalid Input', 'Start date must be less than the End date.');
        }
        else if (dateTo > dateNow && endYear >= yearToday) {
          alertDialog('Invalid Input', 'Start/End Date must be less than the Date today.');
        }
        else {
          $rootScope.rootscopeLoading = true;
          var promiseGet = genericService.get(serviceController + $scope.MemberNo + '/' + dateFrom.toString() + dateTo.toString());

          promiseGet.then(function (pl) {
            $scope.PaymentHistory = pl.data;
            if ($scope.PaymentHistory.length <= 0) {
              alertDialog('No results found', 'No payment history found for the specified dates.');
            }

            for (var i = 0; i < $scope.PaymentHistory.length; i++) {
              if ($scope.PaymentHistory[i].TransNbr == '0210') {
                $scope.displayTrans = true;
                $scope.TransAmt = $scope.PaymentHistory[i].Amount;
                break;
              }
            }     

            $rootScope.rootscopeLoading = false;
          },
            function (errorPl) {
              commonService.handleError(errorPl);
              $log.error('failure loading Payment History', errorPl);
              $rootScope.rootscopeLoading = false;
            })
        }
      }
    };

    $scope.dtOptions = {
      dom: 'Irtip',
      paging: false,
      //autoWidth: false,
      responsive: true,
      scroller: false,
      processing: true,
      ordering: true,
      info: false,
      order: [0, 'desc']


      //For more options, look here: https://datatables.net/reference/option/
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('PaymentController', ['genericService','PaymentContext', '$mdDialog', '$mdMedia', '$scope', '$state', 'CCValidators', 'ECValidators', '$rootScope', 'commonService', 'authService', '$window', PaymentController]);

  /** @ngInject
  * @ngdoc controller
  * @name PaymentController
  * @description Controller used to interact with Payment screen.
  */
  function PaymentController(genericService,PaymentContext, $mdDialog, $mdMedia, $scope, $state, CCValidators, ECValidators, $rootScope, commonService, authService, $window) {
    /// Variables.
    authService.CheckIsPortalEnabled(true, null, null);
    var __this = this;
    $window.document.title = "Payment - " + document.getElementById("title").title;
    PaymentContext.setCCValidation(CCValidators.data);
    PaymentContext.setECValidation(ECValidators.data);

    angular.extend(this, {
      EcheckStat: 0,
      CreditCardStat: 0,
      IsPPM: false,
      /// Bindding Data.
      paymentProgress: { activated: false },
      paymentData: { title: '', type: 1, AccountServices: [] },
      isOpen: false,
      MemberNo: $state.params.id,
      account: { totalPPMPaymentNeeded: 0, PPMPaymentLabel: "", isBelowThreshold: false },


      //Parameters: PortalParameters(),
      SmartAppConfig: {}, //PaymentContext.getSmartAppConfig().data,

      /// Collections and objects.
      AccountServices: [],

      /// Configuration Values.
      customFullscreen: $mdMedia('xs') || $mdMedia('sm'),
      dtOptions: {
        autoWidth: false, dom: 'lrtip', order: [1, 'asc'], paging: false, responsive: true, scroller: false, processing: true, info: false, language: {
          "emptyTable": "Loading",
          "zeroRecords": "No matching records found"
        },
      },

      /// Methods.
      calculateTotalPPMPaymentNeeded: CalculateTotalPPMPaymentNeeded,
      LoadForm: LoadForm,
      rephrasePPMPaymentLabel: RephrasePPMPaymentLabel,
      showPaymentScreen: showPaymentScreen,

      PortalSettings: {}, //PaymentContext.getSettings(),
      SetSmartAppConfig: SetSmartAppConfig
    });


    /// Internal Functions.
    /**
    * @ngdoc method
    * @name LoadForm
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to Load the values needed at starting time.
    */
    function LoadForm() {
      /// Load data from Context.
      $rootScope.rootscopeLoading = true;
      
      PaymentContext.getSettings().then(function (data) {
        __this.PortalSettings = data;

        __this.Parameters = PortalParameters();
      }, function (error) {

        __this.PortalSettings = {};

        __this.Parameters = PortalParameters();
      });
      
      SetSmartAppConfig();

      PaymentContext.loadPaymentService($state.params.id).then(function (data) {
        __this.AccountServices = data.data.Services;
        __this.IsPPM = data.data.IsPPM === "P";
        __this.BudgetLevelized = data.data.BillCode;

        if (data.data.ppmLabel != "" && data.data.ppmMinPayment != null) {
          __this.PPMPaymentLabel = RephrasePPMPaymentLabel(data.data.ppmLabel);
          __this.PPMPaymentNeeded = data.data.ppmMinPayment;
        }

        //#region Old Logic Threshold

        //__this.account.totalPPMPaymentNeeded = __this.calculateTotalPPMPaymentNeeded(__this.AccountServices);

        //if (data.data.IsPPM == "P" && (__this.account.totalPPMPaymentNeeded != 0.00 && __this.account.totalPPMPaymentNeeded != null)) {
        //  __this.account.isBelowThreshold = true;
        //  __this.account.PPMPaymentLabel = __this.rephrasePPMPaymentLabel(__this.AccountServices[0].PPMPaymentLabel);
        //}
        //else
        //  __this.account.isBelowThreshold = false;

        //#endregion


        //Get PPM Minimum Payment to Stay Connected, SECOND SOLUTION for MND-1251
        //for (var i = 0; i < __this.AccountServices.length; i++) {
        //  //if (__this.AccountServices[i].Balance > __this.AccountServices.DisconnectThreshold) {
        //  //  __this.AccountServices[i].PPMPaymentNeeded = (__this.AccountServices[i].Balance - __this.AccountServices.DisconnectThreshold) + 0.01;
        //  //  __this.account.isBelowThreshold = true;
        //  //}

        //  if (__this.AccountServices[i].PPMPaymentNeeded != 0.00)
        //    __this.account.isBelowThreshold = true;
        //}

        //__this.AccountServices[0].Balance = parseFloat(data.data.Services[0].Balance);
        //__this.AccountServices.PPMPaymentNeeded = parseFloat(data.data.PPMPaymentNeeded);
        //__this.AccountServices.Threshold = __this.AccountServices[0].Balance - (__this.AccountServices.PPMPaymentNeeded - 0.01);

        //console.log(__this.AccountServices[0].Balance + " > " + __this.AccountServices.Threshold + " = " + (__this.AccountServices[0].Balance - (__this.AccountServices.PPMPaymentNeeded - 0.01) == __this.AccountServices.Threshold ? true : false));

        for (var i = 0; i < __this.AccountServices.length; i++) {
          __this.AccountServices[i].MemberSep = __this.AccountServices[i].MemberSep.substr(0, __this.AccountServices[i].MemberSep.length - 3) + '-' + __this.AccountServices[i].MemberSep.substr(__this.AccountServices[i].MemberSep.length - 3);
        }

        PaymentContext.defineObject(__this.AccountServices, PaymentContext.AccountServicesObject);

        __this.AccountServices.PaymentDetails.dueDate = data.data.DueDate;
        __this.AccountServices.calculateTotalAmount();


        /// Enable functionality by parameters.
        if (__this.Parameters != undefined && __this.Parameters.FourthParameters != undefined && __this.Parameters.FourthParameters.FOURTHPARM_38 != undefined && __this.Parameters.FourthParameters.FOURTHPARM_38 == 0) {
          __this.AccountServices.showChecks();
        }
        $scope.balanceWidth = commonService.getNumericColumnWidth(__this.AccountServices, "Balance", 0, 83.92);
        $scope.pastDueWidth = commonService.getNumericColumnWidth(__this.AccountServices, "PastDue", 0, 89.6);
        $rootScope.rootscopeLoading = false;
      },
        function (error) {
          if (error) {
            if (error.status != 500) {
              __this.dtOptions.language.emptyTable = 'Unable to load records'
            }
          }

          $rootScope.rootscopeLoading = false;

          commonService.handleError(error);
          __this.AccountServices = undefined;
          $rootScope.rootscopeLoading = false;
        });
    }

    function SetSmartAppConfig() {

      for (var x = 0; x < $rootScope.smartAppConfig.length; x++) {
        if ($rootScope.smartAppConfig[x].ConfigId == '55') {
          __this.EcheckStat = $rootScope.smartAppConfig[x].Value;
        }
        else if ($rootScope.smartAppConfig[x].ConfigId == '54') {
          __this.CreditCardStat = $rootScope.smartAppConfig[x].Value;
        }
      }

    }

    /**
    * @ngdoc method
    * @name showPaymentScreen
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to popup a dialogbox with the detail of
    *                the selected services that the client want to pay.
    **/
    function showPaymentScreen(type, ev) {
      $rootScope.paymentType = type;

      /// Creating the object with the data to be loaded in payment detail.
      this.paymentData = {
        title: (type == 'CreditCard') ? "Credit Card" : "E-Check",
        type: (type == 'CreditCard') ? 1 : 2,
        AccountServices: __this.AccountServices,
        BudgetLevelized: __this.BudgetLevelized,
        IsPPM: __this.IsPPM,
        showNote: CheckCreditBalance(),
        balanceHasMillion: $scope.balanceHasMillion,
        pastDueHasMillion: $scope.pastDueHasMillion
      }
      var paymentDialog = {
        templateUrl: 'app/main/msportal/views/payment/detail/payment_detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: ($mdMedia('sm') || $mdMedia('xs')) && __this.customFullscreen,
        locals: { paymentData: __this.paymentData },
        controller: "PaymentDetailController as paymentDetail",
        onComplete: function () {
          $rootScope.$broadcast('msDialogIsOpened');
        },
        onRemoving: function () {
          $rootScope.$broadcast('msDialogIsClosed');
        }
      };
      $rootScope.rootscopeLoading = true;
      authService.CheckIsPortalEnabled(true, null, function () {
        if (type === 'ECheck') {
          GetCheckCode().then(function (response) {
            var checkCode = response.data;
            $rootScope.rootscopeLoading = false;
            if (checkCode === "01") {
              $rootScope.rootscopeLoading = false;
              $mdDialog.show(commonService.simpleAlertDialog({
                title: "E-Check Payment Error",
                message: "Payment with E-Check is not allowed. Contact your Utility for more information or pay with another method of payment.",
                buttonLabel: "Close"
              }));
              return;
            } else {
              $mdDialog.show(paymentDialog).then(function (answer) {
                __this.SelectedIndex = 0;
                LoadForm();
              }, function () { });
            }
          }, function (error) {
            commonService.handleError(error);
          });
        } else {
          $rootScope.rootscopeLoading = false;
          $mdDialog.show(paymentDialog).then(function (answer) {
            __this.SelectedIndex = 0;
            LoadForm();
          }, function () { });
        }
      });
    }

    function PortalParameters() {
      var Parameters = __this.PortalSettings.data.Response;
      Parameters['ShowConvCCFlag'] = __this.PortalSettings.data.ShowConvCCFlag;
      Parameters['ShowConvECFlag'] = __this.PortalSettings.data.ShowConvECFlag;

      return Parameters;
    }


    function CalculateTotalPPMPaymentNeeded(accountServices) {
      var total = 0;
      angular.forEach(accountServices, function (service, key) {
        total += service.PPMPaymentNeeded;
      });
      return total;
    }
    function RephrasePPMPaymentLabel(label) {
      var newLabel = "";
      if (label == "Min Payment to Stay connected:") {
        newLabel = "Minimum Payment to Stay Connected on Prepaid:";
      } else if (label == "Min Payment to Get Reconnected:") {
        newLabel = "Minimum Payment to Get Reconnected:";
      } else if (label == "Payment to Reach Min PPM Bal:") {
        newLabel = "Payment to Reach Minimum Prepaid Balance:";
      } else if (label == "Min Payment to Stay connected on PPM:") {
        newLabel = "Minimum Payment to Stay Connected on Prepaid:";
      }
      return newLabel;
    }

    function GetCheckCode() {
      var membserSep = __this.AccountServices.length > 0 ? __this.AccountServices[0].MemberSep : '';
      return genericService.post('Payments/CheckCode/' + membserSep);
    }

    function CheckCreditBalance() {
      if (__this.AccountServices.isByService) {
        return (__this.AccountServices.checkCreditBalance());
      }
      else {
        var services = __this.AccountServices;
        for (var i = 0; i < services.length; i++) {
          if (services[i].Balance < 0) {
            return true;
          }
        }
      }
    }
  };
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .factory('PaymentContext', ["genericService", "$resource", "authService", '$rootScope', 'commonService', '$state', '$cacheFactory', PaymentContext]);

  /** @ngInject
  * @ngdoc factory
  * @name PaymentContext
  * @requires genericService
  * @description Factory used to interact with Account Profile back-end.
  */
  function PaymentContext(genericService, $resource, authService, $rootScope, commonService, $state, $cacheFactory) {
    var serviceController = 'Account/Services/';
    var paymentController = 'Payments/';
    var EntitiesValidatorsURL = 'EntityValidators/';
    var __this = this;
    var httpCache = $cacheFactory.get('$http');
    var MemberNo = '';

    this.getPaymentDetail = function () {
      return this.PaymentDetailData;
    };
    this.setPaymentDetail = function (obj) {
      this.PaymentDetailData = angular.copy(obj);
    };

    return {
      Parameters: function () { return $rootScope.Parameters },
      smartAppConfig: function () { return $rootScope.smartAppConfig },
      loadPaymentService: LoadRecordsServ,
      defineObject: DefineObject,
      payBill: PayBill,
      getPaymentValidators: GetPaymentValidators,
      getSettings: GetSettings,
      getSmartAppConfig: GetSmartAppConfig,
      CCValidation: {},
      ECValidation: {},
      getCCValidation: function () {
        return this.CCValidation;
      },
      setCCValidation: function (obj) {
        this.CCValidation = angular.copy(obj);
      },

      getECValidation: function () {
        return this.ECValidation;
      },
      setECValidation: function (obj) {
        this.ECValidation = angular.copy(obj);
      },

      Decrypt: commonService.Decrypt,
      Encrypt: commonService.Encrypt,

      AccountServicesObject: {
        /// Bindings.
        isByService: false,
        allServices: false,
        memberNo: $state.params.id,
        PaymentDetails: {
          totalAmount: 0,
          convenienceFee: 0,
          totalPaymentAmount: 0,
          dueDate: '',
          totalAmountDisplay: 0,
        },

        /// Methods.
        calculateTotalAmount: CalculateTotalAmount,
        hideChecks: HideChecks,
        showChecks: ShowChecks,
        toggleAll: toggleAll,
        getSelectedService: GetSelectedService,
        getAccountDetails: GetAccountDetails,
        getAccounts: GetAccounts,
        loadConvenienceFee: LoadConvenienceFee,
        payBill: PayBill,
        checkCreditBalance: CheckCreditBalance,
      },
      deleteProfile: DeleteProfile
    }

    /// Internal functions.

    /**
    * @ngdoc API method
    * @name DefineObject
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get all the payment information from REST
    *                services and then bind the data with the local variables.
    **/
    function DefineObject(source, schema) {
      angular.extend(source, schema);
    }
    /**
    * @ngdoc API method
    * @name LoadRecordsServ
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get all the payment information from REST
    *                services and then bind the data with the local variables.
    **/
    function LoadRecordsServ(MemberNo) {
      return genericService.get(serviceController + MemberNo);
    }
    /**
    * @ngdoc method
    * @name HideChecks
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to hide checkboxes.
    **/
    function HideChecks() {
      this.isByService = false;
      this.calculateTotalAmount();
    }
    /**
    * @ngdoc method
    * @name ShowChecks
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to show checkboxes.
    **/
    function ShowChecks() {
      this.isByService = true;
      this.calculateTotalAmount();
    }
    /**
    * @ngdoc method
    * @name toggleAll
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to collective selection of checkbox controls in user interface.
    */
    function toggleAll() {
      var _this = this;

      this.forEach(function (element, index, array) {
        element.checkStatus = !_this.allServices;
      });

      this.calculateTotalAmount(true);
    }
    /**
   * @ngdoc method
   * @name CalculateTotalAmount
   * @author Juan Leon <juanl@sedata.com>
   * @description Method used to hide checkboxes.
   **/
    function CalculateTotalAmount(cameFromToggle) {
      var AmountByAccount = 0;
      var AmountByAccountDisplay = 0;
      var PastDueByAccount = 0;
      var PastDueByAccountDisplay = 0;
      var TotalAmount = 0;
      var TotalAmountDisplay = 0;
      var TotalPastDueDisplay = 0;
      var Selected = 0;
      var _this = this;
      _this.PastDueOn = false;

      if ($rootScope.Parameters.FourthParameters.FOURTHPARM_62 == 1) {
        _this.PastDueOn = true;
      }

      this.forEach(function (element, index, array) {

        // It always calculate the total of services in account even if not selected in order to compare with the selected.
        if (element.Balance > 0) {
          AmountByAccount += parseFloat(element.Balance);
          if (_this.PastDueOn) {
            PastDueByAccount += parseFloat(element.PastDue);
          }
        }
        //It is use to display total amount due in payment screen
        AmountByAccountDisplay += parseFloat(element.Balance);
        if (_this.PastDueOn) {
          PastDueByAccountDisplay += parseFloat(element.PastDue);
        }
        // It is used to create a second balance field for be changed, without changing the actual balance value.
        if (element.SubTotal == null) {
          element.SubTotal = angular.copy(element.Balance);
        }

        if (_this.isByService) {
          // It takes the selected services only.
          if (element.checkStatus) {
            Selected++;
            TotalAmount += parseFloat(element.SubTotal);
            TotalAmountDisplay += parseFloat(element.Balance);
          }
        }
      });

      // Validate if the totalAmount is by Service or by Account calculated.
      this.PaymentDetails.totalAmount = (this.isByService) ? parseFloat(TotalAmount).toFixed(2) : parseFloat(AmountByAccount).toFixed(2);
      this.PaymentDetails.totalAmountDisplay = (this.isByService) ? parseFloat(TotalAmountDisplay).toFixed(2) : parseFloat(AmountByAccountDisplay).toFixed(2);
      if (_this.PastDueOn) {
        this.PaymentDetails.totalPastDue = parseFloat(PastDueByAccount).toFixed(2);
        this.PaymentDetails.totalPastDueDisplay = parseFloat(PastDueByAccountDisplay).toFixed(2);
      }
      if (!cameFromToggle)
        this.allServices = (Selected == this.length);
    }
    /**
    * @ngdoc method
    * @name GetSelectedService
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get the data from the principal data.
    */
    function GetSelectedService() {
      var _this = this;
      var AccountServices = [];

      this.forEach(function (element, index, array) {
        if (_this.isByService) {
          //if (element.Balance > 0 && element.checkStatus) {
          if (element.checkStatus) {
            if (element.Balance < 0) {
              element.SubTotal = 0;
            }
            AccountServices.push(element);

          }
        }
        else {
          if (element.Balance < 0) {
            element.SubTotal = 0;
          }
          AccountServices.push(element);
          //}
        }
      });

      AccountServices = angular.copy(AccountServices);

      DefineObject(AccountServices, {
        /// Bindings.
        isByService: false,
        allServices: false,
        memberNo: $state.params.id,
        PaymentDetails: {
          totalAmount: 0,
          convenienceFee: 0,
          totalPaymentAmount: 0,
          dueDate: '',
          AmountByAccountDisplay: 0,
          totalAmountDisplay: 0,
        },

        /// Methods.
        calculateTotalAmount: CalculateTotalAmount,
        hideChecks: HideChecks,
        showChecks: ShowChecks,
        toggleAll: toggleAll,
        getSelectedService: GetSelectedService,
        getAccountDetails: GetAccountDetails,
        getAccounts: GetAccounts,
        loadConvenienceFee: LoadConvenienceFee,
        payBill: PayBill,
      });

      AccountServices.isByService = this.isByService;
      AccountServices.allServices = this.allServices;
      AccountServices.PaymentDetails = angular.copy(this.PaymentDetails);
      AccountServices.PaymentDetails.convenienceFee = 0.0;
      AccountServices.PaymentDetails.totalPaymentAmount = 0.0;

      return AccountServices;
    }
    /**
    * @ngdoc method
    * @name GetAccountDetails
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get the data from the principal data.
    */
    function GetAccountDetails() {
      var AccountDetails = [];

      if (this.isByService) {
        this.forEach(function (element, index, array) {
          if (!element.SubTotal) {
            element.SubTotal = 0;
          }
          AccountDetails.push({
            Amount: (element.SubTotal >= 0 ? element.SubTotal : 0),
            //Account: element.MemberSep.replace('-', ''),
            Account: element.MemberSep,
          })
        });
      }
      else {
        if (!this.PaymentDetails.totalAmount || this.PaymentDetails.totalAmount < 0) {
          this.PaymentDetails.totalAmount = 0;
        }
        AccountDetails.push({
          Amount: this.PaymentDetails.totalAmount,
          Account: this[0].MemberSep.substring(0, 8),
        })
      }

      return AccountDetails;
    }

    /**
    * @ngdoc method
    * @name GetAccountDetails
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get the data from the principal data.
    */
    function GetAccounts() {
      var Accounts = [];

      if (this.isByService) {
        this.forEach(function (element, index, array) {
          Accounts.push({
            MemberSep: element.MemberSep.replace('-', ''),
            Balance: parseFloat(element.Balance).toFixed(2),
            Status: element.Status.substring(0, 1),
            PaymentAmount: parseFloat(element.SubTotal).toFixed(2),
          });
        });
      }
      else {
        var AccountStatus;

        this.some(function (element, index, array) {
          AccountStatus = element.Status.toUpperCase();
          return element.Status.toUpperCase() === 'ACTIVE';
        });

        Accounts.push({
          MemberSep: this[0].MemberSep.substring(0, 8) + "-000",
          Balance: parseFloat(this.PaymentDetails.totalAmount).toFixed(2),
          Status: AccountStatus.substring(0, 1),
          PaymentAmount: parseFloat(this.PaymentDetails.totalAmount).toFixed(2),
        });
      }

      return Accounts;
    }

    /**
    * @ngdoc method
    * @name PayBill
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get the data from the principal data.
    */
    function PayBill(PaymentInput, PaymentType) {

      //Commented by Rovie 2/22/2017 (MND-946)
      //if (PaymentType == 'CC') {
      //    PaymentInput.CreditCardDetails.UpdateProfile = (PaymentInput.CreditCardDetails.UpdateProfile ? 1 : 0);

      //    alert("Payment Input Update Profile: " + PaymentInput.CreditCardDetails.UpdateProfile);
      //}
      //else {
      MemberNo = PaymentInput.Accounts[0].MemberSep.substr(0, 8);
      httpCache.remove($rootScope.serviceBase + serviceController + MemberNo);
      httpCache.remove($rootScope.serviceBase + 'Accounts/' + authService.authentication.CustomerID);

      if (PaymentType == "EC") {
        //TODO: ECHECK PAYMENT

        //Commented by Rovie 2/22/2017 (MND-946)
        //PaymentInput.ECheckDetails.UpdateProfile = (PaymentInput.ECheckDetails.UpdateProfile ? 1 : 0);
        PaymentInput.ECheckDetails.ZipCode = !PaymentInput.ECheckDetails.ZipCode ? '00000' : PaymentInput.ECheckDetails.ZipCode.substr(0, 5);
        if (!PaymentInput.ECheckDetails.MiddleName) {
          PaymentInput.ECheckDetails.MiddleName = genericService.nullToBlank(PaymentInput.ECheckDetails.MiddleName, false);
        }
        if (!PaymentInput.ECheckDetails.Suffix) {
          PaymentInput.ECheckDetails.Suffix = genericService.nullToBlank(PaymentInput.ECheckDetails.Suffix, false);
        }
        if (!PaymentInput.ECheckDetails.CompanyName) {
          PaymentInput.ECheckDetails.CompanyName = genericService.nullToBlank(PaymentInput.ECheckDetails.CompanyName, false);
        }
        if (!PaymentInput.ECheckDetails.EMail) {
          PaymentInput.ECheckDetails.EMail = genericService.nullToBlank(PaymentInput.ECheckDetails.EMail, false);
        }
        if (!PaymentInput.ECheckDetails.Address2) {
          PaymentInput.ECheckDetails.Address2 = genericService.nullToBlank(PaymentInput.ECheckDetails.Address2, false);
        }

      }

      ////Stringify the Object before encrypting
      //var strPaymentInput = JSON.stringify(PaymentInput);
      //var EncryptedText = commonService.Encrypt(strPaymentInput, $rootScope.CryptData.Key, $rootScope.CryptData.IV);

      //return genericService.post(paymentController, { EncryptedText: EncryptedText, Key: $rootScope.CryptData.Key, IV: $rootScope.CryptData.IV });

      var ModPaymentInput = {
        Model: PaymentInput,
        RoleType: authService.adminAuthentication.roleType,
        AdminUsername: authService.adminAuthentication.userName
      };
      return genericService.post(paymentController, ModPaymentInput);
    }
    /**
    * @ngdoc method
    * @name LoadConvenienceFee
    * @author Juan Leon <juanl@sedata.com>
    * @description Method used to get the data from the principal data.
    */
    function LoadConvenienceFee(AccountDetail, DeviceDetail, PaymentType) {
      var _this = this;

      var ConvFee = {
        AccountDetails: AccountDetail,
        DeviceDetails: DeviceDetail,
        PaymentType: PaymentType
      };
      var ModConvFee = {
        Model: ConvFee,
        RoleType: authService.adminAuthentication.roleType,
        AdminUsername: authService.adminAuthentication.userName
      };
      commonService.LoadConvFee(ModConvFee).then(function (data) {

        _this.PaymentDetails.convenienceFee = data.data.ConvenienceFee;

        if (_this.isByService) {
          _this.PaymentDetails.totalAmount = parseFloat(data.data.TotalAmount).toFixed(2);
        }

        _this.PaymentDetails.totalPaymentAmount = parseFloat(data.data.PayAmount).toFixed(2);
      }, function (errorPl) {

      });
    }


    /**
    * @ngdoc internal function
    * @name GetPaymentValidators
    * @author Juan Leon <juanl@sedata.com>
    * @param {String = entityName}  Identifier Account Number.
    * @param {String = ModeljsonModelName} The Data to be updated in the back-end.
    * @description Internal Function used to get the Model validations.
    */
    function GetPaymentValidators(entityName, jsonModelName) {
      return genericService.get(EntitiesValidatorsURL + "?entityName=" + entityName + "&jsonModelName=" + jsonModelName);
    }

    function GetSettings() {
      return genericService.get("Settings?DeviceType=WEBOS&HardwareId=");
    }

    function GetSmartAppConfig() {
      return genericService.get('SmartAppConfig/');
    }

    function DeleteProfile(paymentType) {
      if (paymentType == 'EC') {

      } else { //paymentType = CC

      }
    }

    function CheckCreditBalance() {
      var display = false;
      if (this.isByService) {
        this.forEach(function (element, index, array) {
          if (element.checkStatus) {
            if (element.Balance < 0) {
              display = true;
            }
          }
        });
      }
      return display;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.chart', ['nvd3'])
        .controller('UsageChartController', ['$state', 'genericService', '$filter', 'commonService', '$mdDialog', UsageChartController]);

    //.module('app.msportal')
    //.controller('UsageChartController', ['$state', 'genericService', '$filter', UsageChartController]);

    /** @ngInject
    * @ngdoc controller
    * @name MDM_ChartController
    * @description Controller used to interact with Usage Chart.
    */
    function UsageChartController($state, genericService, $filter, commonService, $mdDialog) {

        /// Variables.
        var vm = this;
        var serviceController = 'Account/Services/';
        var usageController = 'Usage/';
        var dataArray = [];


        /// Bindding Data.
        vm.AccountService = {};
        vm.accountServiceSelected = {};
        vm.MemberNo = $state.params.id;
        vm.progress = { activated: false };
        vm.calendarEvent = { start: "", end: "", memberSep: "" };
        vm.chartHeight = (vm.isSingleService) ? 500 : 370;
        vm.chart = {
            options: {
                chart: {
                    type: 'linePlusBarChart',
                    height: 500,
                    margin: {
                        top: 30,
                        right: 75,
                        bottom: 50,
                        left: 75
                    },
                    bars: {
                        forceY: [0]
                        , forceX: [-0.5]
                    },
                    bars2: {
                        forceY: [0]
                        , forceX: [-0.5]
                    },
                    color: ['#880000', 'darkred'],
                    x: function (d, i) { return i },
                    xAxis: {
                        axisLabel: 'Date',
                        tickFormat: function (d) {
                            var dx = vm.chart.data[0].values[d] && vm.chart.data[0].values[d].x || null;
                            if (dx) {
                                return d3.time.format('%x')(new Date(dx))
                            }
                            return null;
                        }
                    },
                    x2Axis: {
                        tickFormat: function (d) {
                            var dx = vm.chart.data[0].values[d] && vm.chart.data[0].values[d].x || 0;
                            return d3.time.format('%m-%d-%Y')(new Date(dx))
                        },
                        showMaxMin: false
                    },
                    y1Axis: {
                        axisLabel: 'kWh',
                        tickFormat: function (d) {
                            return d3.format(',f')(d);
                        },
                        axisLabelDistance: 0
                    },
                    y2Axis: {
                        axisLabel: 'Y2 Axis',
                        tickFormat: function (d) {
                            return '$' + d3.format(',.2f')(d)
                        }
                    },
                    y3Axis: {
                        tickFormat: function (d) {
                            return d3.format(',f')(d);
                        }
                    },
                    y4Axis: {
                        tickFormat: function (d) {
                            return '$' + d3.format(',.2f')(d)
                        }
                    },
                    focusEnable: false,
                    showLegend: false,
                    useInteractiveGuideline: false,
                    tooltip: {
                        contentGenerator: function (key, x, y, e, graph) {
                            return '<div class="usage-graph-tooltip" ><p><span class="color-indicator" style="background-color:' + key.color + '" ></span><strong>' + key.data.y + ' kWh</strong> (' + key.data.x + ')</p></div>';
                        }
                    }
                }
            },
            data: dataChart(),
            api: {}
        }
        vm.dateLocale = commonService.dateLocaleByDay;
        vm.dtOptions = { dom: 'lrtip', paging: false, autoWidth: true, responsive: true, scroller: false, processing: true, info: false };
        vm.flipped = false;
        vm.isSingleService = false;
        vm.statusMessage = "Please wait a minute until the data is finished loading!";
        vm.UsageRequest = {
            SearchDetails:
                {
                    ID: vm.calendarEvent.memberSep,
                    //ID: "3009001",
                    IdType: 0,
                    StartDate: vm.calendarEvent.start,
                    EndDate: vm.calendarEvent.end
                },
            Device: {
                DeviceType: "",
                HardwareId: ""
            },
            IsPPM: 0,
            IsCostEnable: "0"
        };

        /// Methods.
        /**
        * @ngdoc method
        * @name initializeChart
        * @author Juan Leon <juanl@sedata.com>
        * @description Method used to set initial date parameters and update the chart.
        */
        vm.initializeChart = function () {
            vm.progress.activated = true;
            dataArray = [];
            vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 7);
            vm.calendarEvent.end = new Date();
            vm.updateChart();
        };
        /**
        * @ngdoc method
        * @name updateChart
        * @author Juan Leon <juanl@sedata.com>
        * @description Method used to update the chart with a new data from the server.
        */
        vm.updateChart = function () {

            if (vm.calendarEvent.start > vm.calendarEvent.end) {
                showDateRangeError()
                return
            }

            vm.UsageRequest.SearchDetails.StartDate = angular.copy(vm.calendarEvent.start);
            vm.UsageRequest.SearchDetails.EndDate = vm.calendarEvent.end;
            vm.UsageRequest.SearchDetails.StartDate.setDate(vm.UsageRequest.SearchDetails.StartDate.getDate() + 1)
            vm.UsageRequest.SearchDetails.ID = vm.calendarEvent.memberSep;

            vm.progress.activated = true;

            var getChartDataPost = genericService
                .post(usageController, vm.UsageRequest)
                .then(function (pl) {
                    vm.progress.activated = false;
                    var response = pl.data;

                    dataArray = [];

                    for (var i = 0; i < response.length; i++) {
                        dataArray.push([response[i].dailyTimeStanpField, parseFloat(response[i].totalEnergyField)]);
                    }
                    vm.chart.api.updateWithData(dataChart());
                },
                function (errorPl) {
                    commonService.handleError(errorPl);
                    vm.progress.activated = false;
                    dataArray = [];
                })
        };

        function showDateRangeError() {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert(
				{
				    clickOutsideToClose: false,
				    onComplete: function () {
				        $rootScope.$broadcast('msDialogIsOpened');
				    },
				    onRemoving: function () {
				        $rootScope.$broadcast('msDialogIsClosed');
				    }
				})
				  .title('Invalid Date Range')
				  .textContent('Start Date cannot be later than End Date.')
				  .ariaLabel('Invalid Date Range')
                  .ok('Ok')
                  .multiple(true)

            return $mdDialog.show(alert);
        }

        /**
        * @ngdoc method
        * @name getServiceDetails
        * @author Juan Leon <juanl@sedata.com>
        * @description Method used to bring the list of user service.
        */
        vm.getServiceDetails = function () {
            vm.progress.activated = true;

            vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 7);
            vm.calendarEvent.end = new Date();

            genericService.get(serviceController + vm.MemberNo)
                .then(function (pl) {
                    vm.progress.activated = false;

                    vm.AccountService.Services = $filter('filter')(pl.data.Services, filterServices);

                    vm.isSingleService = (vm.AccountService.Services.length == 1);

                    vm.statusMessage = "Please select one service to check the usage by range of date.";

                    if (vm.isSingleService) {
                        vm.selectServiceFlip(vm.AccountService.Services[0]);
                        d3.select('#chart svg').style({ 'height': 500 });
                    } else {
                        d3.select('#chart svg').style({ 'height': 370 });
                    }
                },
                function (errorPl) {
                    vm.progress.activated = false;
                    vm.AccountService = {};
                    vm.flipped = false;
                })
        };
        /**
        * @ngdoc method
        * @name selectServiceFlip
        * @author Juan Leon <juanl@sedata.com>
        * @description Method used to set the service selected and load the chart with new data.
        */
        vm.selectServiceFlip = function (accountServiceSelected) {
            vm.accountServiceSelected = accountServiceSelected;
            vm.calendarEvent.memberSep = accountServiceSelected.MemberSep;
            vm.initializeChart();
            flip();
        };
        /**
        * @ngdoc method
        * @name closeChart
        * @author Juan Leon <juanl@sedata.com>
        * @description Method used to set close the chart screen and go to the List service screen.
        */
        vm.closeChart = function () {
            dataArray = [];
            vm.calendarEvent.start = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 7);
            vm.calendarEvent.end = new Date();
            vm.chart.api.updateWithData(dataChart());
            flip();
        };

        /// Internal Functions.
        /**
        * @ngdoc internal function
        * @name dataChart
        * @author Juan Leon <juanl@sedata.com>
        * @description Method used to format the data that the chart are going to use.
        **/
        function dataChart() {

            var data = [
                { "key": "Total Energy", "bar": true, "values": dataArray }
            ].map(function (series) {
                series.values = series.values.map(function (d) { return { x: d[0], y: d[1] } });
                return series;
            });

            return data;
        }
        /**
        * @ngdoc internal function
        * @name flip
        * @author Juan Leon <juanl@sedata.com>
        * @description Method used to flip the screen to front or back.
        **/
        function flip() {
            vm.flipped = !vm.flipped;
        }
        /**
        * @ngdoc internal function
        * @name filterServices
        * @author Juan Leon <juanl@sedata.com>
        * @description Method used to filter the data of serviceAccount.
        **/
        function filterServices(service) {
            //return service.Type == "00" || service.Type == "01";
            return service.Type == "00";
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('BankDraftController', BankDraftController)
    .config(['$httpProvider', function ($httpProvider) {
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    }]);

  /** @ngInject */
  function BankDraftController($scope, $state, genericService, $http, DTOptionsBuilder, $log, authService, $rootScope, commonService, $stateParams, BankDraftContext, CCValidators, ECValidators, $mdDialog, $cacheFactory, $window) {
    var serviceController = 'CCDraft/';
    var promiseGet;
    var httpCache = $cacheFactory.get('$http');
    $window.document.title = "Payment Drafts - " + document.getElementById("title").title;
    $scope.Service = {};

    var vm = this;
    vm.dateLocale = commonService.dateLocaleExpDate;
    vm.Message = '';
    vm.CCValidators = CCValidators.data;
    vm.ECValidators = ECValidators.data;
    vm.Parameters = $rootScope.Parameters;
    vm.CreditCardProfile = {};
    vm.ECheckProfile = {};
    vm.MemberNo = $state.params.id;
    vm.RoleType = authService.roleType;
    vm.CCDraftsEnabled = 0;
    vm.BankDraftsEnabled = 0;
    vm.HasExisting = false;
    vm.PassedBusinessRules = false;
    vm.FirstMemberSep = $state.params.id + '001';
    vm.ValidStatus = false;

    SetSmartAppConfig();
    LoadRecordsServ();
    authService.CheckIsPortalEnabled(true, null, null);

    String.prototype.toMask = function () {
      return String("************************" + this.substr(this.length - 4)).slice(-16);
    };

    String.prototype.padLeft = function (len, charac) {
      return Array(len - this.length + 1).join(charac || " ") + this;
    }

    String.prototype.toActualYear = function () {
      var actualYear = new Date().getFullYear().toString();
      var dataYear = this.toString();

      if (this.length == 2)
        dataYear = actualYear.substring(0, 2) + dataYear;

      return String(dataYear);
    }
    String.prototype.replaceAll = function (search, replace) {
      if (replace === undefined) {
        return this.toString();
      }
      return this.split(search).join(replace);
    }

    String.prototype.toTwoDigitsYear = function () {
      var dataYear = this.toString();

      if (this.length > 2)
        dataYear = dataYear.substring((dataYear.length - 2), dataYear.length);

      return String(dataYear);
    }

    function SetSmartAppConfig() {

      for (var x = 0; x < $rootScope.smartAppConfig.length; x++) {
        if ($rootScope.smartAppConfig[x].ConfigId == '87') {
          vm.CCDraftsEnabled = $rootScope.smartAppConfig[x].Value;
        }
        else if ($rootScope.smartAppConfig[x].ConfigId == '88') {
          vm.BankDraftsEnabled = $rootScope.smartAppConfig[x].Value;
        }
      }
    }
    function LoadRecordsServ() {

      $rootScope.rootscopeLoading = true;
      var promiseGet = genericService.get('Account/Services/' + vm.MemberNo);

      promiseGet.then(function (pl) {
        $scope.Service = pl.data;
        //vm.FirstMemberSep = $scope.Service.Services[0].MemberSep;
        for (var x = 0; x < pl.data.Services.length; x++) {
          if (pl.data.Services[x].Status.toUpperCase() == 'ACTIVE') {
            vm.FirstMemberSep = pl.data.Services[x].MemberSep;
            break;
          }
        }
        CheckValidStatus($scope.Service.Status);
        $rootScope.rootscopeLoading = false;

      },
        function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading Services', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    };

    function CheckValidStatus(status) {
      ////Uncomment code once COOPPARM_621 is coded for UPN
      //if (vm.Parameters.FourthParameters.FOURTHPARM_21 == 1) {
      //    if (status.toUpperCase() == 'INACTIVE' || status.toUpperCase() == 'ACTIVE') {
      //        vm.ValidStatus = true;
      //    }
      //    else {
      //        vm.ValidStatus = false;
      //    }
      //}
      //else {
      if (status.toUpperCase() == 'ACTIVE') {
        vm.ValidStatus = true;
      }
      else {
        vm.ValidStatus = false;
      }
      //}
    }

    function CheckPortalBusinessRules() {
      vm.Message = 'This account does not meet the requirements for this  option.';
      $rootScope.rootscopeLoading = true;

      var PortalBusinessRules = [];

      for (var x = 0; x < $rootScope.smartAppConfig.length; x++) {

        if ($rootScope.smartAppConfig[x].ConfigId == '89' && vm.draftURL != 'ccDraft.html') {
          PortalBusinessRules.push({
            Name: 'ActiveAccountSince',
            Value: $rootScope.smartAppConfig[x].Value,
            MonthsVerify: $rootScope.smartAppConfig[x].Value
          });
        }
        else if ($rootScope.smartAppConfig[x].ConfigId == '90' && vm.draftURL != 'ccDraft.html') {
          PortalBusinessRules.push({
            Name: 'BadChecks',
            Value: $rootScope.smartAppConfig[x].Value,
            MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
          });
        }
        else if ($rootScope.smartAppConfig[x].ConfigId == '92' && vm.draftURL != 'ccDraft.html') {
          PortalBusinessRules.push({
            Name: 'CutOffs',
            Value: $rootScope.smartAppConfig[x].Value,
            MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
          });
        }
        else if ($rootScope.smartAppConfig[x].ConfigId == '94' && vm.draftURL != 'ccDraft.html') {
          PortalBusinessRules.push({
            Name: 'Delinquents',
            Value: $rootScope.smartAppConfig[x].Value,
            MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
          });
        }
        //else if ($rootScope.smartAppConfig[x].ConfigId == '97' && vm.draftURL != 'ccDraft.html') {
        //    PortalBusinessRules.push({
        //        Name: 'ZeroBalance',
        //        Value: $rootScope.smartAppConfig[x].Value.trim() == 'Y' || vm.Parameters.Parameters.COOPPARM_150 == 1 ? 'Y' : 'N',
        //        MonthsVerify: 0
        //    });
        //}
        //----------FOR-CC-DRAFTS----------//
        else if ($rootScope.smartAppConfig[x].ConfigId == '98' && vm.draftURL == 'ccDraft.html') {
          PortalBusinessRules.push({
            Name: 'ActiveAccountSince',
            Value: $rootScope.smartAppConfig[x].Value,
            MonthsVerify: $rootScope.smartAppConfig[x].Value
          });
        }
        else if ($rootScope.smartAppConfig[x].ConfigId == '99' && vm.draftURL == 'ccDraft.html') {
          PortalBusinessRules.push({
            Name: 'BadChecks',
            Value: $rootScope.smartAppConfig[x].Value,
            MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
          });
        }
        else if ($rootScope.smartAppConfig[x].ConfigId == '101' && vm.draftURL == 'ccDraft.html') {
          PortalBusinessRules.push({
            Name: 'CutOffs',
            Value: $rootScope.smartAppConfig[x].Value,
            MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
          });
        }
        else if ($rootScope.smartAppConfig[x].ConfigId == '103' && vm.draftURL == 'ccDraft.html') {
          PortalBusinessRules.push({
            Name: 'Delinquents',
            Value: $rootScope.smartAppConfig[x].Value,
            MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
          });
        }
        //else if ($rootScope.smartAppConfig[x].ConfigId == '106' && vm.draftURL == 'ccDraft.html') {
        //    PortalBusinessRules.push({
        //        Name: 'ZeroBalance',
        //        Value: $rootScope.smartAppConfig[x].Value.trim() == 'Y' || vm.Parameters.Parameters.COOPPARM_150 == 1 ? 'Y' : 'N',
        //        MonthsVerify: 0
        //    });
        //}
        else if ($rootScope.smartAppConfig[x].ConfigId == '108' && vm.draftURL != 'ccDraft.html') {
          vm.Message = $rootScope.smartAppConfig[x].Value;
        }
        else if ($rootScope.smartAppConfig[x].ConfigId == '109' && vm.draftURL == 'ccDraft.html') {
          vm.Message = $rootScope.smartAppConfig[x].Value;
        }
      }

      var PBRules = {
        PortalBusinessRulesList: PortalBusinessRules,
        MemberSep: vm.FirstMemberSep,
        NotQualifiedMessage: vm.Message
      }
      var ModPBRules = {
        Model: PBRules,
        RoleType: authService.adminAuthentication.roleType,
        AdminUsername: authService.adminAuthentication.userName
      };

      var promisePost = genericService.post('PortalBusinessRules/' + 'CheckPortalBusinessRules', ModPBRules);

      promisePost.then(function (pl) {
        $rootScope.rootscopeLoading = false;
        //alert(pl.data);
        if (pl.data == '""') {
          vm.PassedBusinessRules = true;
          if (vm.draftURL == 'ccDraft.html') {
            LoadExistingCCDraft();
          }
          else {
            LoadExistingBankDraft();
          }
        }
        else {
          vm.PassedBusinessRules = false;
          vm.draftURL = '';
          if (pl.data == '"This account does not meet the requirements for this  option."') {
            DisplayMessage("Invalid Account", vm.Message, 'OK');
          }
          else {
            DisplayMessage("Error", pl.data.replaceAll('"', ''), 'OK');
          }
        }

      },
        function (errorPl) {
          vm.PassedBusinessRules = false;
          commonService.handleError(errorPl)
          $log.error('failure loading business rules', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    };
    vm.LoadData = function () {
      authService.CheckIsPortalEnabled(true, null, function () {
        CheckPortalBusinessRules();
      });
    }
    function LoadExistingBankDraft(_Form) {

      $rootScope.rootscopeLoading = true;
      var promiseGet = genericService.get('BankDraft/' + 'GetBankDraft?MemberSep=' + vm.MemberNo + '000&DraftCode=' + $scope.Service.DraftCode);

      promiseGet.then(function (pl) {
        $rootScope.rootscopeLoading = false;
        if (!!pl.data) {
          if (pl.data.PrintCode == '2' || pl.data.PrintCode == '3') {
            DisplayMessage("Payment Draft", "You have an existing credit card draft. Redirecting to credit card draft.", 'OK');
            vm.draftURL = 'ccDraft.html';
            //LoadExistingCCDraft();
            vm.LoadData();
          }
          vm.HasExisting = true;
          vm.ECheckProfile = pl.data;
        }
        else {
          vm.HasExisting = false;
        }
        if (!!_Form) {
          _Form.$aaFormExtensions.$resetChanged();
        }

      },
        function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading Services', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    };
    function LoadExistingCCDraft(_Form) {

      $rootScope.rootscopeLoading = true;
      var promiseGet = genericService.get(serviceController + 'GetCCDraft?MemberSep=' + vm.MemberNo + '000&DraftCode=' + $scope.Service.DraftCode);

      promiseGet.then(function (pl) {
        $rootScope.rootscopeLoading = false;

        if (!!pl.data) {
          if (!!pl.data.PrintCode) {
            DisplayMessage("Payment Draft", "You have an existing bank draft. Redirecting to bank draft.", 'OK');
            vm.draftURL = 'bankDraft.html';
            //LoadExistingBankDraft();
            vm.LoadData();
          }
          else {
            vm.HasExisting = true;
            vm.CreditCardProfile = pl.data;
            vm.CreditCardProfile.ExpirationDate = new Date(pl.data.CreditCardInfo.CCExpYear.toActualYear() , pl.data.CreditCardInfo.CCExpMonth, 0);
            vm.CreditCardProfile.CardType = GetNameCCType(pl.data.CardType);
            vm.CreditCardProfile.ZipCode = pl.data.CreditCardInfo.CCZipCode;
            if (vm.CreditCardProfile.ZipCode.length > 5) {
              vm.CreditCardProfile.ZipCode = vm.CreditCardProfile.ZipCode.replace("-", "");
              vm.CreditCardProfile.ZipCodeExtension = vm.CreditCardProfile.ZipCode.substr(5);
              //this.ZipCode = this.ZipCode.substr(0, 5);
            }
            vm.CreditCardProfile.CardName = pl.data.CardName; //pl.data.CreditCardInfo.NameOnCard
            vm.CreditCardProfile.CVV = pl.data.CVV2Code; //pl.data.CreditCardInfo.CCVerifCode;
            document.getElementById("cardname").value = "              " + pl.data.CreditCardInfo.NameOnCard;
            //document.getElementById("cardname").focus();
            //document.getElementById("idnameerrormsg").style.display = 'none';
          }
        }
        else {
          vm.CreditCardProfile.ExpirationDate = new Date();
          vm.HasExisting = false;

        }
        if (!!_Form) {
          _Form.$aaFormExtensions.$resetChanged();
        }

      },
        function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading Services', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    };

    vm.Delete = function (Form) {

      authService.CheckIsPortalEnabled(true, null, function () {
        confirmDelete().then(function () {
          if (vm.draftURL == 'ccDraft.html') {
            vm.Submit(Form, 'D');
            document.getElementById("cardname").value = '';
          }
          else {
            vm.SubmitBankDraft(Form, 'D');
          }

        }, function () {

        });
      });
    }
    vm.Edit = function (form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        form.$editMode = true;
      });
    }
    vm.reset = function (form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        var _Form = form;

        _Form.$aaFormExtensions.$reset().then(
          function Ok(resp) {
            if (resp) {

              if (vm.draftURL == 'ccDraft.html') {
                vm.CreditCardProfile.CardName = '';
                vm.CreditCardProfile.CardType = '';
                vm.CreditCardProfile.CCNumber = '';
                vm.CCNumberMasked = '';
                vm.CreditCardProfile.CVV = '';
                vm.CreditCardProfile.ExpirationDate = new Date();
                vm.CreditCardProfile.ZipCode = '';
                vm.CreditCardProfile = {};
                LoadExistingCCDraft(_Form);
              }
              else {
                vm.ECheckProfile.Name = '';
                vm.ECheckProfile.BankAccountNumber = '';
                vm.ECheckProfile.RoutingNumber = '';
                vm.ECheckProfile.BankName = '';
                vm.ECheckProfile.PrintCode = '';
                vm.ECheckProfile = {};
                LoadExistingBankDraft(_Form);
              }
              _Form.$editMode = false;
            }
          }
        );
      });
    }
    vm.TrimCardName = function (Form, mode) {
      var trimccname = document.getElementById("cardname").value.trim();
      document.getElementById("cardname").value = trimccname;
    }
    vm.Submit = function (Form, mode) {
      var __this = this;
      authService.CheckIsPortalEnabled(true, null, function () {
        $rootScope.rootscopeLoading = true;
        var elcardname = document.getElementById("cardname").value.trim();
        var elsecurity1draft = document.getElementById("cardsecurity1").value;
        //alert(elsecurity1draft); //Name: (__this.CreditCardProfile.CardName === undefined) ? "" : __this.CreditCardProfile.CardName,CVV: (__this.CreditCardProfile.CVV === undefined) ? "" : __this.CreditCardProfile.CVV,
        if (elcardname === undefined || elcardname == "")
          if (__this.CreditCardProfile.CardName === undefined)
            elcardname = "";
          else
            elcardname = __this.CreditCardProfile.CardName;
        var CCDetails = {
          Number: (__this.CreditCardProfile.CCNumber === undefined) ? 0 : __this.CreditCardProfile.CCNumber,
          Name: elcardname,
          Type: (__this.CreditCardProfile.CardType === undefined) ? "" : GetNumberCCType(__this.CreditCardProfile.CardType),
          ExpirationMonth: (__this.CreditCardProfile.ExpirationDate === undefined) ? "01" : (__this.CreditCardProfile.ExpirationDate.getMonth() + 1).toString().padLeft(2, "0"),
          ExpirationYear: (__this.CreditCardProfile.ExpirationDate === undefined) ? ((new Date()).getFullYear() + 1).toString().toTwoDigitsYear() : __this.CreditCardProfile.ExpirationDate.getFullYear().toString().toTwoDigitsYear(),
          ZipCode: (__this.CreditCardProfile.ZipCode === undefined) ? "" : __this.CreditCardProfile.ZipCode.substr(0, 5),
          ZipCodeExtension: (__this.CreditCardProfile.ZipCode === undefined) ? "" : (__this.CreditCardProfile.ZipCode.length > 5) ? __this.CreditCardProfile.ZipCode.substr(6) : "",
          Address1: (__this.CreditCardProfile.CCAddress1 === undefined) ? "" : __this.CreditCardProfile.CCAddress1,
          Address2: "",
          City: (__this.CreditCardProfile.CCCity === undefined) ? "" : __this.CreditCardProfile.CCCity,
          State: (__this.CreditCardProfile.CCState === undefined) ? "" : __this.CreditCardProfile.CCState,
          CVV: elsecurity1draft.padEnd(4, " "),
          UpdateProfile: (__this.CreditCardProfile.UpdateProfile === undefined) ? '0' : __this.CreditCardProfile.UpdateProfile
        };

        $scope.Service.Services = null;
        var Acct = $scope.Service;
        Acct.DueDate = Acct.DueDate.replaceAll('/', '');
        var CCDraftDetails = {
          Account: Acct,
          CreditCardDetails: CCDetails,
        };
        CCDraftDetails.Mode = mode;

        httpCache.removeAll();
        //console.log($rootScope.serviceBase + 'EntityValidators/?entityName=CreditCardProfileDTO&jsonModelName=CreditCardProfile&isForAuth=undefined');
        //httpCache.remove($rootScope.serviceBase + 'EntityValidators/?entityName=CreditCardProfileDTO&jsonModelName=CreditCardProfile&isForAuth=undefined');
        //httpCache.remove($rootScope.serviceBase + 'Account/Services/' + vm.MemberNo);
        //  httpCache.remove($rootScope.serviceBase + 'CCDraft/' + 'GetCCDraft?MemberSep=' + vm.MemberNo + '000&DraftCode=' + $scope.Service.DraftCode);
        var ModCCDraftDetails = {
          Model: CCDraftDetails,
          RoleType: authService.adminAuthentication.roleType,
          AdminUsername: authService.adminAuthentication.userName
        };

        var promisePost = genericService.post(serviceController + 'CreateCCDraft', ModCCDraftDetails);
        promisePost.then(function (pl) {
          $rootScope.rootscopeLoading = false;

          //alert(pl.data.toString());
          Form.$aaFormExtensions.$resetChanged();
          if (pl.data.toString() != '"Success"') {
            DisplayMessage(mode == 'A' ? 'Create Failed' : mode == 'U' ? 'Update Failed' : 'Delete Failed', pl.data.toString().replaceAll('"', ''), 'OK');
          }
          else {
            //LoadRecordsServ();
            Form.$editMode = false;
            if (mode == 'D') {
              vm.HasExisting = false;
              //Form.$editMode = true;
              vm.CreditCardProfile.CardName = '';
              vm.CreditCardProfile.CardType = '';
              vm.CreditCardProfile.CCNumber = '';
              vm.CCNumberMasked = '';
              vm.CreditCardProfile.CVV = '';
              vm.CreditCardProfile.ExpirationDate = new Date();
              vm.CreditCardProfile.ZipCode = '';
              vm.CreditCardProfile = {};
              //LoadExistingCCDraft(Form);
              DisplayMessage("Credit Card Draft Deleted", "Your credit card draft has been successfully deleted.", 'OK');
            }
            else if (mode == 'U') {
              DisplayMessage("Credit Card Draft Updated", "Your credit card draft has been successfully updated.", 'OK');
            } else {
              Form.$editMode = false;
              vm.HasExisting = true;
              LoadRecordsServ();
              DisplayMessage("Credit Card Draft Created", "Your credit card draft has been successfully created.", 'OK');
            }
          }
        }, function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading Services', errorPl);
          $rootScope.rootscopeLoading = false;
        })
      });
    }

    vm.GetBankName = function () {
      if (this.ECheckProfile.RoutingNumber != null) {
        var ECDetails = {
          RoutingNumber: this.ECheckProfile.RoutingNumber
        };

        $scope.Service.Services = null;
        var Acct = $scope.Service;
        Acct.DueDate = Acct.DueDate.replaceAll('/', '');

        var CCDraftDetails = {
          Account: Acct,
          ECheckDetails: ECDetails,
        };

        var promisePost = genericService.post('BankDraft/' + 'GetBankName', CCDraftDetails);

        promisePost.then(function (pl) {
          if (pl.data.toString() == '"The transit number does not exist."') {
            DisplayMessage('Invalid Transit Number', pl.data.toString().replaceAll('"', ''), 'OK');
          }
          else {
            vm.ECheckProfile.BankName = pl.data.toString().replaceAll('"', '');
          }
        },
          function (errorPl) {
            commonService.handleError(errorPl)
          })
      }
    }

    vm.SubmitBankDraft = function (Form, mode) {
      var __this = this;
      authService.CheckIsPortalEnabled(true, null, function () {
        $rootScope.rootscopeLoading = true;

        var ECDetails = {
          LastName: __this.ECheckProfile.Name,
          BankAccountNumber: __this.ECheckProfile.BankAccountNumber,
          RoutingNumber: __this.ECheckProfile.RoutingNumber,
          AccountType: __this.ECheckProfile.PrintCode
        };

        $scope.Service.Services = null;
        var Acct = $scope.Service;
        Acct.DueDate = Acct.DueDate.replaceAll('/', '');
        var CCDraftDetails = {
          Account: Acct,
          ECheckDetails: ECDetails,
        };
        CCDraftDetails.Mode = mode;

        httpCache.removeAll();
        //httpCache.remove($rootScope.serviceBase + 'EntityValidators/?entityName=ECheckProfileDTO&jsonModelName=ECheckProfile&isForAuth=undefined');
        //httpCache.remove($rootScope.serviceBase + 'Account/Services/' + vm.MemberNo);
        //  httpCache.remove($rootScope.serviceBase + 'BankDraft/' + 'GetBankDraft?MemberSep=' + vm.MemberNo + '000&DraftCode=' + $scope.Service.DraftCode);
        var ModCCDraftDetails = {
          Model: CCDraftDetails,
          RoleType: authService.adminAuthentication.roleType,
          AdminUsername: authService.adminAuthentication.userName
        };

        var promisePost = genericService.post('BankDraft/' + 'CreateBankDraft', ModCCDraftDetails);
        promisePost.then(function (pl) {
          $rootScope.rootscopeLoading = false;
          Form.$aaFormExtensions.$resetChanged();
          if (pl.data.toString() != '"Success"') {
            DisplayMessage(mode == 'A' ? 'Create Failed' : mode == 'U' ? 'Update Failed' : 'Delete Failed', pl.data.toString().replaceAll('"', ''), 'OK');
          }
          else {
            Form.$editMode = false;
            if (mode == 'D') {
              vm.HasExisting = false;
              Form.$editMode = false;
              vm.ECheckProfile.Name = '';
              vm.ECheckProfile.BankAccountNumber = '';
              vm.ECheckProfile.RoutingNumber = '';
              vm.ECheckProfile.BankName = '';
              vm.ECheckProfile.PrintCode = '';
              vm.ECheckProfile = {};
              LoadExistingBankDraft(Form);
              DisplayMessage("Bank Draft Deleted", "Your bank draft has been successfully deleted.", 'OK');
            }
            else if (mode == 'U') {
              DisplayMessage("Bank Draft Updated", "Your bank draft has been successfully updated.", 'OK');
            }
            else {
              Form.$editMode = false;
              vm.HasExisting = true;
              LoadRecordsServ();
              DisplayMessage("Bank Draft Created", "Your bank draft has been successfully created.", 'OK');
            }
          }
        }, function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading Services', errorPl);
          $rootScope.rootscopeLoading = false;
        })
      });
    }
    function confirmDelete() {
      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.confirm(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title('Delete Draft')
        .textContent('Are you sure you want to delete this draft?')
        .ariaLabel('Delete Draft')
        .ok('Yes')
        .cancel('No')
        .multiple(true);

      return $mdDialog.show(confirm);
    }

    function DisplayMessage(title, text, command) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(text)
          .ariaLabel(title)
          .ok(command));
    }
    function GetNumberCCType(typeName) {
      var typeNumber;

      switch (typeName) {
        case "visa":
          typeNumber = "01";
          break;
        case "mastercard":
          typeNumber = "02";
          break;
        case "discover":
          typeNumber = "03";
          break;
        case "amex":
          typeNumber = "04";
          break;
        default:
          typeNumber = typeName;
      }

      return typeNumber;
    }
    function GetNameCCType(typeNumber) {
      var typeName;

      switch (typeNumber) {
        case "01":
          typeName = "visa";
          break;
        case "02":
          typeName = "mastercard";
          break;
        case "03":
          typeName = "discover";
          break;
        case "04":
          typeName = "amex";
          break;
        default:
          typeName = typeNumber;
      }

      return typeName;
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.msportal')
        .factory('BankDraftContext', ["genericService", "$resource", "authService", '$rootScope', 'commonService', '$state', '$cacheFactory', BankDraftContext]);

    /** @ngInject
    * @ngdoc factory
    * @name PaymentContext
    * @requires genericService
    * @description Factory used to interact with Account Profile back-end.
    */
    function BankDraftContext(genericService, $resource, authService, $rootScope, commonService, $state, $cacheFactory) {
        var EntitiesValidatorsURL = 'EntityValidators/';
        var httpCache = $cacheFactory.get('$http');

        return {
            getValidators: GetValidators,
            CCNumberMasked: ""

        }

        function GetValidators(entityName, jsonModelName, isForAuth) {
            return genericService.get(EntitiesValidatorsURL + "?entityName=" + entityName + "&jsonModelName=" + jsonModelName + "&isForAuth=" + isForAuth);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('DepositsController', ['genericService', 'authService', '$mdDialog', '$state', '$rootScope', 'commonService', '$window', DepositsController]);

  function DepositsController(genericService, authService, $mdDialog, $state, $rootScope, commonService, $window) {
    var vm = this;
    var serviceUrl = "MemberDeposit/";
    var serviceUrlExt = 'Account/Services/';
    $window.document.title = "Deposits - " + document.getElementById("title").title;
    vm.account = $state.params.id;
    vm.depositDetails = {};

    vm.init = function () {
      authService.CheckIsPortalEnabled(true, null, function () {
        genericService.get(serviceUrl + vm.account).then(function (pl) {
          vm.depositDetails = pl.data;
          vm.consumerDepositWidth = commonService.getNumericColumnWidth(vm.depositDetails, "ConsumerDeposit", 0, 113.6);
          vm.otherDepositWidth = commonService.getNumericColumnWidth(vm.depositDetails, "OtherDeposit", 0, 86.4);

          for (var i = 0; i < vm.depositDetails.length; i++) {
            vm.depositDetails[i].MemberSep = vm.depositDetails[i].MemberSep.substr(0, vm.depositDetails[i].MemberSep.length - 3) + '-' + vm.depositDetails[i].MemberSep.substr(vm.depositDetails[i].MemberSep.length - 3);
          }
        }, function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading deposits', errorPl);
          $rootScope.rootscopeLoading = false;
        })
        genericService.get(serviceUrlExt + vm.account).then(function (pl) {
          vm.depositDetailsExt = pl.data;
        }, function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading deposits', errorPl);
          $rootScope.rootscopeLoading = false;
        })
      });
    }

    vm.dtInstance = {};

    vm.dtOptions = {
      //dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',            
      dom: 'Irtip',
      paging: false,
      autoWidth: false,
      responsive: true,
      scroller: true,
      processing: true,
      info: false, //Displays "Showing 1 to 2 of 2 entries"
      columnDefs: [
        {
          // Customer ID
          targets: 0,
          responsivePriority: 1,
          width: '10px'
        },
        {
          // Target the actions column
          targets: 8,
          responsivePriority: 1,
          filterable: false,
          sortable: false
        }

      ],
      language: {
        "emptyTable": "No records available",
        "zeroRecords": "No matching records found"
      }

      //For more options, look here: https://datatables.net/reference/option/
    }; //dtOptions
  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('DelinquentController', DelinquentController)
    .config(['$httpProvider', function ($httpProvider) {
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    }]);

  /** @ngInject */
  function DelinquentController($scope, genericService, $http, $state, DTOptionsBuilder, $log, $rootScope, $mdDialog, commonService, $cacheFactory, authService, $window) {
    var serviceController = 'Account/Services/';
    var httpCache = $cacheFactory.get('$http');
    $window.document.title = "E-Delinquent - " + document.getElementById("title").title;
    $scope.Service = {};
    $scope.MemberNo = $state.params.id;
    $scope.BillingPreferenceDesc = '';
    $scope.IsMatch = true;
    $scope.IsMatch2 = true;
    $scope.Email1_c = '';
    $scope.Email2_c = '';
    var HardwareId = '';
    $scope.ENotificationDetails = [];
    $scope.ModENotificationDetails = {};
    $scope.BillMethod = [
      { id: '00', desc: 'Paper' },
      { id: '01', desc: 'E-Delinquent' },
      { id: '02', desc: 'Paper & E-Delinquent' }];
    $scope.preventUnsavedPrompt = 'You have unsaved changes in your delinquent notice. Discard your changes?';

    LoadRecordsServ();
    authService.CheckIsPortalEnabled(true, null, null);

    function LoadRecordsServ() {

      $rootScope.rootscopeLoading = true;
      var promiseGet = genericService.get(serviceController + $scope.MemberNo);

      promiseGet.then(function (pl) {
        $scope.Service = pl.data;
        LoadBillingPreference();
      },
        function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading Services in delinquent notice', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    };

    function LoadBillingPreference() {
      httpCache.remove($rootScope.serviceBase + 'BillingPreference/' + $scope.Service.Services[0].MemberSep + '/');
      var promiseGet = genericService.get('BillingPreference/' + $scope.Service.Services[0].MemberSep + '/' + HardwareId);

      promiseGet.then(function (pl) {
        $scope.ENotificationDetails = pl.data;
        $scope.Email1_c = $scope.ENotificationDetails.Email1;
        $scope.Email2_c = $scope.ENotificationDetails.Email2;
        $rootScope.rootscopeLoading = false;
        BindBillingMethod();
      },
        function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading delinquent notice', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    };
    function BindBillingMethod() {
      if ($scope.ENotificationDetails.Code2 == '01') {
        $scope.BillingPreferenceDesc = 'E-Delinquent';
      }
      else if ($scope.ENotificationDetails.Code2 == '02') {
        $scope.BillingPreferenceDesc = 'Paper & E-Delinquent';
      }
      else {
        $scope.ENotificationDetails.Code2 = '00';
        $scope.BillingPreferenceDesc = 'Paper';
      }
    }
    var cleanUpFunc = $rootScope.$on('refreshENotifications', function (event) {
      LoadBillingPreference();
    });

    $scope.$on('$destroy', function () {
      cleanUpFunc();
    });
    //TODO: Change alerts to a more presentable dialog
    $scope.SaveBillingPreference = function (theForm) {
      authService.CheckIsPortalEnabled(true, null, function () {
        if (theForm.$valid && $scope.IsMatch2 && $scope.IsMatch) {
          $rootScope.rootscopeLoading = true;
          $scope.ENotificationDetails.MemberSep = $scope.Service.Services[0].MemberSep;
          $scope.ENotificationDetails.NotificationType = 'E-Delinquent';

          httpCache.remove($rootScope.serviceBase + 'BillingPreference/' + $scope.Service.Services[0].MemberSep + '/');
          $scope.ModENotificationDetails = {
            Model: $scope.ENotificationDetails,
            RoleType: authService.adminAuthentication.roleType,
            AdminUsername: authService.adminAuthentication.userName
          };
          var promisePut = genericService.put('BillingPreference/', $scope.Service.Services[0].MemberSep, $scope.ModENotificationDetails);

          promisePut.then(function (pl) {
            if (pl.data.Edit) {
              alertDialog('Save Failed', pl.data.Edit);
            }
            else {
              alertDialog('Save Successful', pl.data.Result);
            }

            theForm.$aaFormExtensions.$resetChanged();
            $rootScope.rootscopeLoading = false;
            $state.reload();
          },
            function (errorPl) {
              $log.error('failure updating delinquent notice', errorPl);
              $rootScope.rootscopeLoading = false;
              alertDialog('Update failed', 'Failed to update delinquent notice.');
            })
        }
        else {
          alertDialog('Invalid Input', 'Please correct your inputs with red labels and try again.');
        }
      });
    }
    $scope.CheckIfMatch = function (email, email_c, emailNo) {
      if (email && email_c) {
        if (email.toUpperCase() == email_c.toUpperCase()) {
          if (emailNo == 1) {
            $scope.IsMatch = true;
          }
          else {
            $scope.IsMatch2 = true;
          }

          return
        }
      } else if (!email && !email_c) {
        if (emailNo == 1) {
          $scope.IsMatch = true;
        }
        else {
          $scope.IsMatch2 = true;
        }

        return
      }

      if (emailNo == 1) {
        $scope.IsMatch = false;
      }
      else {
        $scope.IsMatch2 = false;
      }
    }

    function alertDialog(title, content) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .title(title)
          .textContent(content)
          .ariaLabel(title)
          .ok('Ok')
        //.targetEvent(ev)
      );
    }

    $scope.dtOptions = {
      dom: 'Irtip',
      paging: false,
      //autoWidth: false,
      responsive: true,
      scroller: false,
      processing: true,
      info: false


      //For more options, look here: https://datatables.net/reference/option/
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('ContactUsController', ['genericService', 'commonService', 'authService', '$mdDialog', '$state', '$rootScope', '$scope', '$timeout', '$interval', '$window', ContactUsController]);

  function ContactUsController(genericService, commonService, authService, $mdDialog, $state, $rootScope, $scope, $timeout, $interval, $window) {
    //alert("Contacts...");
    var serviceController = 'OfficeLocation/';
    $scope.Offices = [];
    $window.document.title = "Contact Us - " + document.getElementById("title").title;
    LoadSmartAppSettings();
    LoadOffices();
    authService.CheckIsPortalEnabled(true, null, null);

    //$scope.activated = false;

    function LoadSmartAppSettings() {
      var configserviceController = 'SmartAppConfig/';
      var promiseGet = genericService.get(configserviceController);
      $rootScope.smartAppConfig = {};

      promiseGet.then(function (pl) {
        $rootScope.smartAppConfig = pl.data;
      },
        function (errorPl) {
          console.log('failure loading Offices', errorPl);
        })

    }

    function LoadOffices() {
        var promiseGet = genericService.get(serviceController);
        showProgress();

        promiseGet.then(function (pl) {
          hideProgress();
          if (!pl.data) {
            $mdDialog.show(
              $mdDialog.alert({
                title: '<span class="badge badge-assertive">!</span> No office locations and contact details retrieved.',
                template: '',
                onComplete: function () {
                  $rootScope.$broadcast('msDialogIsOpened');
                },
                onRemoving: function () {
                  $rootScope.$broadcast('msDialogIsClosed');
                }
              })
            );
          }
          else {
            $scope.Offices = pl.data;
            $scope.SelectedOffice = $scope.Offices[0];
            for (var i = 0; i < $scope.Offices.length; i++) {
              $scope.Offices[i].Telephone = commonService.FormatPhoneNumber($scope.Offices[i].Telephone);
            }
          }

        }, function (errorPl) {
          hideProgress();
          console.log('failure loading Offices', errorPl);
        })
    }

    /// showProgress: Method used to show the progress bar
    function showProgress() {
      $scope.activated = true;
    }

    /// hideProgress: Method used to hide the progress bar
    function hideProgress() {
      $scope.activated = false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('BudgetLevelizedController', BudgetLevelizedController)
    .config(['$httpProvider', function ($httpProvider) {
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    }]);

  /** @ngInject */
  function BudgetLevelizedController($scope, $state, genericService, $http, DTOptionsBuilder, $log, authService, $rootScope, commonService, $cacheFactory, $stateParams, $window, $mdDialog) {
    var serviceController = 'BudgetLevelized/';
    var httpCache = $cacheFactory.get('$http');
    var promiseGet;
    $window.document.title = "Budget/Levelized Billing - " + document.getElementById("title").title;
    var vm = this;
    vm.dtOptions = {
      dom: 'Irtip', paging: false, scroller: false, processing: true, info: false,
      language: {
        "emptyTable": "Loading",
        "zeroRecords": "No matching records found"
      }
      //For more options, look here: https://datatables.net/reference/option/
    };
    vm.Account = {};
    vm.Message = '';
    vm.Parameters = $rootScope.Parameters;
    vm.MemberNo = $state.params.id;
    vm.RoleType = authService.roleType;
    vm.Enrolled = false;
    vm.BillingType = '00';
    vm.BudgetBillEnabled = 0;
    vm.LevelizedEnabled = 0;
    vm.InitData = LoadData;
    vm.editForm = EditForm;
    vm.cancelForm = CancelForm;
    vm.PassedBusinessRules = true;
    vm.HasExcludedService = false;
    vm.NoActiveService = false;
    vm.FirstMemberSep = $state.params.id + '001';
    vm.ReviewMonth = '00';
    vm.EnrolledServices = [];
    vm.ExcludedActiveServices = [];
    vm.ExcludedInactiveServices = [];
    vm.preventUnsavedPrompt = 'You have unsaved changes in budget/levelized billing. Discard your changes?';

    function LoadData() {
      SetSmartAppConfig();
      LoadRecordsServ();
      authService.CheckIsPortalEnabled(true, null, null);
    }

    String.prototype.toMask = function () {
      return String("************************" + this.substr(this.length - 4)).slice(-16);
    };

    String.prototype.padLeft = function (len, charac) {
      return Array(len - this.length + 1).join(charac || " ") + this;
    }

    String.prototype.toActualYear = function () {
      var actualYear = new Date().getFullYear().toString();
      var dataYear = this.toString();

      if (this.length == 2)
        dataYear = actualYear.substring(0, 2) + dataYear;

      return String(dataYear);
    }
    String.prototype.replaceAll = function (search, replace) {
      if (replace === undefined) {
        return this.toString();
      }
      return this.split(search).join(replace);
    }

    String.prototype.toTwoDigitsYear = function () {
      var dataYear = this.toString();

      if (this.length > 2)
        dataYear = dataYear.substring((dataYear.length - 2), dataYear.length);

      return String(dataYear);
    }

    function CancelForm(Form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        var _Form = Form;
        _Form.$aaFormExtensions.$reset().then(
          function Ok(resp) {
            if (resp) {
              _Form.$editMode = false;
              LoadData();
            }
          }
        );
      });
    }

    function EditForm(form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        form.$editMode = true
      });
    }

    function SetSmartAppConfig() {

      for (var x = 0; x < $rootScope.smartAppConfig.length; x++) {
        if ($rootScope.smartAppConfig[x].ConfigId == '48') {
          vm.LevelizedEnabled = $rootScope.smartAppConfig[x].Value;
        }
        else if ($rootScope.smartAppConfig[x].ConfigId == '49') {
          vm.BudgetBillEnabled = $rootScope.smartAppConfig[x].Value;
        }
      }
    }

    function LoadRecordsServ() {

      $rootScope.rootscopeLoading = true;
      var promiseGet = genericService.get('Account/Services/' + vm.MemberNo);
      httpCache.remove($rootScope.serviceBase + 'Account/Services/' + vm.MemberNo);

      promiseGet.then(function (pl) {
        vm.Account = pl.data;
        //vm.FirstMemberSep = vm.Account.Services[0].MemberSep;
        for (var x = 0; x < pl.data.Services.length; x++) {
          if (pl.data.Services[x].Status.toUpperCase() == 'ACTIVE') {
            vm.FirstMemberSep = pl.data.Services[x].MemberSep;
            break;
          }
        }
        CheckIfAllServicesAreEnrolled(pl.data.Services);
        vm.balanceWidth = commonService.getNumericColumnWidth(vm.Account.Services, "Balance", 0, 72);
        vm.amountWidth = commonService.getNumericColumnWidth(vm.Account.Services, "BudgetBillAmount", 0, 72);
        $rootScope.rootscopeLoading = false;
      },
        function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading Services', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    };

    function CheckIfAllServicesAreEnrolled(services) {
      var nbrOfServices = 0;
      var nbrOfInactiveServicesNotEnrolled = 0;
      var nbrOfActiveServices = 0;
      var nbrOfActiveServicesEnrolled = 0;
      var nbrOfActiveServicesNotEnrolled = 0;
      var countEn = 0;
      var countEx = 0;
      var countIn = 0;
      for (var x = 0; x < services.length; x++) {
        nbrOfServices++;
        if (services[x].Status.toUpperCase() == 'ACTIVE') {
          nbrOfActiveServices++;
          if (services[x].BillCode != '00') {
            nbrOfActiveServicesEnrolled++;
            vm.BillingType = services[x].BillCode;
            vm.EnrolledServices[countEn] = {
              index: countEn,
              data: services[x],
              IsCollapsed: true
            };
            countEn++;
          }
          else {
            nbrOfActiveServicesNotEnrolled++;
            vm.ExcludedActiveServices[countEx] = {
              index: countEx,
              data: services[x],
              IsCollapsed: true
            };
            countEx++;
          }
        }
        else {
          if (services[x].BillCode != '00') {
            vm.EnrolledServices[countEn] = {
              index: countEn,
              data: services[x],
              IsCollapsed: true
            };
            countEn++;
          }
          else {
            vm.ExcludedInactiveServices[countIn] = {
              index: countIn,
              data: services[x],
              IsCollapsed: true
            };
            countIn++;
          }
        }

      }
      if (nbrOfActiveServices <= 0 && vm.EnrolledServices.length <= 0) {
        vm.HasExcludedService = false;
        vm.Enrolled = false;
        vm.NoActiveService = true;
      }
      else if (nbrOfActiveServices == nbrOfActiveServicesEnrolled) {
        vm.HasExcludedService = false;
        vm.Enrolled = true;
      }
      else if (nbrOfActiveServices == nbrOfActiveServicesNotEnrolled) {
        vm.HasExcludedService = false;
        vm.Enrolled = false;
      }
      else {
        vm.HasExcludedService = true;
        vm.Enrolled = true;
      }
      //vm.CheckPortalBusinessRules();
    }
    vm.CheckPortalBusinessRules = function () {
      authService.CheckIsPortalEnabled(true, null, function () {
        vm.Message = 'This account does not meet the requirements for this  option.';
        $rootScope.rootscopeLoading = true;

        var PortalBusinessRules = [];

        for (var x = 0; x < $rootScope.smartAppConfig.length; x++) {

          if ($rootScope.smartAppConfig[x].ConfigId == '119' && vm.BillingType == '01') {
            PortalBusinessRules.push({
              Name: 'ActiveAccountSince',
              Value: $rootScope.smartAppConfig[x].Value,
              MonthsVerify: $rootScope.smartAppConfig[x].Value
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '120' && vm.BillingType == '01') {
            PortalBusinessRules.push({
              Name: 'BadChecks',
              Value: $rootScope.smartAppConfig[x].Value,
              MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '122' && vm.BillingType == '01') {
            PortalBusinessRules.push({
              Name: 'CutOffs',
              Value: $rootScope.smartAppConfig[x].Value,
              MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '124' && vm.BillingType == '01') {
            PortalBusinessRules.push({
              Name: 'Delinquents',
              Value: $rootScope.smartAppConfig[x].Value,
              MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '126' && vm.BillingType == '01') {
            PortalBusinessRules.push({
              Name: 'Drafts',
              Value: $rootScope.smartAppConfig[x].Value,
              MonthsVerify: 0
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '127' && vm.BillingType == '01') {
            PortalBusinessRules.push({
              Name: 'ZeroBalance',
              Value: $rootScope.smartAppConfig[x].Value.trim() == 'Y' || vm.Parameters.Parameters.COOPPARM_150 == 1 ? 'Y' : 'N',
              MonthsVerify: 0
            });
          }
          //----------FOR-LEVELIZED-BILLING----------//
          else if ($rootScope.smartAppConfig[x].ConfigId == '110' && vm.BillingType == '02') {
            PortalBusinessRules.push({
              Name: 'ActiveAccountSince',
              Value: $rootScope.smartAppConfig[x].Value,
              MonthsVerify: $rootScope.smartAppConfig[x].Value
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '111' && vm.BillingType == '02') {
            PortalBusinessRules.push({
              Name: 'BadChecks',
              Value: $rootScope.smartAppConfig[x].Value,
              MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '113' && vm.BillingType == '02') {
            PortalBusinessRules.push({
              Name: 'CutOffs',
              Value: $rootScope.smartAppConfig[x].Value,
              MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '115' && vm.BillingType == '02') {
            PortalBusinessRules.push({
              Name: 'Delinquents',
              Value: $rootScope.smartAppConfig[x].Value,
              MonthsVerify: $rootScope.smartAppConfig[x + 1].Value
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '117' && vm.BillingType == '02') {
            PortalBusinessRules.push({
              Name: 'Drafts',
              Value: $rootScope.smartAppConfig[x].Value,
              MonthsVerify: 0
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '118' && vm.BillingType == '02') {
            PortalBusinessRules.push({
              Name: 'ZeroBalance',
              Value: $rootScope.smartAppConfig[x].Value.trim() == 'Y' || vm.Parameters.Parameters.COOPPARM_150 == 1 ? 'Y' : 'N',
              MonthsVerify: 0
            });
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '129' && vm.BillingType == '01') {
            vm.Message = $rootScope.smartAppConfig[x].Value;
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '130' && vm.BillingType == '02') {
            vm.Message = $rootScope.smartAppConfig[x].Value;
          }
          else if ($rootScope.smartAppConfig[x].ConfigId == '128' && vm.BillingType == '01') {
            vm.ReviewMonth = $rootScope.smartAppConfig[x].Value;
          }
        }

        var PBRules = {
          PortalBusinessRulesList: PortalBusinessRules,
          MemberSep: vm.FirstMemberSep,
          NotQualifiedMessage: vm.Message
        }
        var ModPBRules = {
          Model: PBRules,
          RoleType: authService.adminAuthentication.roleType,
          AdminUsername: authService.adminAuthentication.userName
        }


        var promisePost = genericService.post('PortalBusinessRules/' + 'CheckPortalBusinessRules', ModPBRules);

        promisePost.then(function (pl) {
          $rootScope.rootscopeLoading = false;
          //alert(pl.data);
          if (pl.data == '""') {
            vm.PassedBusinessRules = true;

          }
          else {
            vm.PassedBusinessRules = false;
            if (pl.data == '"This account does not meet the requirements for this  option."') {
              DisplayMessage("Invalid Account", vm.Message, 'OK');
            }
            else {
              DisplayMessage("Error", pl.data.replaceAll('"', ''), 'OK');
            }
          }

        },
          function (errorPl) {
            vm.PassedBusinessRules = false;
            commonService.handleError(errorPl)
            $log.error('failure loading business rules', errorPl);
            $rootScope.rootscopeLoading = false;
          })
      });
    };

    vm.Submit = function (code, form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        form.$editMode = true;
        var _Form = form;
        $rootScope.rootscopeLoading = true;
        var type = code == '01' ? 'Budget Billing' : 'Levelized Billing';
        var BudgetLevelized = {
          MemberNo: vm.MemberNo,
          Code: code,
          ReviewMonth: vm.ReviewMonth,
          BeginDate: '',
          Services: vm.Account.Services,
          AnnTranFlag: 'A',
        };
        var ModBudgetLevelized = {
          Model: BudgetLevelized,
          RoleType: authService.adminAuthentication.roleType,
          AdminUsername: authService.adminAuthentication.userName
        };

        var promisePost = genericService.post(serviceController, ModBudgetLevelized);
        promisePost.then(function (pl) {
          $rootScope.rootscopeLoading = false;

          if (pl.data.toString() != '"Success"') {
            DisplayMessage('Failed', pl.data.toString().replaceAll('"', ''), 'OK');
          }
          else {
            httpCache.remove($rootScope.serviceBase + serviceController + vm.MemberNo);
            $state.go($state.current, {}, { reload: true });
            LoadData();
            _Form.$aaFormExtensions.$resetChanged();
            DisplayMessage('Successful', 'Your account has been successfully enrolled to ' + type + '!', 'OK');
          }

        }, function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading Services', errorPl);
          $rootScope.rootscopeLoading = false;
        })
      });
    }
    vm.Remove = function (form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        confirmRemove().then(function () {
          form.$editMode = false;
          var _Form = form;
          $rootScope.rootscopeLoading = true;
          var type = vm.BillingType == '01' ? 'Budget Billing' : 'Levelized Billing';
          var BudgetLevelized = {
            MemberNo: vm.MemberNo,
            Code: '00',
            ReviewMonth: '00',
            BeginDate: '00/00/00',
            Services: vm.Account.Services,
            AnnTranFlag: '',
          };
          var ModBudgetLevelized = {
            Model: BudgetLevelized,
            RoleType: authService.adminAuthentication.roleType,
            AdminUsername: authService.adminAuthentication.userName
          };

          var promisePost = genericService.post(serviceController, ModBudgetLevelized);
          promisePost.then(function (pl) {
            $rootScope.rootscopeLoading = false;

            if (pl.data.toString() != '"Success"') {
              DisplayMessage('Failed', pl.data.toString().replaceAll('"', ''), 'OK');
            }
            else {
              httpCache.remove($rootScope.serviceBase + serviceController + vm.MemberNo);
              $state.go($state.current, {}, { reload: true });
              LoadData();
              _Form.$aaFormExtensions.$resetChanged();
              DisplayMessage('Successful', 'Your account has been successfully removed from ' + type + '!', 'OK');
            }
          }, function (errorPl) {
            commonService.handleError(errorPl)
            $log.error('failure removing Budget/Levelized Billing', errorPl);
            $rootScope.rootscopeLoading = false;
          })

        }, function () {

        });
      });
    }
    function confirmRemove() {

      var BillTypeDesc = vm.BillingType == '01' ? 'Budget Billing' : 'Levelized Billing';
      var title = ('Remove ' + BillTypeDesc);
      var content = ('Are you sure you want to remove this account from ' + BillTypeDesc + '?');
      var confirm = $mdDialog.confirm(
        {
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(false)
        .title(title)
        .textContent(content)
        .ariaLabel(title)
        .ok('Yes')
        .cancel('No')
        .multiple(true);

      return $mdDialog.show(confirm);
    }

    function DisplayMessage(title, text, command) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .clickOutsideToClose(false)
          .title(title)
          .textContent(text)
          .ariaLabel(title)
          .ok(command));
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('BillPreferenceController', BillPreferenceController)
    .config(['$httpProvider', function ($httpProvider) {
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    }]);

  /** @ngInject */
  function BillPreferenceController($scope, genericService, $http, $state, DTOptionsBuilder, $log, $rootScope, $mdDialog, commonService, $cacheFactory, authService, $window) {
    var serviceController = 'Account/Services/';
    var httpCache = $cacheFactory.get('$http');
    $window.document.title = "E-Bill - " + document.getElementById("title").title;
    $scope.Service = {};
    $scope.MemberNo = $state.params.id;
    $scope.BillingPreferenceDesc = '';
    $scope.IsMatch = true;
    $scope.IsMatch2 = true;
    $scope.Email1_c = '';
    $scope.Email2_c = '';
    var HardwareId = '';
    $scope.ENotificationDetails = [];
    $scope.ModENotificationDetails = {};
    $scope.BillMethod = [
      { id: '00', desc: 'Paper' },
      { id: '01', desc: 'E-Bill' },
      { id: '02', desc: 'Paper & E-Bill' }];
    $scope.preventUnsavedPrompt = 'You have unsaved changes in your billing preferences. Discard your changes?';

    LoadRecordsServ()
    authService.CheckIsPortalEnabled(true, null, null);

    function LoadRecordsServ() {

      $rootScope.rootscopeLoading = true;
      var promiseGet = genericService.get(serviceController + $scope.MemberNo);

      promiseGet.then(function (pl) {
        $scope.Service = pl.data;
        LoadBillingPreference();
      },
        function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading Services from billing preference', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    };

    function LoadBillingPreference() {
      httpCache.remove($rootScope.serviceBase + 'BillingPreference/' + $scope.Service.Services[0].MemberSep + '/');
      var promiseGet = genericService.get('BillingPreference/' + $scope.Service.Services[0].MemberSep + '/' + HardwareId);

      promiseGet.then(function (pl) {
        $scope.ENotificationDetails = pl.data;
        $scope.Email1_c = $scope.ENotificationDetails.Email1;
        $scope.Email2_c = $scope.ENotificationDetails.Email2;
        $rootScope.rootscopeLoading = false;
        BindBillingMethod();
      },
        function (errorPl) {
          commonService.handleError(errorPl)
          $log.error('failure loading billing preference', errorPl);
          $rootScope.rootscopeLoading = false;
        })
    };
    function BindBillingMethod() {
      if ($scope.ENotificationDetails.Code1 == '01') {
        $scope.BillingPreferenceDesc = 'E-Bill';
      }
      else if ($scope.ENotificationDetails.Code1 == '02') {
        $scope.BillingPreferenceDesc = 'Paper & E-Bill';
      }
      else {
        $scope.ENotificationDetails.Code1 = '00';
        $scope.BillingPreferenceDesc = 'Paper';
      }
    }

    var cleanUpFunc = $rootScope.$on('refreshENotifications', function (event) {
      LoadBillingPreference();
    });
    $scope.$on('$destroy', function () {
      cleanUpFunc();
    });

    $scope.SaveBillingPreference = function (theForm) {
      authService.CheckIsPortalEnabled(true, null, function () {
        if (theForm.$valid && $scope.IsMatch2 && $scope.IsMatch) {
          $rootScope.rootscopeLoading = true;
          $scope.ENotificationDetails.MemberSep = $scope.Service.Services[0].MemberSep;
          $scope.ENotificationDetails.NotificationType = 'E-Bill';

          httpCache.remove($rootScope.serviceBase + 'BillingPreference/' + $scope.Service.Services[0].MemberSep + '/');
          $scope.ModENotificationDetails = {
            Model: $scope.ENotificationDetails,
            RoleType: authService.adminAuthentication.roleType,
            AdminUsername: authService.adminAuthentication.userName
          };
          var promisePut = genericService.put('BillingPreference/', $scope.Service.Services[0].MemberSep, $scope.ModENotificationDetails);

          promisePut.then(function (pl) {
            if (pl.data.Edit) {
              alertDialog('Save Failed', pl.data.Edit);
            }
            else {
              alertDialog('Save Successful', pl.data.Result);
              //$rootScope.$broadcast('refreshENotifications');
            }

            theForm.$aaFormExtensions.$resetChanged();
            $rootScope.rootscopeLoading = false;
            $state.reload();
          },
            function (errorPl) {
              $log.error('failure updating billing preference', errorPl);
              $rootScope.rootscopeLoading = false;
              alertDialog('Update failed', 'Failed to update billing preference.');
            })
        }
        else {
          //alert('Please correct your inputs with red labels and try again');
          alertDialog('Invalid Input', 'Please correct your inputs with red labels and try again.');
        }
      });
    }
    $scope.CheckIfMatch = function (email, email_c, emailNo) {
      if (email && email_c) {
        if (email.toUpperCase() == email_c.toUpperCase()) {
          if (emailNo == 1) {
            $scope.IsMatch = true;
          }
          else {
            $scope.IsMatch2 = true;
          }

          return
        }
      } else if (!email && !email_c) {
        if (emailNo == 1) {
          $scope.IsMatch = true;
        }
        else {
          $scope.IsMatch2 = true;
        }

        return
      }

      if (emailNo == 1) {
        $scope.IsMatch = false;
      }
      else {
        $scope.IsMatch2 = false;
      }
    }

    function alertDialog(title, content) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .title(title)
          .textContent(content)
          .ariaLabel(title)
          .ok('Ok')
        //.targetEvent(ev)
      );
    }

    $scope.dtOptions = {
      dom: 'Irtip',
      paging: false,
      //autoWidth: false,
      responsive: true,
      scroller: false,
      processing: true,
      info: false


      //For more options, look here: https://datatables.net/reference/option/
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('SubscriptionDetailsController', ['genericService', 'authService', '$mdDialog', '$state', '$rootScope', '$window', SubscriptionDetailsController]);

  function SubscriptionDetailsController(genericService, authService, $mdDialog, $state, $rootScope, $window) {
    var vm = this;
    var serviceUrl = "Alerts/GetSubscriptionDetailsList/";
    $window.document.title = "Alerts & Reminders - " + document.getElementById("title").title;
    vm.accountsList = authService.accountsList;
    vm.subscriptionDetails = {};
    var cid = authService.authentication.CustomerID;

    vm.getSubscriptionDetails = function () {
      genericService.get(serviceUrl + cid)
        .then(function (pl) {
          if (pl.data) {
            vm.subscriptionDetails = pl.data;
          }
        },
          function (errorpl) {
            $mdDialog.show(
              $mdDialog.alert({
                clickOutsideToClose: false,
                title: "",
                textContent: "Cannot get Subscription Details List.",
                ok: "OK",
                onComplete: function () {
                  $rootScope.$broadcast('msDialogIsOpened');
                },
                onRemoving: function () {
                  $rootScope.$broadcast('msDialogIsClosed');
                }
              })
            );
          });
    }

    vm.gotoAlertDetails = function (account) {
      $state.go('app.msportal.alerts', { account: account });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('AlertsController', ['$filter', 'genericService', 'authService', '$mdDialog', '$state', '$rootScope', 'commonService', '$cacheFactory', '$scope', '$window', AlertsController])
    .config(['$httpProvider', function ($httpProvider) {
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    }]);

  function AlertsController($filter, genericService, authService, $mdDialog, $state, $rootScope, commonService, $cacheFactory, $scope, $window) {
    var vm = this;
    var serviceUrl = "Alerts/";
    $window.document.title = "Alerts & Reminders - " + document.getElementById("title").title;
    var CID = authService.authentication.CustomerID;
    var httpCache = $cacheFactory.get('$http');
    var oldSubscriptionDetails = {};

    vm.account = $state.params.id;
    vm.subscriptionDetails = {};
    vm.providerDetails = {};
    vm.alerts = {};
    //vm.confirmEmailAddr = "";
    vm.selectedMobileProvider = "";
    vm.selectedCriteria1 = "1";
    vm.selectedCriteria6 = "1";
    vm.providerID = "";
    vm.temp = {};
    vm.ModifiedModel = {};
    vm.isNewEmail = false;
    vm.enableFlag = false;
    //var original = vm.subscriptionDetails;
    //vm.isInactive = false;
    //vm.hasPreviousAlert = false;
    vm.isTextSelected = false;
    vm.isEmailSelected = false;
    vm.textsSelected = {};
    vm.EmailsSelected = {};
    vm.hideConfirmEmail = false;
    $scope.preventUnsavedPrompt = 'You have unsaved changes in your subscription and alerts service details. Discard your changes?';

    //METHODS
    function GetCriterias() {
      // AlertIds should be filtered by AlertId instead of array index which is not fixed.
      // AlertId: 1
      var alerts = vm.temp.ListItems.Listitem;
      var alert01 = $filter("filter")(alerts, { AlertId: '01' })[0];
      if (alert01) {
        vm.selectedCriteria1 = alert01.Criteria !== "" ? alert01.Criteria : "1";
      }
      // AlertId: 12
      var alert12 = $filter("filter")(alerts, { AlertId: '12' })[0];
      if (alert12) {
        vm.selectedCriteria6 = alert12.Criteria !== "" ? alert12.Criteria : "1";
      }
    }
    function IsSubscriptionDetailsChanged() {
      var isChanged = false;
      if (angular.equals(oldSubscriptionDetails.Email, vm.temp.Email) &&
        angular.equals(oldSubscriptionDetails.Mobile, vm.temp.Mobile) &&
        angular.equals(oldSubscriptionDetails.ProviderId, vm.temp.ProviderId)) {
        isChanged = false;
      } else {
        isChanged = true;
      }
      return isChanged;
    }
    function PadLeftAlertIds(alerts) {
      // Add PadLeft 0 on Alert Id for better distinction on filtering.
      for (var i = 0; i < alerts.length; i++) {
        alerts[i].AlertId = commonService.padLeft(alerts[i].AlertId, 2, '0');
      }
    }
    function RemovePadLeftAlertIds(alerts) {
      // Remove PadLeft 0 on Alert Id to get the actual value.
      for (var i = 0; i < alerts.length; i++) {
        alerts[i].AlertId = commonService.removePadLeft(alerts[i].AlertId, '0');
      }
    }
    function SetCriterias() {
      // AlertIds should be filtered by AlertId instead of array index which is not fixed.
      // AlertId: 1
      var alerts = vm.temp.ListItems.Listitem;
      var alert01 = $filter("filter")(alerts, { AlertId: '01' })[0];
      if (alert01) {
        alert01.Criteria = vm.selectedCriteria1;
      }
      // AlertId: 12
      var alert12 = $filter("filter")(alerts, { AlertId: '12' })[0];
      if (alert12) {
        alert12.Criteria = vm.selectedCriteria6;
      }
    }

    vm.mobilePattern = (function () {
      var regexp = /^\d{3}-\d{3}-\d{4}$/;

      return {
        test: function (value) {
          return regexp.test(value);
        }
      };
    })();

    vm.emailPattern = (function () {
      var regexp = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

      return {
        test: function (value) {
          return regexp.test(value);
        }
      };
    })();

    vm.reset = function (form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        var _Form = form;

        _Form.$aaFormExtensions.$reset().then(function Ok(resp) {
          if (resp) {
            //httpCache.remove($rootScope.serviceBase + serviceUrl + vm.account);
            genericService.get(serviceUrl + vm.account).then(function (pl) {
              if (pl.data) {
                var subsDetails = JSON.parse(pl.data);
                angular.copy(subsDetails["Output"], vm.subscriptionDetails);
                vm.subscriptionDetails.Mobile = vm.subscriptionDetails.Mobile.split('-').join('');
                vm.temp = vm.subscriptionDetails;
              }
            }, function (errorPl) {
              commonService.handleError(errorPl);
              $log.error('failure reset', errorPl);
              $rootScope.rootscopeLoading = false;
            })

            vm.hideConfirmEmail = true;
            _Form.$editMode = false;
          }
        });
      });
    }

    vm.PopulateAlertDetails = function () {
      $rootScope.rootscopeLoading = true;
      authService.CheckIsPortalEnabled(true, null, function () {
        //Getting Subscription Details
        httpCache.remove($rootScope.serviceBase + serviceUrl + vm.account);
        genericService.get(serviceUrl + vm.account).then(function (pl) {
          $rootScope.rootscopeLoading = false;
          if (pl.data) {
            var subsDetails = pl.data;
            subsDetails.LowBalThreshold = parseFloat(subsDetails.LowBalThreshold).toFixed(2);
            angular.copy(subsDetails, vm.subscriptionDetails);
            vm.subscriptionDetails.Mobile = vm.subscriptionDetails.Mobile.split('-').join('');

            PadLeftAlertIds(vm.subscriptionDetails.ListItems.Listitem);

            vm.temp = vm.subscriptionDetails;
            var item = vm.subscriptionDetails.ListItems.Listitem;

            if (item[0].EnableFlag === 'A' || item[0].EnableFlag === 'B' || item[0].EnableFlag === 'P' || item[1].EnableFlag === 'W' ||
              item[1].EnableFlag === 'A' || item[1].EnableFlag === 'B' || item[1].EnableFlag === 'P' || item[2].EnableFlag === 'W' ||
              item[2].EnableFlag === 'A' || item[2].EnableFlag === 'B' || item[2].EnableFlag === 'P' || item[3].EnableFlag === 'W' ||
              item[3].EnableFlag === 'A' || item[3].EnableFlag === 'B' || item[3].EnableFlag === 'P' || item[4].EnableFlag === 'W' ||
              item[4].EnableFlag === 'A' || item[4].EnableFlag === 'B' || item[4].EnableFlag === 'P' || item[5].EnableFlag === 'W' ||
              item[5].EnableFlag === 'A' || item[5].EnableFlag === 'B' || item[5].EnableFlag === 'P' || item[6].EnableFlag === 'W') {
              vm.enableFlag = true;
            }
            else {
              vm.enableFlag = false;
            }

            GetCriterias();
            oldSubscriptionDetails = angular.copy(vm.temp);
          }
        }, function (errorPl) {
          commonService.handleError(errorPl);
          $rootScope.rootscopeLoading = false;
        })

        //Getting Mobile Providers List
        genericService.get(serviceUrl + "GetMobileProvidersList").then(function (pl) {
          if (pl.data) {
            var providersList = JSON.parse(pl.data);

            angular.copy(providersList["listItems"], vm.providerDetails);
          }
        }, function (errorPl) {
          commonService.handleError(errorPl);
          $rootScope.rootscopeLoading = false;
        })
      });
    }

    vm.addModifyAlertDetails = function (form) {
      $rootScope.rootscopeLoading = true;
      authService.CheckIsPortalEnabled(true, null, function () {
        form.$editMode = false;
        var _Form = form;
        vm.temp.ProviderId = vm.selectedMobileProvider;

        SetCriterias();
        RemovePadLeftAlertIds(vm.temp.ListItems.Listitem);

        vm.temp.LowBalThreshold = parseFloat(vm.temp.LowBalThreshold);
        httpCache.remove($rootScope.serviceBase + serviceUrl + vm.account);
        vm.ModifiedModel = {
          Model: vm.temp,
          RoleType: authService.adminAuthentication.roleType,
          AdminUsername: authService.adminAuthentication.userName
        };
        var requestUrl = '';
        var textContent = '';
        var title = '';
        if ($rootScope.Parameters.InternetParameters.INT_COOPPARM_35 === 0 && IsSubscriptionDetailsChanged() && authService.adminAuthentication.roleType !== "Admin") {
          requestUrl = "RequestSubscriptionDetailsChange/";
          textContent = "The requested changes to your Profile have been submitted to the utility for review, you will receive a confirmation email";
          title = 'Changes have been Submitted'
        } else {
          requestUrl = "ModifySubscriptionDetails/";
          textContent = "Alerts and Reminders has been updated successfully.";
          title = 'Success'
        }

        genericService.put(serviceUrl + requestUrl, vm.account, vm.ModifiedModel).then(function (pl) {
          $rootScope.rootscopeLoading = false;
          if (pl.data) {
            vm.hideConfirmEmail = true;
            vm.confirmEmail = '';

            $mdDialog.show($mdDialog.alert({
              clickOutsideToClose: false,
              title: title,
              textContent: textContent,
              ok: 'OK',
              onComplete: function () {
                $rootScope.$broadcast('msDialogIsOpened');
              },
              onRemoving: function () {
                $rootScope.$broadcast('msDialogIsClosed');
              }
            }));
          }
          _Form.$aaFormExtensions.$resetChanged();
          $state.reload();
        }, function (errorPl) {
          commonService.handleError(errorPl);
          $rootScope.rootscopeLoading = false;
        });
      });

    }

    vm.updateAlertType = function (alert, isEmail) {
      var alertType = alert.AlertType;
      var textFlag = alertType.charAt(0);
      var emailFlag = alertType.charAt(1);
      var newAlertType = "";

      if (isEmail) {
        if (emailFlag == '1')
          newAlertType = textFlag + '0';
        else
          newAlertType = textFlag + '1';
      }
      else {
        if (textFlag == '1') {
          newAlertType = '0' + emailFlag;
          //vm.isTextSelected = false;
        }
        else {
          newAlertType = '1' + emailFlag;
          //vm.isTextSelected = true;
        }
      }

      newAlertType += alertType.substr(2, alertType.length - 2);
      alert.AlertType = newAlertType;
    }

    vm.onTextSelected = function () {
      vm.isTextSelected = false;

      for (var key in vm.textsSelected) {
        //console.log('Key -' + key + ' val- ' + vm.textsSelected[key]);
        if (vm.textsSelected[key]) {
          vm.isTextSelected = true;
        }
      }
    }

    vm.onEmailSelected = function () {
      vm.isEmailSelected = false;

      for (var key in vm.EmailsSelected) {
        //console.log('Key -' + key + ' val- ' + vm.EmailsSelected[key]);
        if (vm.EmailsSelected[key]) {
          vm.isEmailSelected = true;
        }
      }
    }

    vm.updateAlertDetails = function (form) {
      $rootScope.rootscopeLoading = true;
      authService.CheckIsPortalEnabled(true, null, function () {
        $rootScope.rootscopeLoading = false;
        form.$editMode = true;
        vm.hideConfirmEmail = false;
        vm.isNewEmail = false;
      });
    }

    vm.dtInstance = {};

    vm.dtOptions = {
      //dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',            
      dom: 'Irtip',
      paging: false,
      autoWidth: false,
      responsive: true,
      scroller: true,
      processing: true,
      info: false, //Displays "Showing 1 to 2 of 2 entries"
      columnDefs: [
        {
          // Customer ID
          targets: 0,
          responsivePriority: 1,
          width: '10px'
        },
        {
          // Target the actions column
          targets: 8,
          responsivePriority: 1,
          filterable: false,
          sortable: false
        }

      ],
      language: {
        "emptyTable": "No records available",
        "zeroRecords": "No matching records found"
      }

      //For more options, look here: https://datatables.net/reference/option/
    }; //dtOptions

    vm.isNumberKey = function (evt) {
      var theEvent = evt || window.event;

      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);

      var regex = /[-0-9]|\./;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('AccountsController', AccountsController);

  /** @ngInject */
  function AccountsController($scope, $state, genericService, $http, DTOptionsBuilder, $log, authService, $rootScope, commonService, $stateParams, $window) {
    $window.document.title = "Accounts - " + document.getElementById("title").title;

    /// Variables
    var completeAccounts = {};
    var promiseGet;
    var serviceController = 'Accounts/';
    var vm = this;

    $scope.Accounts = [];
    $scope.Count = -1;

    /// Binding Data
    vm.dtInstance = {};
    vm.dtOptions = {
      dom: 'Irtip',
      paging: false,
      autoWidth: false,
      responsive: true,
      scroller: false,
      processing: true,
      info: false, //Displays "Showing 1 to 2 of 2 entries"
      columnDefs: [
        {
          // Target the id column
          targets: 0,
          responsivePriority: 1,
          width: '300px'
        },
        {
          // Target the actions column
          targets: 5,
          responsivePriority: 2,
          filterable: false
        },
        {
          // Target the actions column
          targets: 6,
          responsivePriority: 2,
          filterable: false,
          sortable: false
        }

      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#msportal-accounts-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      language: {
        "emptyTable": "No Records Available",
        "zeroRecords": "No matching records found"
      }

      //For more options, look here: https://datatables.net/reference/option/
    };
    vm.FilterStatus = function (status) {
      $scope.Accounts = [];
      vm.Accounts = [];
      AccountIndexing(completeAccounts, status);

      for (var i = 0; i < $scope.Accounts.length; i++) {
        vm.Accounts[i] = {
          index: i,
          data: $scope.Accounts[i].data.data,
          IsCollapsed: true
        };
      }
    }
    vm.PastDueOn = false;
    vm.PPM = false;
    vm.RoleType = authService.roleType;
    vm.searchFields = ['All', 'New', 'Active', 'Inactive']
    vm.selectedSearchField = 'All';
    vm.gotoProductDetail = gotoProductDetail;

    /// Initialization
    authService.CheckIsPortalEnabled(true, null, null);
    LoadRecords();


    /// Methods
    function AccountIndexing(accountList, status) {
      var count = 0;
      if (accountList && accountList.length < 1) {
        vm.dtOptions.language.emptyTable = "No records were found.";
      }
      if (accountList && accountList.length > 0) {
        for (var i = 0; i < accountList.length; i++) {
          if (accountList[i].IsPPM === 'P') {
            vm.PPM = true
            break;
          }
        }
      }
      for (var i = 0; i < accountList.length; i++) {
        if (accountList[i].BillCode) {
          vm.BudgetLevelized = true;
        }
        else {
          vm.BudgetLevelized = false;
          break;
        }
      }
      for (var i = 0; i < accountList.length; i++) {
        if (status === 'All') {
          $scope.Accounts[count] = {
            index: count,
            data: accountList[i],
            IsCollapsed: true
          };
          count++;
        }
        else if ((status === 'Active' || status === 'Active Prepaid') && (accountList[i].data.Status === 'Active' || accountList[i].data.Status === 'Active Prepaid')) {
          $scope.Accounts[count] = {
            index: count,
            data: accountList[i],
            IsCollapsed: true
          };
          count++;
        }
        else if ((status === 'Inactive' || status === 'Inactive Prepaid') && (accountList[i].data.Status === 'Inactive' || accountList[i].data.Status === 'Inactive Prepaid')) {
          $scope.Accounts[count] = {
            index: count,
            data: accountList[i],
            IsCollapsed: true
          };
          count++;
        }
        else if (status === 'New' && accountList[i].data.Status === 'New') {
          $scope.Accounts[count] = {
            index: count,
            data: accountList[i],
            IsCollapsed: true
          };
          count++;
        }
      }
    }
    /**
     * Go to product detail
     *
     * @param id
     */
    function gotoProductDetail(id, status, accountName, serviceAddress, isPPM) {
      $rootScope.rootscopeLoading = true;
      authService.CheckIsPortalEnabled(true, null, function () {
        //Check if account is registered in Alerts
        var mbrNo = id.replace(/^0+/, '') + "000";
        $rootScope.Account = id;
        $rootScope.accountStatus = status;
        $rootScope.accountName = accountName.trim();
        $rootScope.serviceAddress = serviceAddress.trim();
        $rootScope.isPPM = isPPM === "P";

        genericService.get("Alerts/GetAlertRegDetail/" + mbrNo).then(function (pl) {
          $rootScope.rootscopeLoading = false;
          $rootScope.hasAlert = pl.data.length > 0;
          $state.go('app.msportal.service_detail', { id: id, name: $rootScope.accountName, address: $rootScope.serviceAddress, reload: true })
        }, function (errorpl) {
          $rootScope.rootscopeLoading = false;
          $state.go('app.msportal.service_detail', { id: id, name: $rootScope.accountName, address: $rootScope.serviceAddress, reload: true })
        });
      });
    }
    function LoadRecords() {
      if (authService.roleType == "Admin") {
        serviceController = "Customers/";
        authService.adminAuthentication.isCalled = true;
        if (!$stateParams.CID) {
          $rootScope.showAdminToolbar = true;
          var account = {
            Username: authService.authentication.userName,
            CustomerIDNumber: authService.authentication.CustomerID
          }
          $state.go('app.msportal.accounts', { CID: account.CustomerIDNumber });
          $rootScope.$broadcast('simulateAccount', account);
        }
        else {
          authService.authentication.CustomerID = $stateParams.CID;
        }
      }

      $scope.CId = authService.authentication.CustomerID;

      $rootScope.rootscopeLoading = true;
      promiseGet = genericService.get(serviceController + $scope.CId);

      promiseGet.then(function (pl) {

        $scope.Accounts = pl.data;
        $scope.balanceWidth = commonService.getNumericColumnWidth($scope.Accounts, "Balance", 0, 72);
        $scope.pastDueWidth = commonService.getNumericColumnWidth($scope.Accounts, "PastDue", 0, 77.6);
        completeAccounts = pl.data;
        AccountIndexing(pl.data, 'All');
        $scope.Count = $scope.Accounts.length;
        vm.Accounts = $scope.Accounts;
        if ($rootScope.Parameters != undefined && $rootScope.Parameters.FourthParameters != undefined && $rootScope.Parameters.FourthParameters.FOURTHPARM_62 != undefined && $rootScope.Parameters.FourthParameters.FOURTHPARM_62 == 1) {
          vm.PastDueOn = true;
        }
        $rootScope.rootscopeLoading = false;

        authService.accountsList = pl.data;
      }, function (errorPl) {
        commonService.handleError(errorPl);
        vm.dtOptions.language.emptyTable = "Unable to retrieve records.";
        $log.error('failure loading Accounts', errorPl);
        $rootScope.rootscopeLoading = false;
      })
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.msportal')
        .controller('CustomizePortalController', ['$scope', 'genericService', 'DTOptionsBuilder', '$log', '$rootScope', 'commonService', '$timeout', '$state', CustomizePortalController]);

    /** @ngInject */
    function CustomizePortalController($scope, genericService, DTOptionsBuilder, $log, $rootScope, commonService, $timeout, $state) {
        var vm = this;
        var customerListMethod = 'Customers/'
        var testing = false;

        vm.selectedSearchField = 'Customer ID';
        vm.searchFields = ['Customer ID', 'Account Number', 'Name', 'Address']
        vm.searchKey = '';
        vm.testCustomers = [
            {
                id: '00012345',
                balance: 50.23,
                name: 'Tonald Drump'
            },
            {
                id: '00015465',
                balance: 60.23,
                name: 'Beorge Gush'
            },
            {
                id: '00084765',
                balance: 0.23,
                name: 'Barack Oh mama'
            },
            {
                id: '00074657',
                balance: 0.23,
                name: 'Let Ji'
            },
        ]; //dummy customer data
        vm.customers = [];

        vm.searchCustomers = function () {
            var _selectedSearchField = vm.selectedSearchField.replace(/ /g, '');
            //var _searchKey = vm.searchKey.replace(/ /g, '');

            //var searchUrl = customerListMethod + '?searchField=' + vm.selectedSearchField + '&keyword=' + encodeURIComponent(vm.searchKey);
            var searchUrl = customerListMethod + _selectedSearchField + '/' + encodeURIComponent(vm.searchKey);
            
            $rootScope.rootscopeLoading = true;

            if (testing) {
                $timeout(function () {
                    vm.customers = vm.testCustomers;
                    $rootScope.rootscopeLoading = false;
                }, 2000)
                return
            }

            vm.customers = [];

            var promiseGet = genericService.get(searchUrl);

            promiseGet.then(function (pl) {
                if (pl.data) {
                    $rootScope.rootscopeLoading = false;

                    if (pl.data.length == undefined) {
                        vm.customers.push(pl.data);
                    }
                    else {
                        vm.customers = pl.data;
                    }

                    if (vm.customers.length == null || vm.customers.length == 0) {
                        vm.dtOptions.language.emptyTable = "Search criteria did not match any record.";
                    }
                }
            },
            function (errorPl) {
                commonService.handleError(errorPl);
                vm.dtOptions.language.emptyTable = "Unable to retrieve records.";
                $log.error('failure loading Accounts', errorPl);
                $rootScope.rootscopeLoading = false;
            })
        }

        vm.simulateAccount = function (account) {
            $state.go('app.msportal.accounts', { CID: account.CustomerIDNumber });
            $rootScope.$broadcast('simulateAccount', account);
        }

        vm.dtOptions = {
            //dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',            
            dom: 'Irtip',
            paging: false,
            autoWidth: false,
            responsive: true,
            scroller: false,
            processing: true,
            info: false, //Displays "Showing 1 to 2 of 2 entries"
            columnDefs: [
                {
                    // Customer ID
                    targets: 0,
                    responsivePriority: 1,
                    width: '10px'
                },
                {
                    // Target the actions column
                    targets: 8,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }

            ],
            language: {
                "emptyTable": "Use the form above to search for customer records.",
                "zeroRecords": "No matching records found"
            }

            //For more options, look here: https://datatables.net/reference/option/
        }; //dtOptions
    }
})();
(function () {
  'use strict';

  angular
    .module('app.msportal')
    .controller('CustomerListController', ['$filter', '$scope', 'genericService', 'DTOptionsBuilder', '$log', '$mdDialog', '$rootScope', 'commonService', '$timeout', '$state', 'authService', '$window', '$cacheFactory', '$anchorScroll', '$location', CustomerListController]);

  /** @ngInject */
  function CustomerListController($filter, $scope, genericService, DTOptionsBuilder, $log, $mdDialog, $rootScope, commonService, $timeout, $state, authService, $window, $cacheFactory, $anchorScroll, $location) {
    $window.document.title = "Customer List - " + document.getElementById("title").title;

    $rootScope.roleType = 'admin';
    /// Variables
    var customerListMethod = 'Customers'
    var vm = this;


    /// Binding Data
    vm.accountTypes = ['Portal Accounts', 'Non-Portal Accounts', 'All'];
    vm.changeEmailConfirmation = ChangeEmailConfirmation;
    vm.customers = [];
    vm.customerSearchPattern = "9?9?9?9?9?9?9?9";
    vm.deleteUser = DeleteUser;
    vm.display = 'false';
    vm.dtOptions = {
      //dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',            
      dom: 'Irtip',
      paging: false,
      autoWidth: false,
      responsive: true,
      scroller: false,
      processing: true,
      info: false, //Displays "Showing 1 to 2 of 2 entries"
      columnDefs: [
        {
          // Customer ID
          //targets: 0,
          targets: 'col-custID',
          responsivePriority: 1,
          width: '10px'
        },
        {
          // Target the actions column
          //targets: 7,
          targets: "col-action",
          responsivePriority: 1,
          filterable: false,
          sortable: false
        }

      ],
      language: {
        "emptyTable": "No records available",
        "zeroRecords": "No matching records found"
      },
      initComplete: function () {
        CheckScrollbar();
      }
      //For more options, look here: https://datatables.net/reference/option/
    };
    vm.isLimited = true;
    vm.searchFields = ['All', 'Account Number', 'Address', 'Customer ID', 'E-mail', 'Name', 'Username'];
    vm.searchKey = '';
    vm.selectedAccountType = 'Portal Accounts';
    vm.selectedSearchField = 'All';
    vm.titlePage = 'Portal Users';


    /// Pagination Binding Data
    vm.pages = [];
    vm.recordLengths = [10, 50, 100];
    vm.selectedPage = 1;
    vm.selectedRecordsLength = 10;
    vm.totalCount = 0;
    vm.totalpages = 0;


    /// Method Binding
    vm.filter = function (type) {
      if (type === "length") {
        vm.selectedPage = 1;
      }
      if (vm.searchKey.length < 1) {
        vm.getPortalAccounts();
      }
      else {
        vm.searchCustomers();
      }
    }
    vm.filterAccountType = function () {
      vm.searchKey = '';
      if (vm.selectedAccountType === 'Non-Portal Accounts' || vm.selectedAccountType === 'All') {
        vm.display = true;
        vm.customers = [];
        vm.totalCount = 0;
        vm.titlePage = 'Customer List';

        vm.searchFields.forEach(function (element, index) {
          if (element === 'All') {
            vm.searchFields.splice(index, 1);
          }
        });
        vm.selectedSearchField = 'Customer ID';
        vm.setIsLimited();
      }
      else {
        vm.display = false;
        vm.searchFields.unshift('All');
        vm.selectedSearchField = 'All';
        vm.titlePage = 'Portal Users';
        vm.getPortalAccounts();
      }
      if (vm.selectedAccountType === 'Non-Portal Accounts') {
        vm.searchFields = ['All', 'Account Number', 'Address', 'Customer ID', 'Name'];
      }
      else {
        vm.searchFields = ['All', 'Account Number', 'Address', 'Customer ID', 'E-mail', 'Name', 'Username'];
      }
    }
    vm.getPortalAccounts = function () {
      $rootScope.rootscopeLoading = true;
      vm.customers = [];
      var searchUrl = customerListMethod + '/PortalAccounts/' + vm.selectedAccountType + '/' + vm.selectedPage + '/' + vm.selectedRecordsLength;
      $cacheFactory.get('$http').remove($rootScope.serviceBase + searchUrl);
      var promiseGet = genericService.get(searchUrl);

      promiseGet.then(function (pl) {
        $rootScope.rootscopeLoading = false;
        if (pl.data.customers.length !== 0) {
          vm.totalpages = Math.ceil(pl.data.totalCount / vm.selectedRecordsLength);
          vm.totalCount = pl.data.totalCount;
          GetPages(vm.totalpages);
          for (var i = 0; i < pl.data.customers.length; i++) {
            vm.customers[i] = {
              data: pl.data.customers[i]
            };
          }
        }
      }, function (errorPl) {
        commonService.handleError(errorPl);
        vm.dtOptions.language.emptyTable = "Unable to retrieve records.";
        $rootScope.rootscopeLoading = false;
      });
    };
    vm.goTop = function () {
      $location.hash('admin-customers');
      $anchorScroll();
    } 
    vm.init = function () {
      vm.getPortalAccounts();
      authService.CheckIsPortalEnabled(true, null, function () {
        authService.setNavigationItems();
        $rootScope.showAdminToolbar = false;
      });
    };  
    vm.ResetForm = function (Form) {
      Form.$aaFormExtensions.$resetChanged();
    };
    vm.ResetPage = function () {
      vm.selectedRecordsLength = 10;
      vm.selectedPage = 1;

      if (vm.selectedAccountType === 'Portal Accounts' && vm.selectedSearchField === 'All') {
        vm.display = false;
      }
    }
    vm.searchCustomers = function (Form) {
      $rootScope.rootscopeLoading = true;
      vm.display = true;
      var _selectedSearchField = vm.selectedSearchField.replace(/ /g, '');
      //var _searchKey = vm.searchKey.replace(/ /g, '');

      if (vm.selectedSearchField.toLowerCase() === "account number") {
        var pad = "00000000";
        vm.searchKey = pad.substring(0, pad.length - vm.searchKey.length) + vm.searchKey;
      } else if (vm.selectedSearchField.toLowerCase() === "customer id") {
        if (vm.searchKey == 0) {
          commonService.displayError('Invalid customer Id');
          $rootScope.rootscopeLoading = false;
          return;
        }
      } else if (vm.selectedSearchField.toLowerCase() === "name") {
        if (vm.searchKey == 0) {
          commonService.displayError('Invalid name');
          $rootScope.rootscopeLoading = false;
          return;
        }
      } else if (vm.selectedSearchField.toLowerCase() === "address") {
        if (vm.searchKey == 0) {
          commonService.displayError('Invalid address');
          $rootScope.rootscopeLoading = false;
          return;
        }
      } else if (vm.selectedSearchField.toLowerCase() === "username") {
        if (vm.searchKey == 0) {
          commonService.displayError('Invalid username');
          $rootScope.rootscopeLoading = false;
          return;
        }
      } else if (vm.selectedSearchField.toLowerCase() === "e-mail") {
        if (vm.searchKey == 0) {
          commonService.displayError('Invalid e-mail');
          $rootScope.rootscopeLoading = false;
          return;
        }
      }

      authService.CheckIsPortalEnabled(true, null, function () {
        vm.customers = [];
        var searchUrl = customerListMethod + '?field=' + _selectedSearchField + '&key=' + encodeURIComponent(vm.searchKey) + '&type=' + vm.selectedAccountType + '&pagenum=' + vm.selectedPage + '&pagesize=' + vm.selectedRecordsLength;
        $cacheFactory.get('$http').remove($rootScope.serviceBase + searchUrl);
        var promiseGet = genericService.get(searchUrl);

        promiseGet.then(function (pl) {
          $rootScope.rootscopeLoading = false;
          if (pl.data.length !== 0) {
            if (pl.data.length !== 0) {

              vm.totalpages = Math.ceil(pl.data.totalCount / vm.selectedRecordsLength);
              vm.totalCount = pl.data.totalCount;
              GetPages(vm.totalpages);
              for (var i = 0; i < pl.data.customers.length; i++) {
                vm.customers[i] = {
                  data: pl.data.customers[i]
                };
              }


              //if (pl.data.length == undefined) {
              //    vm.customers.push(pl.data);
              //}
              //else {
              //    vm.customers = pl.data;
              //}

              //if (!vm.customers.length || vm.customers.length <= 0) {
              //    vm.dtOptions.language.emptyTable = "Search criteria did not match any record.";
              //}
            }
          }
        }, function (errorPl) {
          commonService.handleError(errorPl);
          vm.dtOptions.language.emptyTable = "Unable to retrieve records.";
          $rootScope.rootscopeLoading = false;
        })
      });
    };
    vm.SearchOnKeyPress = function ($event, Form) {
      var key = $event.keyCode;
      if (key === 13) {
        vm.ResetPage();
        vm.searchCustomers(Form);
      }
    }
    vm.setIsLimited = function () {
      vm.searchKey = '';
      if (vm.selectedSearchField.toLowerCase() === "name" || vm.selectedSearchField.toLowerCase() === "address" || vm.selectedSearchField.toLowerCase() === "username" || vm.selectedSearchField.toLowerCase() === "e-mail") {
        vm.customerSearchPattern = "*";
        vm.isLimited = false;
      }
      else if (vm.selectedSearchField.toLowerCase() === "customer id" || vm.selectedSearchField.toLowerCase() === "account number") {
        vm.customerSearchPattern = "9?9?9?9?9?9?9?9";
        vm.isLimited = true;
      }
      else {
        vm.getPortalAccounts();
      }
    }
    vm.simulateAccount = function (account, Form) {
      $rootScope.rootscopeLoading = true;
      authService.CheckIsPortalEnabled(true, null, function () {
        $rootScope.rootscopeLoading = false;
        //authService.authentication.CustomerID = account.CustomerIDNumber;
        Form.$aaFormExtensions.$resetChanged();
        $state.go('app.msportal.accounts', { CID: account.CustomerIDNumber });
        $rootScope.$broadcast('simulateAccount', account);
      });
    };
    vm.unlockUser = function (account) {
      $mdDialog.show({
        parent: angular.element(document.querySelector('#popupContainer')),
        template:
          '<md-dialog aria-label="Unlock Account">' +
          '  <md-toolbar> <div class="md-toolbar-tools"> <h2>Unlock Account </h2> </div> </md-toolbar>' +
          '  <md-dialog-content> Are you sure you want to unlock the portal account for username <strong>' + account.Username + '</strong>? </md-dialog-content>' +
          '  <md-dialog-actions>' +
          '	   <md-button ng-click="closeDialog()" class="md-primary"> CANCEL </md-button>' +
          '    <md-button ng-click="unlockAccount()" class="md-primary"> UNLOCK </md-button>' +
          '  </md-dialog-actions>' +
          '</md-dialog>',
        controller: DialogController
      });
      function DialogController($scope, $mdDialog) {
        $scope.unlockAccount = function () {

          authService.CheckIsPortalEnabled(true, null, function () {
            authService.unlockAccount(account).then(function (response) {
              $mdDialog.show({
                parent: angular.element(document.querySelector('#popupContainer')),
                template:
                  '<md-dialog aria-label="Unlock Account">' +
                  '  <md-toolbar> <div class="md-toolbar-tools"> <h2>Portal Account Unlocked </h2> </div> </md-toolbar>' +
                  '  <md-dialog-content> The portal user account <strong>' + account.Username + '</strong> has been successfully unlocked.' +
                  '  <md-dialog-actions>' +
                  '	   <md-button ng-click="okDialog()" class="md-primary"> OK </md-button>' +
                  '  </md-dialog-actions>' +
                  '</md-dialog>',
                controller: ActionController
              });

              function ActionController($scope) {
                $scope.okDialog = function () {
                  $mdDialog.hide();
                  //window.location.reload();
                  vm.searchCustomers();
                }
              }

            }, function (err) {
              $scope.hideProgress();
              commonService.handleError(err);
            });
          }, function (err) {
            $scope.hideProgress();
            commonService.handleError(err);
          });
        }

        $scope.closeDialog = function () {
          $mdDialog.hide();
        }
      }

}

    /// Pagination Method Binding
    vm.goFirst = function () {
      vm.selectedPage = 1;
      vm.filter('pagenum');
    }
    vm.goLast = function () {
      vm.selectedPage = vm.totalpages;
      vm.filter('pagenum');
    }
    vm.goNext = function () {
      vm.selectedPage = vm.selectedPage + 1;
      vm.filter('pagenum');
    }
    vm.goPrevious = function () {
      vm.selectedPage = vm.selectedPage - 1;
      vm.filter('pagenum');
    }

    /// Methods
    function ChangeEmailConfirmation(account) {
      var user = {
        UserName: account.Username,
        NewEmailConfirmed: account.EmailConfirmed === 1 ? false : true
      };

      var dialogContent = {};
      if (user.NewEmailConfirmed) {
        dialogContent = GetDialogContent('Activate Portal Account', user);
      } else {
        dialogContent = GetDialogContent('Deactivate Portal Account', user);
      }

      $mdDialog.show(commonService.confirmDialog(dialogContent)).then(function () {
        $rootScope.rootscopeLoading = true;
        authService.CheckIsPortalEnabled(true, null, function () {
          authService.changeEmailConfirmation(user).then(function (response) {
            $rootScope.rootscopeLoading = false;
            var records = $filter("filter")(vm.customers, { Username: user.UserName });
            for (var i = 0; i < records.length; i++) {
              var index = vm.customers.indexOf(records[i]);
              vm.customers[index].EmailConfirmed = user.NewEmailConfirmed ? 1 : 0;
            }

            if (user.NewEmailConfirmed) {
              dialogContent = GetDialogContent('Portal Account Activated', user);
            } else {
              dialogContent = GetDialogContent('Portal Account Deactivated', user);
            }

            $mdDialog.show(commonService.alertDialog(dialogContent));
            vm.searchCustomers();
          }, function (error) {
            $rootScope.rootscopeLoading = false;
            commonService.handleError(error);
          });
        });
      });
    }
    function CheckScrollbar() {
      var divHeight = document.getElementById("admin-customers").clientHeight;
      var winHeight = document.getElementById("main").clientHeight;
      if (divHeight > winHeight) {
        vm.hasScroll = true;
      }
      else {
        vm.hasScroll = false;
      }
    }
    function DeleteUser(account) {
      var user = {
        UserName: account.Username,
        CustomerId: account.CustomerIDNumber
      };
      $mdDialog.show(commonService.confirmDialog(GetDialogContent('Delete Portal Account', user))).then(function () {
        $rootScope.rootscopeLoading = true;
        authService.CheckIsPortalEnabled(true, null, function () {
          authService.deleteUser(user).then(function (response) {
            $rootScope.rootscopeLoading = false;
            if (response.data.indexOf('Success') !== -1) {
              var records = $filter("filter")(vm.customers, { Username: user.UserName });
              for (var i = 0; i < records.length; i++) {
                var index = vm.customers.indexOf(records[i]);
                vm.customers.splice(index, 1);
              }

              $mdDialog.show(commonService.alertDialog(GetDialogContent('Portal Account Deleted', user)));
              vm.searchCustomers();
            }
          }, function (error) {
            $rootScope.rootscopeLoading = false;
            commonService.handleError(error);
          });
        });
      });
    }
    function GetDialogContent(title, object) {
      if (title === 'Activate Portal Account') {
        return {
          title: title,
          message: 'Are you sure you want to activate portal user account for <strong>' + object.UserName + '</strong>?',
          confirmButtonLabel: 'Activate'
        }
      } else if (title === 'Deactivate Portal Account') {
        return {
          title: title,
          message: 'Are you sure you want to deactivate portal user account for <strong>' + object.UserName + '</strong>?',
          confirmButtonLabel: 'Deactivate'
        }
      } else if (title === 'Delete Portal Account') {
        return {
          title: title,
          message: 'Are you sure you want to delete portal user account for <strong>' + object.UserName + '</strong>?',
          confirmButtonLabel: 'Delete'
        }
      } else if (title === 'Portal Account Activated') {
        return {
          title: title,
          message: 'Portal user account <strong>' + object.UserName + '</strong> has been successfully activated.'
        }
      } else if (title === 'Portal Account Deactivated') {
        return {
          title: title,
          message: 'Portal user account <strong>' + object.UserName + '</strong> has been successfully deactivated.'
        }
      } else if (title === 'Portal Account Deleted') {
        return {
          title: title,
          message: 'Portal user account <strong>' + object.UserName + '</strong> has been successfully deleted.'
        }
      }
    }
    function GetPages(totalpages) {
      vm.pages = [];
      for (var i = 1; i <= totalpages; i++) {
        vm.pages.push(i);
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.msportal')
        .factory('CustomerContext', ["genericService", "$q", CustomerContext]);

    /** @ngInject
    * @ngdoc factory
    * @name ProfileContext
    * @requires genericService
    * @description Factory used to interact with Account Profile back-end.
    */
    function CustomerContext(genericService, $q) {

        /// Variables
        var controllerMethod = 'Customers'

        ///functions
        function GetCustomerByAccountNo(acctNo) {
            var deferred = $q.defer();

            var promise = genericService.get(controllerMethod + "?field=AccountNumber&key=" + acctNo + '&type=All&pagenum=1&pagesize=100');

            promise.then(
                function (res) {
                    if (res.data.customers && res.data.customers.length > 0) {
                        deferred.resolve(res.data.customers[0])                        
                    } else {
                        deferred.reject()
                    }
                }, function (err) {
                    deferred.reject(err)
                })
            return deferred.promise
        }

        /// Service Return.
        return {
            /// Methods.
            GetCustomerByAccountNo: GetCustomerByAccountNo,

            /// Properties.
            controllerMethod: controllerMethod
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'datatables',
                'pascalprecht.translate',
                'ui.router',
                'LocalStorageModule',
				'ngMask',
                'treasure-overlay-spinner',
                'ui.utils.masks'
                //'ui.mask'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure
            // we will land to a one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure
            // we will land to a one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null,
                _flatNavigation = [];

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService, $transitions)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService, $transitions)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    $transitions.onStart({ }, function (transition)
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService, $transitions)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;
        vm.isActive = isActive;
        vm.goToState = goToState;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $transitions.onSuccess({ }, function (transition)
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }

        function goToState(node) {
            if ($state.current.name !== node.state) {
               $state.go(node.state, node.stateParams);
            }
        }

        function isActive(stateName) {
            return $state.current.name === stateName;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $transition.onSuccess({ }, function (transition)
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController($transitions)
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService, $transitions)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $transitions.onSuccess({ }, function (transition)
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {

            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {

            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {

            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }

    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {

                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    var refTop = Math.min.apply(Math, referenceArr);

                    var column = referenceArr.indexOf(refTop);

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});

                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }

                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    /* Directive Used to control the flip animation function */
    angular
        .module('app.core')
        .directive("flipper", function () {
            return {
                restrict: "E",
                template: "<div class='flipper' ng-transclude ng-class='{ flipped: flipped }'></div>",
                transclude: true,
                scope: {
                    flipped: "="
                }
            };
        })
        .directive("front", function () {
            return {
                restrict: "E",
                template: "<div class='front tile' ng-transclude></div>",
                transclude: true
            };
        })
        .directive("back", ['$window', '$compile', function ($window, $compile) {
            return {
                restrict: "E",
                template: "<div class='{{backController.dynamicClass}}' ng-transclude></div>",
                transclude: true,
                controller: function ($window) {

                    var userAgent = $window.navigator.userAgent;

                    var browsers = { chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i };
                    var keyAccepted = 'unknown';

                    for (var key in browsers) {
                        if (browsers[key].test(userAgent)) {
                            keyAccepted = key;
                            break;
                        }
                    };

                    if (keyAccepted == "unknown") {
                        this.dynamicClass = "back_IE tile";
                    } else {
                        this.dynamicClass = "back tile";
                    }

                },
                controllerAs: "backController"
            }
        }]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('aa.formExtensions')
      .directive('aaUiListBox', ['$compile', aaUiSelect2])
      .filter('startsWith', function() {
          return function(array,search) {
              //if(!_.isUndefined(array) && !_.isUndefined(search)) {
                  var matches = [];
                  for (var i = 0; i < array.length; i++) {
                      if (array[i].Name.toUpperCase().indexOf(search.toUpperCase()) === 0 &&
                          search.length <= array[i].Name.length) {
                          matches.push(array[i]);
                      }
                  }
                  return matches;
              //}
          };
      });

    function startsWith(actual, expected) {
        alert();
        var lowerStr = (actual + "").toLowerCase();
        return lowerStr.indexOf(expected.toLowerCase()) === 0;
    }

    /** Private directive that represents a list of months inside the calendar. */
    function aaUiSelect2($compile) {
        return {
            restrict: 'A',
            replace: true,
            scope: true,
            template: '<div></div>',
            
            //controller: CalendarMonthCtrl,
            //controllerAs: 'monthCtrl',
            //bindToController: true,
            link: function (scope, element, attrs, controllers) {
                // append the collection directive to this element
                attrs.aaUiListBox = attrs.aaUiListBox.replaceAll("\"", "").replaceAll("'", "\"");
                var listFunction = attrs.ngModel.split(".")[0];
                var options = JSON.parse(attrs.aaUiListBox);
                var required = '>';
                //var required = (attrs.required) ? ' required="required" required-msg="' + attrs.requiredMsg + '">' : '>';
                //element.append(
                //'<ui-select ng-model=' + attrs.ngModel + ' ng-disabled="' + attrs.ngDisabled + '" name="' + attrs.name + '" aa-val-msg="' + attrs.aaValMsg + '" class="' + attrs.class + '" id="' + element[0].id + '"' + required +
                //   '<ui-select-match placeholder="">{{$select.selected.' + options.text + '}}</ui-select-match>' +
                //   '<ui-select-choices style="max-height:60px !important; height:60px !important; overflow-y: visible; position: relative !important;" repeat="item.' + options.value + ' as item in ' + listFunction + '.' + options.data + ' | filter: $select.search" position="up">' +
                //         '<div ng-bind="item.' + options.text + '"></div>' +
                //         //'<div ng-bind="item.' + options.text + ' | highlight: $select.search"></div>' +
                //   '</ui-select-choices>' +
                //'</ui-select>');
                element.append(
               '<ui-select ng-model=' + attrs.ngModel + ' ng-disabled="' + attrs.ngDisabled + '" name="' + attrs.name + '" aa-val-msg="' + attrs.aaValMsg + '" class="' + attrs.class + '" id="' + element[0].id + '"' + required +
                  //'<ui-select-match placeholder="">{{$select.selected.' + options.text + '}}</ui-select-match>' +
                  '<ui-select-match placeholder="">{{$select.selected.' + options.text + '}}</ui-select-match>' +
                  '<ui-select-choices style="-ms-overflow-style: scrollbar; max-height:85px !important; height:85px !important;" repeat="item.' + options.value + ' as item in ' + listFunction + '.' + options.data + ' | startsWith : $select.search" position="down">' +
                        '<div ng-bind="item.' + options.text + '"></div>' +
                        //'<div ng-bind-html="item.' + options.text + ' | highlight: $select.search"></div>' +
                  '</ui-select-choices>' +
               '</ui-select>');

                element.removeAttr('ng-model');
                element.removeAttr('required');
                element.removeAttr('required-msg');
                element.removeAttr('aa-ui-list-box');
                element.removeAttr('ng-disabled');
                element.removeAttr('name');
                element.removeAttr('aa-label');
                element.removeAttr('aa-val-msg');
                element.removeAttr('class');
                element.removeAttr('type');
                element.removeAttr('id');
                
                // we need to tell angular to render the directive
                $compile(element.contents())(scope);
            }
        };
    }

})();


String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('cryptoField', ['$compile', 'commonService', '$parse', cryptoFieldDirective]);

    /** @ngInject */
    function cryptoFieldDirective($compile, commonService, $parse) {
        return {
            priority: 1,
            require: '^ngModel',
            restrict: 'A',
            scope: true,
            compile: function (tElem, tAttrs) {
                return {
                    post: function (scope, element, attrs, controllers) {
                        //console.log(': pre link');
                        var __element = element;
                        var maskedValue = $parse(attrs.maskedValue);
                        var inputType = attrs.type;
                        var inputName = attrs.name;

                        scope.$$parent = {};
                        scope.$$parent.ClearValue = "";
                        attrs.cryptoField = attrs.cryptoField.split(" ").join("");
                        attrs.cryptoField = attrs.cryptoField.split("'").join("");
                        attrs.cryptoField = attrs.cryptoField.split("{").join("");
                        attrs.cryptoField = attrs.cryptoField.split("}").join("");
                        scope.$$parent.field = attrs.cryptoField;
                        scope.$$parent.isValid = false;


                        String.prototype.toMask = function (number) {
                            if (!number)
                                number = parseInt("-16");
                            else 
                                number = parseInt("-" + number);

                            return String("************************" + this.substr(this.length - 4)).slice(number);
                        };

                        var fieldKey = scope.$$parent.field.split(",")[0].split(":")[1];
                        var fieldIv = scope.$$parent.field.split(",")[1].split(":")[1];

                        controllers.$formatters.push(function (value) {
                            var decrypted;

                            if (value != undefined) {

                                var encrypted = value.split("-")[1];
                                scope.$$parent.ClearValue = commonService.Decrypt(encrypted, fieldKey, fieldIv);

                                if (maskedValue != undefined && maskedValue.assign != undefined) {
                                    if (inputType != "password" && inputName != "emailE" && inputName != "usernameE" && inputName != "emailConfirm") {
                                        maskedValue.assign(scope.$parent, scope.$$parent.ClearValue.toMask());
                                        }
                                }


                                decrypted = scope.$$parent.ClearValue;
                            }

                            return decrypted;
                        });

                        controllers.$parsers.push(function (value) {
                            
                            var encrypted = "";
                            scope.$$parent.isValid = true;
                            scope.$$parent.ClearValue = value;

                            if (maskedValue != undefined && maskedValue.assign != undefined) {
                                if (inputType != "password" && inputName != "emailE" && inputName != "usernameE" && inputName != "emailConfirm") {
                                    maskedValue.assign(scope.$parent, scope.$$parent.ClearValue.toMask());
                                }
                            }

                            if (inputType != "password" && inputName != "emailE" && inputName != "usernameE" && inputName != "emailConfirm") {
                                encrypted = "*-" + commonService.Encrypt(value.replace(/\D/g, ''), fieldKey, fieldIv);
                            }
                            else {
                                encrypted = "*-" + commonService.Encrypt(value, fieldKey, fieldIv);
                            }

                            return encrypted;
                        });

                        element.removeAttr('crypto-field');

                        element.bind("focus", function (ele) {
                            if (!controllers.$dirty) {
                                scope.$$parent.isValid = true;
                            }
                            ele.currentTarget.value = scope.$$parent.ClearValue;
                        });

                        element.bind("blur", function (ele) {
                            if (ele.currentTarget.value != "" && scope.$$parent.isValid) {
                                if (inputType != "password" && inputName != "emailE" && inputName != "usernameE" && inputName != "emailConfirm") {
                                    ele.currentTarget.value = scope.$$parent.ClearValue.toMask();
                                }
                            }
                        });


                        element.bind("cut copy paste", function (ele) {
                            ele.preventDefault();
                        });

                    },
                    pre: function (scope, element, attrs, controllers) {

                        controllers.$formatters.push(function (value) {
                            var returnValue;

                            if (value != undefined)
                                returnValue = value.toMask(5);

                            return returnValue;
                        });

                        controllers.$parsers.push(function (value) {
                            
                            if (controllers.$dirty) {
                                scope.$$parent.ClearValue = value;
                                scope.$$parent.isValid = false;
                            }

                            return value;
                        });
                    }
                }
            }

        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/auth/login/login.html',
                    controller: 'LoginController as vm'                  
                },
                'content@app.LoginValidationError': {
                    templateUrl: 'app/auth/login/ErrorPage.html',
                    controller: 'LoginController as vm'
                }

            },
            resolve: {
                Validator: ["authService", function (authService) {
                    return authService.getEntityValidators('LoginBindingModel', 'loginData')
                }]
            },
            bodyClass: 'login',
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        })
        .state('app.LoginValidationError', {
            url: '/auth/login/:ErrorMessage',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.LoginValidationError': {
                    templateUrl: 'app/auth/login/ErrorPage.html',
                    controller: 'LoginController as vm'
                }

            },
            bodyClass: 'login',
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        })

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/login');

        //// Navigation
        //msNavigationServiceProvider.saveItem('auth', {
        //    title : 'Authentication',
        //    icon  : 'icon-lock',
        //    weight: 1
        //});

        //msNavigationServiceProvider.saveItem('auth.login', {
        //    title : 'Login',
        //    state : 'app.pages_auth_login',
        //    weight: 1
        //});
    }

})();
'use strict';
angular.module('app.auth.login')
    .factory('tokensManagerService', ['$http', 'ngAuthSettings', function ($http, ngAuthSettings) {

    var serviceBase = ngAuthSettings.apiServiceBaseUri;
    
    var tokenManagerServiceFactory = {};

    var _getRefreshTokens = function () {

        return $http.get(serviceBase + 'api/refreshtokens').then(function (results) {
            return results;
        });
    };

    var _deleteRefreshTokens = function (tokenid) {

        return $http.delete(serviceBase + 'api/refreshtokens/?tokenid=' + tokenid).then(function (results) {
            return results;
        });
    };

    tokenManagerServiceFactory.deleteRefreshTokens = _deleteRefreshTokens;
    tokenManagerServiceFactory.getRefreshTokens = _getRefreshTokens;

    return tokenManagerServiceFactory;

}]);
(function () {

  'use strict';


  /**
   * Main module of the Fuse
   */
  angular
    .module('fuse', [

      // Core
      'app.core',

      // Navigation
      'app.navigation',

      // Toolbar
      'app.toolbar',

      // Quick panel
      'app.quick-panel',

      // MND-422  Add Accounts List application
      'app.msportal',

      //Auth
      'app.auth.login',

      //Auth Admin
      'app.auth.adminLogin',

      //Forgot Password
      'app.auth.forgot-password',

      //Auth.ResetPassword
      'app.auth.changePassword',

      //Auth.ChangeUserName
      'app.auth.changeUserName',

      //Auth.Forgot User Name
      'app.auth.forgotUserName',

      // Change email
      'app.auth.changeEmail',
      'app.auth.confirmChangeEmail',

      //Register
      'app.auth.register',

      //Admin
      //'app.admin',

      'app.auth.reset-password',

      'app.auth.confirm-user',

      'app.auth.reset-user',

      'app.chart',

      'app.chartdaily',

      'app.chartinterval',

      'app.chartmonthly',

      //Utility Contact Information
      'app.utility.contact',

      //Utility Location
      'app.utility.location',

      'xeditable',

      'angularPayments',

      'aa.formExtensions',

      'aa.formExternalConfiguration',

      'aa.notify',

      'ngSanitize',

      'ui.select',

      'ngIdle',

      'ui.mask'
    ])

    //TODO: This service should be move to its own "service" file
    // MND-422  Add Service for data retrieval
    .service('genericService', ['$http', '$rootScope', '$cacheFactory', function ($http, $rootScope, $cacheFactory) {

      var serviceBase = '/Sedc.Multiservice.Consumer.WebApi/api/';
      //var serviceBase = 'https://10.1.0.57/Sedc.Multiservice.Consumer.WebApi/api/'; //DevV14
      //var serviceBase = 'https://10.1.0.58/Sedc.Multiservice.Consumer.WebApi/api/'; //QCV14
      //var serviceBase = 'https://10.204.0.44/Sedc.Multiservice.Consumer.WebApi/api/'; //DevV15
      //var serviceBase = 'https://10.204.0.45/Sedc.Multiservice.Consumer.WebApi/api/'; //QCV15
      //var serviceBase = 'http://localhost:59559/api/';

      $rootScope.serviceBase = serviceBase;
      var httpCache = $cacheFactory.get('$http');

      //REVIEW: Methods: Pascal Case
      this.get = function (url) {
        return $http.get(serviceBase + url, { cache: true });
      }

      this.post = function (url, obj) {
        httpCache.remove(serviceBase + url);
        return $http.post(serviceBase + url, obj, { cache: false });
      };

      this.put = function (url, objId, obj) {
        httpCache.remove(serviceBase + url + objId);
        return $http.put(serviceBase + url + objId, obj, { cache: false });
      }

      this.nullToBlank = function (possibleNull, withComma) {
        if (!possibleNull)
          return "";
        else
          if (!withComma)
            return possibleNull + " ";
          else
            return possibleNull + ", ";
      };

      this.getIndexOfPropertyValue = function (array, prop, value) {
        for (var i = 0; i < array.length; i += 1) {
          if (array[i][prop] === value) {
            return i;
          }
        }
      }

      this.useProperty = function (prop) {
        return function (a, b) {
          if (a[prop] > b[prop]) {
            return 1;
          } else if (a[prop] < b[prop]) {
            return -1;
          }
          return 0;
        }
      }

    }])

    .service('commonService', ['$filter', '$http', '$q', 'genericService', '$mdToast', '$mdDialog', '$rootScope', '$state', function ($filter, $http, $q, genericService, $mdToast, $mdDialog, $rootScope, $state) {


      var convFeeController = 'ConFee/';
      var __this = this;

      this.GenerateKeys = function (url) {
        return genericService.get(url + '12');
      }

      this.FormatPhoneNumber = function (phoneNumber) {
        var phoneNo = phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3, 6) + '-' + phoneNumber.substring(6);
        return phoneNo;
      }

      this.Encrypt = function (str, key, iv) {

        var Key = CryptoJS.enc.Utf8.parse(key);
        var IV = CryptoJS.enc.Utf8.parse(iv);

        var encryptedText = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(str), Key, { iv: IV, keySize: 128 / 8, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });

        //This will change depending on the actual fields needed to be encrypted

        return encryptedText.toString();
      }

      this.Decrypt = function (str, key, iv) {
        var Key = CryptoJS.enc.Utf8.parse(key);
        var IV = CryptoJS.enc.Utf8.parse(iv);

        var decrypted = CryptoJS.AES.decrypt(str, Key, {
          keySize: 128 / 8,
          iv: IV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });

        return decrypted.toString(CryptoJS.enc.Utf8);
      }

      this.LoadConvFee = function (obj) {
        return genericService.post(convFeeController, obj);

      }


      this.handleError = function (err, customMessage) {
        var errors = [];
        var message = '';

        if (err) {
          if (err.data) {
            if (err.data.error_description) {
              if (err.data.error_uri != null) {
                message = err.data.error_description;
              } else
                errors.push(err.data.error_description);
            }
            else if (err.data.modelState) {
              for (var key in err.data.modelState) {
                for (var i = 0; i < err.data.modelState[key].length; i++) {
                  errors.push(err.data.modelState[key][i]);
                }
              }
            }
            else if (err.status != null) {
              switch (err.status) {
                case -1: //request not sent
                  errors.push('Could not connect to server.');
                  break;
                case 403: //forbidden
                  errors.push('Forbidden: ' + err.data);
                  break;
                case 500: //Internal Server Error
                  if (err.data.Message != null) {
                    errors.push(err.data.Message);
                  }
                  else {
                    errors.push(err.data);
                  }
                  $state.go('app.msportal.accounts');
                  break;
                default:
                  if (err.data.Message != null) {
                    errors.push(err.data.Message);
                  }
                  else {
                    errors.push(err.data);
                  }
              }
            }
            else if (err.data.Message != null) {
              errors.push(err.data.Message);
            }
            else if (customMessage) {
              errors.push(customMessage);
            }
            else {
              errors.push("Internal error, please try again later!");
            }

          }
          else {
            if (err.status == -1) {
              errors.push('Could not connect to server.');
            } else if (customMessage) {
              errors.push(customMessage);
            } else {
              errors.push("Internal error, please try again later!");
            }
          }
        } else if (customMessage) {
          errors.push(customMessage);
        } else {
          errors.push("Internal error, please try again later!");
        }

        if (errors.length != null && errors.length > 0) {
          message = errors.join(" <br /> ")
        }

        __this.displayError(message);

      }

      this.loadSmartAppConfig = function (forceLoad) {
        var deferred = $q.defer();
        if ($rootScope.smartAppConfig && $rootScope.smartAppConfig.length > 0 && forceLoad !== true) {
          deferred.resolve();
        } else {

          var promiseGet = genericService.get("Settings?DeviceType=WEBOS&HardwareId=");

          promiseGet.then(function (pl) {
            $rootScope.Parameters = pl.data.Response;
            $rootScope.Parameters['ShowConvCCFlag'] = pl.data.ShowConvCCFlag;
            $rootScope.Parameters['ShowConvECFlag'] = pl.data.ShowConvECFlag;

            var promiseGetConfig = genericService.get('SmartAppConfig/');
            promiseGetConfig.then(function (pl) {
              $rootScope.smartAppConfig = pl.data;
              //----------------------------------------

              var promiseGetLocations = genericService.get('OfficeLocation/');
              promiseGetLocations.then(function (pl) {
                $rootScope.utilityOffices = pl.data;
                deferred.resolve();
              },
                function (errorPl) {
                  genericService.closeNotifier();
                  console.log('failure loading Offices', errorPl);
                  deferred.reject();
                })
              //----------------------------------------
            },
              function (errorPl) {
                console.log('failure loading Smart App Config', errorPl);
                deferred.reject();
              })
          },
            function (errorPl) {
              console.log('failure loading Settings', errorPl);
              deferred.reject();
            })
        }

        return deferred.promise;
      }

      this.loadAccountDetails = function (acctNo) {
        var deferred = $q.defer();
        if ($rootScope.hasAlert == null || $rootScope.accountStatus == null) {
          var promiseGetConfig = genericService.get('Account/Services/' + acctNo);
          promiseGetConfig.then(function (pl) {
            $rootScope.accountStatus = pl.data.Status;

            genericService.get("Alerts/GetAlertRegDetail/" + acctNo)
              .then(function (pl) {
                if (pl.data.length > 0) {
                  $rootScope.hasAlert = true;
                }
                else {
                  $rootScope.hasAlert = false;
                }
                deferred.resolve();
              },
                function (errorpl) { deferred.reject() });

          }, function () {
            deferred.reject();
          })

        } else {
          deferred.resolve();
        }

        return deferred.promise;
      }

      this.displayError = function (message) {

        $mdToast.show({
          template: '<md-toast><div class="md-toast-content" style="background-color: red !important;">' + message + '</div></md-toast>',
          position: "top",
          hideDelay: 3000
        });
      };

      this.showPasswordHelp = function () {
        var alert = $mdDialog.alert(
          {
            clickOutsideToClose: false,
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
          .title('')
          .htmlContent(
            '<span>Password must contain the following:</span>' +
            '<ul class="password-requirements-list">' +
            '<li>at least one lowercase letter</li>' +
            '<li>at least one uppercase letter</li>' +
            '<li>at least one number</li>' +
            '<li>at least one special character</li>' +
            '<li>6 characters or more</li>' +
            '</ul>'
          )
          .ariaLabel('Password Requirements')
          .ok('Close')
          .multiple(true)

        return $mdDialog.show(alert);
      }

      this.viewPDF = function (url) {
        var mbrsep = getParameterByName("EAccount", url);
        var eType = getParameterByName("EType", url);
        var eData = getParameterByName("EData", url).split('-');
        var date = eData[1].substring(3, eData[1].length) + '-' + eData[2] + '-' + eData[3].substring(0, 2);
        var id = "";

        var serviceURL = "";

        if (eType == 1 || eType == 51) {
          id = mbrsep;
        }
        else if (eType == 2 || eType == 52) {
          id = mbrsep + 'D';
        }

        serviceURL = 'Bills/' + id + '/PDF/' + date;

        var promiseGet = genericService.get(serviceURL);
        promiseGet.then(function (pl) {
          var pdfResult = pl.data;
          if (pdfResult.successFlag === false) {
            //genericService.Notifier("<span class='badge badge-assertive'>!</span> For billdate " + billdate + " : " + pdfResult.DisplayMessage);
            //$scope.isLoading = false;
            $rootScope.rootscopeLoading = false;
            showAlert('Cannot Load PDF!', pdfResult.DisplayMessage);
          }
          else {
            if (!pdfResult.pdfBytes) {
              //genericService.Notifier("<span class='badge badge-assertive'>!</span> PDF is not yet available for billdate " + billdate);
              //$scope.isLoading = false;
              $rootScope.rootscopeLoading = false;
              showAlert('Cannot Load PDF!', "PDF is not yet available for the selected billdate.");
            }
            else {
              //genericService.Notifier("<ion-spinner></ion-spinner> </br> Downloading PDF bill...", 3000);

              // Decode the 64string
              var byteCharacters = atob(pdfResult.pdfBytes);
              // Convert to bytes
              var byteNumbers = new Array(byteCharacters.length);
              for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              var byteArray = new Uint8Array(byteNumbers);

              // become a blob. :O
              var actualPdfFile = new Blob([byteArray], { type: "application/pdf" });
              //var myFilename = $scope.MemberNo + "_" + billdate.replace(/\//g, "-") + ".pdf";
              var fileURL = URL.createObjectURL(actualPdfFile);
              //$scope.isLoading = false;
              $rootScope.rootscopeLoading = false;
              //$window.open(fileURL);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(actualPdfFile); //FOR IE
              }
              else {
                window.open(fileURL);
              }

              //$scope.content = $sce.trustAsResourceUrl(fileURL);
              $rootScope.content = $sce.trustAsResourceUrl(fileURL);
            }
          }
        },
          function (errorpl) {
            commonService.handleError(errorpl);
          });
      }

      function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
      }

      this.showAlert = function (title, messages, ev) {
        $mdDialog.show(
          $mdDialog.alert({
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
            .clickOutsideToClose(true)
            .parent(angular.element(document.body))
            .title(title)
            .textContent(messages)
            .ariaLabel(title)
            .ok('Ok')
            .targetEvent(ev)
        );
      }

      this.simpleAlertDialog = function (dialogContent) {
        var dialog = dialogContent;

        return $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        }).clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .title(dialog.title)
          .textContent(dialog.message)
          .ariaLabel(dialog.title)
          .ok(dialog.buttonLabel)
          .targetEvent(dialog.ev)
      };
      this.alertDialog = function (dialogContent) {
        var dialog = dialogContent;
        dialog.confirmButtonLabel = dialog.confirmButtonLabel === undefined ? "OK" : dialog.confirmButtonLabel;

        return $mdDialog.alert({
          parent: angular.element(document.querySelector('#popupContainer')),
          template:
            '<md-dialog aria-label="' + dialog.title + '">' +
            '  <md-toolbar> <div class="md-toolbar-tools"> <h2>' + dialog.title + ' </h2> </div> </md-toolbar>' +
            '  <md-dialog-content>' + dialog.message + '</md-dialog-content > ' +
            '  <md-dialog-actions>' +
            '    <md-button ng-click="confirm()" class="md-primary"> ' + dialog.confirmButtonLabel + ' </md-button>' +
            '  </md-dialog-actions>' +
            '</md-dialog>',
          controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
            $scope.confirm = function () {
              $mdDialog.hide();
            };
          }]
        });
      };
      this.confirmDialog = function (dialogContent) {
        var dialog = dialogContent;
        dialog.cancelButtonLabel = dialog.cancelButtonLabel === undefined ? "CANCEL" : dialog.cancelButtonLabel;
        dialog.confirmButtonLabel = dialog.confirmButtonLabel === undefined ? "OK" : dialog.confirmButtonLabel;

        return $mdDialog.confirm({
          parent: angular.element(document.querySelector('#popupContainer')),
          template:
            '<md-dialog aria-label="' + dialog.title + '">' +
            '  <md-toolbar> <div class="md-toolbar-tools"> <h2>' + dialog.title + ' </h2> </div> </md-toolbar>' +
            '  <md-dialog-content>' + dialog.message + '</md-dialog-content > ' +
            '  <md-dialog-actions>' +
            '	   <md-button ng-click="cancel()" class="md-primary"> ' + dialog.cancelButtonLabel + ' </md-button>' +
            '    <md-button ng-click="confirm()" class="md-primary"> ' + dialog.confirmButtonLabel + ' </md-button>' +
            '  </md-dialog-actions>' +
            '</md-dialog>',
          controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
            $scope.cancel = function () {
              $mdDialog.cancel();
            };
            $scope.confirm = function () {
              $mdDialog.hide();
            };
          }]
        });
      };
      this.dateLocaleByDay = {
        formatDate: function (date) {
          var m = moment(date);
          return m.isValid() ? m.format("MM/DD/YYYY") : '';
        }
      };
      this.dateLocaleByMonth = {
        formatDate: function (date) {
          var m = moment(date);
          return m.isValid() ? m.format("MMMM YYYY") : '';
        }
      };
      this.dateLocaleExpDate = {
        formatDate: function (date) {
          var m = moment(date);
          return m.isValid() ? m.format("MM / YYYY") : '';
        }
      };
      this.padLeft = function (text, length, character) {
        var pad = "";
        for (var i = 0; i < length - text.length; i++) {
          pad += character;
        }
        return pad + text;
      }
      this.removePadLeft = function (text, character) {
        var actualText = "";
        var i = 0;
        for (i = 0; i < text.length; i++) {
          if (text[i] !== character) {
            actualText = text.substring(i);
            break;
          }
        }
        return actualText;
      }

      /**
       * Determine the width class for columns with decimal values based on the value with most characters.
       * @param {JSON} data List of object that contains the decimal values.
       * @param {PropertyKey} key The key name of the property with decimal values.
       * @param {number} adjustment Number of pixel to be adjust on the width. should be divisible by 10.
       * @returns class for the width.
       */
      this.getNumericColumnWidth = function (data, key, adjustment, minimumWidth) {
        // Get the hightest and lowest value of property from the list.
        var min = Math.min.apply(Math, data.map(function (item) { return item[key]; }));
        var max = Math.max.apply(Math, data.map(function (item) { return item[key]; }));

        // Remove special characters from the value to get the digits only
        min = ($filter('number')(min, 2)).replace("-", "").replace(".", "").replace(",", "").replace(",", "");
        max = ($filter('number')(max, 2)).replace("-", "").replace(".", "").replace(",", "").replace(",", "");

        // Determine which value has the most digits.
        var digits = max.length;
        if (min.length > max.length) {
          digits = min.length;
        }

        // Determine the width based on the digits
        var width = (digits * 10)
        if (digits == 4) {
          width = 50;
        } else if (digits == 3) {
          width = 40;
        }

        // Apply the adjustment if defined.
        if (adjustment !== undefined) {
          width += adjustment;
        }

        if (minimumWidth > width) {
          return minimumWidth;
        } else {
          return width;
        }
      }
    }])
})();

(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse')
        .service('Session', function () {
            this.create = function (userName, userRole) {
                ///this.id = sessionId;
                this.userId = userName;
                this.userRole = userRole;
            };
            this.destroy = function () {
                //this.id = null;
                this.userId = null;
                this.userRole = null;
            };
    })


})();
'use strict';
angular.module('app.auth.login')
  .factory('authService', ['$http', '$q', 'localStorageService', 'ngAuthSettings', 'genericService', '$rootScope', '$log', 'Session', 'commonService', 'Idle', '$mdDialog', 'msNavigationService', '$state', '$cacheFactory', function ($http, $q, localStorageService, ngAuthSettings, genericService, $rootScope, $log, Session, commonService, Idle, $mdDialog, msNavigationService, $state, $cacheFactory) {

    var serviceBase = ngAuthSettings.apiServiceBaseUri;
    var authServiceFactory = {};
    var requestSettings = false;
    var EntitiesValidatorsURL = 'EntityValidators/';
    var _isAdmin = true;
    var _roleType;
    var _customerUserName = '';

    var ProfileStat = false;
    var BillHistStat = false;
    var PaymentHistStat = false;
    var UsageGraphStat = false;
    var EbillEnabled = false;
    var AlertsEnabled = false;
    var CCDraftsEnabled = false;
    var BankDraftsEnabled = false;
    var EDelinquentEnabled = false;
    var DepositsEnabled = false;
    var BudgetBillEnabled = false;
    var LevelizedBillEnabled = false;
    var isActive = false;
    var IsPPM = false;

    var _authentication = {
      isAuth: false,
      userName: "",
      roleType: "",
      useRefreshTokens: true,
      CustomerID: "",
      staySignedIn: false,
      email: "",
      isCalled: false
    };

    var _adminAuthentication = {
      isAuth: false,
      userName: "",
      roleType: "",
      useRefreshTokens: true,
      CustomerID: "",
      staySignedIn: false,
      email: "",
      isCalled: false
    }

    var getAuthorizationData = function () {
      return localStorageService.get('authorizationData');
    }

    var _isLoggedIn = function () {
      return getAuthorizationData() != null;
    }

    var _saveRegistration = function (registration) {
      return $http.post(serviceBase + 'api/accounts/create', registration);
    };

    var _forgotPassword = function (user) {

      return $http.post(serviceBase + 'api/accounts/forgotpassword', user);

    };

    var _lockoutUser = function (loginData) {
      var user = {
        Username: loginData.Username,
        Password: ""
      };
      return $http.post(serviceBase + 'api/accounts/lockoutuser', user);
    }

    var _changePassword = function (user) {

      return $http.post(serviceBase + 'api/accounts/changepassword', user);
    };
    var _changeUserName = function (user) {

      return $http.post(serviceBase + 'api/accounts/changeusername', user);

    };

    var _changeEmail = function (user) {

      return $http.post(serviceBase + 'api/accounts/ChangeEmail', user);
    };
    var _confirmChangeEmail = function (user) {

      return $http.post(serviceBase + 'api/accounts/confirmemailencode', user);
    };

    var _resendEmail = function (user) {
      return $http.post(serviceBase + 'api/accounts/resendemail', user);
    };

    var _resetPassword = function (user) {

      return $http.post(serviceBase + 'api/accounts/resetpassword', user);

    };

    var _forgotUserName = function (user) {

      return $http.post(serviceBase + 'api/accounts/forgotusername', user);

    };

    var _validateUserCode = function (user) {

      return $http.post(serviceBase + 'api/accounts/validateusercode', user);

    };

    var _resetPasswordEncode = function (user) {

      return $http.post(serviceBase + 'api/accounts/resetpasswordencode', user);

    };

    var _confirmEmailEncode = function (user) {

      return $http.post(serviceBase + 'api/accounts/confirmemailencode', user);

    };


    var _login = function (loginData) {

      var data = "grant_type=password&username=" + encodeURIComponent(loginData.Username) + "&Password=" + encodeURIComponent(loginData.Password);

      if (loginData.useRefreshTokens) {
        data = data + "&client_id=" + ngAuthSettings.clientId + "&client_secret=" + ngAuthSettings.clientSecret;
      }

      var deferred = $q.defer();

      $http.post(serviceBase + 'oauth/token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {

        response.data.roleType = (response.data.roleType || '')

        if (loginData.useRefreshTokens) {
          //window.localStorage.setItem("authorizationData", { token: response.data.access_token, userName: loginData.username, refreshToken: response.refresh_token, useRefreshTokens: true });
          localStorageService.set('authorizationData', { token: response.data.access_token, userName: response.data.userName, refreshToken: response.data.refresh_token, useRefreshTokens: true, staySignedIn: loginData.staySignedIn, encryptedUsername: loginData.Username, roleType: response.data.roleType, email: response.data.email });
        }
        else {
          //window.localStorage.setItem("authorizationData", { token: response.data.access_token, userName: loginData.username, refreshToken: "", useRefreshTokens: false});
          localStorageService.set('authorizationData', { token: response.data.access_token, userName: response.data.userName, refreshToken: "", useRefreshTokens: false, staySignedIn: loginData.staySignedIn, encryptedUsername: loginData.Username, roleType: response.data.roleType, email: response.data.email });
        }

        $rootScope.previousUserName = response.data.userName.toLowerCase();

        if (response.data.roleType == "Admin") {
          _adminAuthentication.isAuth = true;
          _adminAuthentication.userName = response.data.userName;
          _adminAuthentication.roleType = response.data.roleType;
          _adminAuthentication.useRefreshTokens = loginData.useRefreshTokens;
          _adminAuthentication.CustomerID = getClaimsFromToken().CustomerID;
          _adminAuthentication.staySignedIn = loginData.staySignedIn;
          _adminAuthentication.email = response.data.email;

          localStorageService.set('authorizationUserData', { token: response.data.access_token, userName: "", refreshToken: response.data.refresh_token, useRefreshTokens: true, staySignedIn: loginData.staySignedIn, encryptedUsername: "", roleType: "", email: "" });

          Session.create(_adminAuthentication.userName);
        }
        else {
          _authentication.isAuth = true;
          _authentication.userName = response.data.userName;
          _authentication.roleType = response.data.roleType;
          _authentication.useRefreshTokens = loginData.useRefreshTokens;
          _authentication.CustomerID = getClaimsFromToken().CustomerID;
          _authentication.staySignedIn = loginData.staySignedIn;
          _authentication.email = response.data.email;

          _customerUserName = response.data.userName;

          Session.create(_authentication.userName);
        }

        authServiceFactory.roleType = response.data.roleType;
        authServiceFactory.isAuth = true;
        //_customerUserName = response.data.userName;

        Idle.watch();

        requestSettings = true;
        _getSettings();
        //getKeyandIV();
        _setNavigationItems();
        deferred.resolve(response);

      }, function (err, status) {
        _logOut();
        deferred.reject(err);
      });

      return deferred.promise;

    };

    var _logOut = function (isLogOutPressed) {
      isLogOutPressed = isLogOutPressed || false;

      if ($rootScope.showAdminToolbar) {
        if (isLogOutPressed) {
          _authentication.userName = '';
          authServiceFactory.authentication.userName = '';
        }
        else {
          _authentication.userName = $rootScope.customerUserName;
          authServiceFactory.authentication.userName = $rootScope.customerUserName;
        }
      }
      else {
        _authentication.userName = '';
        authServiceFactory.authentication.userName = '';
      }

      authServiceFactory.isAuth = false;
      authServiceFactory.roleType = '';
      //_authentication.userName = '';
      _authentication.useRefreshTokens = false;
      _authentication.roleType = '';
      _authentication.CustomerID = '';
      _authentication.staySignedIn = false;
      _authentication.email = '';

      _adminAuthentication.isAuth = false;
      _adminAuthentication.userName = '';
      _adminAuthentication.roleType = '';
      _adminAuthentication.useRefreshTokens = false;
      _adminAuthentication.CustomerID = '';
      _adminAuthentication.staySignedIn = false;
      _adminAuthentication.email = '';

      //authServiceFactory.authentication.userName = '';
      authServiceFactory.authentication.useRefreshTokens = false;
      authServiceFactory.authentication.roleType = '';
      authServiceFactory.authentication.CustomerID = '';
      authServiceFactory.authentication.staySignedIn = false;
      authServiceFactory.authentication.email = '';

      authServiceFactory.adminAuthentication.isAuth = false;
      authServiceFactory.adminAuthentication.userName = '';
      authServiceFactory.adminAuthentication.roleType = '';
      authServiceFactory.adminAuthentication.useRefreshTokens = false;
      authServiceFactory.adminAuthentication.CustomerID = '';
      authServiceFactory.adminAuthentication.staySignedIn = false;
      authServiceFactory.adminAuthentication.email = '';

      //window.localStorage.removeItem('authorizationData');
      localStorageService.remove('authorizationData');
      localStorageService.remove('authorizationUserData');
      Idle.unwatch();

    };

    var _fillAuthData = function () {
      //var authData = window.localStorage.getItem('authorizationData');
      var authData = localStorageService.get('authorizationData');
      var authUserData = localStorageService.get('authorizationUserData');
      if (authData) {
        $rootScope.previousUserName = authData.userName.toLowerCase();

        if (authData.roleType == "Admin") {
          _adminAuthentication.isAuth = true;
          _adminAuthentication.userName = authData.userName;
          _adminAuthentication.roleType = authData.roleType;
          _adminAuthentication.useRefreshTokens = authData.useRefreshTokens;
          _adminAuthentication.CustomerID = '';
          _adminAuthentication.staySignedIn = authData.staySignedIn;
          _adminAuthentication.email = authData.email;
        } else {
          _authentication.isAuth = true;
          _authentication.userName = authData.userName;
          _authentication.roleType = authData.roleType;
          _authentication.useRefreshTokens = authData.useRefreshTokens;
          _authentication.CustomerID = getClaimsFromToken().CustomerID;
          _authentication.staySignedIn = authData.staySignedIn;
          _authentication.email = authData.email;
        }

        authServiceFactory.roleType = authData.roleType;
        authServiceFactory.isAuth = true;

        if (authUserData) {
          _authentication.isAuth = true;
          _authentication.userName = authUserData.userName;
          _authentication.roleType = '';
          _authentication.useRefreshTokens = authUserData.useRefreshTokens;
          _authentication.CustomerID = authUserData.customerId;
          _authentication.staySignedIn = authUserData.staySignedIn;
          _authentication.email = authUserData.email;
        }
      }
      _setNavigationItems();
    };

    var _refreshToken = function () {
      var deferred = $q.defer();

      //var authData = window.localStorage.getItem('authorizationData');
      var authData = localStorageService.get('authorizationData');

      if (authData) {

        if (authData.useRefreshTokens) {

          var data = "grant_type=refresh_token&refresh_token=" + authData.refreshToken + "&client_id=" + ngAuthSettings.clientId;

          //window.localStorage.removeItem('authorizationData');
          localStorageService.remove('authorizationData');

          $http.post(serviceBase + 'oauth/token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {

            //window.localStorage.setItem('authorizationData', { token: response.access_token, userName: response.userName, refreshToken: response.refresh_token, useRefreshTokens: true });
            localStorageService.set('authorizationData', { token: response.access_token, userName: response.userName, refreshToken: response.refresh_token, useRefreshTokens: true });

            deferred.resolve(response);

          }, function (err) {
            _logOut(true);
            deferred.reject(err);
          });
        }
      }

      return deferred.promise;
    };

    var _unlockAccount = function (UserName) {
      return $http.post(serviceBase + 'api/accounts/unlockaccount', UserName);
    };

    function urlBase64Decode(str) {
      var output = str.replace('-', '+').replace('_', '/');
      switch (output.length % 4) {
        case 0:
          break;
        case 2:
          output += '==';
          break;
        case 3:
          output += '=';
          break;
        default:
          throw 'Illegal base64url string!';
      }
      return window.atob(output);
    }

    function getClaimsFromToken() {
      //var authData = window.localStorage.getItem('authorizationData');
      var authData = localStorageService.get('authorizationData');
      var user = {};
      if (typeof authData !== 'undefined') {
        var encoded = authData.token.split('.')[1];
        user = JSON.parse(urlBase64Decode(encoded));
      }
      return user;
    }

    document.addEventListener("deviceready", onDeviceReady, false);
    function onDeviceReady() {
      $rootScope.Parameters = {};
      $rootScope.utilityOffices = {};
      _getSettings();
    }

    var _getSettings = function (refreshed) {
      refreshed = refreshed || false;
      if (requestSettings || refreshed) {
        requestSettings = false;
        //var promiseGet = genericService.get("Settings?DeviceType=" + $rootScope.deviceType + "&HardwareId=" + $rootScope.HardwareId);
        var promiseGet = genericService.get("Settings?DeviceType=WEBOS&HardwareId=");

        promiseGet.then(function (pl) {
          $rootScope.Parameters = pl.data.Response;
          $rootScope.Parameters['ShowConvCCFlag'] = pl.data.ShowConvCCFlag;
          $rootScope.Parameters['ShowConvECFlag'] = pl.data.ShowConvECFlag;

          var promiseGetConfig = genericService.get('SmartAppConfig/');
          promiseGetConfig.then(function (pl) {
            $rootScope.smartAppConfig = pl.data;
            //----------------------------------------

            var promiseGetLocations = genericService.get('OfficeLocation/');
            promiseGetLocations.then(function (pl) {
              $rootScope.utilityOffices = pl.data;
              return true;
            },
              function (errorPl) {
                genericService.closeNotifier();
                console.log('failure loading Offices', errorPl);
                return false;
              })
            //----------------------------------------
          },
            function (errorPl) {
              $log.error('failure loading Smart App Config', errorPl);
              return false;
            })
        },
          function (errorPl) {
            $log.error('failure loading Settings', errorPl);
            return false;
          })

      }
    };
    //function getKeyandIV() {
    //    //Get Key and IV to be used for encryption. Same Key and IV would be used to decrypt it on the server side
    //    var promiseGet = commonService.GenerateKeys('Common/');
    //    promiseGet.then(function (pl) {
    //        $rootScope.CryptData = pl.data;//Key and IV
    //    });
    //}

    function IsAuthenticated() {
      return _authentication.isAuth;
    };

    _authentication.isAuthenticated = function () {
      return !!Session.userId;
    };

    //TODO:Elaborate more
    _authentication.isAuthorized = function (authorizedRoles) {
      if (!angular.isArray(authorizedRoles)) {
        authorizedRoles = [authorizedRoles];
      }
      return (_authentication.isAuthenticated() &&
        authorizedRoles.indexOf(Session.userRole) !== -1);
    };

    function _getEntityValidators(entityName, jsonModelName) {
      return genericService.get(EntitiesValidatorsURL + "?entityName=" + entityName + "&jsonModelName=" + jsonModelName + '&isForAuth=true');
    }

    function _showFloatingLogin() {
      $rootScope.loginDialogIsDisplayed = true;
      $mdDialog.show({
        templateUrl: 'app/auth/floating-login/floating_login.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        fullscreen: true,
        escapeToClose: false,
        controller: "LoginController",
        resolve: {
          Validator: ["authService", function (authService) {
            return authService.getEntityValidators('LoginBindingModel', 'loginData')
          }]
        },

        onComplete: function () {
          $rootScope.$broadcast('msDialogIsOpened');
        },
        onRemoving: function () {
          $rootScope.$broadcast('msDialogIsClosed');
        }
      }).then(function (result) {
        $rootScope.loginDialogIsDisplayed = false;
      }, function (err) {
        $rootScope.loginDialogIsDisplayed = false;
        $log.error('Floating login form failed to open');
      });
    }

    var _setNavigationItems = function () {

      var forCustomer = false;
      var forAdmin = false;
      var showMenu = false;

      if (authServiceFactory.roleType == "Admin") {
        forAdmin = true;
      }
      else {
        forCustomer = true;
      }

      // Navigation
      msNavigationService.saveItem('fuse', {
        title: 'CUSTOMER SERVICES PORTAL',
        group: true,
        weight: 1,
        hidden: function () { return !forCustomer }
      });

      msNavigationService.saveItem('myAccount', {
        title: 'My Account',
        //icon: 'icon-account-multiple',
        weight: 2,
        group: true,
        hidden: function () {
          return ($state.current.name == 'app.msportal.admin.customers')
        }
      });

      msNavigationService.saveItem('myAccount.accounts', {
        title: 'Accounts List',
        state: 'app.msportal.accounts',
        icon: 'icon-account-multiple',
        weight: 1,
        hidden: function () {
          return ($state.current.name == 'app.msportal.admin.customers')
        }

      });

      $rootScope.$on('isAccountSelected', function (event, data) {
        isActive = $rootScope.accountStatus === 'Active' || $rootScope.accountStatus === 'Active Prepaid';
        if (data.id) {
          var promiseGet = genericService.get('Account/GetAccount/' + data.id);
          promiseGet.then(function (pl) {
            IsPPM = pl.data.IsPPM === "P" ? true : false;
          });
        }
        
        showMenu = data.showMenu;
        var promiseGet = commonService.loadSmartAppConfig();
        promiseGet.then(function (pl) {
          for (var x = 0; x < $rootScope.smartAppConfig.length; x++) {
            if ($rootScope.smartAppConfig[x].ConfigId == '52') {
              ProfileStat = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '8') {
              BillHistStat = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '53') {
              PaymentHistStat = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '58') {
              UsageGraphStat = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '50') {
              EbillEnabled = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '51') {
              EDelinquentEnabled = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '59') {
              AlertsEnabled = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '87') {
              CCDraftsEnabled = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '88') {
              BankDraftsEnabled = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '107') {
              DepositsEnabled = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '48') {
              LevelizedBillEnabled = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
            else if ($rootScope.smartAppConfig[x].ConfigId == '49') {
              BudgetBillEnabled = $rootScope.smartAppConfig[x].Value == 1 ? true : false;
            }
          }

          if (data.id) {
            var promiseGetAcct = commonService.loadAccountDetails(data.id);
            promiseGetAcct.then(function (pl) {
              //My Accounts
              msNavigationService.saveItem('myAccount.detail', {
                title: 'Service Details',
                state: 'app.msportal.service_detail',
                stateParams: { 'id': data.id },
                icon: 'icon-file-document',
                weight: 2,
                hidden: function () {
                  return !showMenu
                }

              });

              //Payment
              msNavigationService.saveItem('myAccount.payment', {
                title: 'Payment',
                state: 'app.msportal.payment',
                stateParams: { 'id': data.id },
                icon: 'icon-cash',
                weight: 3,
                hidden: function () {
                  return !showMenu
                }
              });

              msNavigationService.saveItem('myAccount.profile', {
                title: 'Profile',
                state: 'app.msportal.profile',
                stateParams: { 'id': data.id },
                icon: 'icon-account-box-outline',
                weight: 4,
                hidden: function () {

                  if (ProfileStat) {
                    return !showMenu
                  }

                  return true;
                }

              });

              msNavigationService.saveItem('myAccount.deposits', {
                title: 'Deposits',
                state: 'app.msportal.deposits',
                stateParams: { 'id': data.id },
                icon: 'icon-credit-card',
                weight: 5,
                hidden: function () {

                  if (DepositsEnabled) {
                    return !showMenu
                  }

                  return true;
                }

              });

              msNavigationService.saveItem('billHistory', {
                title: 'Bill History',
                state: 'app.msportal.billHist',
                stateParams: { 'id': data.id },
                //icon: 'icon-content-paste',
                icon: 'icon-history',
                weight: 3,
                hidden: function () {

                  if (BillHistStat) {
                    return !showMenu
                  }

                  return true;
                }
              });

              msNavigationService.saveItem('ppmAccountHistory', {
                title: 'Prepaid Account History',
                state: 'app.msportal.ppmAcctHist',
                stateParams: { 'id': data.id },
                //icon: 'icon-content-paste',
                icon: 'icon-calendar-text',
                weight: 3,
                hidden: function () {

                  if (IsPPM) {
                    return !showMenu
                  }

                  return true;
                }
              });

              msNavigationService.saveItem('paymentHistory', {
                title: 'Payment History',
                state: 'app.msportal.paymentHist',
                stateParams: { 'id': data.id },
                icon: 'icon-content-paste',
                weight: 4,
                hidden: function () {

                  if (PaymentHistStat) {
                    return !showMenu
                  }

                  return true;
                }
              });

              msNavigationService.saveItem('usageCharts', {
                title: 'Usage Charts',
                state: 'app.msportal.usageCharts',
                stateParams: { 'id': data.id },
                icon: 'icon-chart-line',
                weight: 5,
                hidden: function () {

                  if (UsageGraphStat) {
                    return !showMenu
                  }

                  return true;
                }
              });



              //Payment Drafts
              msNavigationService.saveItem('paymentDrafts', {
                title: 'Payment Drafts',
                state: 'app.msportal.draft',
                stateParams: { 'id': data.id },
                icon: 'icon-file-multiple',
                weight: 6,
                hidden: function () {

                  if ((CCDraftsEnabled || BankDraftsEnabled) && isActive && !IsPPM) {
                    return !showMenu
                  }

                  return true;
                }
              });

              msNavigationService.saveItem('billTypePreference', {
                title: 'E-Bill',
                state: 'app.msportal.billTypePreference',
                stateParams: { 'id': data.id },
                weight: 7,
                icon: 'icon-email',
                hidden: function () {

                  if (EbillEnabled && !IsPPM) {
                    return !showMenu
                  }

                  return true;
                }
              });

              msNavigationService.saveItem('delinquentNotice', {
                title: 'E-Delinquent',
                state: 'app.msportal.delinquentNotice',
                stateParams: { 'id': data.id },
                icon: 'icon-alert-circle',
                weight: 8,
                hidden: function () {

                  if (EDelinquentEnabled && !IsPPM) {
                    return !showMenu
                  }

                  return true;
                }
              });

              //Budget/Levelized Billing
              msNavigationService.saveItem('billing-levelized', {
                title: 'Budget/Levelized Billing',
                state: 'app.msportal.budget-levelized',
                stateParams: { 'id': data.id },
                icon: 'icon-chart-bar',
                weight: 9,
                hidden: function () {

                  if ((BudgetBillEnabled || LevelizedBillEnabled) && isActive && !IsPPM) {
                    return !showMenu
                  }

                  return true;
                }
              });

              //Alerts & Reminders
              msNavigationService.saveItem('alerts', {
                title: 'Alerts & Reminders',
                state: 'app.msportal.alerts',
                stateParams: { 'id': data.id },
                icon: 'icon-bell',
                weight: 10,
                hidden: function () {

                  if (AlertsEnabled && ($rootScope.hasAlert || $rootScope.accountStatus != 'Inactive')) {
                    return !showMenu
                  }

                  return true;
                }
              });
            });
          }
        });


      });

      //  Admin Navigation Items
      msNavigationService.saveItem('admindashboard', {
        title: 'ADMIN DASHBOARD',
        group: true,
        weight: 1,
        hidden: function () { return !forAdmin } //If multiple user roles have access to this item, you can do ...return (!forAdmin || !forCSR) , for example
      });

      msNavigationService.saveItem('admindashboard.customers', {
        title: 'Customers',
        state: 'app.msportal.admin.customers',
        icon: 'icon-file-multiple',
        weigth: 2,
        hidden: function () {
          return !forAdmin
        }
      });
    }
    var _changeEmailConfirmation = function (user) {
      return $http.post(serviceBase + 'api/accounts/changeemailconfirmation', user);
    }
    var _checkIsPortalEnabled = function (isLoggedIn, form, task) {
      var url = "Settings?DeviceType=WEBOS&HardwareId=";
      $cacheFactory.get('$http').remove($rootScope.serviceBase + url);
      var promiseGet = genericService.get(url);

      promiseGet.then(function (pl) {
        var parameters = pl.data.Response;
        $rootScope.isPortalEnabled = parameters.FourthParameters.FOURTHPARM_54 === 1;
        var isPortalAdmin = authServiceFactory.adminAuthentication.userName === 'portaladmin';
        if ($rootScope.isPortalEnabled || isPortalAdmin) {
          if (task !== null) {
            task();
          }
        } else {
          if (form !== null) {
            form.$aaFormExtensions.$changed = false;
          }
          commonService.showAlert('Service is currently unavailable due to maintenance.');

          var stateName = $state.current.name;
          if (stateName !== 'app.pages_auth_login' && stateName !== 'app.pages_auth_adminLogin') {
            var isAdmin = authServiceFactory.adminAuthentication.roleType === 'Admin';

            if (isLoggedIn) {
              _logOut(true);
            }
            if (isAdmin) {
              $state.go('app.pages_auth_adminLogin');
            }
            else {
              $state.go('app.pages_auth_login');
            } 
          }
        }
      }, function () {

      });
    }
    var _deleteUser = function (user) {
      return $http.post(serviceBase + 'api/accounts/deleteuser', user);
    }
    //var tokenClaims = getClaimsFromToken();

    //authServiceFactory.isAuthorized = _isAuthorized;
    authServiceFactory.setNavigationItems = _setNavigationItems;
    authServiceFactory.saveRegistration = _saveRegistration;
    authServiceFactory.changePassword = _changePassword;
    authServiceFactory.changeUserName = _changeUserName;
    authServiceFactory.changeEmail = _changeEmail;
    authServiceFactory.changeEmailConfirmation = _changeEmailConfirmation;
    authServiceFactory.deleteUser = _deleteUser;
    authServiceFactory.resendEmail = _resendEmail;
    authServiceFactory.resetPassword = _resetPassword;
    authServiceFactory.forgotPassword = _forgotPassword;
    authServiceFactory.lockoutUser = _lockoutUser;
    authServiceFactory.login = _login;
    authServiceFactory.logOut = _logOut;
    authServiceFactory.fillAuthData = _fillAuthData;
    authServiceFactory.authentication = _authentication;
    authServiceFactory.refreshToken = _refreshToken;
    authServiceFactory.forgotUserName = _forgotUserName;
    authServiceFactory.validateUserCode = _validateUserCode;
    authServiceFactory.resetPasswordEncode = _resetPasswordEncode;
    authServiceFactory.confirmEmailEncode = _confirmEmailEncode;
    authServiceFactory.getSettings = _getSettings;
    authServiceFactory.getEntityValidators = _getEntityValidators;
    authServiceFactory.isLoggedIn = _isLoggedIn;
    authServiceFactory.showFloatingLogin = _showFloatingLogin;
    authServiceFactory.isAdmin = _isAdmin;
    authServiceFactory.roleType = "";
    authServiceFactory.adminAuthentication = _adminAuthentication;
    authServiceFactory.CheckIsPortalEnabled = _checkIsPortalEnabled;
    authServiceFactory.unlockAccount = _unlockAccount;

    return authServiceFactory;
  }]);


'use strict';
angular.module('app.auth.login')
    .factory('authInterceptorService', ['$q', '$injector', '$location', 'localStorageService', function ($q, $injector, $location, localStorageService) {

    var authInterceptorServiceFactory = {};

    var _request = function (config) {

        config.headers = config.headers || {};
       
        //var authData = window.localStorage.getItem('authorizationData');
        var authData = localStorageService.get('authorizationData');
        if (authData) {
            config.headers.Authorization = 'Bearer ' + authData.token;
        }

        return config;
    }
       
    var _responseError = function (rejection) {
        var deferred = $q.defer();

        switch (rejection.status) {
            case 401:
                var authService = $injector.get('authService');
                authService.refreshToken().then(function (response) {
                    _retryHttpRequest(rejection.config, deferred);
                }, function () {
                    authService.logOut();
                    var state = $injector.get('$state');
                    state.go('app.pages_auth_login');
                    deferred.reject(rejection);
                });
                break;
            case 403:
                var state = $injector.get('$state');
                state.go('app.msportal.accounts');
                break;
            case 503:
                var state = $injector.get('$state');
                var authService = $injector.get('authService');
                var $rootScope = $injector.get('$rootScope');
                authService.logOut();
                if (state.current.name == 'app.page_loading_failed') {
                    $rootScope.loadingProgress = false;
                } else {
                    state.go('app.page_loading_failed', { resumeState: { name: 'app.pages_auth_login' } });
                }
                
                break;
            default:
                deferred.reject(rejection);
                break;
        }

        return deferred.promise;
    }

    var _retryHttpRequest = function (config, deferred) {
        $http = $http || $injector.get('$http');
        $http(config).then(function (response) {
            deferred.resolve(response);
        }, function (response) {
            deferred.reject(response);
        });
    }

    authInterceptorServiceFactory.request = _request;
    authInterceptorServiceFactory.responseError = _responseError;

    return authInterceptorServiceFactory;
}]);
(function ()
{
    'use strict';

    angular
        .module('app.auth.reset-user', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-user', {
            url      : '/reset-user?uid&code',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-user': {
                    templateUrl: 'app/auth/reset-user/reset-user.html',
                    controller :  'ResetUserController as vm'
                }
            },
            resolve: {
                Validator: ["authService", function (authService) {
                    return authService.getEntityValidators('ResetPasswordBindingModel', 'ResetPasswordBindingModel')
                }]
            },
            bodyClass          : 'reset-user',
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/reset-user');
    }

})();
(function ($scope, $location, authService, ngAuthSettings, $state, $window, genericService, $rootScope)
{
    'use strict';

    angular
        .module('app.auth.reset-user')
        .controller('ResetUserController', ResetUserController, function ($scope, $location, authService) { });

    /** @ngInject */
  function ResetUserController($scope, $location, authService, $rootScope, AUTH_EVENTS, $stateParams, $mdToast, Validator, commonService, $window)
  {
    $window.document.title = "Reset Username - " + document.getElementById("title").title;
        // DTO
        $scope.ValidateUserCodeViewModel = {
            UID: "",
            Code: "",
            Purpose:""
        };

        $scope.ResetPasswordBindingModel = {
            //Token: "",
            //UserID: "",
            //NewPassword: "",
            //ConfirmPassword: "",
        };

        $scope.Validators = Validator.data;


        // Properties
        $scope.showForm = false;
        $scope.flipped = false;

        $scope.flip = function () {
            $scope.flipped = !$scope.flipped;
        };

        $scope.notification = {
            message: "",
            display: ""
        };

        $scope.progress = {
            activated: false
        };

        // Methods
        /// ValidateUserName: Method used for get the username from the server.
        $scope.ValidateCode = function () {
            $scope.showProgress();

            $scope.ValidateUserCodeViewModel.UID = $stateParams.uid;
            $scope.ValidateUserCodeViewModel.Code = $stateParams.code;
            $scope.ValidateUserCodeViewModel.Purpose = "ResetPassword";

            authService.validateUserCode($scope.ValidateUserCodeViewModel).then(function (response) {
                $scope.hideProgress();
                $scope.showForm = true;
            },
             function (err) {
                 $scope.hideProgress(); 
                 $location.path('/portal/accounts');
             });
        };

        /// ResetPassword: Method used for get the username from the server.
        $scope.ResetPassword = function () {
            $scope.showProgress();

            $scope.ResetPasswordBindingModel.UserID = $stateParams.uid;
            $scope.ResetPasswordBindingModel.Token = $stateParams.code;

            /// TODO: Fix related to MND-878 (Sprint 12) message saying "You have unsaved changes..."
            var form = $scope.ResetUserForm;


            authService.resetPasswordEncode($scope.ResetPasswordBindingModel).then(function (response) {
                $scope.hideProgress();
                $scope.flip();

                /// TODO: Fix related to MND-878 (Sprint 12) message saying "You have unsaved changes..."
                form.$rollbackViewValue();

                /// TODO: Fix related to MND-878 (Sprint 12) message saying "You have unsaved changes..."
                $scope.ResetPasswordBindingModel = {};
                //$scope.ResetPasswordBindingModel.Token= "";
                //$scope.ResetPasswordBindingModel.UserID= "";
                //$scope.ResetPasswordBindingModel.NewPassword= "";
                //$scope.ResetPasswordBindingModel.ConfirmPassword= "";

            },
             function (err) {
                 $scope.hideProgress();
                 commonService.handleError(err);
             });
        };

        
        /// showProgress: Method used to show the progress bar
        $scope.showProgress = function () {
            $scope.progress.activated = true;
        }

        /// hideProgress: Method used to hide the progress bar
        $scope.hideProgress = function () {
            $scope.progress.activated = false;
        }

        $scope.showPasswordHelp = function () {
            commonService.showPasswordHelp()
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/auth/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            resolve: {
                Validator: ["authService", function (authService) {
                    return authService.getEntityValidators('ResetPasswordBindingModel', 'ResetPasswordBindingModel')
                }]
            },
            bodyClass: 'reset-password',
                data: {
            authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/reset-password');
       
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
  function ResetPasswordController($location, $scope, authService, Validator, commonService, $window)
    {
        $scope.success = false;
        // Data
        //$scope.user = {
        //    NewPassword: "",
        //    ConfirmPassword: "",
        //    Token: "",
        //    UserID: ""
        //};
        $window.document.title = "Reset Password - " + document.getElementById("title").title;
        $scope.ResetPasswordBindingModel = {};
        $scope.Validators = Validator.data;

        // Methods

        $scope.resetPassword = function () {
            $scope.user.Token = $location.search()['code'];
            $scope.user.UserID = $location.search()['userId'];
            $scope.progress.activated = true;

            authService.resetPassword($scope.ResetPasswordBindingModel).then(function (response) {
                $scope.progress.activated = false;
                if (response.status === 200) {
                    $scope.success = true
                }            
                //TODO:Change this for the right one
                //$location.path('/portal/accounts');

            },
             function (err) {
                 $scope.progress.activated = false;
                 
                 commonService.handleError(err);

             });
        };
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/auth/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/auth/register/register.html',
                    controller: 'RegisterController as vm'                 
                }
            },
            resolve: {
                SignUpValidators: ["RegisterContext", function (RegisterContext) {
                    return RegisterContext.getValidators('CreateUserBindingModel','registration',true);
                }]
            },
            bodyClass: 'register',            
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/register');

        //// Navigation
        //msNavigationServiceProvider.saveItem('pages.auth.register', {
        //    title : 'Register',
        //    state : 'app.pages_auth_register',
        //    weight: 3
        //});
    }

})();
(function () {
  'use strict';

  angular
    .module('app.auth.register')
    .controller('RegisterController', RegisterController);

  /** @ngInject */
  function RegisterController($filter, $scope, $location, $timeout, authService, genericService, $mdToast, $state, SignUpValidators, RegisterContext, commonService, $mdDialog, $rootScope, $window) {
    //////////
    // Properties
    //////////
    $window.document.title = "Register - " + document.getElementById("title").title;
    $scope.savedSuccessfully = false;
    $scope.SignUpValidators = SignUpValidators.data;
    $scope.customer = {
      AccountNumber: ""
    };
    $scope.limit = 50;
    $scope.retries = 1;
    $scope.isNewApplicant = false;

    $scope.registration = {};
    $scope.validation = {};

    $scope.notification = {
      message: "",
      display: ""
    };

    $scope.progress = {
      activated: false
    };
    $scope.checkAccountNumber = CheckAccountNumber;

    $scope.accountNumberPattern = (function () {
      var regexp = /^[0-9]*$/;

      return {
        test: function (value) {
          //if ($scope.requireTel === false) {
          //    return true;
          //}
          return regexp.test(value);
        }
      };
    })();

    $scope.flipped = false;

    $scope.flip = function () {
      $scope.flipped = !$scope.flipped;
      if ($scope.flipped) {
        var register = document.getElementById('register');
        register.scrollTop = 0;
      }
    };

    authService.CheckIsPortalEnabled(false, null, null);
    //////////
    // Methods
    //////////
    $scope.Clear = function () {
      $scope.validation.BillAmount = 0;
      $scope.validation.PNumber = '';
    }
    function alertDialog(title, content) {
      $mdDialog.show(
        $mdDialog.alert({
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .title(title)
          .textContent(content)
          .ariaLabel(title)
          .ok('Ok')
        //.targetEvent(ev)
      );
    }
    $scope.Validate = function (registerForm) {
      authService.CheckIsPortalEnabled(null, registerForm, function () {
        if (registerForm.$invalid) {
          $scope.notification.message = 'Please input a correct e-mail';
        }
        else {
          if ($scope.isNewApplicant) {
            commonService.showAlert(
              'Create Account',
              'You are not allowed to create a Portal Account until your account has been billed. Please try back in a few days.');
          } else {
            fixAccountNumber();
            ValidateBillAmount(registerForm);
          }
        }
      });
    }
    function retrySignUp(registerForm) {
      $scope.signUp(registerForm);
    }


    /// signUp: Method used to register the new user.
    $scope.signUp = function (registerForm) {
      $scope.showProgress();

      //if (registerForm.$invalid) {
      //    $scope.notification.message = 'Please input a correct e-mail';
      //}
      //else {

      //fixAccountNumber();

      var promiseGet = genericService.get('Account/getCID/CID/' + $scope.customer.AccountNumber);

      promiseGet.then(function (pl) {

        //Checks if Account Number entered has corresponding CID (pl.data is not equals 0)
        if (pl.data !== 0) {
          $scope.registration.CustomerID = pl.data;
          $scope.registration.FirstName = "_";
          $scope.registration.LastName = "_";
          $scope.registration.TimeZone = $filter('date')(new Date(), "Z");
          //$scope.registration.AccountNumber = $scope.customer.AccountNumber;

          authService.saveRegistration($scope.registration).then(function (response) {
            //prevents 'Unsaved Changes' pop up
            registerForm.$aaFormExtensions.$changed = false;

            $scope.hideProgress();

            if (response.status === 201) {
              $scope.flip();
              $scope.savedSuccessfully = true;
              //form.$rollbackViewValue();
            }
            else if (response.status === 200) {
              if ($scope.retries < $scope.limit) {
                $scope.retries = $scope.retries + 1;
                retrySignUp(registerForm);
              }
              else {
                $scope.hideProgress();
                $scope.notification.message = "Error while updating the entries. Please try again.";
                $scope.notification.display = true;
                commonService.handleError(null, $scope.notification.message);
              }

            }

            //$scope.notification.message = "User has been registered successfully. You will be redirected to login page in 2 seconds.";
            //$scope.notification.display = true;

            //showSimpleToast(true, $scope.notification.message);
            //startTimer();

          }, function (response) {
            $scope.hideProgress();
            //$scope.EvalErrorWebAPi(response);
            commonService.handleError(response);
          });
        }
        else { //If no CID number returned (pl.data is 0)
          $scope.hideProgress();
          $scope.notification.message = "Account number was not found";
          $scope.notification.display = true;
          commonService.handleError(null, $scope.notification.message);
        }
      }, function (errorPl) {
        $scope.hideProgress();

        //$scope.EvalErrorWebAPi(errorPl, 'Account number was not found');
        commonService.handleError(errorPl, 'Account number was not found');
      });
      //}
    };

    /// Clear: Method used for clean every text control in the page.
    $scope.clear = function () {
      $scope.customer.AccountNumber = "";
      $scope.registration = {};
      $scope.notification = {};
    };

    /// startTimer: Method used for redirect to Login page after 2 seconds.
    var startTimer = function () {
      var timer = $timeout(
        function () {
          $timeout.cancel(timer);
          $state.go('app.pages_auth_login');
        }
        , 2000);
    }

    ///
    function fixAccountNumber() {
      var currentLength = ($scope.customer.AccountNumber).length;
      if (currentLength < 8)
        for (var x = 0; x < (8 - currentLength); x++)
          $scope.customer.AccountNumber = "0" + $scope.customer.AccountNumber;
    }

    $scope.showPasswordHelp = function () {
      commonService.showPasswordHelp()
    }
    $scope.showBillAmountHelp = function () {
      var alert = $mdDialog.alert(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title('Bill Amount')
        .htmlContent(
          '<span>Enter the total amount due from your current bill.</span>'
        )
        .ariaLabel('Bill Amount Help')
        .ok('Close')
        .multiple(true)

      return $mdDialog.show(alert);
    };

    /// showProgress: Method used to show the progress bar
    $scope.showProgress = function () {
      $scope.progress.activated = true;
    }

    /// hideProgress: Method used to hide the progress bar
    $scope.hideProgress = function () {
      $scope.progress.activated = false;
    }

    function ValidateBillAmount(registerForm) {
      $scope.showProgress();
      var promiseGet = genericService.get('Bills/Validate?amount=' + $scope.validation.BillAmount + "&accountNumber=" + $scope.customer.AccountNumber);

      promiseGet.then(function (pl) {
        var result = pl.data;
        if (result === "Success") {
          $scope.hideProgress();
          ValidatePhoneNumber(registerForm);
        }
        else {
          alertDialog("Bill Amount Validation Failed", result);
          $scope.hideProgress();
        }
      }, function (errorPl) {
        $scope.hideProgress();
        commonService.handleError(errorPl, "Internal Error");
      });
    }
    function ValidatePhoneNumber(registerForm) {
      $scope.showProgress();
      var promiseGet = genericService.get('Account/Validate?number=' + $scope.validation.PNumber + "&accountNumber=" + $scope.customer.AccountNumber);

      promiseGet.then(function (pl) {
        var result = pl.data;
        if (result === "Success") {
          $scope.hideProgress();
          $scope.signUp(registerForm);
        }
        else {
          alertDialog("Phone Number Validation Failed", result);
          $scope.hideProgress();
        }
      }, function (errorPl) {
        $scope.hideProgress();
        commonService.handleError(errorPl, 'Internal Error');
      });
    }

    // Functions
    function CheckAccountNumber(accountNo) {
      $rootScope.loadingProgress = true;
      accountNo = accountNo === undefined ? "" : accountNo;
      accountNo = commonService.padLeft(accountNo, 8, "0");
      genericService.get('Account/GetAccount/' + accountNo).then(function (response) {
        $rootScope.loadingProgress = false;
        var account = response.data;
        if (account.MemberNo !== null) {
          $scope.isNewApplicant = account.Status === 'New';
          if ($scope.isNewApplicant) {
            commonService.showAlert(
              'Create Account',
              'You are not allowed to create a Portal Account until your account has been billed. Please try back in a few days.');
          }
        }
      }, function (error) {

      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.register')
        .factory('RegisterContext', ["genericService",'commonService', RegisterContext]);

    function RegisterContext(genericService, commonService) {
        var EntitiesValidatorsURL = 'EntityValidators/';

        return {
            getValidators: GetValidators,
            SignUpValidation: {},

            getSignUpValidation: function () {
                return this.SignUpValidation;
            },
            setCCValidation: function (obj) {
                this.SignUpValidation = angular.copy(obj);
            },


            Decrypt: commonService.Decrypt,
            Encrypt: commonService.Encrypt,

            PasswordMasked: "",
            ConfirmPasswordMasked: "",
            EmailMasked:"",
            UsernameMasked: "",
            ConfirmEmailMasked: ""

        }
       
        function GetValidators(entityName, jsonModelName, isForAuth) {
            return genericService.get(EntitiesValidatorsURL + "?entityName=" + entityName + "&jsonModelName=" + jsonModelName + "&isForAuth=" + isForAuth);
        }
    }
})();
(function ($scope, $location, authService, ngAuthSettings, $state, $window, genericService, $rootScope, commonService) {
  'use strict';

  angular
    .module('app.auth.login')
    .controller('LoginController', LoginController, function ($scope, $location, authService, commonService) { });


  /** @ngInject */
  function LoginController($filter, genericService, $scope, $location, authService, $rootScope, AUTH_EVENTS, $mdToast, $state, $stateParams, $window, Validator, $mdDialog, commonService) {
    $window.document.title = "Login - " + document.getElementById("title").title;
    $scope.Validators = Validator.data;
    $scope.shownAsDialog = $state.current.name != 'app.pages_auth_login';
    $scope.loginData = {
      useRefreshTokens: true,
      staySignedIn: true
    };

    $scope.portalVersion = '';
    $scope.processing = false;
    $scope.accessFailed = 0;
    $scope.lockoutValue = "";
    $scope.levelUser = "";
    $scope.emailConfirmed = "";

    $scope.notification = {
      message: "",
      display: ""
    };

    $scope.progress = {
      activated: false
    };

    $scope.resetNotification = function () {
      $scope.notification.message = "";
      $scope.notification.display = "";
    };
    //$scope.goToForgotPassword = GoToForgotPassword;
    //$scope.goToForgotUsername = GoToForgotUsername;

    $scope.flipped = false;

    $scope.flip = function () {
      $scope.flipped = !$scope.flipped;
    };

    var accountChanged = false;

    // Initialization
    LoadPortalVersion();

    //REVIEW: Pascal Case
    $scope.login = function (loginForm) {
      authService.CheckIsPortalEnabled($scope.shownAsDialog, null, function () {
        if ($scope.shownAsDialog && loginForm.usernameE.$viewValue.toLowerCase() != $rootScope.previousUserName) {
          confirmAccountChange().then(function () {
            accountChanged = true;
            $scope.showProgress();
            lockoutUser(loginForm);
          }, function () {

          });
        } else {
          accountChanged = false;
          $scope.showProgress();
          lockoutUser(loginForm);
        }
      });
    };

    var continueLogin = function (loginForm) {
      $scope.showProgress();

      authService.login($scope.loginData).then(function (response) {
        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess, $scope.loginData);

        $scope.hideProgress();

        if ($scope.shownAsDialog) {
          if (accountChanged) {

            if (!authService.roleType) {
              $window.location.href = 'portal/accounts';
            }
            else {
              switch (authService.roleType.toLowerCase()) {
                case 'admin':
                  $window.location.href = 'portal/admin/customers';
                  break;
                default:
                  $window.location.href = 'portal/accounts';
                  break;
              }
            }
          } else {
            $mdDialog.hide();
          }
        } else {
          if (!authService.adminAuthentication.roleType) {
            $state.go('app.msportal.accounts');
          }
        }

      }, function (err) {
        $scope.EvalErrorWebAPi(err);

        $rootScope.$broadcast(AUTH_EVENTS.loginFailed);

        if ($scope.lockoutValue && $scope.emailConfirmed == "true") {
          failedAttempt();
        }
        else {
          $scope.hideProgress();
        }

      });
    }

    var lockoutUser = function (loginForm) {
      authService.lockoutUser($scope.loginData).then(function (response) {
        $scope.lockoutValue = response.data;
        var valLocation = $scope.lockoutValue.indexOf("*");
        var confirmedLoc = $scope.lockoutValue.indexOf("-");
        $scope.levelUser = $scope.lockoutValue.slice(valLocation + 1, confirmedLoc).toLowerCase();
        $scope.emailConfirmed = $scope.lockoutValue.slice(confirmedLoc + 1, $scope.lockoutValue.length - 1).toLowerCase();
        $scope.accessFailed = 3 - parseInt($scope.lockoutValue.slice(1, valLocation));
        //to check if the username is existing
        if (!$scope.lockoutValue || $scope.emailConfirmed == "false") {
          continueLogin(loginForm);
          return;
        }
        if (!$scope.shownAsDialog && $scope.levelUser == "admin") {
          $mdDialog.show(

            $mdDialog.alert(
              {
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: false,
                title: "Invalid User Account",
                textContent: "If you are an ADMIN of this site, please use the ADMIN login page.",
                ariaLabel: "Invalid User Account",
                ok: "OK",
                onComplete: function () {
                  $rootScope.$broadcast('msDialogIsOpened');
                },
                onRemoving: function () {
                  logOut(true)
                  $rootScope.$broadcast('msDialogIsClosed');
                }
              })
          );
          $scope.hideProgress();
          return;
        }
        if ($scope.accessFailed <= 3 && $scope.accessFailed >= 0) {
          continueLogin(loginForm);
        }
        else {
          $scope.hideProgress();
          lockoutMessage();
        }

      }, function (err) {
        $scope.hideProgress();
        $scope.EvalErrorWebAPi(err);

        $rootScope.$broadcast(AUTH_EVENTS.loginFailed);

      });
    }

    function failedAttempt() {
      $mdDialog.show(
        $mdDialog.alert(
          {
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: false,
            title: "Login Failed",
            textContent: "You have " + $scope.accessFailed + " attempt(s) remaining.",
            ariaLabel: "Login Failed",
            ok: "OK",
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
          .multiple(true)
      );
      $scope.hideProgress();
    }
    function LoadPortalVersion() {
      var promiseGet = genericService.get("Versions/");
      promiseGet.then(function (pl) {
        $scope.portalVersion = $filter("filter")(pl.data, { Name: 'Sedc Multiservice Portal Installer' })[0].Version;
      }, function () {

      });
    }

    function lockoutMessage() {
      $mdDialog.show(
        $mdDialog.alert(
          {
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: false,
            title: "Account Locked",
            textContent: "This account is currently locked due to too many failed login attempts. Please try again later.",
            ariaLabel: "Account Locked",
            ok: "OK",
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
          .multiple(true)
      );
    }

    function confirmAccountChange() {
      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.confirm(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title('Account Changed')
        .textContent('You are logging in using a different account. This will discard any unsaved changes. Do you want to proceed?')
        .ariaLabel('Account Changed')
        .ok('Yes')
        .cancel('No')
        .multiple(true);

      return $mdDialog.show(confirm);
    }


    function logOut() {
      authService.logOut(true);
      $state.go('app.pages_auth_login');
    }

    $window.onbeforeunload = $scope.onExit;

    $scope.goToCreateAccount = function () {
      authService.CheckIsPortalEnabled($scope.shownAsDialog, null, function () {
        $state.go('app.pages_auth_register');
      });
    };
    $scope.goToForgotPassword = function () {
      authService.CheckIsPortalEnabled($scope.shownAsDialog, null, function () {
        var roleType = 'user';
        if ($scope.shownAsDialog) {
          if ($rootScope.roleType === 'admin') {
            roleType = 'admin';
          }
        }
        $state.go('app.pages_auth_forgot-password', { roleType: roleType });
      });
    };
    $scope.goToForgotUsername = function () {
      authService.CheckIsPortalEnabled($scope.shownAsDialog, null, function () {
        var roleType = 'user';
        if ($scope.shownAsDialog) {
          if ($rootScope.roleType === 'admin') {
            roleType = 'admin';
          }
        }
        $state.go('app.pages_auth_forgotUserName', { roleType: roleType });
      });
    };

    /// showProgress: Method used to show the progress bar
    $scope.showProgress = function () {
      $scope.progress.activated = true;
    }

    /// hideProgress: Method used to hide the progress bar
    $scope.hideProgress = function () {
      $scope.progress.activated = false;
    }

    /// showSimpleToast: Method used for show the server response.
    var showSimpleToast = function (isSuccess, message) {
      var status = (isSuccess) ? "success" : "error";
      $scope.hideProgress();

      $mdToast.show({
        template: '<md-toast class="md-toast ' + status + '"><div class="md-toast-content ' + status + '">' + message + '</div></md-toast>',
        position: "top",
        hideDelay: 6000
      });
    };

    /// EvalErrorWebAPi: Method used for eval the error and display message to the user.
    $scope.EvalErrorWebAPi = function (err, customMessage) {
      var errors = [];

      if (err.data != null && err.data.error_description != null) {
        if (err.data.error_uri != null) {
          $scope.notification.message = err.data.error_description;
          $scope.flip();
        } else
          errors.push(err.data.error_description);

      } else if (err.data != null && err.data.modelState != null) {
        for (var key in err.data.modelState) {
          for (var i = 0; i < err.data.modelState[key].length; i++) {
            errors.push(err.data.modelState[key][i]);
          }
        }
      } else if (customMessage != null) {
        errors.push(customMessage);
      } else {
        errors.push("Internal error, please try again later!");
      }

      if (errors.length != null && errors.length > 0) {
        $scope.notification.message = errors.join(" <br /> "),
          $scope.notification.display = errors.join(" <br /> "),

          showSimpleToast(false, $scope.notification.message);
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.utility.location', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.pages_utility_location', {
            url: '/location',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_utility_location': {
                    templateUrl: 'app/auth/location/location.html',
                    controller: 'LocationController as vm'
                }
            },
            bodyClass: 'login',
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.utility.location')
      .controller('LocationController', ['genericService', 'authService', '$mdDialog', '$state', '$rootScope', '$scope', '$compile', '$mdSidenav', '$window', LocationController]);

  function LocationController(genericService, authService, $mdDialog, $state, $rootScope, $scope, $compile, $mdSidenav, $window) {
        $window.document.title = "Location - " + document.getElementById("title").title;
        var options = { timeout: 10000, enableHighAccuracy: true };
        var serviceController = 'OfficeLocation/';

        $scope.IsCollapsed = false;
        var infowindow = null;

        initialize();

        function initialize() {
            if (!$scope.Offices || $scope.Offices.length <= 0) {
                LoadOffices();
            }
            else {
                $scope.map = null;
                var myLatlng = new google.maps.LatLng($scope.SelectedOffice.Latitude, $scope.SelectedOffice.Longitude);

                var mapOptions = {
                    center: myLatlng,
                    zoom: 16,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };

                var map = new google.maps.Map(document.getElementById("map"),
                    mapOptions);

                $scope.map = map;

                for (var x = 0; x <= ($scope.Offices.length - 1) ; x++) {
                    createMarker($scope.Offices[x]);
                }

                CenterOnMe();
            }

        }

        function LoadOffices() {
            var promiseGet = genericService.get(serviceController);
            showProgress();

            promiseGet.then(function (pl) {
                if (pl.data) {
                    $scope.Offices = pl.data;
                    $scope.SelectedOffice = $scope.Offices[0];
                    initialize();
                    hideProgress();
                } else {
                  alert("No location data was found.");
                  hideProgress();
                }
            },
                function (errorPl) {
                    hideProgress();
                })

        }

        var createMarker = function (ofc) {
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(ofc.Latitude, ofc.Longitude),
                map: $scope.map
            });

            var infoWindowTemplate = "<div class='row'>" +
                                            "<div class='col'>" +
                                                "<p class='blueFont'>" + ofc.OfficeTypeDesc + " - " + ofc.City + ", " + ofc.State + "</p>" +
                                                "<div class='item-text-wrap item-icon-right'>" +
                                                    "<p>" + ofc.FullAddress + "</p>" +
                                                   "</div></div></div>";

            infowindow = new google.maps.InfoWindow()
            google.maps.event.addListener(marker, 'click', (function (marker, infoWindowTemplate, infowindow) {
                return function () {
                    infowindow.setContent(infoWindowTemplate);
                    infowindow.open($scope.map, marker);
                };
            })(marker, infoWindowTemplate, infowindow));
        }

        $scope.selectOffice = function (ofc) {

            if (ofc) {
                $scope.SelectedOffice = ofc;
                CenterOnMe();
                
            }

            //$scope.IsCollapsed = true;
            
        };

        $scope.toggle = function (componentID) {
            $mdSidenav(componentID).toggle();
        };


        function CenterOnMe() {
            if (!$scope.map) {
                return;
            }

            $scope.map.setCenter(new google.maps.LatLng($scope.SelectedOffice.Latitude, $scope.SelectedOffice.Longitude));

            var infoWindowTemplate = "<div class='row'>" +
                                            "<div class='col'>" +
                                                "<p class='blueFont'>" + $scope.SelectedOffice.OfficeTypeDesc + " - " + $scope.SelectedOffice.City + ", " + $scope.SelectedOffice.State + "</p>" +
                                                "<div class='item-text-wrap item-icon-right'>" +
                                                    "<p>" + $scope.SelectedOffice.FullAddress + "</p>" +
                                                   "</div></div></div>";

            infowindow = new google.maps.InfoWindow({
                content: infoWindowTemplate,
                position: new google.maps.LatLng($scope.SelectedOffice.Latitude, $scope.SelectedOffice.Longitude),
            });


            var marker = new google.maps.Marker({
                position: new google.maps.LatLng($scope.SelectedOffice.Latitude, $scope.SelectedOffice.Longitude),
                map: $scope.map,
            });

            infowindow.open($scope.map, marker);

            google.maps.event.addListener(marker, 'click', (function (marker, infoWindowTemplate, infowindow) {
                return function () {
                    infowindow.setContent(infoWindowTemplate);
                    infowindow.open($scope.map, marker);
                };
            })(marker, infoWindowTemplate, infowindow));
        };

        /// showProgress: Method used to show the progress bar
        function showProgress() {
            $scope.activated = true;
        }

        /// hideProgress: Method used to hide the progress bar
        function hideProgress() {
            $scope.activated = false;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.forgotUserName', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgotUserName', {
            url      : '/auth/forgotUserName/:roleType',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgotUserName': {
                    templateUrl: 'app/auth/forgotUserName/forgot-username.html',
                    controller : 'ForgotUserNameController as vm'
                }
            },
            bodyClass: 'forgotUserName',
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/forgotUserName');

        //// Navigation
        //msNavigationServiceProvider.saveItem('pages.auth.forgotUserName', {
        //    title : 'Forgot Password',
        //    state : 'app.pages_auth_forgot-username',
        //    weight: 5
        //});
    }

})();

(function ($scope, $location, authService, ngAuthSettings, $state, $window, genericService, $rootScope) {
  'use strict';

  angular
    .module('app.auth.forgotUserName')
    .controller('ForgotUserNameController', ForgotUserNameController, function ($scope, $location, authService) { });

  /** @ngInject */
  function ForgotUserNameController($scope, $location, authService, $rootScope, AUTH_EVENTS, $mdToast, commonService, $stateParams, $window) {
    authService.CheckIsPortalEnabled(false, null, null);
    $window.document.title = "Forgot Username - " + document.getElementById("title").title;
    // Data
    $scope.ForgotUserNameViewModel = {
      Email: "",
    };

    $scope.notification = {
      message: "",
      display: ""
    };

    $scope.flipped = false;

    $scope.flip = function () {
      $scope.flipped = !$scope.flipped;
    };

    $scope.progress = {
      activated: false
    };
    $scope.roleType = $stateParams.roleType;
    // Methods

    /// ValidateUserName: Method used for get the username from the server.
    $scope.ValidateUserName = function () {
      var form = $scope.forgotUserNameForm;
      authService.CheckIsPortalEnabled(false, form, function () {
        $scope.showProgress();

        authService.forgotUserName($scope.ForgotUserNameViewModel).then(function (response) {
          if (response.data === "true") {
            $scope.hideProgress();
            $scope.flip();

            form.$rollbackViewValue();
            $scope.ForgotUserNameViewModel.Email = "";
          }
          else {
            $scope.hideProgress();
            commonService.handleError(null, "Email Address is not found.");
          }
        },
          function (err) {
            $scope.hideProgress();
            commonService.handleError(err);
          });
      });
    };


    /// showProgress: Method used to show the progress bar
    $scope.showProgress = function () {
      $scope.progress.activated = true;
    }

    /// hideProgress: Method used to hide the progress bar
    $scope.hideProgress = function () {
      $scope.progress.activated = false;
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/auth/forgot-password/:roleType',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password',
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/forgot-password');
       
    }

})();

(function () {
  'use strict';

  angular
    .module('app.auth.forgot-password')
    .controller('ForgotPasswordController', ForgotPasswordController);

  function ForgotPasswordController(authService, commonService, $mdDialog, $rootScope, $scope, $stateParams, $window) {
    $window.document.title = "Forgot Password - " + document.getElementById("title").title;

    // Data Binding
    $scope.flipped = false;
    $scope.isUserExists = false;
    $scope.progress = {
      activated: false
    };
    $scope.roleType = $stateParams.roleType;
    $scope.showRetry = false;
    $scope.user = {
      username: "",
      email: ""
    };

    // Function Binding
    $scope.flip = Flip;
    $scope.forgotPassword = ForgotPassword;
    $scope.hideProgress = HideProgress;
    $scope.retry = Retry;
    $scope.showProgress = ShowProgress;

    // Init
    authService.CheckIsPortalEnabled(false, null, null);

    // Functions
    function Flip() {
      $scope.flipped = !$scope.flipped;
    }
    function forgetPasswordMessage() {
      $mdDialog.show(
        $mdDialog.alert(
          {
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: false,
            title: "Account Locked",
            textContent: "This account is currently locked due to too many failed login attempts. Please try again later or contact the utility for assistance.",
            ariaLabel: "Account Locked",
            ok: "OK",
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
          .multiple(true)
      );
    }
    function ForgotPassword() {
      var form = $scope.forgotPasswordForm;
      authService.CheckIsPortalEnabled(false, form, function () {
        $scope.showProgress();
        $scope.FPData = {
          useRefreshTokens: true,
          staySignedIn: true,
          Username: $scope.user.username
        };

        authService.lockoutUser($scope.FPData).then(function (response) {
          $scope.lockoutValue = response.data;
          var valLocation = $scope.lockoutValue.indexOf("*");
          $scope.accessFailed = parseInt($scope.lockoutValue.slice(1, valLocation));

          if ($scope.accessFailed == 4) {
            $scope.hideProgress();
            forgetPasswordMessage();
          }
          else {
            authService.forgotPassword($scope.user).then(function (response) {
              $scope.hideProgress();
              if (response.status === 200) {

                $scope.isUserExists = response.data === 'true' ? true : false;
                $scope.showRetry = $scope.isUserExists === false ? true : false;
                $scope.flip();

                /// TODO: Fix related to MND-878 (Sprint 12) message saying "You have unsaved changes..."
                form.$rollbackViewValue();
                /// TODO: Fix related to MND-878 (Sprint 12) message saying "You have unsaved changes..."
                $scope.user.username = "";
                $scope.user.email = "";
              }

              //TODO:Change this for the right one
              //$location.path('/portal/accounts');
            },
              function (err) {
                $scope.hideProgress();
                commonService.handleError(err);
              });
          }
        },
          function (err) {
            $scope.hideProgress();
            commonService.handleError(err);
          });
      });
    }
    function HideProgress() {
      $scope.progress.activated = false;
    }
    function Retry() {
      $scope.showRetry = false;
      $scope.flip();
    }
    function ShowProgress() {
      $scope.progress.activated = true;
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.utility.contact', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.pages_utility_contact', {
            url: '/contact-us',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_utility_contact': {
                    templateUrl: 'app/auth/contact/contact.html',
                    controller: 'ContactController as vm'  
                }
            },
            bodyClass: 'login',
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.utility.contact')
      .controller('ContactController', ['genericService', 'authService', '$mdDialog', '$state', '$rootScope', '$scope', '$timeout', '$interval', '$window', ContactController]);

  function ContactController(genericService, authService, $mdDialog, $state, $rootScope, $scope, $timeout, $interval, $window) {
        $window.document.title = "Contact Us - " + document.getElementById("title").title;
        var serviceController = 'OfficeLocation/';
        $scope.Offices = [];

        LoadSmartAppSettings();
        LoadOffices();

        //$scope.activated = false;

        function LoadSmartAppSettings() {
            var configserviceController = 'SmartAppConfig/';
            var promiseGet = genericService.get(configserviceController);
            $rootScope.smartAppConfig = {};

            promiseGet.then(function (pl) {
                $rootScope.smartAppConfig = pl.data;
            },
                function (errorPl) {
                    console.log('failure loading Offices', errorPl);
                })

        }

        function LoadOffices() {
            var promiseGet = genericService.get(serviceController);
            showProgress();

            promiseGet.then(function (pl) {
                hideProgress();

                if (!pl.data) {
                    $mdDialog.show(
                        $mdDialog.alert({
                            title: '<span class="badge badge-assertive">!</span> No office locations and contact details retrieved.',
                            template: '',
                            onComplete: function () {
                                $rootScope.$broadcast('msDialogIsOpened');
                            },
                            onRemoving: function () {
                                $rootScope.$broadcast('msDialogIsClosed');
                            }
                        })
                    );
                }
                else {
                    $scope.Offices = pl.data;
                    $scope.SelectedOffice = $scope.Offices[0];
                }

            },
            function (errorPl) {
                hideProgress();
                console.log('failure loading Offices', errorPl);
            })
        }

        /// showProgress: Method used to show the progress bar
        function showProgress() {
            $scope.activated = true;
        }

        /// hideProgress: Method used to hide the progress bar
        function hideProgress() {
            $scope.activated = false;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.confirmChangeEmail', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_confirmChangeEmail', {
            url      : '/confirm-email-change?uid&code',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_confirmChangeEmail': {
                    templateUrl: 'app/auth/confirmChangeEmail/confirmChangeEmail.html',
                    controller: 'ConfirmChangeEmailController as vm'
                }
            },
            bodyClass: 'confirmChangeEmail',
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/confirmChangeEmail');
    }

})();
(function ($scope, $location, authService, ngAuthSettings, $state, $window, genericService, $rootScope) {
    'use strict';

    angular
        .module('app.auth.confirmChangeEmail')
        .controller('ConfirmChangeEmailController', ConfirmChangeEmailController, function ($scope, $location, authService) { });

    /** @ngInject */
  function ConfirmChangeEmailController($scope, $location, authService, $rootScope, AUTH_EVENTS, $stateParams, $mdToast, $timeout, $window) {
    $window.document.title = "Confirm Change Email - " + document.getElementById("title").title;
    // DTO
        $scope.ValidateUserCodeViewModel = {
            UID: "",
            Code: "",
            Purpose: "",
        };

        $scope.ConfirmEmailViewModel = {
            UID :"",
            Code: "",
        }

        // Properties
        $scope.showForm = false;
        $scope.flipped = false;

        $scope.flip = function () {
            $scope.flipped = !$scope.flipped;
        };

        $scope.notification = {
            message: "",
            display: ""
        };

        $scope.progress = {
            activated: false
        };

        // Methods
        /// ValidateCode: Method used for validate the user token.
        $scope.ValidateCode = function () {
            $scope.showProgress();

            //alert("Pasok dito!");

            $scope.ValidateUserCodeViewModel.UID = $stateParams.uid;
            $scope.ValidateUserCodeViewModel.Code = $stateParams.code;
            $scope.ValidateUserCodeViewModel.Purpose = "Confirmation";

            $scope.hideProgress();
            $scope.showForm = true;

            $timeout(function () {
                $scope.hideProgress();
                $scope.notification.message = "You can now access your account again. <br/> Please click the link below to return to the Portal Login Screen.";
                $scope.notification.display = true;
                $scope.flip();
            }, 2000);
            //return;

            authService.validateUserCode($scope.ValidateUserCodeViewModel).then(function (response) {
                $scope.hideProgress();
                $scope.showForm = true;
                $timeout($scope.ConfirmUser, 2000);
            },
             function (err) {
                 $scope.hideProgress();
                 $location.path('/portal/accounts');
             });
        };

        $scope.ConfirmUser = function () {
            $scope.showProgress();

            $scope.ConfirmEmailViewModel.UID = $stateParams.uid;
            $scope.ConfirmEmailViewModel.Code = $stateParams.code;

            authService.confirmEmailEncode($scope.ConfirmEmailViewModel).then(function (response) {
                $scope.hideProgress();

                if (response.status === 200) {
                    $scope.notification.message = "Account has been successfully confirmed. <br/> Please click the link below to return to the Portal Login Screen.";
                    $scope.notification.display = true;

                    //$scope.flip();
                }
                else {
                    $scope.flip();
                }
                //$scope.notification.message = "Please feel free to enter in our application. <br />Click the link below to go to main page.";
                
            },
             function (err) {
                 console.log("err: " + err);
                 $scope.hideProgress(); 
                 $scope.EvalErrorWebAPi(err);
             });
        };

        /// showProgress: Method used to show the progress bar
        $scope.showProgress = function () {
            $scope.progress.activated = true;
        }

        /// hideProgress: Method used to hide the progress bar
        $scope.hideProgress = function () {
            $scope.progress.activated = false;
        }

        /// showSimpleToast: Method used for show the server response.
        var showSimpleToast = function (isSuccess, message) {
            var status = (isSuccess) ? "success" : "error";
            $scope.hideProgress();

            $mdToast.show({
                template: '<md-toast class="md-toast ' + status + '"><div class="md-toast-content ' + status + '">' + message + '</div></md-toast>',
                position: "top",
                hideDelay: 6000
            });
        };

        /// EvalErrorWebAPi: Method used for eval the error and display message to the user.
        $scope.EvalErrorWebAPi = function (err, customMessage) {
            var errors = [];

            if (err.data != null && err.data.error_description != null) {
                if (err.data.error_uri != null) {
                    var ErrMessage = encodeURI(err.data.error_description);
                    $state.go('app.' + err.data.error_uri, { ErrorMessage: ErrMessage });
                } else
                    errors.push(err.data.error_description);

            } else if (err.data != null && err.data.modelState != null) {
                for (var key in err.data.modelState) {
                    for (var i = 0; i < err.data.modelState[key].length; i++) {
                        errors.push(err.data.modelState[key][i]);
                    }
                }
            } else if (customMessage != null) {
                errors.push(customMessage);
            } else {
                errors.push("Internal error, please try again later!");
            }

            if (errors.length != null && errors.length > 0) {
                $scope.notification.message = errors.join(" <br /> "),
                $scope.notification.display = errors.join(" <br /> "),

                showSimpleToast(false, $scope.notification.message);
            }

        }
        //////////

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.confirm-user', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_confirm-user', {
            url      : '/confirm-user?uid&code',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_confirm-user': {
                    templateUrl: 'app/auth/confirm-user/confirm-user.html',
                    controller:  'ConfirmUserController as vm'
                }
            },
            bodyClass: 'confirm-user',
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/confirm-user');
    }

})();
(function ($scope, $location, authService, ngAuthSettings, $state, $window, genericService, $rootScope) {
  'use strict';

  angular
    .module('app.auth.confirm-user')
    .controller('ConfirmUserController', ConfirmUserController, function ($filter, $scope, $location, authService) { });

  /** @ngInject */
  function ConfirmUserController($filter, $scope, $location, authService, $rootScope, AUTH_EVENTS, $stateParams, $mdToast, $timeout, $window) {
    $window.document.title = "Confirm Change Username - " + document.getElementById("title").title;

    // DTO
    $scope.ResendActivationEmailViewEmail = {
      UserId: "",
      TimeZone: new Date()
    };
    $scope.ValidateUserCodeViewModel = {
      UID: "",
      Code: "",
      Purpose: "",
    };

    $scope.ConfirmEmailViewModel = {
      UID: "",
      Code: "",
    }

    // Properties
    $scope.action = '';
    $scope.showForm = false;
    $scope.flipped = false;
    $scope.errPage = false;
    $scope.response = '';

    $scope.flip = function () {
      $scope.flipped = !$scope.flipped;
    };

    $scope.notification = {
      message: "",
      display: ""
    };

    $scope.progress = {
      activated: false
    };

    // Methods
    $scope.resendEmail = function () {
      $scope.action = 'Resend Activation Email';
      $scope.showProgress();
      $scope.notification.display = false;
      $scope.ResendActivationEmailViewEmail.TimeZone = $filter('date')(new Date(), "Z");
      authService.resendEmail($scope.ResendActivationEmailViewEmail).then(function (response) {
        $scope.response = 'Activation Email sent';
        $scope.hideProgress();
        $scope.notification.display = true;
        $scope.errPage = false;
      }, function (err) {
        $scope.response = 'Activation Email not sent';
        $scope.hideProgress();
        $scope.errPage = true;
        $scope.notification.display = true;
      });
    }
    /// ValidateCode: Method used for validate the user token.
    var retryConfirm = 0;
    $scope.ValidateCode = function () {

      $scope.action = 'Validate User Code';
      $scope.ResendActivationEmailViewEmail.UserId = $stateParams.uid;
      //alert("Pasok dito!");

      $scope.ValidateUserCodeViewModel.UID = $stateParams.uid;
      $scope.ValidateUserCodeViewModel.Code = $stateParams.code;
      $scope.ValidateUserCodeViewModel.Purpose = "Confirmation";

      $scope.showProgress();
      $scope.showForm = true;

      authService.validateUserCode($scope.ValidateUserCodeViewModel).then(function (response) {
        if (response.data === 'Code verified') {
          $scope.showForm = true;
          $scope.ConfirmUser();
          $scope.errPage = false;
          $scope.response = response.data;
        } else if (response.data !== 'Code verified') {
          if (response.data === 'Code not verified' && retryConfirm < 30) {
            retryConfirm += 1;
            $scope.ValidateCode();
          }
          else {
            $scope.response = response.data;
            $scope.hideProgress();
            $scope.errPage = true;
            $scope.notification.display = true;
          }
        }
      }, function (err) {
        if (retryConfirm < 30) {
          retryConfirm += 1;
          $scope.ValidateCode();
        }
        else {
          $scope.hideProgress();
          $scope.errPage = true;
          $scope.notification.display = true;
        }
      });
    };

    $scope.ConfirmUser = function () {
      $scope.showProgress();

      $scope.ConfirmEmailViewModel.UID = $stateParams.uid;
      $scope.ConfirmEmailViewModel.Code = $stateParams.code;

      authService.confirmEmailEncode($scope.ConfirmEmailViewModel).then(function (response) {

        if (response.status === 200) {  
          $scope.notification.message = "Account has been successfully confirmed. <br/> Please click the link below to return to the Portal Login Screen.";
          $scope.notification.display = true;
          $scope.errPage = false;
          $scope.hideProgress();
          $scope.flip();
        }
        else {
          if (retryConfirm < 30) {
            retryConfirm += 1;
            $scope.ConfirmUser();
          }
          else {
            $scope.hideProgress();
            $scope.errPage = true;
            $scope.flip();
            $scope.notification.display = true;
          }
        }

      }, function (err) {
        if (retryConfirm < 30) {
          retryConfirm += 1;
          $scope.ConfirmUser();
        }
        else {
          $scope.hideProgress();
          $scope.EvalErrorWebAPi(err);
          $scope.errPage = true;
          $scope.notification.display = true;
        }
      });
    };

    /// showProgress: Method used to show the progress bar
    $scope.showProgress = function () {
      $scope.progress.activated = true;
    }

    /// hideProgress: Method used to hide the progress bar
    $scope.hideProgress = function () {
      $scope.progress.activated = false;
    }

    /// showSimpleToast: Method used for show the server response.
    var showSimpleToast = function (isSuccess, message) {
      var status = (isSuccess) ? "success" : "error";
      $scope.hideProgress();

      $mdToast.show({
        template: '<md-toast class="md-toast ' + status + '"><div class="md-toast-content ' + status + '">' + message + '</div></md-toast>',
        position: "top",
        hideDelay: 6000
      });
    };

    /// EvalErrorWebAPi: Method used for eval the error and display message to the user.
    $scope.EvalErrorWebAPi = function (err, customMessage) {
      var errors = [];

      if (err.data != null && err.data.error_description != null) {
        if (err.data.error_uri != null) {
          var ErrMessage = encodeURI(err.data.error_description);
          $state.go('app.' + err.data.error_uri, { ErrorMessage: ErrMessage });
        } else
          errors.push(err.data.error_description);

      } else if (err.data != null && err.data.modelState != null) {
        for (var key in err.data.modelState) {
          for (var i = 0; i < err.data.modelState[key].length; i++) {
            errors.push(err.data.modelState[key][i]);
          }
        }
      } else if (customMessage != null) {
        errors.push(customMessage);
      } else {
        errors.push("Internal error, please try again later!");
      }

      if (errors.length != null && errors.length > 0) {
        $scope.notification.message = errors.join(" <br /> "),
          $scope.notification.display = errors.join(" <br /> "),

          showSimpleToast(false, $scope.notification.message);
      }

    }
    //////////

  }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.changeUserName', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.pages_auth_changeUserName', {
            url: '/auth/changeUserName',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_changeUserName': {
                    templateUrl: 'app/auth/changeUserName/changeUserName.html',
                    controller: 'ChangeUserNameController as vm'
                }
            },
            resolve: {
                Validator: ["authService", function (authService) {
                    return authService.getEntityValidators('ChangeUserNameBindingModel', 'ChangeUserNameBindingModel')
                }]
            },
            bodyClass: 'changeUserName',
            data: {
                authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/changeUserName');
    }
})();


(function ($scope, $location, authService, ngAuthSettings, $state, $window, genericService, $rootScope, $mdDialog, commonService) {
  'use strict';

  angular
    .module('app.auth.changeUserName')
    .controller('ChangeUserNameController', ChangeUserNameController, function ($scope, $location, authService, $mdDialog, commonService, $state, $rootScope) { });

  /** @ngInject */
  function ChangeUserNameController($scope, $location, authService, $mdToast, Validator, $mdDialog, commonService, $state, $rootScope, $window) {
    authService.CheckIsPortalEnabled(true, null, null);
    $window.document.title = "Change Username - " + document.getElementById("title").title;
    $scope.ChangeUserNameBindingModel = {
      UserName: null,
      //OldUserName: (!authService.roleType ? authService.authentication.userName : authService.adminAuthentication.userName)
      OldUserName: null
    };

    $scope.Validators = Validator.data;

    $scope.notification = {
      message: "",
      display: ""
    };

    $scope.progress = {
      activated: false
    };


    //REVIEW: Pascal Case
    $scope.changeUserName = function (Form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        $scope.showProgress();
        $scope.ChangeUserNameBindingModel.UserName = $scope.ChangeUserNameBindingModel.UserName.trim();
        $scope.ChangeUserNameBindingModel.OldUserName = (!authService.roleType ? authService.authentication.userName : authService.adminAuthentication.userName);

        authService.changeUserName($scope.ChangeUserNameBindingModel).then(function (response) {

          $scope.hideProgress();
          Form.$aaFormExtensions.$resetChanged();

          var obj = JSON.parse(response.data)

          if (obj.succeeded.toString().toLowerCase() == "true") {
            var title = 'Username Changed';
            var text = 'Your Username has been successfully updated. Please try logging in again with your new username. Thank you!';
            var command = 'OK';
            DisplaySuccessMessage(title, text, command)
          }

        }, function (err) {
          $scope.hideProgress();
          var obj = '';
          try {
            obj = JSON.parse(err.data)
          }
          catch (e) {
            obj = err.data;
          }
          var title = 'Failed to Update Username';
          var text = '';
          if (!obj.modelState) {
            text = obj.message;
          }
          else {
            text = obj.modelState[""][0];
          }
          var command = 'Retry';
          DisplayMessage(title, text, command);
          Form.$aaFormExtensions.$resetChanged();
          $state.reload();
          //commonService.handleError(err);
        });
      });
    };

    $scope.GoBackToAccountsList = function () {
      if (!authService.adminAuthentication.roleType) {
        $state.go('app.msportal.accounts');
      }
      else {
        if (!authService.authentication.CustomerID) {
          $state.go('app.msportal.admin.customers');
        }
        else {
          $state.go('app.msportal.accounts', { CID: authService.authentication.CustomerID });
          var account = {
            Username: authService.authentication.userName,
            CustomerIDNumber: authService.authentication.CustomerID
          }
          $rootScope.showAdminToolbar = true;

          $rootScope.$broadcast('simulateAccount', account);

        }
      }
      //$rootScope.$broadcast('simulateAccount', account);
    }

    function DisplaySuccessMessage(title, text, command) {
      $mdDialog.show(

        $mdDialog.alert(
          {
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: false,
            title: title,
            textContent: text,
            ariaLabel: title,
            ok: command,
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              logOut()
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
      );

    }

    function DisplayMessage(title, text, command) {
      $mdDialog.show(

        $mdDialog.alert(
          {
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: false,
            title: title,
            textContent: text,
            ariaLabel: title,
            ok: command,
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
      );
    }

    $scope.showUserNameHelp = function () {
      commonService.showUserNameHelp()
    }

    function logOut() {
      //authService.logOut(); 
      //$state.go('app.pages_auth_login');
      if (!authService.adminAuthentication.roleType) {
        authService.logOut();
        $state.go('app.pages_auth_login');
      }
      else {
        // if (!authService.authentication.CustomerID) {
        authService.logOut();
        $state.go('app.pages_auth_adminLogin');
        //}
        //else {
        //    authService.authentication.userName = '';
        //    authService.authentication.useRefreshTokens = false;
        //    authService.authentication.roleType = '';
        //    authService.authentication.CustomerID = '';
        //    authService.authentication.staySignedIn = false;
        //    authService.authentication.email = '';
        //    authService.authentication.isAuth = false;
        //    $state.go('app.admin.customers')
        //}
      }
    }

    $scope.onExit = function () {
      if (!authService.authentication.staySignedIn) {
        authService.logOut();
      }
    };

    /// showProgress: Method used to show the progress bar
    $scope.showProgress = function () {
      $scope.progress.activated = true;
    }

    /// hideProgress: Method used to hide the progress bar
    $scope.hideProgress = function () {
      $scope.progress.activated = false;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.changePassword', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.pages_auth_changePassword', {
            url: '/auth/changePassword',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_changePassword': {
                    templateUrl: 'app/auth/changePassword/changePassword.html',
                    controller: 'changePasswordController as vm'
                }
            },
            resolve: {
                Validator: ["authService", function (authService) {
                    return authService.getEntityValidators('ChangePasswordBindingModel', 'ChangePasswordBindingModel')
                }]
            },
            bodyClass: 'changePassword',
            data: {
                authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/changePassword');
    }
})();


(function ($scope, $location, authService, ngAuthSettings, $state, $mdDialog, $window, genericService, $rootScope) {
  'use strict';

  angular
    .module('app.auth.changePassword')
    .controller('changePasswordController', changePasswordController, function ($scope, $location, $mdDialog, authService, $state, $rootScope) { });

  /** @ngInject */
  function changePasswordController($scope, $location, authService, $mdToast, $mdDialog, Validator, commonService, $state, $rootScope, $window) {
    authService.CheckIsPortalEnabled(true, null, null);
    $window.document.title = "Change Password - " + document.getElementById("title").title;
    $scope.ChangePasswordBindingModel = {
      OldPassword: null,
      NewPassword: null,
      ConfirmPassword: null
    };

    //authService.setChangePasswordValidator(Validator.data);

    $scope.Validators = Validator.data;
    $scope.OldPasswordValidate = false;

    $scope.notification = {
      message: "",
      display: ""
    };

    $scope.progress = {
      activated: false
    };

    //REVIEW: Pascal Case
    $scope.changePassword = function (Form) {
      authService.CheckIsPortalEnabled(true, null, function () {
        $scope.showProgress();

        authService.changePassword($scope.ChangePasswordBindingModel).then(function (response) {
          Form.$aaFormExtensions.$resetChanged();

          if (response.status === 200) {
            var title = "Change Password";
            var content = "Your password has been changed successfully!";
            var method = "Ok";
            $scope.hideProgress();

            DisplayMessage(title, content, method);
          }

        }, function (err) {
          $scope.hideProgress();

          commonService.handleError(err);
        });
      });
    };

    $scope.onExit = function () {
      if (!authService.authentication.staySignedIn) {
        authService.logOut();
      }
    };
    $scope.GoBackToAccountsList = function () {
      if (!authService.adminAuthentication.roleType) {
        $state.go('app.msportal.accounts');
      }
      else {
        if (!authService.authentication.CustomerID) {
          $state.go('app.msportal.admin.customers');
        }
        else {
          var account = {
            Username: authService.authentication.userName,
            CustomerIDNumber: authService.authentication.CustomerID
          }
          $state.go('app.msportal.accounts', { CID: authService.authentication.CustomerID });
          $rootScope.showAdminToolbar = true;

          $rootScope.$broadcast('simulateAccount', account);
        }
      }
    }
    /// showProgress: Method used to show the progress bar
    $scope.showProgress = function () {
      $scope.progress.activated = true;
    }

    /// hideProgress: Method used to hide the progress bar
    $scope.hideProgress = function () {
      $scope.progress.activated = false;
    }

    $scope.showPasswordHelp = function () {
      commonService.showPasswordHelp()
    }

    function DisplayMessage(title, text, command) {
      $mdDialog.show(
        $mdDialog.alert(
          {
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: false,
            title: title,
            textContent: text,
            ariaLabel: title,
            ok: command,
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
              $scope.GoBackToAccountsList();
            }
          })
      );
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.changeEmail', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.pages_auth_changeEmail', {
            url: '/auth/changeEmail',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_changeEmail': {
                    templateUrl: 'app/auth/changeEmail/changeEmail.html',
                    controller: 'ChangeEmailController as vm'
                }
            },
            resolve: {
                Validator: ["authService", function (authService) {
                    return authService.getEntityValidators('ChangeEmailBindingModel', 'ChangeEmailBindingModel')
                }]
            },
            bodyClass: 'changeEmail',
            data: {
                authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/changeEmail');
    }
})();


(function ($scope, $location, authService, ngAuthSettings, $state, $window, genericService, $rootScope, $mdDialog, commonService) {
  'use strict';

  angular
    .module('app.auth.changeEmail')
    .controller('ChangeEmailController', ChangeEmailController, function ($scope, $location, authService, $mdDialog, commonService, $state, $rootScope) { });

  /** @ngInject */
  function ChangeEmailController($scope, $location, authService, $mdToast, Validator, commonService, $rootScope, $mdDialog, $state, $window) {
    // #region Data Binding
    $scope.ChangeEmailBindingModel = {
      OldEmail: (!authService.roleType ? authService.authentication.email : authService.adminAuthentication.email),
      NewEmail: null,
      ConfirmEmail: null,
      UserName: (!authService.roleType ? authService.authentication.userName : authService.adminAuthentication.userName),
      Password: null,
      UtilityNumber: "(02) 477-66-61"
    };
    $scope.notification = {
      message: "",
      display: ""
    };
    $scope.progress = {
      activated: false
    };
    // #endregion Data Binding

    // #region Initialization
    ShowProgress();
    $window.document.title = "Change Email - " + document.getElementById("title").title;
    authService.CheckIsPortalEnabled(true, null, null);
    HideProgress();
    // #endregion Initialization

    // #region Method Binding
    $scope.changeEmail = ChangeEmail;
    $scope.GoBackToAccountsList = GoBackToAccountsList;
    $scope.hideProgress = HideProgress;
    $scope.onExit = OnExit;
    $scope.showProgress = ShowProgress;
    // #endregion Method Binding

    //REVIEW: Pascal Case
    function ChangeEmail(Form) {
      $scope.showProgress();
      authService.CheckIsPortalEnabled(true, null, function () {
        if (!$rootScope.utilityContact) {
          SendLocation();
        }

        $scope.ChangeEmailBindingModel.UtilityNumber = $rootScope.utilityContact;
        authService.changeEmail($scope.ChangeEmailBindingModel).then(function (response) {
          $scope.hideProgress();
          Form.$aaFormExtensions.$resetChanged();

          var obj = JSON.parse(response.data)

          if (obj.toString().toLowerCase() == "change email") {
            var title = 'E-mail Changed';
            var text = 'Your e-mail has been successfully updated. Please check your e-mail and click on the confirmation link to enable you to log in. Thank you!';
            var command = 'OK';
            DisplayMessage(title, text, command).then(function () {
              logOut();
            });
          }
        }, function (err) {
          $scope.hideProgress();
          var obj = '';
          try {
            obj = JSON.parse(err.data)
          }
          catch (e) {
            obj = err.data;
          }
          var title = 'Error Changing E-mail';
          var text = obj.message;
          var command = 'Retry';
          DisplayMessage(title, text, command);
          Form.$aaFormExtensions.$resetChanged();
          //$state.reload();
        });
      });
    }
    function DisplayMessage(title, text, command) {
      return $mdDialog.show($mdDialog.alert({
        parent: angular.element(document.querySelector('#popupContainer')),
        clickOutsideToClose: false,
        title: title,
        textContent: text,
        ariaLabel: title,
        ok: command,
        onComplete: function () {
          $rootScope.$broadcast('msDialogIsOpened');
        },
        onRemoving: function () {
          $rootScope.$broadcast('msDialogIsClosed');
        }
      }));
    }
    function GoBackToAccountsList() {
      if (!authService.adminAuthentication.roleType) {
        $state.go('app.msportal.accounts');
      }
      else {
        if (!authService.authentication.CustomerID) {
          $state.go('app.msportal.admin.customers');
        }
        else {
          var account = {
            Username: authService.authentication.userName,
            CustomerIDNumber: authService.authentication.CustomerID
          }
          $state.go('app.msportal.accounts', { CID: authService.authentication.CustomerID });
          $rootScope.showAdminToolbar = true;
          $rootScope.$broadcast('simulateAccount', account);
        }
      }
    }
    function HideProgress() {
      $scope.progress.activated = false;
    }
    function logOut() {
      if (!authService.adminAuthentication.roleType) {
        authService.logOut();
        $state.go('app.pages_auth_login');
      }
      else {
        // if (!authService.authentication.CustomerID) {
        authService.logOut();
        $state.go('app.pages_auth_adminLogin');
        //}
        //else {
        //    authService.authentication.userName = '';
        //    authService.authentication.useRefreshTokens = false;
        //    authService.authentication.roleType = '';
        //    authService.authentication.CustomerID = '';
        //    authService.authentication.staySignedIn = false;
        //    authService.authentication.email = '';
        //    authService.authentication.isAuth = false;
        //    $state.go('app.admin.customers')
        //}
      }
    }
    function OnExit() {
      if (!authService.authentication.staySignedIn) {
        authService.logOut();
      }
    }
    function SendLocation() {
      //var p = $rootScope.utilityOffices;
      if (!$rootScope.utilityOffices.length) {
        $rootScope.utilityContact = "its nearest branch";
      }
      else {
        for (var x = 0; x < $rootScope.utilityOffices.length; x++) {
          if ($rootScope.utilityOffices[x].OfficeType == 'M') {
            if (!$rootScope.utilityOffices[x].Telephone) {
              // No phone, just eadd
              if (!$rootScope.utilityOffices[x].EmailAddress) {
                // No phone AND eadd
                $rootScope.utilityContact = "its nearest branch";
              }
              else {
                $rootScope.utilityContact = $rootScope.utilityOffices[x].EmailAddress;
              }
            }
            else {
              // with phone
              var phone = $rootScope.utilityOffices[x].Telephone;
              phone = phone.substr(0, 3) + '-' + phone.substr(3, 3) + '-' + phone.substr(6, 4)
              if (!$rootScope.utilityOffices[x].EmailAddress) {
                // no eadd
                $rootScope.utilityContact = phone;
              }
              else {
                $rootScope.utilityContact = phone + " or " + $rootScope.utilityOffices[x].EmailAddress;
              }
            }
            break;
          }
        }
      }
    }
    function ShowProgress() {
      $scope.progress.activated = true;
    }
    // #endregion Functions
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.adminLogin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
       $stateProvider.state('app.pages_auth_adminLogin', {
            url      : '/auth/admin/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_adminLogin': {
                    templateUrl: 'app/auth/adminLogin/adminLogin.html',
                    controller: 'AdminLoginController as vm'                  
                },
                
            },
            resolve: {
                Validator: ["authService", function (authService) {
                    return authService.getEntityValidators('LoginBindingModel', 'loginData')
                }]
            },
            bodyClass: 'login',
            data: {
                authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        })
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/auth/adminLogin');
        //$translatePartialLoaderProvider.addPart('app/auth/adminlogin');

        //// Navigation
        //msNavigationServiceProvider.saveItem('auth', {
        //    title : 'Authentication',
        //    icon  : 'icon-lock',
        //    weight: 1
        //});

        //msNavigationServiceProvider.saveItem('auth.login', {
        //    title : 'Login',
        //    state : 'app.pages_auth_login',
        //    weight: 1
        //});
    }

})();
(function ($scope, $location, authService, ngAuthSettings, $state, $window, genericService, $rootScope) {
  'use strict';

  angular
    .module('app.auth.adminLogin')
    .controller('AdminLoginController', AdminLoginController, function ($scope, $location, authService) { });


  /** @ngInject */
  function AdminLoginController(genericService, $scope, $location, authService, $rootScope, AUTH_EVENTS, $mdToast, $state, $stateParams, $window, Validator, $mdDialog) {
    $window.document.title = "Admin Login - " + document.getElementById("title").title;
    $scope.Validators = Validator.data;
    $scope.shownAsDialog = $state.current.name != 'app.pages_auth_adminLogin';
    $scope.loginData = {
      useRefreshTokens: true,
      staySignedIn: true
    };

    $scope.notification = {
      message: "",
      display: ""
    };

    $scope.programs = [];
    $scope.progress = {
      activated: false
    };

    $scope.accessFailed = 0;
    $scope.lockoutValue = "";
    $scope.levelUser = "";

    $scope.resetNotification = function () {
      $scope.notification.message = "";
      $scope.notification.display = "";
    };


    $scope.flipped = false;
    $scope.showLoginError = false;
    $scope.showVersions = false;

    $scope.goToState = GoToState;

    $scope.flip = function (item) {
      if (item === 'versions') {
        $scope.showVersions = true;
      } else if (item === 'login') {
        $scope.showLoginError = false;
        $scope.showVersions = false;
      } else {
        $scope.showLoginError = true;
      }
      $scope.flipped = !$scope.flipped;
    };

    var accountChanged = false;
    LoadPortalVersion();

    function GoToState(stateName) {
      $scope.showProgress();
      authService.CheckIsPortalEnabled($scope.shownAsDialog, null, function () {
        $scope.hideProgress();
        $state.go(stateName, { roleType: 'admin' });
      });
    };

    function LoadPortalVersion() {
      var promiseGet = genericService.get("Versions/");
      promiseGet.then(function (pl) {
        ModifyProgramsProperties(pl.data);
        $scope.programs = pl.data;
      }, function () {

      });
    }
    function ModifyProgramsProperties(programs) {
      for (var i = 0; i < programs.length; i++) {
        var p = programs[i];
        if (p.Name === 'Sedc Multiservice Authentication Service') {
          p.Name = 'Authentication Service';
        } else if (p.Name === 'Sedc Multiservice Consumer Web API') {
          p.Name = 'Consumer Web API';
        } else if (p.Name === 'Sedc Multiservice Consumer WinService') {
          p.Name = 'Consumer WinService';
        } else if (p.Name === 'Sedc Multiservice Portal Installer') {
          p.Name = 'Portal Website (MSCP)';
        }
      }
    }
    //REVIEW: Pascal Case
    $scope.login = function (loginForm) {
      authService.adminAuthentication.userName = loginForm.usernameE.$viewValue.toLowerCase() === 'portaladmin' ? 'portaladmin' : '';
      authService.CheckIsPortalEnabled($scope.shownAsDialog, null, function () {
        if ($scope.shownAsDialog && loginForm.usernameE.$viewValue.toLowerCase() != $rootScope.previousUserName) {
          confirmAccountChange().then(function () {
            accountChanged = true;
            $scope.showProgress();
            lockoutUser(loginForm);
          }, function () {

          });
        } else {
          accountChanged = false;
          $scope.showProgress();
          lockoutUser(loginForm);
        }
      });
    };

    var continueLogin = function (loginForm) {
      $scope.showProgress();

      authService.login($scope.loginData).then(function (response) {
        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess, $scope.loginData);
        $scope.setCurrentUser($scope.loginData.Username);
        authService.adminAuthentication.isFirstLogin = true;

        $scope.hideProgress();

        if ($scope.shownAsDialog) {
          if (accountChanged) {
            if (!authService.adminAuthentication.roleType) {
              $window.location.href = 'portal/accounts';
            }
            else {
              //$window.location.href = 'admin/customers';//TODO: Change this to new landing page
              $state.go('app.msportal.admin.customers');
            }
          } else {
            $mdDialog.hide();
          }

        } else {
          $state.go('app.msportal.admin.customers');//TODO: Change this to new landing page.
          //$window.location.href = '/portal/admin/customers';
        }

      },
        function (err) {
          $scope.EvalErrorWebAPi(err);

          $rootScope.$broadcast(AUTH_EVENTS.loginFailed);

          if ($scope.lockoutValue) {
            failedAttempt();
          }
          else {
            $scope.hideProgress();
          }
        });
    }

    var lockoutUser = function (loginForm) {
      authService.lockoutUser($scope.loginData).then(function (response) {
        $scope.lockoutValue = response.data;
        var valLocation = $scope.lockoutValue.indexOf("*");
        var confirmedLoc = $scope.lockoutValue.indexOf("-");
        $scope.levelUser = $scope.lockoutValue.slice(valLocation + 1, confirmedLoc).toLowerCase();
        $scope.accessFailed = 3 - parseInt($scope.lockoutValue.slice(1, valLocation));
        //to check if the username is existing
        if (!$scope.lockoutValue) {
          continueLogin(loginForm);
          return;
        }
        if ($scope.levelUser != "admin") {
          $mdDialog.show(

            $mdDialog.alert(
              {
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: false,
                title: "Invalid Admin Account",
                textContent: "The account that you are using is not a valid ADMIN account. You may login with that account using the USER login page which you will be redirected to.",
                ariaLabel: "Invalid Admin Account",
                ok: "OK",
                onComplete: function () {
                  $rootScope.$broadcast('msDialogIsOpened');
                },
                onRemoving: function () {
                  $rootScope.$broadcast('msDialogIsClosed');
                  logOut();
                }
              })
          );
          $scope.hideProgress();
          return;
        }
        if ($scope.accessFailed <= 3 && $scope.accessFailed >= 0) {
          continueLogin(loginForm);
        }
        else {
          $scope.hideProgress();
          lockoutMessage();
        }

      }, function (err) {
        $scope.hideProgress();
        $scope.EvalErrorWebAPi(err);

        $rootScope.$broadcast(AUTH_EVENTS.loginFailed);

      });
    }

    function failedAttempt() {
      $mdDialog.show(
        $mdDialog.alert(
          {
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: false,
            title: "Login Failed",
            textContent: "You have " + $scope.accessFailed + " attempt(s) remaining.",
            ariaLabel: "Login Failed",
            ok: "OK",
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
          .multiple(true)
      );
      $scope.hideProgress();
    }

    function lockoutMessage() {
      $mdDialog.show(
        $mdDialog.alert(
          {
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: false,
            title: "Account Locked",
            textContent: "This account is currently locked due to too many failed login attempts. Please try again later.",
            ariaLabel: "Account Locked",
            ok: "OK",
            onComplete: function () {
              $rootScope.$broadcast('msDialogIsOpened');
            },
            onRemoving: function () {
              $rootScope.$broadcast('msDialogIsClosed');
            }
          })
          .multiple(true)
      );
    }

    function confirmAccountChange() {
      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.confirm(
        {
          clickOutsideToClose: false,
          onComplete: function () {
            $rootScope.$broadcast('msDialogIsOpened');
          },
          onRemoving: function () {
            $rootScope.$broadcast('msDialogIsClosed');
          }
        })
        .title('Account Changed')
        .textContent('You are logging in using a different account. This will discard any unsaved changes. Do you want to proceed?')
        .ariaLabel('Account Changed')
        .ok('Yes')
        .cancel('No')
        .multiple(true);

      return $mdDialog.show(confirm);
    }

    function logOut() {
      authService.logOut(true);
      $state.go('app.pages_auth_login');
    }

    $scope.onExit = function () {
      if (!authService.adminAuthentication.staySignedIn) {
        authService.logOut()
      }
    };

    $window.onbeforeunload = $scope.onExit;



    /// showProgress: Method used to show the progress bar
    $scope.showProgress = function () {
      $scope.progress.activated = true;
    }

    /// hideProgress: Method used to hide the progress bar
    $scope.hideProgress = function () {
      $scope.progress.activated = false;
    }

    /// showSimpleToast: Method used for show the server response.
    var showSimpleToast = function (isSuccess, message) {
      var status = (isSuccess) ? "success" : "error";
      $scope.hideProgress();

      $mdToast.show({
        template: '<md-toast class="md-toast ' + status + '"><div class="md-toast-content ' + status + '">' + message + '</div></md-toast>',
        position: "top",
        hideDelay: 6000
      });
    };

    /// EvalErrorWebAPi: Method used for eval the error and display message to the user.
    $scope.EvalErrorWebAPi = function (err, customMessage) {
      var errors = [];

      if (err.data != null && err.data.error_description != null) {
        if (err.data.error_uri != null) {
          $scope.notification.message = err.data.error_description;
          $scope.flip();
        } else
          errors.push(err.data.error_description);

      } else if (err.data != null && err.data.modelState != null) {
        for (var key in err.data.modelState) {
          for (var i = 0; i < err.data.modelState[key].length; i++) {
            errors.push(err.data.modelState[key][i]);
          }
        }
      } else if (customMessage != null) {
        errors.push(customMessage);
      } else {
        errors.push("Internal error, please try again later!");
      }

      if (errors.length != null && errors.length > 0) {
        $scope.notification.message = errors.join(" <br /> "),
          $scope.notification.display = errors.join(" <br /> "),

          showSimpleToast(false, $scope.notification.message);
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log, $resource)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular.module('angularPayments')
        .factory('Common', [function () {

            var ret = {};

            // expiry is a string "mm / yy[yy]"
            ret['parseExpiry'] = function (value) {
                var month, prefix, year, _ref;

                var isDate = new Date(value);
                isDate = new Date(isDate.getUTCFullYear(), isDate.getUTCMonth(), isDate.getUTCDate());
                //var currentTime = new Date(currentTime.getUTCFullYear(), currentTime.getUTCMonth(), currentTime.getUTCDate());

                if (value && isDate) {
                    /*console.log('value.split("-")[2]: ' + value.split("-")[2]);
                    console.log('value.split("-") != undefined ' + (value.split("-") != undefined));
                    console.log('value.split("-")[2] != undefined ' + (value.split("-")[2] != undefined));
                    console.log('parseInt(value.split("-")[2]) == 1 ' + (parseInt(value.split("-")[2]) == 1));
                    if (value.split("-") != undefined && value.split("-")[2] != undefined && parseInt(value.split("-")[2]) == 1)
                    {
                        console.log("if statement");
                        month = (isDate.getMonth() + 1);
                        console.log("month " + month);
                    }
                    else
                    {
                        console.log("else statement");
                        month = (isDate.getMonth());
                        console.log("month " + month);
                    }*/

                    if (value.split("-") != undefined && value.split("-")[2] != undefined)
                    { month = (isDate.getMonth() + 1); }


                    year = isDate.getFullYear();
                } else {

                    value = value || '';

                    value = value.replace(/\s/g, '');
                    _ref = value.split('/', 2), month = _ref[0], year = _ref[1];

                    if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
                        prefix = (new Date).getFullYear();
                        prefix = prefix.toString().slice(0, 2);
                        year = prefix + year;
                    }

                    month = parseInt(month, 10);
                    year = parseInt(year, 10);
                }

                return {
                    month: month,
                    year: year
                };
            }

            return ret;

        }]);

    angular
        .module('angularPayments')
        .directive('routingNumber', function () {

            var _passesLuhnCheck = function (routing) {
                var checksumTotal = (7 * (parseInt(routing.charAt(0), 10) + parseInt(routing.charAt(3), 10) + parseInt(routing.charAt(6), 10))) +
                  (3 * (parseInt(routing.charAt(1), 10) + parseInt(routing.charAt(4), 10) + parseInt(routing.charAt(7), 10))) +
                  (9 * (parseInt(routing.charAt(2), 10) + parseInt(routing.charAt(5), 10) + parseInt(routing.charAt(8), 10)));
                var checksumMod = checksumTotal % 10;
                if (checksumMod !== 0) return false;
                return true;
            }

            return {
                restrict: 'A',
                require: 'ngModel',
                compile: function (element, attributes) {
                    attributes.$set('pattern', '/[012346789][0-9]{8}/');
                    attributes.$set('maxlength', 9);
                    attributes.$set('xAutocompletetype', 'routing-transit-number');

                    return function (scope, elm, attrs, ngModel) {
                        ngModel.$validators.abaRoutingMinLength = function (value) {
                            if (!value || value === '') return true;
                            value = String(value);
                            if (value.length < 9) return false;
                            return true;
                        };

                        ngModel.$validators.abaRoutingMaxLength = function (value) {
                            if (!value || value === '') return true;
                            value = String(value);
                            if (value.length > 9) return false;
                            return true;
                        };

                        // internal routing numbers begin with a 5 - these are not valid routing numbers
                        ngModel.$validators.abaRoutingInternal = function (value) {
                            if (!value || value === '') return true;
                            value = String(value);
                            if (value.length < 1) return true; // don't fail if we don't have a value yet
                            if (value.substring(0, 1) === '5') return false;
                            return true;
                        };

                        ngModel.$validators.abaRouting = function (value) {
                            if (!value || value === '') return true;
                            if (typeof value !== 'string') return false;

                            // should be 9 digits, not starting with a 5
                            var abaRegex = /^[012346789][0-9]{8}$/;
                            if (!abaRegex.test(value)) return false;

                            // should pass the Luhn algorithm check
                            return _passesLuhnCheck(value);
                        };
                    };
                },
            };
        });

    angular
        .module('app.msportal')
        .run(['editableOptions', function (editableOptions) {
            editableOptions.theme = 'bs3';
        }]);


    angular
    .module('angularPayments')
    .config(['$provide', function ($provide) {
        $provide.decorator("paymentsValidateDirective", ['$delegate', '$window', '_Validate', '_ValidateWatch', function ($delegate, $window, _Validate, _ValidateWatch) {
            var directive = $delegate[0];

            var link = function myLinkFunction(scope, elem, attr, ctrl) {
                var type = attr.paymentsValidate;
                var crypto = attr.cryptoField;

                _ValidateWatch(type, ctrl, scope, attr);

                var validateFn = function (val) {
                    if (type == "card") {

                        var ModelValue = ctrl.$modelValue;

                        /// It validate if there are encryption functionality applied.
                        if (scope.$$parent != undefined && scope.$$parent.ClearValue != undefined) {
                            ModelValue = scope.$$parent.ClearValue;
                        }

                        if (ModelValue != undefined && !ctrl.$dirty && ModelValue.indexOf("*") == 0) {
                            /// Validate the Credit Card Type.
                            var validCardType = _Validate("cardType", val, ctrl, scope, attr);
                            ctrl.$setValidity("cardType", validCardType);

                            return validCardType ? ModelValue : undefined;
                        }

                        if (val != undefined && ctrl.$dirty) {

                            /// Validate the Credit Card Type.
                            var validCardType = _Validate("cardType", val, ctrl, scope, attr);
                            ctrl.$setValidity("cardType", validCardType);

                            if (!validCardType) {
                                return undefined;
                            }
                        }

                        /// Validate the Controller for credit card.
                        var valid = _Validate(type, val, ctrl, scope, attr);
                        ctrl.$setValidity(type, valid);

                        return valid ? val : undefined;
                    }

                    else {
                        var valid = _Validate(type, val, ctrl, scope, attr);
                        ctrl.$setValidity(type, valid);

                        return valid ? val : undefined;
                    }
                };
                ctrl.$formatters.push(validateFn);
                ctrl.$parsers.push(validateFn);
            }

            directive.compile = function () {
                return function (scope, elem, attr, ctrl) {

                    link.apply(this, arguments);
                };
            };

            return $delegate;
        }]);
    }]);

    angular
        .module('angularPayments')
        .factory('_Validate', ['Cards', 'Common', '$parse', function (Cards, Common, $parse) {

            var __indexOf = [].indexOf || function (item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; }

            var _luhnCheck = function (num) {
                var digit, digits, odd, sum, i, len;

                odd = true;
                sum = 0;
                digits = (num + '').split('').reverse();

                for (i = 0, len = digits.length; i < len; i++) {

                    digit = digits[i];
                    digit = parseInt(digit, 10);

                    if ((odd = !odd)) {
                        digit *= 2;
                    }

                    if (digit > 9) {
                        digit -= 9;
                    }

                    sum += digit;

                }

                return sum % 10 === 0;
            };

            var _validators = {}

            _validators['cvc'] = function (cvc, ctrl, scope, attr) {
                var ref, ref1;

                // valid if empty - let ng-required handle empty
                if (cvc == null || cvc.length == 0) return true;

                if (!/^\d+$/.test(cvc)) {
                    return false;
                }

                var type;
                if (attr.paymentsTypeModel) {
                    var typeModel = $parse(attr.paymentsTypeModel);
                    type = typeModel(scope);
                }

                if (type) {
                    return ref = cvc.length, __indexOf.call((ref1 = Cards.fromType(type)) != null ? ref1.cvcLength : void 0, ref) >= 0;
                } else {
                    return cvc.length >= 3 && cvc.length <= 4;
                }
            }

            _validators['card'] = function (num, ctrl, scope, attr) {
                var card, ref, typeModel;

                if (attr.paymentsTypeModel) {
                    typeModel = $parse(attr.paymentsTypeModel);
                }

                var clearCard = function () {
                    if (typeModel) {
                        typeModel.assign(scope, null);
                    }
                    ctrl.$card = null;
                };

                // valid if empty - let ng-required handle empty
                if (num == null || num.length == 0) {
                    clearCard();
                    return true;
                }

                num = (num + '').replace(/\s+|-/g, '');

                if (!/^\d+$/.test(num)) {
                    clearCard();
                    return false;
                }

                card = Cards.fromNumber(num);

                if (!card) {
                    clearCard();
                    return false;
                }

                ctrl.$card = angular.copy(card);

                /// Handle the credit card type if it comes from the server and the card number is masked.
                if (typeModel && num.length > 4) {
                    typeModel.assign(scope, card.type);
                }

                var ret = (ref = num.length, __indexOf.call(card.length, ref) >= 0) && (card.luhn === false || _luhnCheck(num));

                return ret;
            }

            _validators['expiry'] = function (val) {
                // valid if empty - let ng-required handle empty
                if (val == null || val.length == 0) return true;

                var obj = Common.parseExpiry(val);

                var month = obj.month;
                var year = obj.year;

                var currentTime, expiry, prefix;

                if (!(month && year)) {
                    return false;
                }

                if (!/^\d+$/.test(month)) {
                    return false;
                }

                if (!/^\d+$/.test(year)) {
                    return false;
                }

                if (!(parseInt(month, 10) <= 12)) {
                    return false;
                }

                /// This month is necesary for take the last date of the month to be compared.
                /// To doing this you have to do the next:
                /// If the current month is November then you are going to have [month = 10], because "Common.parseExpiry(val)" returns a cero base array.
                /// in order to get the last day of the month you have to use this date format (yyyy-mm-01). That means that
                /// if you want to know the last day of november of 2016, you need to use this date (new Date(2016-12-01)) this is going to
                /// return (November 30 2016).
                //month = parseInt(month) + 2;

                /// Common.parseExpiry(val) now returns actual month instead of zero-based array.
                /// Add an additional month to get the last day of the selected month-year
                /*month = parseInt(month) + 1;

                /// It reset the month greater than 12.
                if (parseInt(month) > 12) {
                    month = parseInt(month) - 12;
                    year = parseInt(year) + 1;
                }

                /// The month have to be parsed with left cero.
                if (parseInt(month) < 10) {
                    month = "0" + month;
                }*/

                /// Note: Using this format "yyyy-mm-01" it takes the last day of the month when instantiate the new Date() function.
                /*var dateFixed = year + "-" + month + "-01";
                expiry = new Date(dateFixed);
                expiry.setDate(expiry.getDate() - 1);
                var expiry = new Date(Date.UTC(expiry.getFullYear(), expiry.getMonth(), expiry.getDate()));*/

                //var expiry = new Date(Date.UTC(year, month, month));

                currentTime = new Date;
                var currMonth, currYear;
                currMonth = currentTime.getMonth() + 1;
                currYear = currentTime.getFullYear();

                var returnStatement = false;
                if (obj.year > currYear) {
                    returnStatement = true;
                }
                else if (obj.year == currYear) {
                    if (obj.month >= currMonth) {
                        returnStatement = true;
                    }
                }

                //return expiry >= currentTime;
                return returnStatement;
            }

            _validators['cardType'] = function (num, ctrl, scope, attr) {
                var isTypeValid = false;
                var card, typeModel, typeModelValid;

                var clearCard = function () {
                    if (typeModel) {
                        typeModel.assign(scope, null);
                    }
                    ctrl.$card = null;
                };

                // valid if empty - let ng-required handle empty
                if (num == null || num.length == 0) {
                    clearCard();
                    return true;
                }



                if (attr.paymentsTypeModelValid) {
                    typeModelValid = $parse(attr.paymentsTypeModelValid);
                }

                if (attr.paymentsTypeModel) {
                    typeModel = $parse(attr.paymentsTypeModel);
                }

                if (typeModel != undefined && typeModel(scope) != null) {
                    card = Cards.fromType(typeModel(scope));
                }

                if (card == undefined || !card) {
                    card = Cards.fromNumber(num);

                    if (card != null && card.type != null) {
                        typeModel.assign(scope, card.type);
                    }
                }


                if (!card) {
                    clearCard();

                    /// I return true but the required field validation will do the work.
                    return true;
                }

                ctrl.$card = angular.copy(card);


                /// Validates if the credit card number is allowed.
                if (typeModelValid(scope)) {
                    switch (ctrl.$card.type) {
                        case "visa":
                            isTypeValid = (typeModelValid(scope).INT_COOPPARM_1 > 0);
                            break;
                        case "mastercard":
                            isTypeValid = (typeModelValid(scope).INT_COOPPARM_2 > 0);
                            break;
                        case "discover":
                            isTypeValid = (typeModelValid(scope).INT_COOPPARM_3 > 0);
                            break;
                        case "amex":
                            isTypeValid = (typeModelValid(scope).INT_COOPPARM_4 > 0);
                            break;
                    }

                }

                return isTypeValid;
            }


            return function (type, val, ctrl, scope, attr) {
                if (!_validators[type]) {

                    types = Object.keys(_validators);

                    errstr = 'Unknown type for validation: "' + type + '". ';
                    errstr += 'Should be one of: "' + types.join('", "') + '"';

                    throw errstr;
                }
                return _validators[type](val, ctrl, scope, attr);
            }
        }]);

    angular
        .module('angularPayments')
        .factory('_Format', ['Cards', 'Common', '$filter', function (Cards, Common, $filter) {

            var _formats = {}

            var _hasTextSelected = function ($target) {
                var ref;

                if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== $target.prop('selectionEnd')) {
                    return true;
                }

                if (typeof document !== "undefined" && document !== null ? (ref = document.selection) != null ? typeof ref.createRange === "function" ? ref.createRange().text : void 0 : void 0 : void 0) {
                    return true;
                }

                return false;
            };

            // card formatting

            var _formatCardNumber = function (e) {
                var $target, card, digit, length, re, upperLength, value;

                digit = String.fromCharCode(e.which);
                $target = angular.element(e.currentTarget);
                value = $target.val();
                card = Cards.fromNumber(value + digit);
                length = (value.replace(/\D/g, '') + digit).length;

                upperLength = 16;

                //Override for backspace issue in Firefox (MND-890)
                if (e.keyCode == 46 || e.keyCode == 8 || (e.keyCode >= 37 && e.keyCode <= 40)) {
                    return;
                }

                if (card) {
                    upperLength = card.length[card.length.length - 1];
                }

                if (length >= upperLength) {
                    return;
                }

                if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
                    e.preventDefault();
                    return;
                }

                if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
                    return;
                }

                re = Cards.defaultInputFormat();
                if (card) {
                    re = card.inputFormat;
                }

                if (re.test(value)) {
                    e.preventDefault();
                    return $target.val(value + ' ' + digit);

                } else if (re.test(value + digit)) {
                    e.preventDefault();
                    return $target.val(value + digit + ' ');

                }
            };

            var _restrictCardNumber = function (e) {
                var $target, card, digit, value;

                $target = angular.element(e.currentTarget);
                digit = String.fromCharCode(e.which);

                if (!/^\d+$/.test(digit)) {
                    return;
                }

                if (_hasTextSelected($target)) {
                    return;
                }

                value = ($target.val() + digit).replace(/\D/g, '');
                card = Cards.fromNumber(value);

                if (card) {
                    if (!(value.length <= card.length[card.length.length - 1])) {
                        e.preventDefault();
                    }
                } else {
                    if (!(value.length <= 16)) {
                        e.preventDefault();
                    }
                }
            };

            var _formatBackCardNumber = function (e) {
                var $target, value;

                $target = angular.element(e.currentTarget);
                value = $target.val();

                if (e.meta) {
                    return;
                }

                if (e.which !== 8) {
                    return;
                }

                if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
                    return;
                }

                if (/\d\s$/.test(value) && !e.meta && e.keyCode >= 46) {
                    e.preventDefault();
                    return $target.val(value.replace(/\d\s$/, ''));
                } else if (/\s\d?$/.test(value)) {
                    e.preventDefault();
                    return $target.val(value.replace(/\s\d?$/, ''));
                }
            };

            var _getFormattedCardNumber = function (num) {
                var card, groups, upperLength, ref;
                card = Cards.fromNumber(num);

                if (!card) {
                    return num;
                }

                upperLength = card.length[card.length.length - 1];
                num = num.replace(/\D/g, '');
                num = num.slice(0, +upperLength + 1 || 9e9);

                if (card.format.global) {
                    return (ref = num.match(card.format)) != null ? ref.join(' ') : void 0;
                } else {
                    groups = card.format.exec(num);

                    if (groups != null) {
                        groups.shift();
                    }

                    return groups != null ? groups.join(' ') : void 0;
                }
            };

            var _reFormatCardNumber = function (e) {
                return setTimeout(function () {
                    var $target, value;
                    $target = angular.element(e.target);

                    value = $target.val();
                    value = _getFormattedCardNumber(value);
                    return $target.val(value);
                });
            };

            var _parseCardNumber = function (value) {
                /// Fix of the MND-890 related to the Credit Card Number format.

                if (value != null) {
                    value = value.replace(/\D/g, '');
                    value = _getFormattedCardNumber(value);
                }

                return value;
            };

            _formats['card'] = function (elem, ctrl) {
                elem.bind('keypress', _restrictCardNumber);
                elem.bind('keypress', _formatCardNumber);
                elem.bind('keydown', _formatBackCardNumber);
                elem.bind('paste', _reFormatCardNumber);

                ctrl.$parsers.push(_parseCardNumber);
                ctrl.$formatters.push(_getFormattedCardNumber);
            }


            // cvc

            var _formatCVC = function (e) {
                $target = angular.element(e.currentTarget);
                digit = String.fromCharCode(e.which);

                if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
                    e.preventDefault();
                    return;
                }

                val = $target.val() + digit;

                if (val.length <= 4) {
                    return;
                } else {
                    e.preventDefault();
                    return;
                }
            }

            _formats['cvc'] = function (elem) {
                elem.bind('keypress', _formatCVC)
            }

            // expiry

            var _restrictExpiry = function (e) {
                var $target, digit, value;

                $target = angular.element(e.currentTarget);
                digit = String.fromCharCode(e.which);

                if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
                    e.preventDefault();
                    return;
                }

                if (_hasTextSelected($target)) {
                    return;
                }

                value = $target.val() + digit;
                value = value.replace(/\D/g, '');

                if (value.length > 6) {
                    e.preventDefault()
                    return;
                }
            };

            var _formatExpiry = function (e) {
                var $target, digit, val;

                digit = String.fromCharCode(e.which);

                if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
                    e.preventDefault();
                    return;
                }

                $target = angular.element(e.currentTarget);
                val = $target.val() + digit;

                if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
                    e.preventDefault();
                    return $target.val("0" + val + " / ");

                } else if (/^\d\d$/.test(val)) {
                    e.preventDefault();
                    return $target.val("" + val + " / ");

                }
            };

            var _formatForwardExpiry = function (e) {
                var $target, digit, val;

                digit = String.fromCharCode(e.which);

                if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
                    return;
                }

                $target = angular.element(e.currentTarget);
                val = $target.val();

                if (/^\d\d$/.test(val)) {
                    return $target.val("" + val + " / ");
                }
            };

            var _formatForwardSlash = function (e) {
                var $target, slash, val;

                slash = String.fromCharCode(e.which);

                if (slash !== '/') {
                    return;
                }

                $target = angular.element(e.currentTarget);
                val = $target.val();

                if (/^\d$/.test(val) && val !== '0') {
                    return $target.val("0" + val + " / ");
                }
            };

            var _formatBackExpiry = function (e) {
                var $target, value;

                if (e.meta) {
                    return;
                }

                $target = angular.element(e.currentTarget);
                value = $target.val();

                if (e.which !== 8) {
                    return;
                }

                if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
                    return;
                }

                if (/\d(\s|\/)+$/.test(value)) {
                    e.preventDefault();
                    return $target.val(value.replace(/\d(\s|\/)*$/, ''));

                } else if (/\s\/\s?\d?$/.test(value)) {
                    e.preventDefault();
                    return $target.val(value.replace(/\s\/\s?\d?$/, ''));

                }
            };

            var _parseExpiry = function (value) {

                if (value != null) {
                    var obj = Common.parseExpiry(value);
                    var expiry = new Date(obj.year, obj.month - 1);
                    return $filter('date')(expiry, 'MM/yyyy');
                }
                return null;
            };

            var _getFormattedExpiry = function (value) {

                if (value != null) {
                    var obj = Common.parseExpiry(value);
                    var expiry = new Date(obj.year, obj.month - 1);
                    return $filter('date')(expiry, 'MM / yyyy');
                }
                return null;
            };


            _formats['expiry'] = function (elem, ctrl) {
                elem.bind('keypress', _restrictExpiry);
                elem.bind('keypress', _formatExpiry);
                elem.bind('keypress', _formatForwardSlash);
                elem.bind('keypress', _formatForwardExpiry);
                elem.bind('keydown', _formatBackExpiry);

                ctrl.$parsers.push(_parseExpiry);
                ctrl.$formatters.push(_getFormattedExpiry);
            }

            return function (type, elem, ctrl) {
                if (!_formats[type]) {

                    types = Object.keys(_formats);

                    errstr = 'Unknown type for formatting: "' + type + '". ';
                    errstr += 'Should be one of: "' + types.join('", "') + '"';

                    throw errstr;
                }
                return _formats[type](elem, ctrl);
            }

        }])

})();
(function ()
{
	'use strict';

	/* Directive Used to control the values introduced in a currency input field */
	angular
		.module('app.core')
		.directive("stringToNumber", ["$filter", directive]);

	function directive($filter) {

		function getCaretPosition(input) {
			if (!input) return 0;

			if (input.selectionStart !== undefined) {
				return input.selectionStart;
			} else if (document.selection) {
				// Curse you IE
				input.focus();
				var selection = document.selection.createRange();
				selection.moveStart('character', input.value ? -input.value.length : 0);
				return selection.text.length;
			}

			return 0;
		}

		function setCaretPosition(input, pos) {
			if (!input) return 0;
			if (input.offsetWidth === 0 || input.offsetHeight === 0) {
				return; // Input's hidden
			}
			if (input.setSelectionRange) {
				//input.focus(); Commented by Rovie 3/2/2017 fix for MND-961
				input.setSelectionRange(pos, pos);
			}
			else if (input.createTextRange) {
				// Curse you IE
				var range = input.createTextRange();
				range.collapse(true);
				range.moveEnd('character', pos);
				range.moveStart('character', pos);
				range.select();
			}
		}

		return {
			priority: 1,
			require: 'ngModel',
			restrict: 'A',
			scope: true,
			link: function (scope, element, attrs, controller) {
				
				function NumberToString(value) {
				    var oldModelValue = controller.$modelValue;
				    if (isNaN(value)) {
				        value = oldModelValue;
				    } else if (!value) {
				        value = 0;
				    }

				    var newModelValue = parseFloat(value).toFixed(2);
					var pos = getCaretPosition(element[0]);
					
					element.val(parseFloat(value).toFixed(2));

					var newPos = pos + controller.$viewValue.length - value.length;

					if ((oldModelValue === undefined) || isNaN(oldModelValue)) {
						newPos -= 3;
					}
					
					setCaretPosition(element[0], newPos);

					return newModelValue;
				}

				function StringToNumber(value) {
				    return $filter('number') (value, '2');
				}

				controller.$parsers.push(NumberToString);
				controller.$formatters.push(StringToNumber);


				//element.bind('keypress', function (val) {				    
				//	//switch(val.charCode)
				//	//{
				//	//    case 8:
				//	//    case 48:
				//	//    case 49:
				//	//	case 50:
				//	//	case 51:
				//	//	case 52:
				//	//	case 53:
				//	//	case 54:
				//	//	case 55:
				//	//	case 56:
				//	//	case 57:

				//	//		break;
				//	//	default:
				//	//		val.preventDefault();

				//	//}
				//});
			}
		};
	}

})();

(function () {
    'use strict';

    /* 
    Usage: use this directive to override angular-agility's navigate away strategies.
    Related Attributes:
    - prevent-leaving-unsaved => Required. Assign a string to it to override the default message on the pop up.
    - login-required => Add login-required="false" to a form if you want to display the 
      'Unsaved changes' pop up even when the user is not logged in (in Registration form for example)
    - on-navigate-away-strategy => This MUST have a value in order to override angular-agility's 
      default strategy.
    - tab-index => use this on any form contained in the tabs (Services, Profile, Billing History, etc.).
      This is needed to determine which tab to go back to when the user clicks on Cancel on the 'Unsaved Changes' pop up.
    */


    angular
        .module('app.core')
        .directive("preventLeavingUnsaved", ["aaFormExtensions", "$rootScope", 'authService', '$transitions', directive]);

    function directive(aaFormExtensions, $rootScope, authService, $transitions) {
        return {
            priority: 2,
            restrict: "A",
            require: "form",
            compile: function () {
                return {
                    pre: function (scope, element, attrs, ctrl) {
                        var funcName = attrs.onNavigateAwayStrategy;

                        if(funcName){

                        //add the function to aaFormExtensions.onNavigateAwayStrategies array
                            aaFormExtensions.onNavigateAwayStrategies[funcName] = function (rootFormScope, rootForm, $injector) {
                                var confirmationMessage = attrs.preventLeavingUnsaved || 'You have unsaved changes. Are you sure you want to navigate away without saving them?';
                                var tabIndex = attrs.tabIndex;
                                var loginRequired = attrs.loginRequired;

                                var deRegisterEventListener = $transitions.onStart({ }, function (transition) {

                                    if (rootForm.$aaFormExtensions.$changed) { //if the value of any field in the form is changed
                                        if ((authService.isLoggedIn() || loginRequired == 'false') && !window.confirm(confirmationMessage)) {
                                            transition.abort();
                                            $rootScope.loadingProgress = false;
                                            if (tabIndex) {//if the element has tab-index attribute
                                                //broadcast event to move back to tab containing the form. This is handled in serviceController
                                                $rootScope.$broadcast('setCurrentTabIndex', tabIndex);
                                            }
                                        } else {
                                            //reset the form to prevent the pop up from showing again when user tries to navigate away
                                            ctrl.$aaFormExtensions.$reset(true);
                                        }
                                    }
                                });

                                //NATIVE DOM IE9+
                                function beforeUnload(e) {
                                    if (rootForm.$aaFormExtensions.$changed) {
                                        (e || window.event).returnValue = confirmationMessage;
                                        return confirmationMessage;
                                    }
                                }

                                angular.element(window).on('beforeunload', beforeUnload);

                                rootFormScope.$on('$destroy', function () {
                                    deRegisterEventListener();
                                    angular.element(window).off('beforeunload', beforeUnload);
                                });
                            }
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';
    angular
	.module('app.core')
	.directive('notEqualToValue', function () {
	    return {
	        priority: 2,
	        restrict: 'A',
	        require: 'ngModel',
	        link: function (scope, element, attr, ctrl) {

	            var compareValue = attr.notEqualToValue;

	            var check = function (value) {

	                var isSame = value === compareValue;

	                ctrl.$setValidity("notEqualTo", !isSame);

	                return value;

	            }

	            ctrl.$parsers.push(check);
	            ctrl.$formatters.push(check);
	            attr.$observe("notEqualToWatch", function (value) {
	                compareValue = value;
	                check(ctrl.$$rawModelValue);
	            });

	            check(ctrl.$$rawModelValue);

	        }
	    };
	});
})();
(function () {
    'use strict';

    /* 
    Usage: use this directive to override angular-agility's navigate away strategies.
    Related Attributes:
    - prevent-leaving-unsaved => Required. Assign a string to it to override the default message on the pop up.
    - login-required => Add login-required="false" to a form if you want to display the 
      'Unsaved changes' pop up even when the user is not logged in (in Registration form for example)
    - on-navigate-away-strategy => This MUST have a value in order to override angular-agility's 
      default strategy.
    - tab-index => use this on any form contained in the tabs (Services, Profile, Billing History, etc.).
      This is needed to determine which tab to go back to when the user clicks on Cancel on the 'Unsaved Changes' pop up.
    */


    angular
        .module('app.core')
        .directive('msPassword', function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attr, ctrl) {

                    var check = function (value) {

                        var isValid = true;
                        var str = ctrl.$viewValue;

                        if (str) {

                            if ((attr.msRequireNumbers !== 'false' && str.search(/\d/) == -1)) {
                                isValid = false
                            }
                            if ((attr.msRequireSpecialChars !== 'false' && !(/\W/.test(str)))) {
                                isValid = false
                            }
                            if (attr.msRequireCapitalLetter !== 'false' && str.search(/[A-Z]/) == -1) {
                                isValid = false
                            }
                            if (attr.msRequireSmallLetter !== 'false' && str.search(/[a-z]/) == -1) {
                                isValid = false
                            }

                        }

                        ctrl.$setValidity("ms-password", isValid);

                        return value;

                    }

                    ctrl.$parsers.push(check);
                    ctrl.$formatters.push(check);

                    check(ctrl.$modelValue);

                }
            };
        })
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    /* Directive Used to display google map */
    angular
        .module('app.core')
        .directive('googleMap', function () {
            return {
                restrict: 'E',
                template: '<div></div>',
                replace: true,
                link: function (scope, element, attrs) {
                    function initialize() {
                        var myLatlng = new google.maps.LatLng(20, 50);

                        var mapOptions = {
                            center: myLatlng,
                            zoom: 16,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        };

                        var map = new google.maps.Map(attrs.id,
                        mapOptions);
                    }

                    google.maps.event.addDomListener(window, "load", initialize);
                }
            };
        });
})();
(function ()
{
    'use strict';

    /* Directive Used to control a Compare Validator function in an input field */
    angular
        .module('app.core')
        .directive
  ('emailAddressCheck'
  , function () {
      var directive =
        {
            require: 'ngModel'
        , link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (value) {
                var isValid = (/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(value))

                ctrl.$setValidity('invalid', !!isValid)
                return value
            })
        }
        }
      return directive
  }
    )
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('customerSearch', customerSearch);

    //function customerSearch() {
    //    return {
    //        require: 'ngModel',
    //        link: function (scope, elm, attr, ctrl) {
    //            var selectedField = attr.customerSearch;
    //            var regex;
                
    //            var check = function (value) {

    //                switch (selectedField) {
    //                    case "Customer ID":
    //                        regex = /^\d{5}$/g;
    //                        break;
    //                    case "Account Number":
    //                        regex = /^\d{8}$/g;
    //                        break;
    //                    case "Name":
    //                        regex = /^[a-zA-Z-\s]+$/g;
    //                        break;
    //                    case "Address":
    //                        regex = /[^;:]/g;
    //                        break;
    //                }

    //                scope.customerSearchPattern = regex;
    //                return value;
    //            }

    //            ctrl.$parsers.push(check);
    //            attr.$observe("changeField", function (value) {
    //                selectedField = value;
    //                check(ctrl.$$rawModelValue);
    //            });

    //            check(ctrl.$$rawModelValue);
    //        }
    //    };
    //}

    function customerSearch() {
        return {
            require: 'ngModel',
            link: function (scope, elm, attr, ctrl) {
                var selectedField = attr.customerSearch;
                var regex;

                var check = function (value) {

                    switch (selectedField) {
                        case "Customer ID":
                            regex = "9?9?9?9?9?9?9?9";
                            break;
                        case "Account Number":
                            regex = "9?9?9?9?9?9?9?9";
                            break;
                        case "Name":
                            regex = "*";
                            break;
                        case "Address":
                            regex = "*";
                            break;
                    }

                    scope.customerSearchPattern = regex;
                    return value;
                }

                ctrl.$parsers.push(check);
                attr.$observe("changeField", function (value) {
                    selectedField = value;
                    check(ctrl.$$rawModelValue);
                });

                check(ctrl.$$rawModelValue);
            }
        };
    }
})();
(function ()
{
    'use strict';

    /* Directive Used to control the values introduced in a currency input field */
    angular
        .module('app.core')
        .directive("realTimeCurrency", ["$filter", "$locale", directive]);

    function directive($filter, $locale) {
        var decimalSep = $locale.NUMBER_FORMATS.DECIMAL_SEP;
        var toNumberRegex = new RegExp('[^0-9\\' + decimalSep + ']', 'g');
        var trailingZerosRegex = new RegExp('\\' + decimalSep + '0+$');

        var filterFunc = function (value) {
            return $filter('currency')(value);
        };

        function getCaretPosition(input) {
            if (!input) return 0;

            if (input.selectionStart !== undefined) {
                return input.selectionStart;
            } else if (document.selection) {
                // Curse you IE
                input.focus();
                var selection = document.selection.createRange();
                selection.moveStart('character', input.value ? -input.value.length : 0);
                return selection.text.length;
            }

            return 0;
        }

        function setCaretPosition(input, pos) {
            if (!input) return 0;
            if (input.offsetWidth === 0 || input.offsetHeight === 0) {
                return; // Input's hidden
            }
            if (input.setSelectionRange) {
                input.focus();
                input.setSelectionRange(pos, pos);
            }
            else if (input.createTextRange) {
                // Curse you IE
                var range = input.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        }

        function toNumber(currencyStr) {
            return parseFloat(currencyStr.replace(toNumberRegex, ''), 10);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function postLink(scope, elem, attrs, modelCtrl) {
                modelCtrl.$formatters.push(filterFunc);

                modelCtrl.$parsers.push(function (newViewValue) {
                    var oldModelValue = modelCtrl.$modelValue;
                    var newModelValue = toNumber(newViewValue);

                    modelCtrl.$viewValue = filterFunc(newModelValue);
                    
                    var pos = getCaretPosition(elem[0]);
                    
                    elem.val(modelCtrl.$viewValue);
                    
                    var newPos = pos + modelCtrl.$viewValue.length - newViewValue.length;

                    if ((oldModelValue === undefined) || isNaN(oldModelValue)) {
                        newPos -= 3;
                    }
                    
                    setCaretPosition(elem[0], newPos);
                    
                    return newModelValue;
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    /* Directive Used to control a Compare Validator function in an input field */
    angular
        .module('app.core')
        .directive("matchField", ["$parse", directive]);

    function directive($parse) {
        return {
            priority: 2,
            restrict: "A",
            require: "ngModel",
            link: function (scope, element, attrs, ctrl) {
                if (!ctrl) return;

                var compareField = $parse(attrs["matchField"]);

                var validate = function (value) {
                    var temp = compareField(scope)

                    var v = value === temp;

                    ctrl.$setValidity("match", v);

                    return value;
                };

                ctrl.$parsers.push(validate);
                ctrl.$formatters.push(validate);
                attrs.$observe("matchValue", function () {
                    validate(ctrl.$modelValue);
                });

                validate(ctrl.$modelValue);
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, authService, localStorageService, commonService) {
    var vm = this;

    // Data
    $rootScope.global = {
      search: ''
    };

    vm.bodyEl = angular.element('body');
    vm.userStatusOptions = [
      {
        'title': 'Online',
        'icon': 'icon-checkbox-marked-circle',
        'color': '#4CAF50'
      },
      {
        'title': 'Away',
        'icon': 'icon-clock',
        'color': '#FFC107'
      },
      {
        'title': 'Do not Disturb',
        'icon': 'icon-minus-circle',
        'color': '#F44336'
      },
      {
        'title': 'Invisible',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#BDBDBD'
      },
      {
        'title': 'Offline',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#616161'
      }
    ];
    vm.languages = {
      en: {
        'title': 'English',
        'translation': 'TOOLBAR.ENGLISH',
        'code': 'en',
        'flag': 'us'
      },
      es: {
        'title': 'Spanish',
        'translation': 'TOOLBAR.SPANISH',
        'code': 'es',
        'flag': 'es'
      },
      tr: {
        'title': 'Turkish',
        'translation': 'TOOLBAR.TURKISH',
        'code': 'tr',
        'flag': 'tr'
      }
    };

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;
    vm.changePassword = changePassword
    vm.changeUserName = changeUserName;
    vm.changeEmail = changeEmail;
    vm.openMenu = OpenMenu;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Select the first status as a default
      vm.userStatus = vm.userStatusOptions[0];

      if (authService.adminAuthentication.roleType && !$rootScope.showAdminToolbar) {
        vm.session = authService.adminAuthentication;
      }
      else {
        vm.session = authService.authentication;
      }

      //TODO: Double check
      // Get the selected language directly from angular-translate module setting
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
    }

    $rootScope.$on('simulateAccount', function (event, account) {
      $rootScope.customerUserName = account.Username;

      if ($rootScope.showAdminToolbar) {

        authService.authentication.isAuth = true;
        authService.authentication.userName = account.Username;
        authService.authentication.roleType = '';
        authService.authentication.useRefreshTokens = true;
        authService.authentication.CustomerID = account.CustomerIDNumber;
        authService.authentication.staySignedIn = true;
        authService.authentication.email = account.Email;

        localStorageService.set('authorizationUserData', { customerId: account.CustomerIDNumber, userName: account.Username, email: account.Email });

        vm.session = authService.authentication;
      }
    });

    $rootScope.$on('adminDashboard', function (event, account) {
      vm.session = account;
    });


    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
    }

    /**
     * Logout Function
     */
    function logout() {
      var roleType = authService.roleType;
      // Do logout here..
      authService.logOut(true);
      if (!roleType) {
        $state.go('app.pages_auth_login');
      }
      else {
        $state.go('app.pages_auth_adminLogin');
        window.location.reload();
      }
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;

      /**
       * Show temporary message if user selects a language other than English
       *
       * angular-translate module will try to load language specific json files
       * as soon as you change the language. And because we don't have them, there
       * will be a lot of errors in the page potentially breaking couple functions
       * of the template.
       *
       * To prevent that from happening, we added a simple "return;" statement at the
       * end of this if block. If you have all the translation files, remove this if
       * block and the translations should work without any problems.
       */
      if (lang.code !== 'en') {
        var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top right',
          parent: '#content'
        });

        return;
      }

      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function (item) {
          if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function () {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        }
        else {
          $state.go(item.state);
        }
      }
    }

    /**
    * Reset password action
    */
    function changePassword() {
      authService.CheckIsPortalEnabled(true, null, function () {
        $state.go('app.pages_auth_changePassword');
      });

    }
    function changeUserName() {
      authService.CheckIsPortalEnabled(true, null, function () {
        $state.go('app.pages_auth_changeUserName');
      });
    }
    function changeEmail() {
      authService.CheckIsPortalEnabled(true, null, function () {
        $state.go('app.pages_auth_changeEmail');
      });
    }
    function OpenMenu($mdOpenMenu, e) {
      if ($rootScope.showAdminToolbar == false) {
        $mdOpenMenu(e);
      }
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('AdminToolbarController', AdminToolbarController);

    /** @ngInject */
    function AdminToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, authService) {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.changePassword = changePassword
        vm.changeUserName = changeUserName;
        vm.changeEmail = changeEmail;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];
            vm.session = authService.adminAuthentication; //TODO: Double check
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
            var roleType = authService.roleType;
            // Do logout here..
            authService.logOut(true);
            if (!roleType) {
                $state.go('app.pages_auth_login');
            }
            else {
                $state.go('app.pages_auth_adminLogin');
            }
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                }
                else {
                    $state.go(item.state);
                }
            }
        }

        /**
        * Reset password action
        */
        function changePassword() {
            $state.go('app.pages_auth_changePassword');
        }
        function changeUserName() {
            $state.go('app.pages_auth_changeUserName');
        }
        function changeEmail() {
            $state.go('app.pages_auth_changeEmail');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function () {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController($scope, $transitions) {
    var vm = this;

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $transitions.onSuccess({}, function (transition) {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });
  }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, AUTH_ROLES, authService, $stateParams)
    {
        $scope.userRoles = AUTH_ROLES;
        $scope.isAuthorized = authService.isAuthorized;
        $scope.resumeState = $stateParams.resumeState;
        $scope.auth = authService

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
                $rootScope.splashScreenIsRemoved = true;
            }
        });
     
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);
        
        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function () {
  'use strict';

  angular
    .module('fuse')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state, $stateParams, authService, Idle, commonService, $location, genericService, $window, $sce, $mdDialog, CustomerContext, localStorageService, $transitions) {
    /// Juan Leon: Implementing the stay signed in functionality.
    authService.fillAuthData();

    //var url = $location.absUrl(); //TODO: For E-Bill URL Forwarding
    var prevSimulatedAcctNo; //The last account no. that was simulated by an admin

    //var url = "https://localhost:3000/mscp/enotify.asp?EAccount=10480001&EType=1&EData=x%20%20%2010480-00101-30-171701&EServType=00&ECkCd=00&EBalance=%20%20%201040.73%20&EShare=%20%20%20%200.00%20&PdfFlag=0&PdfInvoiceNbr=&CoopNbr=0160&Param3D30=100";
    var url = $location.absUrl();
    var eType = getParameterByName("EType", url);

    $rootScope.network = {
      online: navigator.onLine,
      showWarning: !navigator.onLine
    }

    $rootScope.resumeState = null;

    var hasOpenDialogCnt = 0;
    $rootScope.$on('msDialogIsOpened', function () {
      hasOpenDialogCnt++
    })

    $rootScope.$on('msDialogIsClosed', function () {
      hasOpenDialogCnt--
    })

    $state.defaultErrorHandler(function (error) {
      // This is a naive example of how to silence the default error handler.
       //console.log(error);
    });

    // Activate loading indicator
    var stateChangeStartEvent = $transitions.onStart({}, function (transition) {
      var stateName = transition.to().name;
      var toParams = transition.targetState().params();
      var loggedIn = authService.isLoggedIn();
      var sessionRole = authService.roleType;

      if ($rootScope.loginDialogIsDisplayed) {
        if (stateName == 'app.pages_auth_forgotUserName' ||
          stateName == 'app.pages_auth_forgot-password' ||
          stateName == 'app.pages_auth_register') {
          $mdDialog.cancel();
          return;
        }
        event.preventDefault();
        return
      } else if (hasOpenDialogCnt > 0) {
        $mdDialog.cancel();
        event.preventDefault();
        return
      }

      $rootScope.showAdminToolbar = false;

      if (stateName.indexOf("app.msportal") == 0) {
        if (stateName == 'app.msportal.admin.customers') {
          //localStorageService.remove('authorizationUserData');
          $rootScope.$broadcast('adminDashboard', authService.adminAuthentication);
        } else {
          if (authService.roleType == 'Admin') {
            $rootScope.showAdminToolbar = true;
            $rootScope.$broadcast('adminDashboard', authService.authentication);
          }
        }
      }

      if ((stateName == 'app.pages_auth_adminLogin' ||
        stateName == 'app.pages_auth_login' ||
        stateName == 'app.pages_auth_forgotUserName' ||
        stateName == 'app.pages_auth_forgot-password' ||
        stateName == 'app.pages_auth_confirm-user' ||
        stateName == 'app.pages_auth_register' ||
        stateName == 'app.pages_auth_confirmChangeEmail' ||
        stateName == 'app.pages_auth_reset-password' ||
        stateName == 'app.pages_auth_reset-user' ||
        stateName == 'app.page_loading_failed')) {

        if (stateName == 'app.page_loading_failed' && !toParams.resumeState) {
          transition.abort();
          if (stateName == 'app.pages_auth_adminLogin') {
            $state.go('app.pages_auth_adminLogin');
          }
          else { $state.go('app.pages_auth_login'); }
        }
        if (stateName != 'app.page_loading_failed' && loggedIn) {
          transition.abort();

          if (!authService.roleType) {
            $state.go('app.msportal.accounts');
          }
          else {
            $state.go('app.msportal.accounts', { CID: authService.authentication.CustomerID });
            var account = {
              Username: authService.authentication.userName,
              CustomerIDNumber: authService.authentication.CustomerID
            }
            $rootScope.$broadcast('simulateAccount', account);
          }

        } else {
          Idle.unwatch(); //stop monitoring session
        }
      }
      else {
        if (!loggedIn && stateName != 'app.pages_utility_contact' && stateName != 'app.pages_utility_location') {
          transition.abort();
          if (stateName == 'app.pages_auth_adminLogin' ||
            stateName == 'app.msportal.admin.customization' ||
            stateName == 'app.msportal.admin.customers') {
            $state.go('app.pages_auth_adminLogin');
          }
          else {
            authService.logOut();

            if (sessionRole == 'Admin') {
              $state.go('app.pages_auth_adminLogin');
            }
            else if (!sessionRole && url.toString().toLowerCase().indexOf("/mscp/enotify.asp") >= 0) {
              if (eType == 1 || eType == 2) {
                commonService.viewPDF(url);
                url = "";
              }
              else {
                $state.go('app.pages_auth_login');
              }
            }
            else {
              $state.go('app.pages_auth_login');
            }
          }
        }
        else {

          Idle.watch();

          if (!sessionRole) {
            if (stateName == "app.msportal.accounts" && url.toString().toLowerCase().indexOf("/mscp/enotify.asp") >= 0) {
              commonService.viewPDF(url);
              url = "";
            }
          }
        }
      }

      if (stateName.indexOf("app.msportal") == 0) {
        var showMenu;
        if (stateName == 'app.msportal.admin.customers' || stateName == 'app.msportal.accounts') {
          showMenu = false;

          if (authService.roleType == 'Admin' && stateName == 'app.msportal.accounts' && (!authService.authentication.CustomerID && !toParams.CID)) {
            $rootScope.showAdminToolbar = false;
            transition.abort();
            $state.go('app.msportal.admin.customers');
          }
        }
        else {
          showMenu = true;

          //If simulated account is changed by modifying the URL or thru the browser history, refresh username and CID
          if (authService.roleType == 'Admin') {
            if (prevSimulatedAcctNo != toParams.id) {
              if (stateName == 'app.msportal.contactUs') {
                $state.go('app.msportal.contactUs');
              }
              else {
                CustomerContext.GetCustomerByAccountNo(toParams.id).then(
                  function (res) {
                    if (res.CustomerIDNumber != authService.authentication.CustomerID) {
                      $rootScope.$broadcast('simulateAccount', res)
                    }
                  }, function (err) {
                    transition.abort();
                    commonService.displayError('No records were found for the account number ' + toParams.id);
                    if (authService.roleType == 'Admin') {
                      $state.go('app.msportal.admin.customers');
                    } else {
                      $state.go('app.msportal.accounts');
                    }

                  })
              }
            }
            prevSimulatedAcctNo = toParams.id;
          }
        }

        $rootScope.$broadcast('isAccountSelected', { id: toParams.id, showMenu: showMenu });
      }

      $rootScope.loadingProgress = true;

    });

    var stateChangeErrorListener = $transitions.onError({}, function (transition) {
      var resumeState = angular.copy(transition.to());
      $rootScope.loadingProgress = false;

      /*
      If firstRedirection is true, it means the splash screen
      is displayed, and splash screen gets stuck
      if redirection fails, so redirect to error screen.
      */
      if (!$rootScope.splashScreenIsRemoved) {
        transition.abort();
        $state.go('app.page_loading_failed', { resumeState: resumeState });
      } else {
        commonService.displayError('Could not load requested page. Please try again later.')
      }
    });

    //Ebill notification
    function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    // De-activate loading indicator
    var stateChangeSuccessEvent = $transitions.onSuccess({}, function (transition) {
      if (!$rootScope.splashScreenIsRemoved) {
        $rootScope.splashScreenIsRemoved = true;
        $rootScope.$broadcast('msSplashScreen::remove');
      }

      $timeout(function () {
        $rootScope.loadingProgress = false;
        pageValidation(transition);
      });

    });

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on('$destroy', function () {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });

    function pageValidation(transition) {
      var next = transition.to();
      if (typeof (next.data) == "undefined") {
        transition.abort();
        $state.go('app.pages_auth_login');
      }

      var authorizedRoles = next.data.authorizedRoles;

      if (authorizedRoles[0] != "*") {
        //TODO:Elaborate more - Role should be checked
        if (!authService.isAuth) {
          transition.abort();
          $state.go('app.pages_auth_login');
        }
      }
    }

    var networkConnectionStatusIndicatorTimer;

    $window.addEventListener("offline", function () {
      $rootScope.$apply(function () {
        $rootScope.network.online = false;
        $rootScope.network.showWarning = true;
        $timeout.cancel(networkConnectionStatusIndicatorTimer);
      });
    }, false);

    $window.addEventListener("online", function () {
      $rootScope.$apply(function () {
        $rootScope.network.online = true;
        networkConnectionStatusIndicatorTimer = $timeout(function () {
          $rootScope.network.showWarning = false;
        }, 3000);
      });
    }, false);
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        // MND-422  Modify Landing Page to Accounts List
        $urlRouterProvider.otherwise('/portal/accounts');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                admin_toolbar: 'app/toolbar/layouts/vertical-navigation/admin_toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'admin_toolbar@app': {
                        templateUrl: layouts[layoutStyle].admin_toolbar,
                        controller: 'AdminToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            })
            .state('app.page_loading_failed', {
                url: '/page-loading-failed',
                params:{
                    resumeState:null
                },
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.page_loading_failed': {
                        templateUrl: 'app/page-load-failed/page-load-failed.html'
                    }
                },
                bodyClass: 'login',
                data: {
                    authorizedRoles: ['*'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            });
    }

})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming, $scope, Idle, authService, $mdDialog, $mdMedia, $state, $rootScope, AUTH_EVENTS, $http, $location, $transitions) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;
    $scope.currentUser = null;
    $scope.roleType = '';

    //if ($location.host() != 'localhost') {
    //  $http.get("https://ipinfo.io/" + $location.host()).then(function (response) {
    //    $scope.ip = response.data.ip;
    //  });
    //}

    //Start monitoring session, if not already monitoring
    if (!Idle.running()) {
      Idle.watch();
    }

    var removeIdleTimeoutListener = $scope.$on('IdleTimeout', function () {
      // the user's session has timed out 
      authService.logOut(false);
      if ($state.current.name != 'app.pages_utility_contact' && $state.current.name != 'app.pages_utility_location') {
        authService.showFloatingLogin();
      }

    });

    //This is executed when the user logs in (using the floating login dialog) using a different account after his/her session expires
    //In which case, the user will be redirected to customer/accounts list
    //The login dialog should only be closed after the redirection
    var stateChangeSuccessEvent = $transitions.onSuccess({}, function (transition) {
      if ($rootScope.loginDialogIsDisplayed) {
        $mdDialog.hide();
      }
    });

    $scope.$on('$destroy', function () {
      Idle.unwatch();
      removeIdleTimeoutListener();
      removeIdleEndListener();
      stateChangeSuccessEvent();
    })

    $rootScope.$on(AUTH_EVENTS.loginSuccess), function (userData) {
      $scope.setCurrentUser(userData.Username);
    };

    $scope.setCurrentUser = function (user) {
      $scope.currentUser = user;
      $scope.roleType = authService.roleType;
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse').constant('ngAuthSettings', {
            apiServiceBaseUri: '/Sedc.Multiservice.AspNet.Identity/',
            //apiServiceBaseUri: 'https://10.1.0.57/Sedc.Multiservice.AspNet.Identity/', //DevV14
            //apiServiceBaseUri: 'https://10.1.0.58/Sedc.Multiservice.AspNet.Identity/', //QCV14
            //apiServiceBaseUri: 'https://10.204.0.44/Sedc.Multiservice.AspNet.Identity/', //DevV15
            //apiServiceBaseUri: 'https://10.204.0.45/Sedc.Multiservice.AspNet.Identity/', //QCV15
            //apiServiceBaseUri: 'http://localhost:60023/',
            clientId: 'MSPortal',
            clientSecret: 'qMCdFDQuF23RV1Y-1Gq9L3cF3VmuFwVbam4fMTdAfpo'
        });

    angular
      .module('fuse').constant('AUTH_EVENTS', {
          loginSuccess: 'auth-login-success',
          loginFailed: 'auth-login-failed',
          logoutSuccess: 'auth-logout-success',
          sessionTimeout: 'auth-session-timeout',
          notAuthenticated: 'auth-not-authenticated',
          notAuthorized: 'auth-not-authorized'
      });

    angular
     .module('fuse').constant('AUTH_ROLES', {
         all: '*',
         admin: 'admin',
         user: 'user'
     });
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(config);

  /** @ngInject */
  function config($httpProvider, IdleProvider, KeepaliveProvider, $mdThemingProvider, TitleProvider) {
    // Put your custom configurations here
    $httpProvider.interceptors.push('authInterceptorService');

    // configure Idle settings
    IdleProvider.idle(5); //Number of SECONDS of inactivity before the user is considered idle
    IdleProvider.timeout(900); // number of seconds of idleness before session expires
    IdleProvider.keepalive(false);
    //KeepaliveProvider.interval(1);
    $mdThemingProvider.theme('dark-grey');
    TitleProvider.enabled(false);
  }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
      .factory('api', apiService);

    ///Base-href case-insensitivity
    var base = document.querySelector("base");
    var normalized = RegExp(base.href, "i").exec(location.href);
    base.href = normalized ? normalized[0] : base.href;

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin',
            [
                'flow'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.admin', {
                abstract: true,
                url: '/admin'
            })
            .state('app.admin.customers', {
                url: '/customers',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/adminpages/views/customer_list/customer_list.html',
                        controller: 'CustomerListController as vm'
                    }
                },
                bodyClass: 'msportal',
                data: {
                    authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
                }
            })

        .state('app.admin.customization', {
            url: '/customizePortal',
            views: {
                'content@app': {
                    templateUrl: 'app/main/adminpages/views/customizePortal/customizePortal.html',
                    controller: 'CustomizePortalController as vm'
                }
            },
            bodyClass: 'msportal',
            data: {
                authorizedRoles: ['user'] //TODO: Use constant for consistency. It wasn't done that way because of issue trying to inject constant to a config
            }
        });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/adminPages');
        $translatePartialLoaderProvider.addPart('app/main/msportal');

        // Api
        //msApiProvider.register('msportal.accounts', ['app/data/msportal/accounts.json']);
        //msApiProvider.register('msportal.services', ['app/data/msportal/product.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('msportal', {
        //    title: 'My Account',
        //    icon: 'icon-account-multiple',
        //    weight: 2
        //});

        //msNavigationServiceProvider.saveItem('fuse', {
        //    title: 'CUSTOMER SERVICES PORTAL',
        //    group: true,
        //    weight: 1
        //});


        //msNavigationServiceProvider.saveItem('msportal.accounts', {
        //    title: 'Accounts',
        //    state: 'app.msportal.accounts',
        //    icon: 'icon-file-multiple',
        //    weigth: 3
        //});

        

    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/page-load-failed/page-load-failed.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" md-mode=\"query\" \nng-show=\"loadingProgress\"></md-progress-linear><div id=\"page-load-failed\" class=\"flex-scrollable\" layout=\"column\" \nms-scroll><div id=\"wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"form-container\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>SEDC</span></div><div><h1>Alert</h1><div \nstyle=\"text-align:left\"><h3 style=\"text-align:center\">Service is currently unavailable due to maintenance.</h3></div>\n</div><div class=\"login\" layout=\"row\" layout-align=\"center center\" style=\"padding-top:40px\">Please&nbsp;<a \nclass=\"link\" ui-sref=\"{{resumeState.name}}\">try again</a>&nbsp;later</div></div></div></div>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div ng-if=\"network.showWarning\" class=\"network-indicator\" \nng-class=\"{\'custom-bg-error\': !network.online, \'custom-bg-success\': network.online}\"><span ng-if=\"!network.online\">\nYou went offline!</span> <span ng-if=\"network.online\">You are now online!</span></div><div id=\"layout-content-only\" \nclass=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div ng-if=\"network.showWarning\" class=\"network-indicator\" \nng-class=\"{\'custom-bg-error\': !network.online, \'custom-bg-success\': network.online}\"><span ng-if=\"!network.online\">\nYou went offline!</span> <span ng-if=\"network.online\">You are now online!</span></div><md-toolbar id=\"admin-toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"admin_toolbar\" ng-if=\"showAdminToolbar\"></md-toolbar><div \nid=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div class=\"Aligner\" \nstyle=\"display: flex;align-items: center;justify-content: center; height:100%!important\"><div class=\"Aligner-item\" \nstyle=\"max-width: 50%\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div><div \nng-class=\"{\'overlayeffect\': rootscopeLoading == true}\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"verticalNavigationFullwidthToolbar\">Vertical Navigation with Fullwidth Toolbar\n</md-radio-button><md-radio-button value=\"verticalNavigationFullwidthToolbar2\">\nVertical Navigation with Fullwidth Toolbar 2</md-radio-button><md-radio-button value=\"horizontalNavigation\">\nHorizontal Navigation</md-radio-button><md-radio-button value=\"contentOnly\">Content Only</md-radio-button>\n<md-radio-button value=\"contentWithToolbar\">Content with Toolbar</md-radio-button></md-radio-group></div><md-divider>\n</md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">\nBoxed</md-radio-button><md-radio-button value=\"wide\">Wide</md-radio-button></md-radio-group></div><md-divider>\n</md-divider><div class=\"theme-option\"><div class=\"option-title\">Color Palette:</div><md-menu-item \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\"><md-button class=\"md-raised theme-button\" \naria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/msportal/msportal.html","<div id=\"msportal\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/mail/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\" translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.search\" type=\"text\" \nplaceholder=\"Search for an e-mail or contact\" translate-attr-placeholder=\"MAIL.SEARCH_PLACEHOLDER\"></div></div></div>\n</div></div>");
$templateCache.put("app/auth/changeEmail/changeEmail.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"changeEmail\" \nclass=\"flex-scrollable ms-scroll ng-scope layout-column ps-container ps-theme-default\" layout=\"column\" ms-scroll=\"\" \ndata-ps-id=\"e9bcc745-19e1-81b7-1cb0-3851d5ea046e\"><div id=\"changeEmail-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\" class=\"layout-align-center-center layout-column\"><div id=\"changeEmail-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span></span></div><div class=\"title ng-scope\" \ntranslate=\"CHANGEEMAIL.TITLE\">Change your e-mail</div><form name=\"changeEmailForm\" method=\"post\" validate \naa-configured-form validation-config=\"Validators\" prevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\" \nlogin-required=\"true\"><div class=\"OldEmail\">Your current e-mail is: {{ChangeEmailBindingModel.OldEmail}}</div>\n<md-input-container class=\"md-block\" flex-gt-sm><label>New E-mail</label><input type=\"text\" name=\"newEmail\" \nng-model=\"ChangeEmailBindingModel.NewEmail\" email-address-check required \nnot-equal-to-value=\"{{ChangeEmailBindingModel.OldEmail}}\" not-equal-to-watch=\"{{ChangeEmailBindingModel.OldEmail}}\">\n<div ng-messages=\"changeEmailForm.newEmail.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"CHANGEEMAIL.ERRORS.EMAIL_REQUIRED\">New e-mail field is required.</span></div><div ng-message=\"pattern\"><span\n translate=\"CHANGEEMAIL.ERRORS.EMAIL_MUST_VALID\">E-mail must be a valid e-mail address.</span></div><div \nng-message=\"invalid\"><span translate=\"CHANGEEMAIL.ERRORS.EMAIL_MUST_VALID\">E-mail must be a valid e-mail address.\n</span></div><div ng-message=\"notEqualTo\"><span translate=\"CHANGEEMAIL.ERRORS.NEW_EMAIL_SAMEASOLD\">\nOld and new e-mail must not be the same.</span></div></div>\n{{changeEmailForm.newEmail.$setValidity(\"notEqualTo\", !((changeEmailForm.newEmail.$viewValue.substring(changeEmailForm.newEmail.$viewValue.indexOf(\'@\')).toLowerCase() == ChangeEmailBindingModel.OldEmail.substring(ChangeEmailBindingModel.OldEmail.indexOf(\'@\')).toLowerCase()) && (changeEmailForm.newEmail.$viewValue.substring(0, changeEmailForm.newEmail.$viewValue.indexOf(\'@\')).toLowerCase() == ChangeEmailBindingModel.OldEmail.substring(0, ChangeEmailBindingModel.OldEmail.indexOf(\'@\')).toLowerCase())))}}\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Confirm E-mail</label><input type=\"text\" \nname=\"emailConfirm\" ng-model=\"ChangeEmailBindingModel.ConfirmEmail\" email-address-check required><div \nng-messages=\"changeEmailForm.emailConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CHANGEEMAIL.ERRORS.EMAIL_REQUIRED\">Confirm e-mail field is required.</span></div><div ng-message=\"match\" \nstyle=\"opacity: 1; margin-top: 0px\"><span translate=\"CHANGEEMAIL.ERRORS.EMAIL_DOES_NOT_MATCH\">\nNew e-mail and e-mail confirm does not match.</span></div><div ng-message=\"invalid\"><span \ntranslate=\"CHANGEEMAIL.ERRORS.EMAIL_MUST_VALID\">E-mail must be a valid e-mail address.</span></div></div>\n{{changeEmailForm.emailConfirm.$setValidity(\"match\", !((changeEmailForm.newEmail.$viewValue.substring(changeEmailForm.newEmail.$viewValue.indexOf(\'@\')).toLowerCase() != changeEmailForm.emailConfirm.$viewValue.substring(changeEmailForm.emailConfirm.$viewValue.indexOf(\'@\')).toLowerCase()) || (changeEmailForm.newEmail.$viewValue.substring(0, changeEmailForm.newEmail.$viewValue.indexOf(\'@\')).toLowerCase() != changeEmailForm.emailConfirm.$viewValue.substring(0, changeEmailForm.emailConfirm.$viewValue.indexOf(\'@\')).toLowerCase())))}}\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Password</label><input type=\"password\" \nname=\"password\" autocomplete=\"off\" ng-model=\"ChangeEmailBindingModel.Password\" required masked-value=\"PasswordMasked\" \nng-maxlength=\"50\" maxlength=\"50\"><div ng-messages=\"changeEmailForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CHANGEEMAIL.ERRORS.PASSWORD_REQUIRED\">Password field is required.</span></div>\n</div></md-input-container><button \nclass=\"md-raised md-accent submit-button md-button ng-scope md-ink-ripple md-default-theme\" type=\"submit\" \naria-label=\"CHANGE E-MAIL\" ng-disabled=\"changeEmailForm.$invalid || changeEmailForm.$pristine\" \ntranslate=\"CHANGEEMAIL.UPDATE_EMAIL\" translate-attr-aria-label=\"CHANGEEMAIL.UPDATE_EMAIL\" \nng-click=\"changeEmail(changeEmailForm)\">CHANGE MY E-MAIL</button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" ng-click=\"GoBackToAccountsList()\" translate=\"CHANGEEMAIL.GO_BACK\">\nGo back to accounts</a></div></div></div></div>");
$templateCache.put("app/auth/adminLogin/adminLogin.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"adminLogin\" \nclass=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"adminLogin-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"adminLogin-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"></div>\n<flipper flipped=\"flipped\" horizontal><back><div ng-if=\"showLoginError\"><h1>Sorry</h1><div style=\"text-align:left\"><h3>\nWe did not recognize that information.<br>The problem is one of the following:</h3><ul \nng-bind-html=\"notification.message\"></ul></div><div class=\"adminLogin\" layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:20px\"><a class=\"link\" ng-click=\"flip(\'login\')\" translate=\"FORGOTUSERNAME.GO_BACK\">Go back to Login\n</a></div></div><div ng-if=\"showVersions\"><div><h3>Portal Component Versions</h3><hr><div class=\"p-20 align-left\"><div \nng-repeat=\"p in programs\">{{ p.Name }}<span class=\"float-right\">{{ p.Version }}</span></div></div><hr></div><div \nclass=\"adminLogin pt-20\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ng-click=\"flip(\'login\')\" \ntranslate=\"FORGOTUSERNAME.GO_BACK\">Go back to Login</a></div></div></back><front><div class=\"title\" \ntranslate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" method=\"post\" novalidate \nng-submit=\"login(loginForm)\" aa-configured-form validation-config=\"Validators\" aa-confirmation-message=\"false\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"LOGIN.USERNAME\" ng-hide=\"flipped\"></label><input \ntype=\"text\" name=\"usernameE\" ng-model=\"loginData.Username\" required ng-change=\"resetNotification()\" tabindex=\"1\"><div \nng-messages=\"loginForm.usernameE.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.USER_REQUIRED\">Username field is required</span></div></div><div style=\"text-align: right\" \nclass=\"remember-forgot-password\"><a ng-click=\"goToState(\'app.pages_auth_forgotUserName\');\" \nclass=\"forgot-password md-accent-color link\" translate=\"LOGIN.FORGOT_USERNAME\">Forgot username?</a></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"LOGIN.PASSWORD\" \nng-hide=\"flipped\"></label><input type=\"password\" name=\"password\" autocomplete=\"off\" ng-model=\"loginData.Password\" \nrequired=\"\" ng-change=\"resetNotification()\" tabindex=\"2\"><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n<div style=\"text-align: right\" class=\"remember-forgot-password\"><a \nng-click=\"goToState(\'app.pages_auth_forgot-password\');\" class=\"forgot-password md-accent-color link\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><button class=\"link\" ng-click=\"flip(\'versions\');\" \ntranslate=\"LOGIN.VIEW_COMPONENT_VERSIONS\"></button></div></front></flipper></div></div></div>");
$templateCache.put("app/auth/changeUserName/changeUserName.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"changeUserName\" \nclass=\"flex-scrollable ms-scroll ng-scope layout-column ps-container ps-theme-default\" layout=\"column\" ms-scroll=\"\" \ndata-ps-id=\"e9bcc745-19e1-81b7-1cb0-3851d5ea046e\"><div id=\"changeUserName-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\" class=\"layout-align-center-center layout-column\"><div id=\"changeUserName-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span></span></div><div class=\"title ng-scope\" \ntranslate=\"CHANGEUSERNAME.TITLE\">Change your username</div><form name=\"changeUserNameForm\" validate aa-configured-form \nvalidation-config=\"Validators\" prevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\" \nlogin-required=\"true\"><md-input-container class=\"md-block\" flex-gt-sm><label \nng-class=\"{\'invalid-input\': (!changeUserNameForm.usernameE.$valid && !changeUserNameForm.$pristine)}\">Username</label>\n<input type=\"text\" name=\"usernameE\" ng-model=\"ChangeUserNameBindingModel.UserName\" required ng-pattern=\"/^[\\w_.@]+$/\" \nng-maxlength=\"50\" maxlength=\"50\" ng-change=\"SetOldUserName()\"><div ng-messages=\"changeUserNameForm.usernameE.$error\" \nng-show=\"changeUserNameForm.usernameE.$dirty\"><div ng-message=\"required\"><span \ntranslate=\"CHANGEUSERNAME.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div><div ng-message=\"pattern\">\n<span>Username is invalid</span><ul class=\"password-requirements-list\"><li>\nUsername may consist only of alphanumeric characters and the special characters at sign, underscore and period (@ _ .)\n</li><li>Other special characters and spaces are NOT allowed</li></ul></div></div></md-input-container><button \nclass=\"md-raised md-accent submit-button md-button ng-scope md-ink-ripple md-default-theme\" type=\"submit\" \naria-label=\"CHANGE USERNAME\" ng-disabled=\"changeUserNameForm.$invalid || changeUserNameForm.$pristine\" \ntranslate=\"CHANGEUSERNAME.UPDATE_USERNAME\" translate-attr-aria-label=\"CHANGEUSERNAME.UPDATE_USERNAME\" \nng-click=\"changeUserName(changeUserNameForm)\">CHANGE MY USERNAME</button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" ng-click=\"GoBackToAccountsList()\" translate=\"CHANGEUSERNAME.GO_BACK\">\nGo back to accounts</a></div></div></div></div>");
$templateCache.put("app/auth/changePassword/changePassword.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"changePassword\" \nclass=\"flex-scrollable ms-scroll ng-scope layout-column ps-container ps-theme-default\" layout=\"column\" ms-scroll=\"\" \ndata-ps-id=\"e9bcc745-19e1-81b7-1cb0-3851d5ea046e\"><div id=\"changePassword-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\" class=\"layout-align-center-center layout-column\"><div id=\"changePassword-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>SEDC</span></div><div class=\"title ng-scope\" \ntranslate=\"CHANGEPASSWORD.TITLE\">Change your password</div><form name=\"changePasswordForm\" method=\"post\" validate \naa-configured-form validation-config=\"Validators\" prevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>Old Password</label><input type=\"password\" name=\"OldPassword\" \nautocomplete=\"off\" ng-model=\"ChangePasswordBindingModel.OldPassword\" required ng-maxlength=\"50\" maxlength=\"50\"><div \nng-messages=\"changePasswordForm.OldPassword.$error\"><div ng-message=\"required\"><span \ntranslate=\"CHANGEPASSWORD.ERRORS.OLD_PASSWORD_REQUIRED\"></span></div><div ng-message=\"pattern\" \nstyle=\"opacity: 1; margin-top: 0px\"><span translate=\"CHANGEPASSWORD.ERRORS.PASSWORD_PATTERN\"></span></div><div \nng-message=\"minlength\" style=\"opacity: 1; margin-top: 0px\"><span translate=\"CHANGEPASSWORD.ERRORS.PASSWORD_PATTERN\">\n</span></div><div ng-message=\"maxlength\" style=\"opacity: 1; margin-top: 0px\"><span \ntranslate=\"CHANGEPASSWORD.ERRORS.PASSWORD_PATTERN\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>New Password</label><input type=\"password\" name=\"NewPassword\" autocomplete=\"off\" \nng-model=\"ChangePasswordBindingModel.NewPassword\" required ng-maxlength=\"50\" maxlength=\"50\" \nnot-equal-to-value=\"{{ChangePasswordBindingModel.OldPassword}}\" \nnot-equal-to-watch=\"{{ChangePasswordBindingModel.OldPassword}}\" ms-password> <span class=\"input-help\"><md-icon \nclass=\"help-button\" ng-click=\"showPasswordHelp()\" md-font-icon=\"icon-question-mark-circle\"></md-icon></span><div \nng-messages=\"changePasswordForm.NewPassword.$error\"><div ng-message=\"required\"><span \ntranslate=\"CHANGEPASSWORD.ERRORS.NEW_PASSWORD_REQUIRED\"></span></div><div ng-message=\"notEqualTo\" \nstyle=\"opacity: 1; margin-top: 0px\"><span translate=\"CHANGEPASSWORD.ERRORS.NEW_PASSWORD_SAMEASOLD\"></span></div><div \nng-message=\"pattern\" style=\"opacity: 1; margin-top: 0px\"><span translate=\"CHANGEPASSWORD.ERRORS.PASSWORD_PATTERN\">\n</span></div><div ng-message=\"ms-password\"><span>Password must contain the following:</span><ul><li>\nat least one lowercase letter</li><li>at least one uppercase letter</li><li>at least one number</li><li>\nat least one special character</li></ul></div><div ng-message=\"minlength\" style=\"opacity: 1; margin-top: 0px\"><span \ntranslate=\"CHANGEPASSWORD.ERRORS.PASSWORD_PATTERN\"></span></div><div ng-message=\"maxlength\" \nstyle=\"opacity: 1; margin-top: 0px\"><span translate=\"CHANGEPASSWORD.ERRORS.PASSWORD_PATTERN\"></span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Password (Confirm)</label><input \ntype=\"password\" name=\"ConfirmPassword\" ng-model=\"ChangePasswordBindingModel.ConfirmPassword\" \nmatch-field=\"ChangePasswordBindingModel.NewPassword\" match-value=\"{{ChangePasswordBindingModel.NewPassword}}\" required \nng-maxlength=\"50\" maxlength=\"50\"><div ng-messages=\"changePasswordForm.ConfirmPassword.$error\"><div \nng-message=\"required\"><span translate=\"CHANGEPASSWORD.ERRORS.PASSWORDCONF_REQUIRED\"></span></div><div \nng-message=\"match\" style=\"opacity: 1; margin-top: 0px\"><span translate=\"CHANGEPASSWORD.ERRORS.PASSWORDCONF_NOTSAME\">\n</span></div></div></md-input-container><button \nclass=\"md-raised md-accent submit-button md-button ng-scope md-ink-ripple md-default-theme\" type=\"submit\" \naria-label=\"RESET MY PASSWORD\" ng-disabled=\"changePasswordForm.$invalid || changePasswordForm.$pristine\" \ntranslate=\"CHANGEPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"CHANGEPASSWORD.UPDATE_PASSWORD\" \nng-click=\"changePassword(changePasswordForm)\">RESET MY PASSWORD</button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" ng-click=\"GoBackToAccountsList()\" translate=\"CHANGEPASSWORD.GO_BACK\">\nGo back to accounts</a></div></div></div></div>");
$templateCache.put("app/auth/contact/contact.html","<style>\nh4 {\r\n        font-weight:700;\r\n    }\r\n\r\n    input {\r\n        background: none;\r\n        text-align: center;\r\n    }\n</style><md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"activated\"></md-backdrop><md-progress-linear class=\"md-warn\" md-mode=\"query\" \nng-show=\"activated\"></md-progress-linear><div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" \nclass=\"md-whiteframe-8dp flex-scrollable\" ms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"ofc in Offices\"><div class=\"md-list-item-text\" style=\"margin:10px 0px 0px 0px\"><h3>\n{{ofc.OfficeTypeDesc}} - {{ofc.City}}, {{ofc.State}}</h3><div style=\"margin:5px 0px\"><div layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-email\" style=\"margin:5px\"></md-icon><h4>E-mail</h4></div><p>\n{{ofc.EmailAddress}}</p><p ng-if=\"ofc.EmailAddress == \'    \'\">N/A</p></div><div style=\"margin:5px 0px\"><div \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-phone\" style=\"margin:5px\"></md-icon><h4>Telephone\n</h4></div><input type=\"text\" ng-disabled=\"true\" class=\"custom-disabled-text\" ui-mask=\"999-999-9999\" \nng-model=\"ofc.Telephone\" ng-if=\"ofc.Telephone != \'    \'\"><p ng-if=\"ofc.Telephone == \'    \'\">N/A</p></div><div \nstyle=\"margin:5px 0px\"><div layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-clock\" \nstyle=\"margin:5px\"></md-icon><h4>Working Hours</h4></div><p>{{ofc.WorkingHours}}</p><p \nng-if=\"ofc.WorkingHours == \'    \'\">N/A</p></div><div style=\"margin:5px 0px\"><div layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-navigation\" style=\"margin:5px\"></md-icon><h4>Services Provided\n</h4></div><p>{{ofc.Services}}</p><p ng-if=\"ofc.Services == \'    \'\">N/A</p></div></div><md-divider ng-if=\"!$last\">\n</md-divider></md-list-item></md-list><br><a ng-show=\"!activated\" ui-sref=\"app.pages_auth_login\">Go back to Login</a>\n</md-content></div></div></div>");
$templateCache.put("app/auth/confirm-user/confirm-user.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\" ng-init=\"ValidateCode()\"></md-progress-linear><div \nid=\"confirm-user\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"confirm-user-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"confirm-user-form\" class=\"md-whiteframe-8dp\" \nng-class=\"{\'h-470\':flipped}\"><div class=\"logo md-accent-bg\"><span>SEDC</span></div><div class=\"title\">Account Creation\n</div><flipper flipped=\"flipped\" horizontal ng-show=\"showForm\"><back><h1 ng-if=\"!errPage\">Congratulations!</h1><h1 \nng-if=\"errPage\">Error!</h1><div style=\"text-align:center\"><span ng-bind-html=\"notification.message\"></span><br><br><a \nclass=\"link\" ui-sref=\"app.msportal.accounts\" translate=\"CONFIRMUSER.GO_BACK\">Return to Portal Login</a></div></back>\n<front><div ng-show=\"!notification.display\"><h3 ng-show=\"action === \'Validate User Code\'\">\nPlease wait a minute while the application confirm your information...</h3><h3 \nng-show=\"action === \'Resend Activation Email\'\">Please wait a minute while the application resending activation email...\n</h3></div><div ng-show=\"notification.display && (response === \'\' || response === \'Code not verified\')\"><h1 \nclass=\"warning\">Error!</h1><div>We encountered an error while activating your account.</div><b><ul \nng-bind-html=\"notification.message\"></ul><div>Unknown Error! Please try again later.</div></b><br><br><a class=\"link\" \nui-sref=\"app.msportal.accounts\" translate=\"CONFIRMUSER.GO_BACK\">Return to Portal Login</a></div><div \nng-show=\"notification.display && response === \'Code expired\'\"><h1 class=\"warning\">Expired Link!</h1><div>\nThe activation link has expired. Click on the link below to resend activation email.</div><br><a class=\"link fs-16\" \nng-click=\"resendEmail()\">Resend Activation Email</a><br><br><a class=\"link\" ui-sref=\"app.msportal.accounts\" \ntranslate=\"CONFIRMUSER.GO_BACK\">Return to Portal Login</a></div><div \nng-show=\"notification.display && response === \'Activation Email sent\'\"><h1 class=\"warning\">Activation Email Sent!</h1>\n<div>Please check your e-mail and confirm your registration.</div><br><br><a class=\"link\" \nui-sref=\"app.msportal.accounts\" translate=\"CONFIRMUSER.GO_BACK\">Return to Portal Login</a></div><div \nng-show=\"notification.display && response === \'Activation Email not sent\'\"><h1 class=\"warning\">\nResend Activation Email unsuccessful!</h1><div>\nAn error occured while resending activation email. Please click on the link below to resend activation email again.\n</div><br><a class=\"link fs-16\" ng-click=\"resendEmail()\">Resend Activation Email</a><br><br><a class=\"link\" \nui-sref=\"app.msportal.accounts\" translate=\"CONFIRMUSER.GO_BACK\">Return to Portal Login</a></div></front></flipper>\n</div></div></div>");
$templateCache.put("app/auth/confirmChangeEmail/confirmChangeEmail.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\" ng-init=\"ValidateCode()\"></md-progress-linear><div \nid=\"confirm-user\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"confirm-user-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"confirm-user-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span></span></div><div class=\"title\">Change E-mail Confirmed</div><flipper \nflipped=\"flipped\" horizontal ng-show=\"showForm\"><back><h1>Congratulations!</h1><div style=\"text-align:center\"><ul \nng-bind-html=\"notification.message\"></ul><a class=\"link\" ui-sref=\"app.msportal.accounts\" \ntranslate=\"CONFIRMNEWEMAIL.GO_BACK\">Return to Portal Login</a></div></back><front><h3 ng-hide=\"notification.display\">\nPlease wait a minute while the application confirm your information...</h3><center ng-hide=\"notification.display\">\n<md-progress-circular ng-disabled=\"!vm.activated\" \nclass=\"md-accent ng-isolate-scope md-default-theme _md-mode-indeterminate\" md-diameter=\"40\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" md-mode=\"indeterminate\" aria-disabled=\"false\" style=\"width: 40px; height: 40px\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" \nstyle=\"width: 40px; height: 40px; transform-origin: 20px 20px 20px\"><path fill=\"none\" \nd=\"M16.624143017788544,2.3194007557533816A18,18 0 0,0 2.527945689431295,24.327507154071217\" style=\"stroke-width: 4px\">\n</path></svg></md-progress-circular></center><h1 ng-show=\"notification.display\" class=\"warning\">Error!</h1><div \nng-show=\"notification.display\">We could not confirm your information, please check this issues:</div><b><ul \nng-show=\"notification.display\" ng-bind-html=\"notification.message\"></ul></b><br><br><a ng-show=\"notification.display\" \nclass=\"link\" ui-sref=\"app.msportal.accounts\" translate=\"CONFIRMNEWEMAIL.GO_BACK\">Return to Portal Login</a></front>\n</flipper></div></div></div>");
$templateCache.put("app/auth/floating-login/floating_login.html","<md-dialog id=\"login-dialog\"><md-dialog-content><md-backdrop \nclass=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" aria-hidden=\"true\" \nng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" md-mode=\"query\" \nng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"floating-login\" class=\"flex-scrollable\" \nlayout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div \nid=\"login-form\" class=\"md-whiteframe-8dp\"><div translate=\"LOGIN.SESSION_TIMED_OUT\" class=\"title\">\nYou have been logged out due to inactivity. Please log back in to continue.</div><flipper flipped=\"flipped\" horizontal>\n<back><div><h1>Sorry</h1><div style=\"text-align:left\"><h3>We did not recognize that information.</h3><h3>\nThe problem is one of the following:</h3><ul ng-bind-html=\"notification.message\"></ul></div><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:40px\"><a class=\"link\" ng-click=\"flip()\" \ntranslate=\"FORGOTUSERNAME.GO_BACK\">Go back to login</a></div></div></back><front><form name=\"loginForm\" method=\"post\" \nnovalidate ng-submit=\"login(loginForm)\" aa-configured-form validation-config=\"Validators\" \naa-confirmation-message=\"false\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"LOGIN.USERNAME\" \nng-hide=\"flipped\"></label><input type=\"text\" name=\"usernameE\" ng-model=\"loginData.Username\" required \nng-change=\"resetNotification()\" tabindex=\"1\"><div ng-messages=\"loginForm.usernameE.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.USER_REQUIRED\">Username field is required\n</span></div></div><div style=\"text-align: right\" class=\"remember-forgot-password\"><a ng-click=\"goToForgotUsername();\" \nclass=\"forgot-password md-accent-color link\" translate=\"LOGIN.FORGOT_USERNAME\">Forgot username?</a></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"LOGIN.PASSWORD\" \nng-hide=\"flipped\"></label><input type=\"password\" name=\"password\" autocomplete=\"off\" ng-model=\"loginData.Password\" \nrequired=\"\" ng-change=\"resetNotification()\" tabindex=\"2\"><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n<div style=\"text-align: right\" class=\"remember-forgot-password\"><a ng-click=\"goToForgotPassword();\" \nclass=\"forgot-password md-accent-color link\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div>\n</md-input-container><div ng-hide=\"true\" class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"loginData.staySignedIn\" \naria-label=\"Stay signed on\" tabindex=\"3\"><span translate=\"LOGIN.REMEMBER_ME\">Stay signed in</span></md-checkbox></div>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <button class=\"link\" ng-click=\"goToCreateAccount();\" translate=\"LOGIN.CREATE_ACCOUNT\">\nCreate an account</button></div></front></flipper></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/auth/forgot-password/forgot-password.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"forgot-password\" \nclass=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\">\n<span>SEDC</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password</div><form \nname=\"forgotPasswordForm\" prevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\" login-required=\"false\">\n<flipper flipped=\"flipped\" horizontal><back><div style=\"text-align:center\"><div class=\"title\" \ntranslate=\"{{ isUserExists ? \'FORGOTPASSWORD.CONFIRMATION\' : \'FORGOTPASSWORD.CONFIRMATION3\' }}\"></div></div></back>\n<front><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"username\" ng-model=\"user.username\" \nplaceholder=\"Username\" translate translate-attr-placeholder=\"FORGOTPASSWORD.USERNAME\" required><div \nng-messages=\"forgotPasswordForm.username.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" ng-click=\"forgotPassword()\">SEND RESET LINK</md-button>\n</front></flipper></form><div class=\"login\" layout=\"row\" layout-align=\"center center\" ng-hide=\"!showRetry\"><a \nclass=\"link\" ng-click=\"retry()\" translate=\"FORGOTPASSWORD.RETRY\"></a></div><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a ng-if=\"roleType === \'user\'\" class=\"link\" ui-sref=\"app.pages_auth_login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\"></a> <a ng-if=\"roleType === \'admin\'\" class=\"link\" \nui-sref=\"app.pages_auth_adminLogin\" translate=\"FORGOTPASSWORD.GO_BACK_ADMIN\"></a></div></div></div></div>");
$templateCache.put("app/auth/forgotUserName/forgot-username.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"forgotUserName\" \nclass=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgotUserName-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"forgotUserName-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\">\n<span>SEDC</span></div><div class=\"title\" translate=\"FORGOTUSERNAME.TITLE\">Recover your username</div><form \nname=\"forgotUserNameForm\" novalidate prevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\" \nlogin-required=\"false\"><flipper flipped=\"flipped\" horizontal><back><div translate=\"FORGOTUSERNAME.CONFIRMATION\" \nstyle=\"text-align:center\"></div></back><front><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"ForgotUserNameViewModel.Email\" placeholder=\"E-mail address\" translate \ntranslate-attr-placeholder=\"FORGOTUSERNAME.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotUserNameForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTUSERNAME.ERRORS.EMAIL_REQUIRED\">E-mail field is required</span></div><div ng-message=\"pattern\" \nstyle=\"opacity: 1; margin-top: 0px\"><span translate=\"FORGOTUSERNAME.ERRORS.EMAIL_MUST_VALID\">\nE-mail must be a valid e-mail address</span></div></div></md-input-container><md-input-container \nng-show=\"notification.display\" md-no-float><div role=\"alert\"><div class=\"errorMessage\" \nstyle=\"opacity: 1; margin-top: 0px\"><span class=\"ng-scope\">{{notification.message}}</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotUserNameForm.$invalid || forgotUserNameForm.$pristine\" translate=\"FORGOTUSERNAME.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTUSERNAME.SEND_RESET_LINK\" ng-click=\"ValidateUserName()\">SEND RESET LINK</md-button>\n</front></flipper></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a ng-if=\"roleType === \'user\'\" \nclass=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"FORGOTUSERNAME.GO_BACK\"></a> <a ng-if=\"roleType === \'admin\'\" \nclass=\"link\" ui-sref=\"app.pages_auth_adminLogin\" translate=\"FORGOTUSERNAME.GO_BACK_ADMIN\"></a></div></div></div></div>");
$templateCache.put("app/auth/location/location.html","<style>\n#map {\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n    .office-toolbar {\r\n        text-align: center;\r\n        font-size: 1em;\r\n        color: white;\r\n        height: 100%;\r\n        max-height: 100%;\r\n    }\r\n\r\n    .office-toolbar .other-offices{\r\n        color: white;\r\n        cursor: pointer;\r\n        text-decoration: none;\r\n    }\r\n\r\n    .other-offices:hover{\r\n        cursor: pointer;\r\n        background: rgb(3,155,229);\r\n    }\r\n\r\n    .other-offices.active{\r\n        cursor: pointer;\r\n        background: rgb(3,155,229);\r\n    }\r\n\r\n    .other-offices {\r\n        width: 100%;\r\n        cursor: pointer;\r\n    }\r\n\r\n    #collapsedBar {\r\n        width: 5%;\r\n        background: rgb(45,50,62);\r\n        color: white;\r\n    }\r\n\r\n    .toggle-close{\r\n        margin: 0 0 0 28%;\r\n    }\n</style><md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"activated\"></md-backdrop><md-progress-linear class=\"md-warn\" md-mode=\"query\" \nng-show=\"activated\"></md-progress-linear><div id=\"login\" class=\"flex-scrollable\" layout=\"row\" ms-scroll><md-sidenav \nlayout=\"column\" class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'gt-md\')\">\n<md-toolbar class=\"office-toolbar\"><div layout=\"row\" layout-align=\"start center\"><a ui-sref=\"app.pages_auth_login\" \nstyle=\"margin-left: 2%\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></a><h3 id=\"location-title\" \nstyle=\"margin-left:28%\">OFFICES</h3><md-icon class=\"toggle-close s18\" md-font-icon=\"icon-backburger\" hide-gt-md \nng-click=\"toggle(\'left\')\" layout-align=\"center end\"></md-icon></div><div ng-repeat=\"ofc in Offices\" \nng-click=\"selectOffice(ofc);\"><div layout=\"row\" layout-align=\"center\"><a class=\"other-offices\" \nng-class=\"{\'active\' : ofc === SelectedOffice}\"><p>{{ofc.OfficeTypeDesc}} - {{ofc.City}}, {{ofc.State}}</p></a></div>\n</div></md-toolbar></md-sidenav><div id=\"collapsedBar\" hide-gt-md ng-click=\"toggle(\'left\')\" layout=\"column\"><md-icon \nclass=\"fold-toggle s20\" md-font-icon=\"icon-arrow-left\" layout-align=\"center center\" style=\"color:white\"></md-icon>\n</div><div id=\"map\"></div></div>");
$templateCache.put("app/auth/login/ErrorPage.html","<md-progress-linear class=\"md-warn\" md-mode=\"query\" ng-show=\"progress.activated\"></md-progress-linear><div id=\"login\" \nclass=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>SEDC\n</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><div><h1>Sorry</h1><div \nstyle=\"text-align:left\"><h3>We did not recognize that information.</h3><h3>The problem is one of the following:</h3><ul\n ng-bind-html=\"notification.message\"></ul></div></div><div class=\"login\" layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:40px\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"FORGOTUSERNAME.GO_BACK\">\nGo back to login</a></div></div></div></div>");
$templateCache.put("app/auth/login/login.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"login\" \nclass=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"></div><div \nclass=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><flipper flipped=\"flipped\" horizontal><back><div><h1>\nSorry</h1><div style=\"text-align:left\"><h3>We did not recognize that information.</h3><h3>\nThe problem is one of the following:</h3><ul ng-bind-html=\"notification.message\"></ul></div><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:40px\"><a class=\"link\" ng-click=\"flip()\" \ntranslate=\"FORGOTUSERNAME.GO_BACK\">Go back to login</a></div></div></back><front><form name=\"loginForm\" method=\"post\" \nnovalidate ng-submit=\"login(loginForm)\" aa-configured-form validation-config=\"Validators\" \naa-confirmation-message=\"false\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"LOGIN.USERNAME\" \nng-hide=\"flipped\"></label><input type=\"text\" name=\"usernameE\" ng-model=\"loginData.Username\" required \nng-change=\"resetNotification()\" tabindex=\"1\"><div ng-messages=\"loginForm.usernameE.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.USER_REQUIRED\">Username field is required\n</span></div></div><div style=\"text-align: right\" class=\"remember-forgot-password\"><a ng-click=\"goToForgotUsername();\" \nclass=\"forgot-password md-accent-color link\" translate=\"LOGIN.FORGOT_USERNAME\">Forgot username?</a></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"LOGIN.PASSWORD\" \nng-hide=\"flipped\"></label><input type=\"password\" name=\"password\" autocomplete=\"off\" ng-model=\"loginData.Password\" \nrequired=\"\" ng-change=\"resetNotification()\" tabindex=\"2\"><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n<div style=\"text-align: right\" class=\"remember-forgot-password\"><a ng-click=\"goToForgotPassword();\" \nclass=\"forgot-password md-accent-color link\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div>\n</md-input-container><div ng-hide=\"true\" class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"loginData.staySignedIn\" \naria-label=\"Stay signed on\" tabindex=\"3\"><span translate=\"LOGIN.REMEMBER_ME\">Stay signed in</span></md-checkbox></div>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine || processing\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <button class=\"link\" ng-click=\"goToCreateAccount();\" translate=\"LOGIN.CREATE_ACCOUNT\">\nCreate an account</button></div><div class=\"register\" layout=\"row\" layout-sm=\"row\" layout-align=\"center center\"><a \nclass=\"link\" ui-sref=\"app.pages_utility_contact\">Contact Us</a> <span>&nbsp;|&nbsp;</span> <a class=\"link\" \nui-sref=\"app.pages_utility_location\">Locate Us</a></div><span class=\"fs-12\">Version {{portalVersion}}</span></front>\n</flipper></div></div></div>");
$templateCache.put("app/auth/register/register.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"register\" \nclass=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\" ng-class=\"{successCard : flipped}\"><div \nclass=\"logo md-accent-bg\"><span>SEDC</span></div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div>\n<div><form name=\"registerForm\" method=\"post\" novalidate aa-configured-form validation-config=\"SignUpValidators\" \nprevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\" login-required=\"false\"><flipper flipped=\"flipped\" \nhorizontal><back style=\"height:20% !important\"><div layout=\"row\"><div style=\"text-align:center\"><div class=\"title\" \ntranslate=\"REGISTER.SUCCESSFUL\"></div><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" \nui-sref=\"app.pages_auth_login\" translate=\"REGISTER.GO_BACK\"></a></div></div></div></back><front><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"REGISTER.ACCOUNT\"></label><input name=\"account\" \nng-model=\"customer.AccountNumber\" maxlength=\"8\" mask=\"9?9?9?9?9?9?9?9\" ng-pattern=\"accountNumberPattern\" \nrestrict=\"reject\" clean=\"true\" required ng-blur=\"checkAccountNumber(customer.AccountNumber)\"><div \nng-messages=\"registerForm.account.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.ACCOUNT_REQUIRED\">Account No. field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER.ERRORS.INVALID_ACCOUNT_NUMBER_FORMAT\"></span></div><div ng-message=\"maxlength\"><span \ntranslate=\"REGISTER.ERRORS.INVALID_ACCOUNT_NUMBER_LENGTH\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"REGISTER.NAME\"></label><input name=\"usernameE\" \nmasked-value=\"UsernameMasked\" ng-model=\"registration.Username\" ng-pattern=\"/^[\\w_.@]+$/\" ng-maxlength=\"50\" \nmaxlength=\"50\" required><div ng-messages=\"registerForm.usernameE.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div><div ng-message=\"pattern\"><span>\nUsername is invalid</span><ul class=\"password-requirements-list\"><li>\nUsername may consist only of alphanumeric characters and the special characters at sign, underscore and period (@ _ .)\n</li><li>Other special characters and spaces are NOT allowed</li></ul></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"REGISTER.EMAIL\"></label><input type=\"text\" \nname=\"emailE\" ng-model=\"registration.Email\" masked-value=\"EmailMasked\" email-address-check required><div \nng-messages=\"registerForm.emailE.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">E-mail field is required</span></div><div ng-message=\"invalid\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">E-mail must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"REGISTER.EMAIL_CONFIRM\"></label>\n<input type=\"text\" name=\"emailConfirm\" masked-value=\"ConfirmEmailMasked\" ng-model=\"registration.ConfirmEmail\" required \nmatch-field=\"registration.Email\" match-value=\"{{registration.Email}}\"><div \nng-messages=\"registerForm.emailConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_CONFIRM_REQUIRED\">E-mail (Confirm) field is required</span></div><div \nng-message=\"match\" style=\"opacity: 1; margin-top: 0px\"><span translate=\"REGISTER.ERRORS.EMAILCONF_NOTSAME\"></span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><label translate=\"REGISTER.PASSWORD\">\n</label><input ms-password type=\"password\" name=\"password\" autocomplete=\"off\" masked-value=\"PasswordMasked\" \nng-model=\"registration.Password\" required> <span class=\"input-help\"><md-icon class=\"help-button\" \nng-click=\"showPasswordHelp()\" md-font-icon=\"icon-question-mark-circle\"></md-icon></span><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"ms-password\">\n<span>Password must contain the following:</span><ul class=\"password-requirements-list\"><li>\nat least one lowercase letter</li><li>at least one uppercase letter</li><li>at least one number</li><li>\nat least one special character</li></ul></div><div ng-message=\"minlength\"><span>\nPassword must be at least 6 characters long.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><label translate=\"REGISTER.PASSWORD_CONFIRM\"></label><input type=\"password\" \nname=\"passwordConfirm\" autocomplete=\"off\" masked-value=\"ConfirmPasswordMasked\" ng-model=\"registration.ConfirmPassword\" \nrequired match-field=\"registration.Password\" match-value=\"{{registration.Password}}\"><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div \nng-message=\"match\" style=\"opacity: 1; margin-top: 0px\"><span translate=\"REGISTER.ERRORS.PASSWORDCONF_NOTSAME\"></span>\n</div></div></md-input-container><div id=\"validate-type-section\"><label>Validate account number using:</label>\n<md-input-container class=\"md-block\" flex-gt-sm><label>Enter Latest Bill Amount</label><input type=\"text\" \nname=\"billAmount\" ng-model=\"validation.BillAmount\" ui-number-mask ui-negative-number required> <span \nclass=\"input-help\"><md-icon class=\"help-button\" ng-click=\"showBillAmountHelp()\" \nmd-font-icon=\"icon-question-mark-circle\"></md-icon></span></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Enter Phone Number</label><input name=\"PNum\" ng-model=\"validation.PNumber\" mask=\"999-999-9999\" \nrestrict=\"reject\" clean=\"true\" required></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \nng-click=\"Validate(registerForm)\" translate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button><div\n class=\"login\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" \ntranslate=\"REGISTER.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" \ntranslate=\"REGISTER.LOGIN\">Log in</a></div></front></flipper></form></div></div></div></div>");
$templateCache.put("app/auth/reset-password/reset-password.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"reset-password\" \nclass=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\">\n<span>F</span></div><form name=\"resetPasswordForm\" method=\"post\" novalidate ng-hide=\"success\" aa-configured-form \nvalidation-config=\"Validators\" prevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\" \nlogin-required=\"false\"><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nautocomplete=\"off\" ng-model=\"ResetPasswordBindingModel.NewPassword\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" required ms-password><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div \nng-message=\"ms-password\"><span>Password must contain the following:</span><ul><li>at least one lowercase letter</li>\n<li>at least one uppercase letter</li><li>at least one number</li><li>at least one special character</li></ul></div>\n<div ng-message=\"minlength\"><span>Password must be at least 6 characters long.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" autocomplete=\"off\" \nng-model=\"ResetPasswordBindingModel.ConfirmPassword\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" match-field=\"ResetPasswordBindingModel.NewPassword\" \nmatch-value=\"{{ResetPasswordBindingModel.NewPassword}}\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div \nng-message=\"match\" style=\"opacity: 1; margin-top: 0px\"><span translate=\"RESETPASSWORD.ERRORS.PASSWORDCONF_NOTSAME\">\n</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\" \nng-click=\"resetPassword()\">RESET MY PASSWORD</md-button></form><div class=\"title\" translate=\"RESETPASSWORD.SUCCESS\" \nng-show=\"success\">Your password has been reset</div><div class=\"login\" layout=\"row\" layout-align=\"center center\" \nng-show=\"success\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"RESETPASSWORD.GO_BACK\">Go back to login</a>\n</div></div></div></div>");
$templateCache.put("app/auth/reset-user/reset-user.html","<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"progress.activated || loadingProgress\"></md-backdrop><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"progress.activated || loadingProgress\"></md-progress-linear><div id=\"reset-user\" \nclass=\"flex-scrollable\" layout=\"column\" ms-scroll ng-init=\"ValidateCode()\"><div id=\"reset-user-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-user-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>SEDC</span></div><form name=\"ResetUserForm\" method=\"post\" novalidate \naa-configured-form validation-config=\"Validators\" prevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\" \nlogin-required=\"false\"><flipper flipped=\"flipped\" horizontal ng-show=\"showForm\"><back><div style=\"text-align:center\">\n<h3>Your password has been changed.</h3><ul ng-bind-html=\"notification.message\"></ul><a class=\"link\" \nui-sref=\"app.msportal.accounts\" translate=\"RESETUSERCODE.GO_BACK\"></a></div></back><front><md-input-container \nclass=\"md-block\" flex-gt-sm><label>New Password</label><input type=\"password\" name=\"NewPassword\" autocomplete=\"off\" \nng-model=\"ResetPasswordBindingModel.NewPassword\" required ng-maxlength=\"50\" maxlength=\"50\" ms-password> <span \nclass=\"input-help\"><md-icon class=\"help-button\" ng-click=\"showPasswordHelp()\" md-font-icon=\"icon-question-mark-circle\">\n</md-icon></span><div ng-messages=\"ResetUserForm.NewPassword.$error\"><div ng-message=\"required\"><span \ntranslate=\"RESETUSERCODE.ERRORS.NEW_PASSWORD_REQUIRED\"></span></div><div ng-message=\"ms-password\"><span>\nPassword must contain the following:</span><ul><li>at least one lowercase letter</li><li>at least one uppercase letter\n</li><li>at least one number</li><li>at least one special character</li></ul></div><div ng-message=\"pattern\" \nstyle=\"opacity: 1; margin-top: 0px\"><span translate=\"RESETUSERCODE.ERRORS.PASSWORD_PATTERN\"></span></div><div \nng-message=\"minlength\" style=\"opacity: 1; margin-top: 0px\"><span translate=\"RESETUSERCODE.ERRORS.PASSWORD_PATTERN\">\n</span></div><div ng-message=\"maxlength\" style=\"opacity: 1; margin-top: 0px\"><span \ntranslate=\"RESETUSERCODE.ERRORS.PASSWORD_PATTERN\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Password (Confirm)</label><input type=\"password\" name=\"ConfirmPassword\" \nautocomplete=\"off\" ng-model=\"ResetPasswordBindingModel.ConfirmPassword\" \nmatch-field=\"ResetPasswordBindingModel.NewPassword\" match-value=\"{{ResetPasswordBindingModel.NewPassword}}\" required \nng-maxlength=\"50\" maxlength=\"50\"><div ng-messages=\"ResetUserForm.ConfirmPassword.$error\"><div ng-message=\"required\">\n<span translate=\"RESETUSERCODE.ERRORS.PASSWORDCONF_REQUIRED\"></span></div><div ng-message=\"match\" \nstyle=\"opacity: 1; margin-top: 0px\"><span translate=\"RESETUSERCODE.ERRORS.PASSWORDCONF_NOTSAME\"></span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"ResetUserForm.$invalid || ResetUserForm.$pristine\" translate=\"RESETUSERCODE.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"RESETUSERCODE.SEND_RESET_LINK\" ng-click=\"ResetPassword()\">SEND RESET LINK</md-button>\n</front></flipper></form></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"start center\" flex><div class=\"shortcuts\" layout=\"row\" \nlayout-align=\"start center\" ms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" \nng-sortable=\"MsShortcuts.sortableOptions\"><div ng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" \nui-sref=\"{{shortcut.uisref}}\"><md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\">\n</md-icon><div ng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip \nmd-direction=\"bottom\">{{shortcut.title}}</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s20\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"40\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" class=\"{{result.icon}}\">\n</i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">{{result.title}}</div>\n</div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" ng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon>\n</div></div></div></div></md-menu-content></md-menu></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"48\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div>\n<div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">{{result.description}}\n</div></div></div></div></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><div ng-if=\"vm.session.isAuth\">Hi,<span class=\"username\">{{vm.session.userName}}</span></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-delete-variant\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.resetPassword()\">reset password</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item\n class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><div ng-if=\"vm.session.isAuth\">Hi,<span class=\"username\">{{vm.session.userName}}</span></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-delete-variant\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.resetPassword()\">reset password</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item\n class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><div ng-if=\"vm.session.isAuth\">Hi,<span class=\"username\">{{vm.session.userName}}</span></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-delete-variant\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.changePassword()\">Change Password</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/admin_toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex></div><div \nlayout=\"row\" layout-align=\"start center\"><md-menuom-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"></div><div ng-if=\"vm.session.isAuth\">Good day <span class=\"username\">{{vm.session.roleType}},\n</span>&nbsp;<span>{{vm.session.userName}}</span></div><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-delete-variant\" class=\"icon\"></md-icon><md-button ng-click=\"vm.changePassword()\">Change Password\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-delete-variant\" class=\"icon\"></md-icon><md-button ng-click=\"vm.changeUserName()\">Change Username\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-delete-variant\" class=\"icon\"></md-icon><md-button ng-click=\"vm.changeEmail()\">Change E-mail\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menuom-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\">\n<md-menuom-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"vm.openMenu($mdOpenMenu,$event)\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><div ng-if=\"vm.session.isAuth && vm.session.roleType==\'Admin\'\">Hi <span>{{vm.session.roleType}},</span>\n<span class=\"username\">{{vm.session.userName}}</span></div><div ng-if=\"vm.session.isAuth && vm.session.roleType==\'\'\">\nHi, <span class=\"username\">{{vm.session.userName}}</span></div><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs ng-if=\"!showAdminToolbar\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item\n class=\"md-indent\" ng-if=\"!showAdminToolbar\"><md-icon md-font-icon=\"icon-delete-variant\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.changePassword()\">Change Password</md-button></md-menu-item><md-menu-divider \nng-if=\"!showAdminToolbar\"></md-menu-divider><md-menu-item class=\"md-indent\" ng-if=\"!showAdminToolbar\"><md-icon \nmd-font-icon=\"icon-delete-variant\" class=\"icon\"></md-icon><md-button ng-click=\"vm.changeUserName()\">Change Username\n</md-button></md-menu-item><md-menu-divider ng-if=\"!showAdminToolbar\"></md-menu-divider><md-menu-item \nclass=\"md-indent\" ng-if=\"!showAdminToolbar\"><md-icon md-font-icon=\"icon-delete-variant\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.changeEmail()\">Change E-mail</md-button></md-menu-item><md-menu-divider \nng-if=\"!showAdminToolbar\"></md-menu-divider><md-menu-item class=\"md-indent\" ng-if=\"!showAdminToolbar\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menuom-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><div ng-if=\"vm.session.isAuth\">Hi,\n<span class=\"username\">{{vm.session.userName}}</span></div><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-delete-variant\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.changePassword()\">Change Password</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\"></span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable m-bottom-50x\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation><div class=\"ms-navigation dock-bottom\" layout=\"row\"><div \nclass=\"divider_x\"></div><ul><li class=\"ms-navigation-node\"><div class=\"ms-navigation-item\" layout=\"row\"><a \nclass=\"ms-navigation-button\" ui-sref=\"app.msportal.contactUs\" ui-sref-active=\"active md-accent-bg\"><i \nclass=\"icon s16 icon-phone\"></i> <span class=\"title\" flex>Contact Us</span></a></div></li></ul></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ng-click=\"vm.goToState(node)\" ng-class=\"{\'active md-accent-bg\': vm.isActive(node.state)}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/adminpages/views/customer_list/customer_list.html","<style>a, md-button {\r\n        cursor: pointer;\r\n    }</style><div id=\"admin-customers\" \nclass=\"page-layout simple fullwidth\" layout=\"row\" ng-init=\"vm.init()\"><div class=\"content\" layout=\"column\" flex><div \nclass=\"md-title mb-32\"><span>{{vm.titlePage}}</span></div><span class=\"txtResult\" ng-show=\"vm.totalCount > 0\">\n{{vm.totalCount}} <span ng-if=\"vm.totalCount > 1\">results</span><span ng-if=\"vm.totalCount == 1\">result</span></span>\n<div class=\"white-bg md-whiteframe-4dp\" ng-form=\"searchForm\"><div class=\"dataTables_wrapper no-footer\"><div \nclass=\"top\"><div class=\"dataTables_filter\"><md-select id=\"typeField\" class=\"md-no-underline\" \nng-change=\"vm.ResetPage(); vm.filterAccountType()()\" ng-model=\"vm.selectedAccountType\"><strong><md-option \nng-value=\"type\" ng-repeat=\"type in vm.accountTypes\">{{type}}</md-option></strong></md-select><md-select \nid=\"searchField\" class=\"md-no-underline\" ng-change=\"vm.ResetPage(); vm.setIsLimited()\" \nng-model=\"vm.selectedSearchField\" aria-label=\"Search Category\"><md-option style=\"height: 35px\" ng-value=\"field\" \nng-repeat=\"field in vm.searchFields\">{{field}}</md-option></md-select><input ng-model=\"vm.searchKey\" name=\"search\" \nmask=\"{{vm.customerSearchPattern}}\" ng-blur=\"vm.ResetForm(searchForm)\" restrict=\"reject\" limit=\"{{vm.isLimited}}\" \nclean=\"true\" type=\"search\" ng-keydown=\"vm.SearchOnKeyPress($event, searchForm)\" \nng-disabled=\"vm.selectedSearchField == \'All\'\" onpaste=\"return false\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.ResetPage(); vm.searchCustomers(searchForm)\" ng-disabled=\"vm.searchKey == \'\'\">Search</md-button><span \nclass=\"infoMessage\" ng-show=\"vm.searchKey == \'\' && vm.totalCount == 0\">\nEnter a search criteria in Search box to return results.</span><div ng-messages=\"searchForm.search.$error\"><div \nng-message=\"pattern\" style=\"color:red\"><span ng-if=\"vm.selectedSearchField == \'Customer ID\'\">\nInvalid input. Customer ID must be 5 digits.</span> <span ng-if=\"vm.selectedSearchField == \'Account Number\'\">\nInvalid input. Account Number must be 8 digits.</span> <span ng-if=\"vm.selectedSearchField == \'Name\'\">\nPlease make sure there are no numbers or special characters.</span></div></div></div><div class=\"customPagination\" \nng-show=\"vm.totalCount > 0 && vm.totalCount > 10\"><span class=\"adminLabels\" style=\"margin-right:8px\">View</span>\n<md-select id=\"lengthField\" ng-change=\"vm.filter(\'length\')\" ng-model=\"vm.selectedRecordsLength\"><strong><md-option \nng-value=\"length\" ng-repeat=\"length in vm.recordLengths\">{{length}}</md-option></strong></md-select><span \nclass=\"adminLabels\" style=\"margin-right:5px;margin-left:5px\">Page</span> <a ng-click=\"vm.goFirst()\" title=\"First\" \nstyle=\"text-decoration: none\" ng-show=\"vm.selectedPage != \'1\'\"><i class=\"icon-chevron-double-left\" \nstyle=\"position:relative; top: 5px; color: dimgray\"></i></a> <a ng-click=\"vm.goPrevious()\" title=\"Previous\" \nstyle=\"margin-left: -10px; text-decoration: none\" ng-show=\"vm.selectedPage != \'1\'\"><i class=\"icon-chevron-left\" \nstyle=\"position:relative; top: 5px;color: dimgray\"></i></a><md-select id=\"pageField\" ng-change=\"vm.filter(\'pagenum\')\" \nclass=\"md-no-underline\" ng-model=\"vm.selectedPage\"><strong><md-option ng-value=\"page\" ng-repeat=\"page in vm.pages\">\n{{page}}</md-option></strong></md-select><span class=\"adminLabels\" style=\"margin-left: 5px\">of {{vm.totalpages}}</span>\n <a ng-click=\"vm.goNext()\" title=\"Next\" style=\"margin-right: -10px; margin-left: -5px; text-decoration: none\" \nng-hide=\"vm.selectedPage == vm.totalpages\"><i class=\"icon-chevron-right\" \nstyle=\"position:relative; top: 5px; color: dimgray\"></i></a> <a ng-click=\"vm.goLast()\" title=\"Last\" \nstyle=\"text-decoration: none\" ng-hide=\"vm.selectedPage == vm.totalpages\"><i class=\"icon-chevron-double-right\" \nstyle=\"position:relative; top: 5px; color: dimgray\"></i></a></div></div><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text col-custID\"><div class=\"table-header\">\n<span class=\"column-title\">Customer ID</span></div></th><th class=\"secondary-text\" ng-show=\"vm.display == true\"><div \nclass=\"table-header\"><span class=\"column-title\">Account No.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Username</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">E-mail</span></div></th><th class=\"secondary-text\" \nng-show=\"vm.display == true\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\" ng-show=\"vm.display == true\"><div class=\"table-header\"><span class=\"column-title\">Address</span>\n</div></th><th class=\"secondary-text\" ng-show=\"vm.display == true\"><div class=\"table-header\"><span \nclass=\"column-title\">Balance</span></div></th><th class=\"secondary-text col-action\"><div class=\"table-header\"><span \nclass=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"account in vm.customers\" ng-click=\"\">\n<td><span>{{account.data.CustomerIDNumber}}</span></td><td ng-show=\"vm.display == true\"><span>{{account.data.MemberNo}}\n</span></td><td><span>{{account.data.Username}}</span></td><td><span>{{account.data.Email}}</span></td><td \nng-show=\"vm.display == true\"><span>{{account.data.AccountName}}</span></td><td ng-show=\"vm.display == true\"><span>\n{{account.data.ServiceAddress}}</span></td><td ng-show=\"vm.display == true\"><span ng-if=\"account.data.Balance >= 0\">\n${{account.data.Balance | number:2}}</span><span ng-if=\"account.data.Balance < 0\">\n-${{account.data.Balance * -1 | number:2}}</span></td><td><a ng-click=\"vm.simulateAccount(account.data,searchForm)\">\nView</a><br><a ng-if=\"account.data.AccessFailedCount == 4\" ng-click=\"vm.unlockUser(account.data)\">Unlock</a> <a \nng-if=\"account.data.Username !== \' \'\" ng-click=\"vm.changeEmailConfirmation(account.data)\">\n{{ account.data.EmailConfirmed === 1 ? \"Deactivate\" : \"Activate\" }} </a><a ng-if=\"account.data.Username !== \' \'\" \nng-click=\"vm.deleteUser(account.data)\" class=\"block\">Delete</a></td></tr></tbody></table></div><a \nng-show=\"vm.totalCount > 0 && vm.hasScroll\" id=\"btnBacktoTop\" ng-click=\"vm.goTop()\"><i class=\"icon-chevron-up\" \nstyle=\"position:relative; top: 5px\"></i><strong>BACK TO TOP</strong></a></div></div></div>");
$templateCache.put("app/main/msportal/views/accounts/accounts.html","<div id=\"msportal-accounts\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"center\" layout=\"column\" flex>\n<md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon \nmd-font-icon=\"icon-folder-multiple-outline\"></md-icon></md-button><h2><span>Accounts</span></h2><span flex \nstyle=\"font-size:14px; text-align:right\"><label>Filter by Status:</label><md-input-container style=\"width:150px\">\n<md-select aria-label=\"Filter by Status\" class=\"md-no-underline search search-input\" \nng-change=\"vm.FilterStatus(vm.selectedSearchField)\" ng-model=\"vm.selectedSearchField\"><md-option ng-value=\"field\" \nng-repeat=\"field in vm.searchFields\">{{field}}</md-option></md-select></md-input-container></span></div></md-toolbar>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" \nstyle=\"overflow:auto;-ms-overflow-style:scrollbar\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Service Address</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Account Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Due Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><div \nclass=\"column-title numeric\" style=\"width: {{ pastDueWidth+5 }}px\" ng-if=\"vm.PastDueOn\">Past Due</div></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><div class=\"column-title numeric\" \nstyle=\"width: {{ balanceWidth+5 }}px\">Balance</div></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Account No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">View Service Details</span></div></th></tr></thead><tbody><tr ng-repeat=\"account in vm.Accounts\" \nng-click=\"vm.gotoProductDetail(account.data.MemberNo, account.data.Status, account.data.AccountName, account.data.ServiceAddress, account.data.IsPPM)\">\n<td><span class=\"md-subhead\"><md-icon md-font-icon=\"icon-map-marker\"></md-icon>{{account.data.ServiceAddress}}</span>\n</td><td><md-icon md-font-icon=\"icon-brightness-1 s16\" class=\"status-{{ account.data.Status[0] }}\"></md-icon>\n{{account.data.Status}}</td><td>{{account.data.DueDate}}</td><td><div class=\"item-note numeric\" \nstyle=\"width: {{ pastDueWidth }}px\" \nng-if=\"vm.PastDueOn && !vm.BudgetLevelized && !account.data.BillCode && account.data.IsPPM !== \'P\'\">\n{{ account.data.PastDue | currency }}</div></td><td><div class=\"item-note numeric\" style=\"width: {{ balanceWidth }}px\" \nng-if=\"account.data.IsPPM !== \'P\'\">{{ account.data.Balance | currency }}</div><div class=\"item-note numeric\" \nstyle=\"width: {{ balanceWidth }}px\" ng-if=\"account.data.IsPPM === \'P\'\">{{ account.data.Balance * -1 | currency }}</div>\n</td><td>{{account.data.MemberNo}}</td><td><md-icon md-font-icon=\"icon-arrow-right-bold-circle\" \nclass=\"s16 ng-scope md-font icon-arrow-right-bold-circle material-icons md-default-theme clickable\" aria-hidden=\"true\">\n</md-icon></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/adminpages/views/customizePortal/customizePortal.html","<div><h1>Customize Portal</h1></div>");
$templateCache.put("app/main/msportal/views/alerts/alerts.html","<style>#alertDetails {\r\n        padding: 0px 20px 40px 20px;\r\n    }</style><div layout=\"row\" \nng-controller=\"AlertsController as vm\" ng-init=\"vm.PopulateAlertDetails();\"><div class=\"center\" layout=\"column\" flex>\n<md-content><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon \nmd-font-icon=\"icon-bell\"></md-icon></md-button><h2><span>Alerts & Reminders -- Account Number {{vm.account}}</span>\n</h2></div></md-toolbar><div name=\"alertsForm\" class=\"content-card\" id=\"alertDetails\" layout=\"column\" flex ng-form \nprevent-leaving-unsaved=\"{{preventUnsavedPrompt}}\" on-navigate-away-strategy=\"confirmCancel\"><h2>Subscription Details\n</h2><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><span>E-mail Address</span> <input \naria-label=\"Email Address\" name=\"email\" ng-disabled=\"!alertsForm.$editMode\" ng-model=\"vm.temp.Email\" \nng-pattern=\"vm.emailPattern\" ng-required=\"vm.isEmailSelected\" ng-change=\"vm.isNewEmail = true;\"><div \nng-messages=\"alertsForm.email.$error\" role=\"alert\"><span ng-message=\"required\">E-mail Address is required</span> <span \nng-message=\"pattern\">Invalid E-mail Address</span></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm ng-if=\"vm.isNewEmail && vm.temp.Email.length && !vm.hideConfirmEmail\"><span>Confirm E-mail Address</span> \n<input aria-label=\"Confirm Email Address\" name=\"confirmEmail\" ng-disabled=\"!alertsForm.$editMode && !vm.isNewEmail\" \nng-model=\"vm.confirmEmail\" match-field=\"vm.temp.Email\" match-value=\"{{vm.temp.Email}}\"><div \nng-messages=\"alertsForm.confirmEmail.$error\" role=\"alert\"><span ng-message=\"required\">\nPlease confirm your e-mail address</span> <span ng-message=\"match\">\nConfirmation E-mail does not match with E-mail Address</span></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><span>Mobile Number</span> <input aria-label=\"Mobile Number\" \nname=\"mobile\" ng-disabled=\"!alertsForm.$editMode\" ng-model=\"vm.temp.Mobile\" ui-mask=\"999-999-9999\" \nui-options=\"{clearOnBlur: false}\" ng-required=\"vm.isTextSelected\"><div ng-messages=\"alertsForm.mobile.$error\" \nrole=\"alert\"><span ng-message=\"required\">Mobile Number is required</span> <span ng-message=\"mask\">\nInvalid format. Mobile Number should be 10 digits</span></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><span>Mobile Service Provider</span><md-select aria-label=\"Mobile Service Provider\" \nname=\"provider\" ng-model=\"vm.selectedMobileProvider\" ng-disabled=\"!alertsForm.$editMode\" style=\"width:50%\" \nng-required=\"vm.isTextSelected\"><md-option ng-value=\"provider.ProviderId\" \nng-repeat=\"(index, provider) in vm.providerDetails.listItem\" \nng-selected=\"provider.ProviderId == vm.subscriptionDetails.ProviderId\">{{provider.ProviderName}}</md-option>\n</md-select><div ng-messages=\"alertsForm.provider.$error\" role=\"alert\"><span ng-message=\"required\">\nMobile Service Provider is required</span></div></md-input-container></div><div ng-if=\"vm.enableFlag\"><h2>\nAlerts Service Details</h2><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Alert Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Text Message</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">E-mail</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"(index, alert) in vm.temp.ListItems.Listitem\" \nng-if=\"alert.EnableFlag === \'A\' || alert.EnableFlag === \'B\' || alert.EnableFlag === \'P\' || alert.EnableFlag === \'W\'\">\n<td><div layout-gt-sm=\"column\"><span style=\"font-weight:500\">{{alert.AlertName}}</span> <span \nng-show=\"alert.AlertId === \'01\'\">Remind the customer<select ng-model=\"vm.selectedCriteria1\" \nng-disabled=\"!alertsForm.$editMode\"><option ng-repeat=\"i in [].constructor(10) track by $index\">{{$index + 1}}</option>\n</select>day(s) before.</span> <span ng-show=\"alert.AlertId === \'02\'\">Alert the customer when due date has passed.\n</span> <span ng-show=\"alert.AlertId === \'03\'\">Alert the customer when account profile has changed.</span> <span \nng-show=\"alert.AlertId === \'04\'\">Alert the customer when a check is returned/rejected.</span> <span \nng-show=\"alert.AlertId === \'05\'\">Notify the customer when the bill is paid.</span> <span \nng-show=\"alert.AlertId === \'06\'\">Alert the customer when a service is connected.</span> <span \nng-show=\"alert.AlertId === \'07\'\">Alert the customer when a service is disconnected</span> <span \nng-show=\"alert.AlertId === \'08\'\">Alert the customer when a service is reconnected.</span> <span \nng-show=\"alert.AlertId === \'09\'\">Alert the customer when Prepaid Balance reaches <input \nng-disabled=\"!alertsForm.$editMode\" ng-model=\"vm.subscriptionDetails.LowBalThreshold\" \nng-keypress=\"vm.isNumberKey(event)\" text-align=\"right\" onpaste=\"return false\"></span><span \nng-show=\"alert.AlertId === \'10\'\">Alert the customer each day with Prepaid Balance and Usage</span> <span \nng-show=\"alert.AlertId === \'12\'\">Remind the customer<select ng-model=\"vm.selectedCriteria6\" \nng-disabled=\"!alertsForm.$editMode\"><option ng-repeat=\"i in [].constructor(10) track by $index\">{{$index + 1}}</option>\n</select>day(s) before the due date.</span></div></td><td><md-checkbox \naria-label=\"Enable Text Message for {{alert.AlertName}}\" ng-checked=\"alert.AlertType.charAt(0) == \'1\'\" \nng-click=\"vm.updateAlertType(alert, false);\" ng-disabled=\"!alertsForm.$editMode\" ng-model=\"vm.textsSelected[index]\" \nng-change=\"vm.onTextSelected();\"></md-checkbox></td><td><md-checkbox aria-label=\"Enable Email for {{alert.AlertName}}\" \nng-checked=\"alert.AlertType.charAt(1) == \'1\'\" ng-click=\"vm.updateAlertType(alert, true)\" \nng-disabled=\"!alertsForm.$editMode\" ng-model=\"vm.EmailsSelected[index]\" ng-change=\"vm.onEmailSelected();\">\n</md-checkbox></td></tr></tbody></table><div class=\"padding\" style=\"color:red\"><p \nng-show=\"alertsForm.email.$error.required\">* E-mail Address is required</p><p \nng-show=\"alertsForm.email.$error.pattern\">* Invalid E-mail Address</p><p \nng-show=\"vm.isNewEmail && alertsForm.confirmEmail.$untouched\">* Please confirm your e-mail address</p><p \nng-show=\"alertsForm.confirmEmail.$error.match && alertsForm.confirmEmail.$touched\">\n* Confirmation E-mail does not match with E-mail Address</p><p ng-show=\"alertsForm.mobile.$error.required\">\n* Mobile Number is required</p><p ng-show=\"alertsForm.mobile.$error.pattern\">\n* Invalid format. Mobile Number should be 10 digits</p><p ng-show=\"alertsForm.mobile.$error.mask\">\n* Invalid format. Mobile Number should be 10 digits</p><p ng-show=\"alertsForm.provider.$error.required\">\n* Mobile Provider is required</p></div></div><div layout-gt-sm=\"row\"><md-input-container><md-button \nng-show=\"!alertsForm.$editMode\" class=\"md-raised md-primary\" ng-click=\"vm.updateAlertDetails(alertsForm);\">Edit\n</md-button><md-button ng-show=\"alertsForm.$editMode\" ng-disabled=\"alertsForm.$invalid\" class=\"md-raised md-primary\" \nng-click=\"vm.addModifyAlertDetails(alertsForm);\">Save</md-button><md-button ng-show=\"alertsForm.$editMode\" \nclass=\"md-raised md-primary\" ng-click=\"vm.reset(alertsForm);\">Cancel</md-button></md-input-container></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/msportal/views/alerts/subscription_details.html","<style>tr {\r\n        cursor: pointer;\r\n    }</style><div id=\"msportal-subscription-details\" \nclass=\"page-layout carded fullwidth\" layout=\"row\" ng-controller=\"SubscriptionDetailsController as vm\" \nng-init=\"vm.getSubscriptionDetails();\"><div class=\"center\" layout=\"column\" flex><md-toolbar><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-bell\">\n</md-icon></md-button><h2><span>Alerts & Reminders</span></h2></div></md-toolbar><div class=\"content-card\" \nlayout=\"column\" flex><md-content><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Account Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">E-mail Address</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Mobile Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">View Full Detail</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"account in vm.subscriptionDetails\" ng-click=\"vm.gotoAlertDetails(account.MbrNo)\"><td>\n<span class=\"md-subhead\">{{account.MbrNo}}</span></td><td>{{account.EmailAddr}}</td><td>{{account.Cellphone}}</td><td>\n<button class=\"edit-button md-icon-button md-button ng-scope md-ink-ripple md-default-theme\" type=\"button\" \nng-click=\"vm.gotoAlertDetails(account.MbrNo)\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\" \nclass=\"s16 ng-scope md-font icon-arrow-right-bold-circle material-icons md-default-theme\" aria-hidden=\"true\"></md-icon>\n<div class=\"md-ripple-container\"></div></button></td></tr></tbody></table></div></md-content></div></div></div>");
$templateCache.put("app/main/msportal/views/bill_preference/bill_preference.html","<div ng-form name=\"billPreference\" prevent-leaving-unsaved=\"{{preventUnsavedPrompt}}\" tab-index=\"5\" \non-navigate-away-strategy=\"confirmCancel\"><div ng-cloak layout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex>\n<md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon \nmd-font-icon=\"icon-folder-outline\"></md-icon></md-button><h2><span>E-Bill -- Account Number {{MemberNo}}</span></h2>\n</div></md-toolbar><md-content><md-list flex><md-list-item class=\"md-3-line\"><div class=\"md-list-item-text\" \nlayout=\"column\"><div layout=\"row\" layout-xs=\"column\" align=\"left\"><div flex><h4>Account No. {{MemberNo}}</h4></div><div\n flex><h4>Account Status: {{Service.Status}}</h4></div><div flex><p></p><h4>Amount Due: <span class=\"item-note\" \nng-if=\"Service.Balance >= 0\">${{Service.Balance| number:2}}</span> <span class=\"item-note\" ng-if=\"Service.Balance < 0\">\n-${{Service.Balance * -1| number:2}}</span></h4><p></p></div><div flex><h4>\nBilling Preference: {{BillingPreferenceDesc}}</h4></div></div></div><md-divider></md-divider></md-list-item></md-list>\n</md-content></div></div><div ng-cloak layout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex><md-toolbar><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-cube-outline\">\n</md-icon></md-button><h2><span>Instructions</span></h2></div></md-toolbar><md-content class=\"input-space\"><md-card>\n<md-card-content><h4>\nTo enroll the selected account in E-Bill, change the Billing Method to \'E-Bill\'. An e-mail address will be required. You must also confirm your e-mail address before clicking \n<strong>SAVE</strong>\n. If you\'d like the convenience of E-Bill but want to continue receiving paper, change the Billing Method to \'Paper & E-Bill\'. To stop receiving E-Bill Notifications at any time, simply change the Billing Method back to \'Paper\'.\n</h4></md-card-content></md-card><md-list flex><md-list-item class=\"md-3-line\"><div class=\"md-list-item-text\" \nlayout=\"column\"><p></p><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><h4>Billing Method:</h4>\n<md-select aria-label=\"Billing Method\" name=\"billingMethod\" ng-model=\"ENotificationDetails.Code1\"><md-select-header>\n<span>Billing Method</span></md-select-header><md-option ng-value=\"b.id\" ng-repeat=\"b in BillMethod\">{{b.desc}}\n</md-option></md-select></md-input-container></div><p></p><p></p><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-xs><h4 ng-class=\"{\'invalid-input\': !billPreference.Mail1.$valid}\">E-mail 1:</h4><input \naria-label=\"Primary Email Address\" ng-change=\"CheckIfMatch(ENotificationDetails.Email1,Email1_c,1)\" \nng-model=\"ENotificationDetails.Email1\" name=\"Mail1\" \nng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/i\" \nng-required=\"ENotificationDetails.Code1 ==\'01\' || ENotificationDetails.Code1 == \'02\' ||ENotificationDetails.Code2 ==\'01\' || ENotificationDetails.Code2 == \'02\'\">\n</md-input-container><md-input-container class=\"md-block input-left\" flex-gt-xs><h4 \nng-class=\"{\'invalid-input\': !IsMatch}\">Confirm E-mail 1:</h4><input aria-label=\"Confirm Primary Email Address\" \nname=\"ConfirmMail1\" ng-change=\"CheckIfMatch(ENotificationDetails.Email1,Email1_c,1)\" ng-model=\"Email1_c\">\n</md-input-container></div><p></p><p></p><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><h4 \nng-class=\"{\'invalid-input\': !billPreference.Mail2.$valid}\">E-mail 2:</h4><input aria-label=\"Seconary Email Address\" \nng-change=\"CheckIfMatch(ENotificationDetails.Email2,Email2_c,2)\" ng-model=\"ENotificationDetails.Email2\" name=\"Mail2\" \nng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/i\"></md-input-container>\n<md-input-container class=\"md-block input-left\" flex-gt-xs><h4 ng-class=\"{\'invalid-input\': !IsMatch2}\">\nConfirm E-mail 2:</h4><input aria-label=\"Confirm Secondary Email Address\" name=\"ConfirmMail2\" \nng-change=\"CheckIfMatch(ENotificationDetails.Email2,Email2_c,2)\" ng-model=\"Email2_c\"></md-input-container></div><p></p>\n<p><md-button class=\"md-raised md-primary\" ng-click=\"SaveBillingPreference(billPreference)\">Save</md-button></p></div>\n</md-list-item></md-list></md-content></div></div></div>");
$templateCache.put("app/main/msportal/views/budget_levelized/budgetLevelized.html","<div ng-form=\"billingtype\" prevent-leaving-unsaved=\"{{preventUnsavedPrompt}}\" \non-navigate-away-strategy=\"confirmCancel\" tab-index=\"1\"><div ng-init=\"vm.InitData()\"></div><div ng-cloak \nlayout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon></md-button><h2><span>\nBudget/Levelized Billing -- Account Number {{vm.MemberNo}}</span></h2></div></md-toolbar><md-content \nstyle=\"overflow-x: hidden\"><md-list flex><md-list-item class=\"md-3-line\"><div class=\"md-list-item-text\" \nlayout=\"column\"><div layout=\"row\" layout-xs=\"column\" align=\"left\"><div flex><h4>Account No. {{vm.MemberNo}}</h4></div>\n<div flex><h4>Account Status: {{vm.Account.Status}}</h4></div><div flex><h4>Address: {{vm.Account.ServiceAddress}}</h4>\n</div></div><div layout=\"row\" layout-xs=\"column\" align=\"left\"><div flex><h4>Account Name: {{vm.Account.AccountName}}\n</h4></div><div flex><h4>Due Date: {{vm.Account.DueDate}}</h4></div><div flex><p></p><h4>Amount Due: <span \nclass=\"item-note\" ng-if=\"vm.Account.Balance >= 0\">${{vm.Account.Balance| number:2}}</span> <span class=\"item-note\" \nng-if=\"vm.Account.Balance < 0\">-${{vm.Account.Balance * -1| number:2}}</span></h4><p></p></div></div></div><md-divider>\n</md-divider></md-list-item></md-list><md-divider></md-divider><md-card><md-card-content><h3><strong>For Signing Up: \n</strong>Only <strong>ACTIVE</strong>\n accounts and services can be enrolled in Budget/Levelized Billling. Select the desired type of billing (Budget Bill or Levelized Bill) and click \n<strong>EDIT</strong> then <strong>SUBMIT</strong>\n to sign up. The changes you make will be effective with the next billing.</h3><h3><strong>For Removing: </strong>\nOnce you are signed up for Budget/Levelized Billing, you will be able to see the list of your <strong>Enrolled Services\n</strong>. To remove them from Budget/Levelized Billing, click <strong>EDIT</strong> then <strong>REMOVE</strong>.</h3>\n</md-card-content></md-card><div layout-gt-sm=\"row\" layout-align-gt-sm=\"space-around center\" class=\"ie-njrochcho\">\n<md-input-container class=\"md-block\" flex-gt-xl><h4>Please select the type of billing:</h4><md-select \nng-disabled=\"vm.Enrolled || vm.NoActiveService\" ng-change=\"vm.CheckPortalBusinessRules()\" ng-model=\"vm.BillingType\" \nplaceholder=\"------------\"><md-option ng-disabled=\"vm.BudgetBillEnabled != \'1\'\" value=\"01\">Budget Bill</md-option>\n<md-option ng-disabled=\"vm.LevelizedEnabled != \'1\'\" value=\"02\">Levelized Bill</md-option></md-select>\n</md-input-container></div><md-toolbar \nng-if=\"vm.ExcludedInactiveServices.length > 0 && vm.EnrolledServices.length === 0\"><div class=\"md-toolbar-tools\">\n<md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon></md-button>\n<h2><span>Inactive Services</span></h2></div></md-toolbar><div \nng-if=\"vm.ExcludedInactiveServices.length > 0 && vm.EnrolledServices.length === 0\" \nclass=\"content-card content fullpage-datatable\" layout=\"column\" layout-gt-sm=\"row\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Service ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><div class=\"column-title numeric\" style=\"width: {{ vm.balanceWidth+5 }}px\">Balance</div></div>\n</th></tr></thead><tbody><tr ng-repeat=\"s in vm.ExcludedInactiveServices\"><td><span class=\"md-subhead\">\n{{s.data.MemberSep.replace(s.data.MemberNo, s.data.MemberNo + \"-\")}}</span></td><td><span class=\"md-subhead\"><md-icon \nmd-font-icon=\"icon-water\" ng-if=\"(s.data.Description | uppercase)===\'WATER\'\" alt=\"Water\"></md-icon><md-icon \nmd-font-icon=\"icon-flash\" ng-if=\"(s.data.Description | uppercase)===\'ELECTRIC\'\" alt=\"Electric\"></md-icon><md-icon \nmd-font-icon=\"icon-water-pump\" ng-if=\"(s.data.Description | uppercase)===\'SEWER\'\" alt=\"Sewer\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.data.Description | uppercase)===\'REFUSE\'\" alt=\"Refuse\"></md-icon><md-icon \nmd-font-icon=\"icon-fire\" ng-if=\"(s.data.Description | uppercase)===\'GAS\'\" alt=\"Gas\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.data.Description | uppercase)===\'SANITATION\'\" alt=\"Sanitation\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.data.Description | uppercase)===\'GARBAGE\'\" alt=\"Garbage\"></md-icon><md-icon \nmd-font-icon=\"icon-speedometer\" ng-if=\"(s.data.Description | uppercase)===\'OTH METERED\'\" alt=\"Oth Metered\"></md-icon>\n<md-icon md-font-icon=\"icon-bookmark-remove\" ng-if=\"(s.data.Description | uppercase)===\'NON METERED\'\" \nalt=\"Non Metered\"></md-icon>{{s.data.Description}}</span></td><td><span class=\"md-subhead\"><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'green\'}\" ng-if=\"s.data.Status==\'Active\'\"></md-icon><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'red\'}\" ng-if=\"s.data.Status==\'Inactive\'\"></md-icon><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'blue\'}\" ng-if=\"s.data.Status==\'New\'\"></md-icon>\n{{s.data.Status}}</span></td><td ng-if=\"s.data.Balance >=0\"><div><div class=\"numeric\" \nstyle=\"width:{{vm.balanceWidth}}px\">${{s.data.Balance| number:2}}</div></div></td><td ng-if=\"s.data.Balance < 0\"><div>\n<div class=\"numeric\" style=\"width:{{vm.balanceWidth}}px\">-${{s.data.Balance * -1| number:2}}</div></div></td></tr>\n</tbody></table></div><md-toolbar \nng-if=\"(!vm.Enrolled && vm.ExcludedActiveServices.length > 0) || (vm.Enrolled && vm.HasExcludedService) && vm.EnrolledServices.length === 0\">\n<div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon \nmd-font-icon=\"icon-cube-outline\"></md-icon></md-button><h2><span ng-if=\"!vm.Enrolled\">Active Services</span> <span \nng-if=\"vm.Enrolled && vm.HasExcludedService\">Excluded Services</span></h2></div></md-toolbar><div \nng-if=\"(!vm.Enrolled && vm.ExcludedActiveServices.length > 0) || (vm.Enrolled && vm.HasExcludedService) && vm.EnrolledServices.length === 0\" \nclass=\"content-card content fullpage-datatable\" layout=\"column\" layout-gt-sm=\"row\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Service ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><div class=\"column-title numeric\" style=\"width: {{vm.balanceWidth+5}}px\">Balance</div></div></th>\n<th class=\"secondary-text\" ng-show=\"!vm.Enrolled && vm.BillingType === \'01\'\"><div class=\"table-header\"><div \nclass=\"column-title numeric\" style=\"width: {{vm.amountWidth+5}}px\">Amount</div></div></th></tr></thead><tbody><tr \nng-repeat=\"s in vm.ExcludedActiveServices\"><td><span class=\"md-subhead\">\n{{s.data.MemberSep.replace(s.data.MemberNo, s.data.MemberNo + \"-\")}}</span></td><td><span class=\"md-subhead\"><md-icon \nmd-font-icon=\"icon-water\" ng-if=\"(s.data.Description | uppercase)===\'WATER\'\" alt=\"Water\"></md-icon><md-icon \nmd-font-icon=\"icon-flash\" ng-if=\"(s.data.Description | uppercase)===\'ELECTRIC\'\" alt=\"Electric\"></md-icon><md-icon \nmd-font-icon=\"icon-water-pump\" ng-if=\"(s.data.Description | uppercase)===\'SEWER\'\" alt=\"Sewer\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.data.Description | uppercase)===\'REFUSE\'\" alt=\"Refuse\"></md-icon><md-icon \nmd-font-icon=\"icon-fire\" ng-if=\"(s.data.Description | uppercase)===\'GAS\'\" alt=\"Gas\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.data.Description | uppercase)===\'SANITATION\'\" alt=\"Sanitation\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.data.Description | uppercase)===\'GARBAGE\'\" alt=\"Garbage\"></md-icon><md-icon \nmd-font-icon=\"icon-speedometer\" ng-if=\"(s.data.Description | uppercase)===\'OTH METERED\'\" alt=\"Oth Metered\"></md-icon>\n<md-icon md-font-icon=\"icon-bookmark-remove\" ng-if=\"(s.data.Description | uppercase)===\'NON METERED\'\" \nalt=\"Non Metered\"></md-icon>{{s.data.Description}}</span></td><td><span class=\"md-subhead\"><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'green\'}\" ng-if=\"s.data.Status==\'Active\'\"></md-icon><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'red\'}\" ng-if=\"s.data.Status==\'Inactive\'\"></md-icon><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'blue\'}\" ng-if=\"s.data.Status==\'New\'\"></md-icon>\n{{s.data.Status}}</span></td><td ng-if=\"s.data.Balance >=0\"><div><div class=\"numeric\" \nstyle=\"width: {{ vm.balanceWidth }}px\">${{s.data.Balance| number:2}}</div></div></td><td ng-if=\"s.data.Balance < 0\">\n<div class=\"numeric\" style=\"width: {{ vm.balanceWidth }}px\"><div>-${{s.data.Balance * -1| number:2}}</div></div></td>\n<td ng-show=\"!vm.Enrolled && vm.BillingType === \'01\'\"><div><div class=\"numeric\" style=\"width: {{ vm.amountWidth }}px\">\n<span ng-if=\"s.data.BudgetBillAmount >=0\">${{s.data.BudgetBillAmount| number:2}}</span> <span \nng-if=\"s.data.BudgetBillAmount < 0\">-${{s.data.BudgetBillAmount * -1| number:2}}</span></div></div></td></tr></tbody>\n</table></div><md-toolbar ng-if=\"vm.Enrolled\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Icon\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon></md-button><h2><span>Enrolled Services</span>\n</h2></div></md-toolbar><div ng-if=\"vm.Enrolled\" class=\"content-card content fullpage-datatable\" layout=\"column\" \nlayout-gt-sm=\"row\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><div class=\"column-title numeric\" \nstyle=\"width: {{ vm.balanceWidth+5 }}px\">Balance</div></div></th><th class=\"secondary-text\" \nng-if=\"vm.BillingType === \'01\'\"><div class=\"table-header\"><div class=\"column-title numeric\" \nstyle=\"width: {{ vm.amountWidth+5 }}px\">Amount</div></div></th></tr></thead><tbody><tr \nng-repeat=\"s in vm.EnrolledServices\"><td><span class=\"md-subhead\">\n{{s.data.MemberSep.replace(s.data.MemberNo, s.data.MemberNo + \"-\")}}</span></td><td><span class=\"md-subhead\"><md-icon \nmd-font-icon=\"icon-water\" ng-if=\"(s.data.Description | uppercase)===\'WATER\'\" alt=\"Water\"></md-icon><md-icon \nmd-font-icon=\"icon-flash\" ng-if=\"(s.data.Description | uppercase)===\'ELECTRIC\'\" alt=\"Electric\"></md-icon><md-icon \nmd-font-icon=\"icon-water-pump\" ng-if=\"(s.data.Description | uppercase)===\'SEWER\'\" alt=\"Sewer\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.data.Description | uppercase)===\'REFUSE\'\" alt=\"Refuse\"></md-icon><md-icon \nmd-font-icon=\"icon-fire\" ng-if=\"(s.data.Description | uppercase)===\'GAS\'\" alt=\"Gas\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.data.Description | uppercase)===\'SANITATION\'\" alt=\"Sanitation\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.data.Description | uppercase)===\'GARBAGE\'\" alt=\"Garbage\"></md-icon><md-icon \nmd-font-icon=\"icon-speedometer\" ng-if=\"(s.data.Description | uppercase)===\'OTH METERED\'\" alt=\"Oth Metered\"></md-icon>\n<md-icon md-font-icon=\"icon-bookmark-remove\" ng-if=\"(s.data.Description | uppercase)===\'NON METERED\'\" \nalt=\"Non Metered\"></md-icon>{{s.data.Description}}</span></td><td><span class=\"md-subhead\"><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'green\'}\" ng-if=\"s.data.Status==\'Active\'\"></md-icon><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'red\'}\" ng-if=\"s.data.Status==\'Inactive\'\"></md-icon><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'blue\'}\" ng-if=\"s.data.Status==\'New\'\"></md-icon>\n{{s.data.Status}}</span></td><td ng-if=\"s.data.Balance >=0\"><div><div class=\"numeric\" \nstyle=\"width: {{ vm.balanceWidth }}px\">${{s.data.Balance| number:2}}</div></div></td><td ng-if=\"s.data.Balance < 0\">\n<div><div class=\"numeric\" style=\"width: {{ vm.balanceWidth }}px\">-${{s.data.Balance * -1| number:2}}</div></div></td>\n<td ng-if=\"vm.BillingType === \'01\'\"><div><div class=\"numeric\" style=\"width: {{ vm.amountWidth }}px\"><span \nng-if=\"s.data.BudgetBillAmount >=0\">${{s.data.BudgetBillAmount| number:2}}</span> <span \nng-if=\"s.data.BudgetBillAmount < 0\">-${{s.data.BudgetBillAmount * -1| number:2}}</span></div></div></td></tr></tbody>\n</table></div><md-divider></md-divider><p><md-button ng-show=\"!billingtype.$editMode\" class=\"md-raised md-primary\" \nng-click=\"vm.editForm(billingtype)\" ng-disabled=\"vm.Form.isLoading\">Edit</md-button><md-button \nng-show=\"billingtype.$editMode && !vm.Enrolled\" class=\"md-raised md-primary\" \nng-disabled=\"vm.ExcludedActiveServices.length<=0 || vm.Account.Status.toString().toUpperCase() != \'ACTIVE\' || !vm.PassedBusinessRules || vm.BillingType == \'00\' || (vm.BudgetBillEnabled != \'1\' && vm.BillingType == \'01\') || (vm.LevelizedEnabled != \'1\' && vm.BillingType == \'02\')\" \nng-click=\"vm.Submit(vm.BillingType, billingtype)\">SUBMIT</md-button><md-button \nng-show=\"billingtype.$editMode && vm.Enrolled\" class=\"md-raised md-primary\" \nng-disabled=\"vm.Account.Status.toString().toUpperCase() != \'ACTIVE\'|| !vm.PassedBusinessRules || vm.HasExcludedService || (vm.BudgetBillEnabled != \'1\' && vm.BillingType == \'01\') || (vm.LevelizedEnabled != \'1\' && vm.BillingType == \'02\')\" \nng-click=\"vm.Remove(billingtype)\">REMOVE</md-button><md-button ng-show=\"billingtype.$editMode\" \nclass=\"md-raised md-primary\" ng-click=\"vm.cancelForm(billingtype);\">Cancel</md-button></p></md-content></div></div>\n</div>");
$templateCache.put("app/main/msportal/views/contact_us/contact_us.html","<div class=\"h-95p-i h-min-600x-i\" ng-controller=\"ContactUsController\"><div ng-cloak layout-gt-sm=\"row\" layout=\"column\">\n<div flex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Icon\"><md-icon md-font-icon=\"icon-phone\"></md-icon></md-button><h2><span>Contact Us</span></h2></div>\n</md-toolbar><md-card ng-repeat=\"office in Offices\" class=\"w-80p br-30x-i m-10x-auto\"><md-toolbar class=\"br-top-30x\">\n<div class=\"md-toolbar-tools\"><span>{{ office.Description }} - {{ office.City }}, {{ office.State }}</span></div>\n</md-toolbar><md-card-content><md-list layout=\"row\" layout-xs=\"column\"><md-list-item class=\"md-2-line\" flex=\"50\">\n<md-icon md-font-icon=\"icon-email\" class=\"mr-10x\"></md-icon><div class=\"md-list-item-text m-5x-auto\"><h3>Email</h3><p>\n{{ office.EmailAddress }}</p></div></md-list-item><md-list-item class=\"md-2-line\" flex=\"50\"><md-icon \nmd-font-icon=\"icon-phone\" class=\"mr-10x\"></md-icon><div class=\"md-list-item-text m-5x-auto\"><h3>Telephone</h3><p>\n{{ office.Telephone }}</p></div></md-list-item></md-list><md-list layout=\"row\" layout-xs=\"column\"><md-list-item \nclass=\"md-2-line\" flex=\"50\"><md-icon md-font-icon=\"icon-clock\" class=\"mr-10x\"></md-icon><div \nclass=\"md-list-item-text m-5x-auto\"><h3>Working Hours</h3><p>{{ office.WorkingHours }}</p></div></md-list-item>\n<md-list-item class=\"md-2-line\" flex=\"50\"><md-icon md-font-icon=\"icon-navigation\" class=\"mr-10x\"></md-icon><div \nclass=\"md-list-item-text m-5x-auto\"><h3>Services Provided</h3><p>{{ office.Services }}</p></div></md-list-item>\n</md-list></md-card-content></md-card></div></div></div>");
$templateCache.put("app/main/msportal/views/delinquent/delinquent.html","<div ng-form name=\"delinquentPreference\" prevent-leaving-unsaved=\"{{preventUnsavedPrompt}}\" tab-index=\"5\" \non-navigate-away-strategy=\"confirmCancel\"><div ng-cloak layout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex>\n<md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon \nmd-font-icon=\"icon-folder-outline\"></md-icon></md-button><h2><span>E-Delinquent -- Account Number {{MemberNo}}</span>\n</h2></div></md-toolbar><md-content><md-list flex><md-list-item class=\"md-3-line\"><div class=\"md-list-item-text\" \nlayout=\"column\"><div layout=\"row\" layout-xs=\"column\" align=\"left\"><div flex><h4>Account No. {{MemberNo}}</h4></div><div\n flex><h4>Account Status: {{Service.Status}}</h4></div><div flex><p></p><h4>Amount Due: <span class=\"item-note\" \nng-if=\"Service.Balance >= 0\">${{Service.Balance| number:2}}</span> <span class=\"item-note\" ng-if=\"Service.Balance < 0\">\n-${{Service.Balance * -1| number:2}}</span></h4><p></p></div><div flex><h4>Delinquent Notice: {{BillingPreferenceDesc}}\n</h4></div></div></div><md-divider></md-divider></md-list-item></md-list></md-content></div></div><div ng-cloak \nlayout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon></md-button><h2><span>\nInstructions</span></h2></div></md-toolbar><md-content><md-card><md-card-content><h4>\nTo enroll the selected account in E-Delinquent, change the Delinquent Method to \'E-Delinquent\'. An e-mail address will be required. You must also confirm your e-mail address before clicking \n<strong>SAVE</strong>\n. If you\'d like the convenience of E-Delinquent, but want to continue receiving paper notices, change the Delinquent Method to \'Paper & E-Delinquent\'. To stop receiving E-Delinquent Notifications at any time, simply change the Delinquent Method back to \'Paper\'.\n</h4></md-card-content></md-card><md-list flex><md-list-item class=\"md-3-line\"><div class=\"md-list-item-text\" \nlayout=\"column\"><p></p><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><h4>Delinquent Method:\n</h4><md-select aria-label=\"Delinquent Method\" name=\"billingMethod\" ng-model=\"ENotificationDetails.Code2\">\n<md-select-header><span>Delinquent Method</span></md-select-header><md-option ng-value=\"b.id\" \nng-repeat=\"b in BillMethod\">{{b.desc}}</md-option></md-select></md-input-container></div><p></p><p></p><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><h4 \nng-class=\"{\'invalid-input\': !delinquentPreference.Mail1.$valid}\">E-mail 1:</h4><input \naria-label=\"Primary Email Address\" ng-change=\"CheckIfMatch(ENotificationDetails.Email1,Email1_c,1)\" \nng-model=\"ENotificationDetails.Email1\" name=\"Mail1\" \nng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/i\" \nng-required=\"ENotificationDetails.Code1 ==\'01\' || ENotificationDetails.Code1 == \'02\'|| ENotificationDetails.Code2 ==\'01\' || ENotificationDetails.Code2 == \'02\'\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><h4 ng-class=\"{\'invalid-input\': !IsMatch}\">\nConfirm E-mail 1:</h4><input aria-label=\"Confirm Primary Email Address\" name=\"ConfirmMail1\" \nng-change=\"CheckIfMatch(ENotificationDetails.Email1,Email1_c,1)\" ng-model=\"Email1_c\"></md-input-container></div><p></p>\n<p></p><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><h4 \nng-class=\"{\'invalid-input\': !delinquentPreference.Mail2.$valid}\">E-mail 2:</h4><input \naria-label=\"Secondary Email Address\" ng-change=\"CheckIfMatch(ENotificationDetails.Email2,Email2_c,2)\" \nng-model=\"ENotificationDetails.Email2\" name=\"Mail2\" \nng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/i\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs><h4 ng-class=\"{\'invalid-input\': !IsMatch2}\">Confirm E-mail 2:</h4>\n<input aria-label=\"Confirm Secondary Email Address\" name=\"ConfirmMail2\" \nng-change=\"CheckIfMatch(ENotificationDetails.Email2,Email2_c,2)\" ng-model=\"Email2_c\"></md-input-container></div><p></p>\n<p><md-button class=\"md-raised md-primary\" ng-click=\"SaveBillingPreference(delinquentPreference)\">Save</md-button></p>\n</div></md-list-item></md-list></md-content></div></div></div>");
$templateCache.put("app/main/msportal/views/deposits/deposits.html","<div layout=\"row\" ng-controller=\"DepositsController as vm\" ng-init=\"vm.init()\"><div class=\"center\" layout=\"column\" \nflex><md-content><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon\n md-font-icon=\"icon-bell\"></md-icon></md-button><h2><span>Deposit Information -- Account Number {{vm.account}}</span>\n</h2></div></md-toolbar><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Service ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Service Address</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><div class=\"column-title numeric\" style=\"width: {{ vm.consumerDepositWidth }}px\">Consumer Deposits\n</div></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Paid Date</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Refund Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><div class=\"column-title numeric\" \nstyle=\"width: {{ vm.otherDepositWidth }}px\">Other Deposits</div></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Paid Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Refund Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"deposit in vm.depositDetails\"><td>{{deposit.MemberSep}}</td><td>{{vm.depositDetailsExt.AccountName}}</td>\n<td>{{vm.depositDetailsExt.ServiceAddress}}</td><td><div class=\"numeric\" style=\"width: {{vm.consumerDepositWidth}}px\">\n{{deposit.ConsumerDeposit | currency }}</div></td><td><span ng-if=\"deposit.CDPaidDate == \'\'\">N/A</span>\n {{deposit.CDPaidDate}}</td><td><span ng-if=\"deposit.CDRefundDate == \'\'\">N/A</span> {{deposit.CDRefundDate}}</td><td>\n<div class=\"numeric\" style=\"width: {{vm.otherDepositWidth}}px\">{{deposit.OtherDeposit | currency }}</div></td><td><span\n ng-if=\"deposit.ODPaidDate == \'\'\">N/A</span> {{deposit.ODPaidDate}}</td><td><span ng-if=\"deposit.ODRefundDate == \'\'\">\nN/A</span> {{deposit.ODRefundDate}}</td></tr></tbody></table></div></md-content></div></div>");
$templateCache.put("app/main/msportal/views/draft/bankDraft.html","<div ng-cloak layout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\">\n<md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon></md-button>\n<h2><span>Bank Draft</span></h2></div></md-toolbar><form name=\"editableForm\" aa-configured-form editable-form \nnovalidate validation-config=\"vm.ECValidators\" prevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\">\n<md-content><md-card><md-card-content><h3>\nBy signing up for Bank Draft, you authorize us to draft your bank account each month for the total amount of your utility bill. This authority will remain in effect until the selected account has been removed from draft. In the event that a payment cannot be made due to insufficient funds, a service charge may be imposed.\n</h3><h3>Your security and privacy are guaranteed, and you make changes to this information at any time.</h3><h4>\n<strong>Bank Routing Number:</strong>\n The routing number is the first nine digits of the encoded number along the bottom of a check. (This may also be referred to as the \'Transit Number\'.) If in doubt, contact your bank for the correct number to enter in this field. After clicking \'Submit\', the name of your bank should display in the \'Bank Name\' field.\n</h4><h4><strong>Bank Account Number:</strong>\n The bank account number follows the nine-digit routing number on the encoded line along the bottom of the check. If in doubt, refer to a bank statement or contact your bank.\n</h4></md-card-content></md-card><div layout-gt-sm=\"column\"><div layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-around center\" class=\"ie-njrochcho\" style=\"margin-top: 25px\"><md-input-container \nclass=\"md-block input-margin\" flex-gt-xs><label class=\"black-text\">Name on Bank Account:</label><input \nng-disabled=\"(!editableForm.$editMode && vm.HasExisting) || !vm.ValidStatus || !vm.PassedBusinessRules\" \nname=\"acctName\" ng-model=\"vm.ECheckProfile.Name\" required><div ng-messages=\"editableForm.acctName.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the account name</span></div></div>\n</md-input-container><md-input-container class=\"md-block input-margin\" flex-gt-xs><label class=\"black-text\">\nBank Routing Number</label><input \nng-disabled=\"(!editableForm.$editMode && vm.HasExisting) || !vm.ValidStatus || !vm.PassedBusinessRules\" name=\"routing\" \nng-pattern=\"vm.RoutingNumberPattern\" ng-model=\"vm.ECheckProfile.RoutingNumber\" masked-value=\"vm.RoutingNumberMasked\" \nng-change=\"vm.GetBankName()\" required maxlength=\"9\"><div ng-messages=\"editableForm.routing.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Please select a Bank Routing Number.</span></div><div \nng-message=\"pattern\"><span>Invalid Format.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-around center\" class=\"ie-njrochcho\"><md-input-container class=\"md-block input-margin\" \nflex-gt-xs><label class=\"black-text\">Bank Name:</label><input name=\"bankName\" ng-model=\"vm.ECheckProfile.BankName\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block input-margin\" flex-gt-xs><label \nclass=\"black-text\">Bank Account Number</label><input \nng-disabled=\"(!editableForm.$editMode && vm.HasExisting) || !vm.ValidStatus || !vm.PassedBusinessRules\" \nname=\"bankAccount\" ng-model=\"vm.ECheckProfile.BankAccountNumber\" masked-value=\"vm.BankAccountNumberMasked\" required \nmaxlength=\"17\" ng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm))\"><div \nng-messages=\"editableForm.bankAccount.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease Select a Bank Account Number</span></div></div></md-input-container></div><div id=\"echeck-account-type-section\">\n<label class=\"input-margin\">Account Type</label><md-input-container class=\"input-margin\"><md-radio-group \nng-disabled=\"(!editableForm.$editMode && vm.HasExisting) || !vm.ValidStatus || !vm.PassedBusinessRules\" \nname=\"accountType\" ng-model=\"vm.ECheckProfile.PrintCode\" ng-required=\"true\" \nng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm))\"><md-radio-button class=\"md-block black-text\" \nflex-gt-sm ng-value=\'\"1\"\' ng-required>Savings</md-radio-button><md-radio-button class=\"md-block black-text\" flex-gt-sm \nng-value=\'\"0\"\' ng-required>Checking</md-radio-button></md-radio-group><div \nng-messages=\"editableForm.accountType.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease select an Account Type</span></div></div></md-input-container></div></div><p><md-button \nng-show=\"vm.HasExisting && !editableForm.$editMode\" \nng-disabled=\"!vm.ValidStatus || vm.BankDraftsEnabled != \'1\' || !vm.PassedBusinessRules\" class=\"md-raised md-primary\" \nng-click=\"vm.Edit(editableForm)\">EDIT</md-button><md-button ng-show=\"!vm.HasExisting || editableForm.$editMode\" \nclass=\"md-raised md-primary\" \nng-disabled=\"editableForm.$invalid || !vm.ValidStatus || vm.BankDraftsEnabled != \'1\' || !vm.PassedBusinessRules\" \nng-click=\"vm.SubmitBankDraft(editableForm,vm.HasExisting ? \'U\' : \'A\')\">SUBMIT</md-button><md-button \nclass=\"md-raised md-warn\" \nng-disabled=\"!vm.HasExisting || !vm.ValidStatus || vm.BankDraftsEnabled != \'1\' || !vm.PassedBusinessRules\" \nng-click=\"vm.Delete(editableForm)\">DELETE</md-button><md-button ng-show=\"!vm.HasExisting || editableForm.$editMode\" \nclass=\"md-raised md-primary\" ng-click=\"vm.reset(editableForm);\" \nng-disabled=\"!vm.ValidStatus || vm.BankDraftsEnabled != \'1\' || !vm.PassedBusinessRules\">CANCEL</md-button></p>\n</md-content></form></div></div>");
$templateCache.put("app/main/msportal/views/draft/ccDraft.html","<div ng-cloak layout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\">\n<md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon></md-button>\n<h2><span>Credit Card Draft</span></h2></div></md-toolbar><form name=\"editableForm\" aa-configured-form editable-form \nnovalidate validation-config=\"vm.CCValidators\" on-navigate-away-strategy=\"defaultStrategy\"><md-content><md-card>\n<md-card-content><h3>\nBy signing up for Credit Card Draft, you authorize us to draft your credit card account each month for the total amount of your utility bill.\n</h3><h3 ng-show=\"vm.Parameters[\'ShowConvCCFlag\'] != \'0\'\">\nYou will be charged a convenience fee every time your credit card account is drafted.</h3><h3>\nThis authority will remain in effect until the selected account has been removed from draft. In the event that a payment cannot be made due to insufficient funds, a service charge may be imposed. Your security and privacy are guaranteed, and you make changes to this information at any time.\n</h3></md-card-content></md-card><div layout-gt-sm=\"column\"><div layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-around center\" class=\"md-block input-margin input-top ie-njrochcho\"><md-input-container \nclass=\"md-block\" flex-gt-xs><label class=\"black-text\">Name</label><input id=\"cardname\" name=\"cardname\" \nng-model=\"vm.CreditCarfdProile.CardName\" required maxlength=\"28\" \nng-disabled=\"(!editableForm.$editMode && vm.HasExisting) || !vm.ValidStatus || !vm.PassedBusinessRules\"><div \nng-messages=\"editableForm.cardname.$error\" role=\"alert\" multiple=\"multiple\"><div id=\"idnameerrormsg\" \nng-message=\"required\"><span>Credit card name is a required field</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" class=\"ie-njrochcho\"><md-input-container class=\"md-block input-margin\" flex-gt-xs><label \nclass=\"black-text\">Credit Card Number</label><p class=\"no-filter drinkcard-cc {{vm.CreditCardProfile.CardType}}\"><input\n name=\"creditcard\" ng-model=\"vm.CreditCardProfile.CCNumber\" required payments-validate=\"card\" payments-format=\"card\" \npayments-type-model=\"vm.CreditCardProfile.CardType\" masked-value=\"vm.CCNumberMasked\" \npayments-type-model-valid=\"{{vm.Parameters.InternetParameters}}\" \nng-disabled=\"(!editableForm.$editMode && vm.HasExisting) || !vm.ValidStatus || !vm.PassedBusinessRules\"></p><div \nng-messages=\"editableForm.creditcard.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"cardType\"><span>\nWe no longer accept {{vm.CreditCardProfile.CardType}}. Please use one of the following cards:</span><br><span \nclass=\"no-filter drinkcard-cc visa\" ng-if=\"vm.Parameters.InternetParameters.INT_COOPPARM_1 > 0\" style=\"width:40px\">\n&nbsp;</span> <span class=\"no-filter drinkcard-cc mastercard\" \nng-if=\"vm.Parameters.InternetParameters.INT_COOPPARM_2 > 0\" style=\"width:40px\">&nbsp;</span> <span \nclass=\"no-filter drinkcard-cc discover\" ng-if=\"vm.Parameters.InternetParameters.INT_COOPPARM_3 > 0\" style=\"width:40px\">\n&nbsp;</span> <span class=\"no-filter drinkcard-cc amex\" ng-if=\"vm.Parameters.InternetParameters.INT_COOPPARM_4 > 0\" \nstyle=\"width:40px\">&nbsp;</span></div><div ng-message=\"card\"><span>Credit Card is not valid</span></div><div \nng-message=\"required\"><span>Credit Card is a required field!</span></div></div></md-input-container><md-input-container\n class=\"md-block input-margin\" flex-gt-xs><label class=\"black-text\">Card Security Code</label><input \nid=\"cardsecurity1\" name=\"cardsecurity1\" ng-model=\"vm.CreditCardProfile.CVV\" payments-validate=\"cvc\" \nng-disabled=\"(!editableForm.$editMode && vm.HasExisting) || !vm.ValidStatus || !vm.PassedBusinessRules\"><div \nng-messages=\"editableForm.cardsecurity1.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"cvc\"><span>\nCard Security Code is not valid</span></div><div ng-message=\"required\"><span>Card Security Code is a required field!\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-align-gt-sm=\"space-around center\" \nclass=\"ie-njrochcho\"><md-input-container class=\"md-block input-margin\" flex-gt-xs><label class=\"black-text\">\nExpiration Date</label><md-datepicker md-open-on-focus id=\"expdate\" name=\"expdate\" \nng-model=\"vm.CreditCardProfile.ExpirationDate\" md-current-view=\"year\" md-mode=\"month\" md-date-locale=\"vm.dateLocale\" \npayments-validate=\"expiry\" onkeydown=\"return false\" \nng-disabled=\"(!editableForm.$editMode && vm.HasExisting) || !vm.ValidStatus || !vm.PassedBusinessRules\">\n</md-datepicker><div ng-messages=\"editableForm.expdate.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"expiry\"><span>Expiration Date must be greater than the date today</span></div></div></md-input-container>\n<md-input-container class=\"md-block input-margin\" flex-gt-xs><label class=\"black-text\">Zip</label><input \nname=\"TempZip\" ng-model=\"vm.CreditCardProfile.ZipCode\" data-ng-pattern=\"/^(\\d{5}|\\d{5}-\\d{4})$/\" required \nmask=\"99999-9999\" clean=\"false\" restrict=\"reject\" limit=\"true\" validate=\"false\" \nng-disabled=\"(!editableForm.$editMode && vm.HasExisting) || !vm.ValidStatus || !vm.PassedBusinessRules\"><div \nng-messages=\"editableForm.TempZip.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nZip Code is a required field!</span></div></div></md-input-container></div></div><p><md-button \nng-show=\"vm.HasExisting && !editableForm.$editMode\" \nng-disabled=\"!vm.ValidStatus || vm.CCDraftsEnabled != \'1\' || !vm.PassedBusinessRules\" class=\"md-raised md-primary\" \nng-click=\"editableForm.$editMode = true;vm.TrimCardName();\">EDIT</md-button><md-button \nng-show=\"!vm.HasExisting || editableForm.$editMode\" class=\"md-raised md-primary\" \nng-disabled=\"editableForm.$invalid || !vm.ValidStatus || vm.CCDraftsEnabled != \'1\' || !vm.PassedBusinessRules\" \nng-click=\"vm.Submit(editableForm,vm.HasExisting ? \'U\' : \'A\')\">SUBMIT</md-button><md-button class=\"md-raised md-warn\" \nng-disabled=\"!vm.HasExisting || !vm.ValidStatus || vm.CCDraftsEnabled != \'1\' || !vm.PassedBusinessRules\" \nng-click=\"vm.Delete(editableForm)\">DELETE</md-button><md-button ng-show=\"!vm.HasExisting || editableForm.$editMode\" \nclass=\"md-raised md-primary\" ng-click=\"vm.reset(editableForm);\" \nng-disabled=\"!vm.ValidStatus || vm.CCDraftsEnabled != \'1\' || !vm.PassedBusinessRules\">CANCEL</md-button></p>\n</md-content></form></div></div>");
$templateCache.put("app/main/msportal/views/draft/drafts.html","<style>h4 span:first-child {\r\n        font-weight: 500;\r\n    }</style><div><div ng-cloak layout-gt-sm=\"row\" \nlayout=\"column\"><div flex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Icon\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon></md-button><h2><span>\nPayment Drafts -- Account Number {{vm.MemberNo}}</span></h2></div></md-toolbar><md-content><md-list flex><md-list-item \nclass=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><div layout=\"row\" layout-xs=\"column\" align=\"left\"><div\n flex><h4><span>Account No.:</span> {{vm.MemberNo}}</h4></div><div flex><h4><span>Account Status:</span>\n {{Service.Status}}</h4></div><div flex><h4><span>Svc Address:</span> {{Service.ServiceAddress}}</h4></div></div><div \nlayout=\"row\" layout-xs=\"column\" align=\"left\"><div flex><h4><span>Account Name:</span> {{Service.AccountName}}</h4>\n</div><div flex><h4><span>Pay by:</span> {{Service.DueDate}}</h4></div><div flex><p></p><h4><span>Amount Due:</span> \n<span class=\"item-note\" ng-if=\"Service.Balance >= 0\">${{Service.Balance| number:2}}</span> <span class=\"item-note\" \nng-if=\"Service.Balance < 0\">-${{Service.Balance * -1| number:2}}</span></h4><p></p></div></div></div><md-divider>\n</md-divider></md-list-item></md-list><md-divider></md-divider><div layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-around center\" class=\"input-margin ie-njrochcho\"><md-input-container class=\"md-block\" \nflex-gt-xl><h4>Please select the type of draft:</h4><md-select ng-change=\"vm.LoadData()\" ng-model=\"vm.draftURL\" \nplaceholder=\"Draft Type\"><md-option ng-disabled=\"vm.CCDraftsEnabled != \'1\'\" value=\"ccDraft.html\">Credit Card Draft\n</md-option><md-option ng-disabled=\"vm.BankDraftsEnabled != \'1\'\" value=\"bankDraft.html\">Bank Draft</md-option>\n</md-select></md-input-container></div><md-divider></md-divider></md-content></div></div><div style=\"padding-top:10px\" \nng-if=\"vm.draftURL\" ng-include=\"\'app/main/msportal/views/draft/\' + vm.draftURL\"></div></div>");
$templateCache.put("app/main/msportal/views/mdm_chart/mdm_chart.html","<div ng-controller=\"UsageChartController as vm\" ng-init=\"vm.getServiceDetails()\"><md-progress-linear class=\"md-warn\" \nmd-mode=\"query\" ng-show=\"vm.flipped && vm.progress.activated\"></md-progress-linear><md-toolbar><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-credit-card\">\n</md-icon></md-button><h2><span>Usage</span></h2></div></md-toolbar><md-content><form name=\"loginForm\" novalidate \naa-confirmation-message=\"false\"><div \nclass=\"pv-8 mh-16 border-top layout-wrap ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div \nclass=\"pv-8 layout-align-center-center layout-column flex-gt-xs-50 flex-100\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><md-datepicker ng-model=\"vm.calendarEvent.start\" \nmd-date-locale=\"vm.dateLocale\" md-placeholder=\"Start Date\" md-min-date=\"minDate\" md-max-date=\"maxDate\" \nng-change=\"vm.updateChart()\" onkeydown=\"return false\"></md-datepicker><span class=\"font-size-16 ng-binding\" \nstyle=\"padding-bottom:30px\">Start Date</span></div><div \nclass=\"pv-8 layout-align-center-center layout-column flex-gt-xs-50 flex-100\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><md-datepicker ng-model=\"vm.calendarEvent.end\" \nmd-date-locale=\"vm.dateLocale\" md-placeholder=\"End Date\" md-min-date=\"minDate\" md-max-date=\"maxDate\" \nng-change=\"vm.updateChart()\" onkeydown=\"return false\"></md-datepicker><span class=\"font-size-16 ng-binding\" \nstyle=\"padding-bottom:30px\">End Date</span></div></div><div class=\"p-16 ng-scope\"><nvd3 id=\"chart\" \noptions=\"vm.chart.options\" data=\"vm.chart.data\" api=\"vm.chart.api\" config=\"{refreshDataOnly: true}\"></nvd3></div>\n</form></md-content></div>");
$templateCache.put("app/main/msportal/views/payment/payment.html","<style>.payment-button {\r\n    width: 200px;\r\n    padding: 0 10px;\r\n  }</style><md-toolbar><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-credit-card\">\n</md-icon></md-button><h2><span>Payment Review -- Account Number {{vm.MemberNo}}</span></h2></div></md-toolbar>\n<md-content style=\"overflow:hidden\"><div style=\"padding-left: 10px; padding-right: 10px; padding-bottom: 10px\"><div \nalign=\"left\"><div class=\"padded\" style=\"padding: 10px\" md-whiteframe=\"6\" flex=\"100\" layout=\"column\" \nlayout-align=\"center left\"><md-tabs md-dynamic-height md-border-bottom md-selected=\"vm.SelectedIndex\"><md-tab \nlabel=\"Pay by Account\" ng-click=\"vm.AccountServices.hideChecks()\" \nng-if=\"vm.Parameters.FourthParameters.FOURTHPARM_38 != 0\"><md-content class=\"md-padding\"></md-content></md-tab><md-tab \nlabel=\"Pay By Services\" ng-click=\"vm.AccountServices.showChecks()\" \nng-if=\"vm.Parameters.FourthParameters.FOURTHPARM_38 != 1 && !vm.IsPPM\"><md-content class=\"md-padding\"><h3><i \nclass=\"icon icon-information s35\"></i>&nbsp;Please select one or more services and then select the payment method.</h3>\n</md-content></md-tab></md-tabs></div></div></div><div \nclass=\"price md-primary-bg md-hue-3 layout-align-center-start layout-row red-bg\" layout=\"row\" \nlayout-align=\"center start\"><div class=\"note\">Note:</div><div layout=\"row\" layout-align=\"center end\" \nclass=\"layout-align-center-end layout-row\"><div class=\"value\">\nThe payee on your financial statement for the transaction will be listed as <strong>\"SEDC Payment.\"</strong></div>\n</div></div><form ng-init=\"vm.LoadForm()\"><div class=\"content-card content fullpage-datatable\" layout-gt-sm=\"row\" \nstyle=\"display:block !important\"><table id=\"AccountServices\" class=\"dataTable row-border hover mdl-data-table\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span></span>\n<md-checkbox ng-model=\"vm.AccountServices.allServices\" style=\"margin-bottom:0px\" \nng-show=\"vm.AccountServices.isByService\" ng-click=\"vm.AccountServices.toggleAll()\"></md-checkbox></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Due Date</span></div></th><th \nclass=\"secondary-text\" \nng-show=\"!vm.AccountServices.isByService && vm.AccountServices.PastDueOn && !vm.BudgetLevelized && !vm.IsPPM\"><div \nclass=\"table-header\"><div class=\"column-title numeric\" style=\"width: {{pastDueWidth + 4}}px\">Past Due</div></div></th>\n<th class=\"secondary-text\" ng-if=\"!vm.IsPPM\"><div class=\"table-header\"><div class=\"column-title numeric\" \nstyle=\"width: {{balanceWidth + 4}}px\">Balance</div></div></th></tr></thead><tbody><tr \nclass=\"demo-select-all-checkboxes row\" flex=\"100\" ng-repeat=\"service in vm.AccountServices\"><td><md-checkbox \nclass=\"accountService\" aria-label=\"Checkbox 1\" ng-model=\"service.checkStatus\" ng-show=\"vm.AccountServices.isByService\" \nng-change=\"vm.AccountServices.calculateTotalAmount()\"></md-checkbox></td><td><span class=\"md-subhead\">\n{{service.MemberSep}}</span></td><td><span class=\"md-subhead\"><md-icon md-font-icon=\"icon-water\" \nng-if=\"(service.Description | uppercase)===\'WATER\'\"></md-icon><md-icon md-font-icon=\"icon-flash\" \nng-if=\"(service.Description | uppercase)===\'ELECTRIC\'\"></md-icon><md-icon md-font-icon=\"icon-water-pump\" \nng-if=\"(service.Description | uppercase)===\'SEWER\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(service.Description | uppercase)===\'REFUSE\'\"></md-icon><md-icon md-font-icon=\"icon-fire\" \nng-if=\"(service.Description | uppercase)===\'GAS\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(service.Description | uppercase)===\'SANITATION\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(service.Description | uppercase)===\'GARBAGE\'\"></md-icon><md-icon md-font-icon=\"icon-speedometer\" \nng-if=\"(service.Description | uppercase)===\'OTH METERED\'\"></md-icon><md-icon md-font-icon=\"icon-bookmark-remove\" \nng-if=\"(service.Description | uppercase)===\'NON METERED\'\"></md-icon>{{service.Description}}</span></td><td><span \nclass=\"md-subhead\"><md-icon md-font-icon=\"icon-brightness-1 s16\" class=\"status-{{ service.Status[0] }}\"></md-icon>\n{{service.Status}}</span></td><td>{{service.DueDate}}</td><td \nng-show=\"!vm.AccountServices.isByService && vm.AccountServices.PastDueOn && !vm.BudgetLevelized && !vm.IsPPM\"><div \nclass=\"numeric\" style=\"width: {{pastDueWidth}}px\">{{ service.PastDue | currency }}</div></td><td ng-if=\"!vm.IsPPM\"><div\n ng-if=\"!vm.IsPPM\" class=\"numeric\" style=\"width: {{balanceWidth}}px\">{{ service.Balance | currency }}</div></td></tr>\n</tbody><tbody ng-hide=\"!vm.IsPPM\"><tr style=\"color:red; font-weight:bold\" ng-if=\"true\"><td colspan=\"4\"><div \nstyle=\"float:right\">{{ vm.PPMPaymentLabel }}</div></td><td class=\"mdl-data-table__cell-numeric\">\n{{ vm.PPMPaymentNeeded | currency }}</td></tr></tbody></table></div><p class=\"row\" style=\"margin: 12px\" \nng-if=\"vm.AccountServices.PastDueOn && !vm.BudgetLevelized && !vm.IsPPM && !vm.AccountServices.isByService\">\nTotal Past Due for this account is {{vm.AccountServices.PaymentDetails.totalPastDueDisplay | currency}}.</p><p \nclass=\"row\" style=\"margin: 12px\" ng-if=\"!vm.IsPPM && !vm.AccountServices.isByService\">\nTotal Amount Due for this account is {{vm.AccountServices.PaymentDetails.totalAmountDisplay | currency}}.</p><p \nclass=\"row\" style=\"margin: 12px\" \nng-if=\"!vm.IsPPM && vm.AccountServices.isByService && vm.AccountServices.getSelectedService().length <=0\">\nTotal Amount Due for services above is {{vm.AccountServices.PaymentDetails.totalAmountDisplay | currency}}.</p><p \nclass=\"row\" style=\"margin: 12px\" \nng-if=\"!vm.IsPPM && vm.AccountServices.isByService && vm.AccountServices.getSelectedService().length > 0\">\nTotal Amount Due for services checked above is {{vm.AccountServices.PaymentDetails.totalAmountDisplay | currency}}.</p>\n<p class=\"row\" style=\"margin: 12px\" ng-if=\"vm.IsPPM && !vm.AccountServices.isByService\">\nTotal Amount Due for this account is {{vm.AccountServices.PaymentDetails.totalAmount * -1 | currency}}.</p><p \nclass=\"row\" style=\"margin: 12px\" \nng-if=\"vm.IsPPM && vm.AccountServices.isByService && vm.AccountServices.getSelectedService().length <= 0\">\nTotal Amount Due for services above is {{vm.AccountServices.PaymentDetails.totalAmount * -1 | currency}}.</p><p \nclass=\"row\" style=\"margin: 12px\" \nng-if=\"vm.IsPPM && vm.AccountServices.isByService && vm.AccountServices.getSelectedService().length > 0\">\nTotal Amount Due for services checked above is {{vm.AccountServices.PaymentDetails.totalAmount * -1 | currency}}.</p>\n<md-divider></md-divider><div layout=\"column\" layout-gt-sm=\"row\"><md-button \nclass=\"md-raised md-primary payment-button\" ng-click=\"vm.showPaymentScreen(\'CreditCard\')\" \nng-disabled=\"(vm.AccountServices.isByService && vm.AccountServices.getSelectedService().length == 0)\" \nng-show=\"((vm.Parameters.InternetParameters.INT_COOPPARM_1 == 1 || vm.Parameters.InternetParameters.INT_COOPPARM_2 == 1 || vm.Parameters.InternetParameters.INT_COOPPARM_3 == 1 || vm.Parameters.InternetParameters.INT_COOPPARM_4 == 1) && (vm.CreditCardStat == 1))\">\nPay with Credit Card</md-button><md-button class=\"md-raised md-primary payment-button\" \nng-click=\"vm.showPaymentScreen(\'ECheck\')\" \nng-disabled=\"(vm.AccountServices.isByService && vm.AccountServices.getSelectedService().length == 0)\" \nng-show=\"(vm.Parameters.InternetParameters.INT_COOPPARM_20 == 1) && (vm.EcheckStat == 1)\">Pay with e-Check</md-button>\n</div></form></md-content>");
$templateCache.put("app/main/msportal/views/payment_history/payment_history.html","<div style=\"height:95% !important;min-height:600px !important\"><div ng-cloak layout-gt-sm=\"row\" layout=\"column\"><div \nflex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\">\n<md-icon md-font-icon=\"icon-folder-outline\"></md-icon></md-button><h2><span>\nPayment History -- Account Number {{MemberNo}}</span></h2></div></md-toolbar><md-content><md-list flex><md-list-item \nclass=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><div layout=\"row\" layout-xs=\"column\" align=\"left\"><div\n flex><md-input-container class=\"md-block\" flex-gt-sm><label>Start Date</label><md-datepicker md-open-on-focus \nng-model=\"StartDate\" md-current-view=\"year\" md-date-locale=\"dateLocale\" md-mode=\"month\" md-max-date=\"getMaxDate\" \nonkeydown=\"return false\"></md-datepicker></md-input-container></div><div flex><md-input-container class=\"md-block\" \nflex-gt-sm><label>End Date</label><md-datepicker md-open-on-focus ng-model=\"EndDate\" md-current-view=\"year\" \nmd-date-locale=\"dateLocale\" md-mode=\"month\" md-max-date=\"getMaxDate\" onkeydown=\"return false\"></md-datepicker>\n</md-input-container></div><div flex><md-button class=\"md-raised md-primary\" \nng-click=\"LoadRecordsByDateRange(StartDate,EndDate)\">Filter</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"ReloadRecords()\">Clear Filter</md-button></div></div></div><md-divider></md-divider></md-list-item></md-list>\n</md-content></div></div><div class=\"content fullpage-datatable\" layout=\"column\" layout-gt-sm=\"row\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Payment Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><div class=\"column-title numeric\" style=\"width: {{amountWidth+5}}px\">Amount</div></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Check No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Approval Code</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"b in PaymentHistory\"><td>{{b.PaymentDate}}</td><td><div class=\"numeric\" \nstyle=\"width: {{amountWidth}}px\">{{ b.Amount| currency }}</div></td><td>{{b.CheckNo}}</td><td>{{b.ApprovalCode}}</td>\n</tr></tbody></table></div><h4 style=\"padding-left: 20px; font-weight: bold\" ng-show=\"displayTrans == true\">\nThe payment of {{TransAmt| currency}} was generated by the system to write off to the account. Contact the utility for more information.\n</h4></div>");
$templateCache.put("app/main/msportal/views/ppm_history/dailyTransactions.html","<md-dialog aria-label=\"Prepaid Services History\" flex=\"80\" ng-cloak \nstyle=\"min-height:60%!important; max-height:80% !important; background-color:white !important\" \nclass=\"modal-set-max-width\"><div style=\"height:95% !important;min-height:600px !important\"><div ng-cloak \nlayout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon></md-button><h2 flex>\n<span>Prepaid Services History for {{ item.SystemDate | date : \"MM/dd/yy\"}}</span></h2><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\"><img src=\"assets/images/icons/close.png\" aria-label=\"Close dialog\" \nstyle=\"pointer-events: none\"></md-button></div></md-toolbar></div></div><div layout=\"row\"><div layout=\"col\" flex \nclass=\"custom-header\" align=\"center\" ng-click=\"sortList(\'MemberSep\')\"><span flex>Service Id </span><i \nclass=\"fa {{ sortClass(\'MemberSep\') }} fs-20 w-15\"></i></div><div layout=\"col\" flex class=\"custom-header hidden-xs\" \nalign=\"right\"><span flex ng-click=\"sortList(\'Charges\')\">Charges</span> <i class=\"fa fa-info-circle fs-20\" \nng-click=\"showHelp(\'Charges\')\"></i> <i class=\"fa {{ sortClass(\'Charges\') }} fs-20 w-15\" ng-click=\"sortList(\'Charges\')\">\n</i></div><div layout=\"col\" flex class=\"custom-header hidden-xs\" align=\"right\" ng-click=\"sortList(\'Payment\')\"><span \nflex>Payment</span> <i class=\"fa {{ sortClass(\'Payment\') }} fs-20 w-15\"></i></div><div layout=\"col\" flex \nclass=\"custom-header hidden-xs\" align=\"right\" ng-click=\"sortList(\'Adjustment\')\"><span flex>Adjustment</span> <i \nclass=\"fa {{ sortClass(\'Adjustment\') }} fs-20 w-15\"></i></div><div layout=\"col\" flex class=\"custom-header hidden-xs\" \nalign=\"right\" ng-click=\"sortList(\'Reconciliation\')\"><span flex>Reconciliation</span> <i \nclass=\"fa {{ sortClass(\'Reconciliation\') }} fs-20 w-15\"></i></div><div layout=\"col\" flex class=\"custom-header\" \nalign=\"right\" ng-click=\"sortList(\'Balance\')\"><span flex>Prepaid Balance</span> <i \nclass=\"fa {{ sortClass(\'Balance\') }} fs-20 w-15\"></i></div><div layout=\"col\" flex class=\"custom-header hidden-gt-xs\" \nalign=\"right\"><span flex>View Details</span></div></div><div \nng-repeat=\"p in item.Transactions | orderBy: sort.Column : sort.Reverse\"><div layout=\"row\" class=\"custom-row\" \nng-class=\"{\'expanded\' : !p.isCollapsed}\"><div layout=\"col\" flex class=\"custom-content\" layout-align=\"center\"><span \nclass=\"mr-15\">{{ p.MemberSep }}</span></div><div layout=\"col\" flex class=\"custom-content hidden-xs\" layout-align=\"end\">\n<span class=\"\">{{ p.Charges | number:2 }}</span></div><div layout=\"col\" flex class=\"custom-content hidden-xs\" \nlayout-align=\"end\"><span class=\"\">{{ p.Payment | number:2 }}</span></div><div layout=\"col\" flex \nclass=\"custom-content hidden-xs\" layout-align=\"end\"><span class=\"\">{{ p.Adjustment | number:2 }}</span></div><div \nlayout=\"col\" flex class=\"custom-content hidden-xs\" layout-align=\"end\"><span class=\"\">{{ p.Reconciliation | number:2 }}\n</span></div><div layout=\"col\" flex class=\"custom-content\" layout-align=\"end\"><span class=\"\">{{ p.Balance | number:2 }}\n</span></div><div layout=\"col\" flex class=\"custom-content hidden-gt-xs\" layout-align=\"end\"><span class=\"hidden-gt-xs\">\n<i class=\"fa fs-20\" ng-class=\"{\'fa-chevron-down\': p.isCollapsed, \'fa-chevron-left\': !p.isCollapsed }\" \nng-click=\"toggleDetails(p)\"></i></span></div></div><div ng-hide=\"p.isCollapsed\" \nclass=\"hidden-gt-xs custom-collapsible\"><div layout=\"row\"><div layout=\"col\" flex><span flex>Charges<md-icon \nclass=\"help-button\" ng-click=\"showHelp(\'Charges\')\" md-font-icon=\"icon-information-outline\"></md-icon></span><span \nclass=\"mr-10\">{{ p.Charges | number:2 }}</span></div><div layout=\"col\" flex><span flex>Payment</span> <span \nclass=\"mr-10\">{{ p.Payment | number:2 }}</span></div></div><div layout=\"row\"><div layout=\"col\" flex><span flex>\nAdjustment</span> <span class=\"mr-10\">{{ p.Adjustment | number:2 }}</span></div><div layout=\"col\" flex><span flex>\nReconciliation</span> <span class=\"mr-10\">{{ p.Reconciliation | number: 2}}</span></div></div></div></div></div><style>\n@media screen and (min-width:800px) {\r\n      .modal-set-max-width {\r\n        /*max-width: 785px !important;*/\r\n      }\r\n    }\n</style></md-dialog>");
$templateCache.put("app/main/msportal/views/ppm_history/ppm_history.html","<div style=\"height:95% !important;min-height:600px !important\"><div ng-cloak layout-gt-sm=\"row\" layout=\"column\"><div \nflex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\">\n<md-icon md-font-icon=\"icon-folder-outline\"></md-icon></md-button><h2><span>\nPrepaid Account History -- Account Number {{::MemberNo}}</span></h2></div></md-toolbar><md-content><md-list flex>\n<md-list-item class=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nalign=\"left\"><div flex><md-input-container class=\"md-block\" flex-gt-sm><label>Start Date</label><md-datepicker \nmd-open-on-focus ng-model=\"startDate\" md-current-view=\"year\" md-date-locale=\"dateLocale\" md-mode=\"month\" \nmd-max-date=\"getMaxDate\" onkeydown=\"return false\"></md-datepicker></md-input-container></div><div flex>\n<md-input-container class=\"md-block\" flex-gt-sm><label>End Date</label><md-datepicker md-open-on-focus \nng-model=\"endDate\" md-current-view=\"year\" md-date-locale=\"dateLocale\" md-mode=\"month\" md-max-date=\"getMaxDate\" \nonkeydown=\"return false\"></md-datepicker></md-input-container></div><div flex><md-button class=\"md-raised md-primary\" \nng-click=\"filter()\">Filter</md-button><md-button class=\"md-raised md-primary\" ng-click=\"ReloadPPMRecords()\">\nClear Filter</md-button></div></div></div><md-divider></md-divider></md-list-item></md-list></md-content></div></div>\n<div ng-if=\"PPMAccount.PaymentNotice !== \'\'\"><h3 class=\"align-right red-text\" style=\"margin: 0px 20px\">\n{{ PPMAccount.PaymentNotice }} {{ PPMAccount.PaymentNeeded | currency }}</h3></div><hr><div layout=\"row\"><div \nlayout=\"col\" flex class=\"custom-header\" align=\"center\" ng-click=\"sortList(\'SystemDate\')\"><span flex>Date </span><i \nclass=\"fa {{ sortClass(\'SystemDate\') }} fs-20 w-15\"></i></div><div layout=\"col\" flex class=\"custom-header hidden-xs\" \nalign=\"right\"><span flex ng-click=\"sortList(\'Charges\')\">Charges</span> <i class=\"fa fa-info-circle fs-20\" \nng-click=\"showHelp(\'Charges\')\"></i> <i class=\"fa {{ sortClass(\'Charges\') }} fs-20 w-15\" ng-click=\"sortList(\'Charges\')\">\n</i></div><div layout=\"col\" flex class=\"custom-header hidden-xs\" align=\"right\" ng-click=\"sortList(\'Payment\')\"><span \nflex>Payment</span> <i class=\"fa {{ sortClass(\'Payment\') }} fs-20 w-15\"></i></div><div layout=\"col\" flex \nclass=\"custom-header hidden-xs\" align=\"right\" ng-click=\"sortList(\'Adjustment\')\"><span flex>Adjustment</span> <i \nclass=\"fa {{ sortClass(\'Adjustment\') }} fs-20 w-15\"></i></div><div layout=\"col\" flex class=\"custom-header hidden-xs\" \nalign=\"right\" ng-click=\"sortList(\'Reconciliation\')\"><span flex>Reconciliation</span> <i \nclass=\"fa {{ sortClass(\'Reconciliation\') }} fs-20 w-15\"></i></div><div layout=\"col\" flex class=\"custom-header\" \nalign=\"right\" ng-click=\"sortList(\'Balance\')\"><span flex>Prepaid Balance</span> <i \nclass=\"fa {{ sortClass(\'Balance\') }} fs-20 w-15\"></i></div><div layout=\"col\" flex class=\"custom-header\" align=\"right\">\n<span flex>View History Breakdown</span></div></div><div \nng-repeat=\"p in filteredPPMAcctHistory | orderBy: sort.Column : sort.Reverse\"><div layout=\"row\" class=\"custom-row\" \nng-class=\"{\'expanded\' : !p.isCollapsed}\"><div layout=\"col\" flex class=\"custom-content\" layout-align=\"center\"><span \nclass=\"mr-15\">{{ p.SystemDate | date : \"MM/dd/yy\" }}</span></div><div layout=\"col\" flex \nclass=\"custom-content hidden-xs\" layout-align=\"end\"><span class=\"\">{{ p.Charges | number:2 }}</span></div><div \nlayout=\"col\" flex class=\"custom-content hidden-xs\" layout-align=\"end\"><span class=\"\">{{ p.Payment | number:2 }}</span>\n</div><div layout=\"col\" flex class=\"custom-content hidden-xs\" layout-align=\"end\"><span class=\"\">\n{{ p.Adjustment | number:2 }}</span></div><div layout=\"col\" flex class=\"custom-content hidden-xs\" layout-align=\"end\">\n<span class=\"\">{{ p.Reconciliation | number:2 }}</span></div><div layout=\"col\" flex class=\"custom-content\" \nlayout-align=\"end\"><span class=\"\">{{ p.Balance | number:2 }}</span></div><div layout=\"col\" flex class=\"custom-content\" \nlayout-align=\"end\"><span class=\"hidden-xs\"><md-icon class=\"help-button clickable\" \nmd-font-icon=\"icon-arrow-right-bold-circle\" ng-click=\"showDetails(p)\"></md-icon></span><span class=\"hidden-gt-xs\"><i \nclass=\"fa fs-20 w-15\" ng-class=\"{\'fa-chevron-down\': p.isCollapsed, \'fa-chevron-left\': !p.isCollapsed }\" \nng-click=\"toggleDetails(p)\"></i></span></div></div><div ng-hide=\"p.isCollapsed\" \nclass=\"hidden-gt-xs custom-collapsible\"><div layout=\"row\"><div layout=\"col\" flex><span flex>Charges<md-icon \nclass=\"help-button\" ng-click=\"showHelp(\'Charges\')\" md-font-icon=\"icon-information-outline\"></md-icon></span><span \nclass=\"mr-10\">{{ p.Charges | number:2 }}</span></div><div layout=\"col\" flex><span flex>Payment</span> <span \nclass=\"mr-10\">{{ p.Payment | number:2 }}</span></div><span layout=\"col\" flex=\"10\"><md-icon \nclass=\"help-button clickable\" md-font-icon=\"icon-arrow-right-bold-circle\" ng-click=\"showDetails(p)\"></md-icon></span>\n</div><div layout=\"row\"><div layout=\"col\" flex><span flex>Adjustment</span> <span class=\"mr-10\">\n{{ p.Adjustment | number:2 }}</span></div><div layout=\"col\" flex><span flex>Reconciliation</span> <span class=\"mr-10\">\n{{ p.Reconciliation | number: 2}}</span></div><span layout=\"col\" flex=\"10\"></span></div></div></div></div>");
$templateCache.put("app/main/msportal/views/profile/profile.html","<link href=\"//netdna.bootstrapcdn.com/font-awesome/4.0.3/css/font-awesome.min.css\" rel=\"stylesheet\"><style>\nmd-input-container.md-default-theme:not(.md-input-invalid).md-input-has-value label, md-input-container:not(.md-input-invalid).md-input-has-value label, md-input-container.md-default-theme label, md-input-container label {\r\n    color: black;\r\n  }\n</style><div ng-if=\"!vm.Model\"><p>Unable to load profile details.</p></div><div id=\"accountProfileForm\" \nng-form=\"accountProfileForm\" aa-configured-form validation-config=\"vm.Validators\" \nprevent-leaving-unsaved=\"{{\'You have unsaved changes in your profile. Are sure you want to navigate away without saving them?\'}}\" \non-navigate-away-strategy=\"profileNavigateAwayStrategy\" tab-index=\"1\"><div style=\"z-index:15000; width:100%\" \nng-init=\"vm.initForm(accountProfileForm)\"></div><div id=\"notifyArea\" ng-if=\"!errorClose && !POBoxExist\"><div \nng-if=\"accountProfileForm.$invalid && accountProfileForm.$editMode && (vm.errorList() || saveCounter>0)\"><div \nclass=\"pull-right aa-notify-close\"><span class=\"fa-stack fa-lg\" ng-click=\"vm.closeNotify()\"><i \nclass=\"fa fa-circle fa-stack-2x\"></i><i class=\"fa fa-times fa-stack-1x fa-inverse\"></i></span></div><div><strong>\nThere are some validation errors:</strong></div></div><ul id=\"errorLi\"><li \nng-if=\"!accountProfileForm.homePhone.$valid && (accountProfileForm.homePhone.$touched || saveCounter>0)\">\nInvalid phone number.&nbsp;<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" ng-click=\"vm.setFocus(\'homePhone\')\">\n<i class=\"fa fa-search\"></i></a></li><li \nng-if=\"!accountProfileForm.businessPhone.$valid && (accountProfileForm.businessPhone.$touched || saveCounter>0)\">\nInvalid phone number.&nbsp;<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" \nng-click=\"vm.setFocus(\'businessPhone\')\"><i class=\"fa fa-search\"></i></a></li><li \nng-if=\"!accountProfileForm.OtherPhoneNumber.$valid && (accountProfileForm.OtherPhoneNumber.$touched || saveCounter>0)\">\nInvalid phone number.&nbsp;<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" \nng-click=\"vm.setFocus(\'OtherPhoneNumber\')\"><i class=\"fa fa-search\"></i></a></li><li \nng-if=\"!accountProfileForm.cellPhoneNumber.$valid && (accountProfileForm.cellPhoneNumber.$touched || saveCounter>0)\">\nInvalid phone number.&nbsp;<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" \nng-click=\"vm.setFocus(\'cellPhoneNumber\')\"><i class=\"fa fa-search\"></i></a></li><li \nng-if=\"!accountProfileForm.pagerNumber.$valid && (accountProfileForm.pagerNumber.$touched || saveCounter>0)\">\nInvalid phone number.&nbsp;<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" \nng-click=\"vm.setFocus(\'pagerNumber\')\"><i class=\"fa fa-search\"></i></a></li><li \nng-if=\"!accountProfileForm.faxNumber.$valid && (accountProfileForm.faxNumber.$touched || saveCounter>0)\">\nInvalid phone number.&nbsp;<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" ng-click=\"vm.setFocus(\'faxNumber\')\">\n<i class=\"fa fa-search\"></i></a></li><li \nng-if=\"!vm.Model.streetnbr && (accountProfileForm.streetnbr.$touched || saveCounter>0)\">\nStreet Number is required.&nbsp;<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" \nng-click=\"vm.setFocus(\'streetNumber\')\"><i class=\"fa fa-search\"></i></a></li><li \nng-if=\"!vm.Model.street && (accountProfileForm.street.$touched || saveCounter>0)\">Street / P.O. Box is required.&nbsp;\n<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" ng-click=\"vm.setFocus(\'streetField\')\"><i class=\"fa fa-search\">\n</i></a></li><li ng-if=\"!vm.Model.city && (accountProfileForm.city.$touched || saveCounter>0)\">City is required.&nbsp;\n<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" ng-click=\"vm.setFocus(\'cityField\')\"><i class=\"fa fa-search\">\n</i></a></li><li ng-if=\"!vm.Model.state && (accountProfileForm.state.$touched || saveCounter>0)\">\nState is required.&nbsp;<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" ng-click=\"vm.setFocus(\'stateField\')\"><i\n class=\"fa fa-search\"></i></a></li><li \nng-if=\"!accountProfileForm.zip.$valid && vm.Model.zip && (accountProfileForm.zip.$touched || saveCounter>0)\">\nThe Postal Code is not in a correct format.&nbsp;<a href=\"\" title=\"Focus Field\" class=\"md-default-theme\" \nng-click=\"vm.setFocus(\'zipCode\')\"><i class=\"fa fa-search\"></i></a></li><li \nng-if=\"!vm.Model.zip && (accountProfileForm.zip.$touched || saveCounter>0)\">Zip is required.&nbsp;<a href=\"\" \ntitle=\"Focus Field\" class=\"md-default-theme\" ng-click=\"vm.setFocus(\'zipCode\')\"><i class=\"fa fa-search\"></i></a></li>\n</ul></div><md-button ng-show=\"!accountProfileForm.$editMode\" class=\"md-raised md-primary\" \nng-click=\"vm.editForm(accountProfileForm)\" ng-disabled=\"vm.Form.isLoading\">Edit</md-button><md-button \nng-show=\"accountProfileForm.$editMode\" class=\"md-raised md-primary\" ng-click=\"vm.checkSave()\" \naa-submit-form=\"vm.saveChanges(accountProfileForm);\">Save</md-button><md-button ng-show=\"accountProfileForm.$editMode\" \nclass=\"md-raised md-primary\" ng-click=\"vm.cancelForm(accountProfileForm);\">Cancel</md-button><div layout-gt-sm=\"row\">\n<div flex layout-padding><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\">\n<md-icon md-font-icon=\"icon-account-box-outline\"></md-icon></md-button><h2><span>\nAccount Profile -- Account Number {{vm.MemberNo}}</span></h2></div></md-toolbar><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-xs><input aa-field-group=\"vm.Model.accountName\" ng-disabled=\"true\" \naria-label=\"Account Name\"></md-input-container></div><div layout-gt-xs=\"row\"></div><md-toolbar><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon \nmd-font-icon=\"icon-microphone-outline\"></md-icon></md-button><h2><span>Contact Information</span></h2></div>\n</md-toolbar><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><input \naa-field-group=\"vm.Model.EMailAddress\" ng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"40\" \nng-blur=\"vm.checkNotify()\" aria-label=\"Primary Email Adress\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><input aa-field-group=\"vm.Model.EMailAddress2\" ng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"28\" \nng-blur=\"vm.checkNotify()\" aria-label=\"Secondary Email Address\"></md-input-container></div><div><label \nclass=\"phonelabel\">Phone numbers must include 10 digits; first digit cannot be 0 or 1.</label></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.homePhone\" \nng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"13\" validate=\"false\" ng-blur=\"vm.checkNotify()\" \nng-change=\"vm.reformatPhone(vm.Model.homePhone, \'homePhone\')\" ng-keydown=\"vm.getKeyCode($event)\" id=\"homePhone\" \nng-model-options=\"{allowInvalid: true}\" aria-label=\"Telephone Number\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.businessPhone\" ng-disabled=\"!accountProfileForm.$editMode\" \nmaxlength=\"13\" validate=\"false\" ng-blur=\"vm.checkNotify()\" \nng-change=\"vm.reformatPhone(vm.Model.homePhone, \'businessPhone\')\" ng-keydown=\"vm.getKeyCode($event)\" \nid=\"businessPhone\" ng-model-options=\"{allowInvalid: true}\" aria-label=\"Business Phone Number\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.OtherPhoneNumber\" \nng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"13\" validate=\"false\" ng-blur=\"vm.checkNotify()\" \nng-change=\"vm.reformatPhone(vm.Model.homePhone, \'OtherPhoneNumber\')\" ng-keydown=\"vm.getKeyCode($event)\" \nid=\"OtherPhoneNumber\" ng-model-options=\"{allowInvalid: true}\" aria-label=\"Other Phone Number\"></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><input \naa-field-group=\"vm.Model.cellPhoneNumber\" ng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"13\" validate=\"false\" \nng-blur=\"vm.checkNotify()\" ng-change=\"vm.reformatPhone(vm.Model.homePhone, \'cellPhoneNumber\')\" \nng-keydown=\"vm.getKeyCode($event)\" id=\"cellPhoneNumber\" ng-model-options=\"{allowInvalid: true}\" \naria-label=\"Cellphone Number\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><input \naa-field-group=\"vm.Model.pagerNumber\" ng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"13\" validate=\"false\" \nng-blur=\"vm.checkNotify()\" ng-change=\"vm.reformatPhone(vm.Model.homePhone, \'pagerNumber\')\" \nng-keydown=\"vm.getKeyCode($event)\" id=\"pagerNumber\" ng-model-options=\"{allowInvalid: true}\" aria-label=\"Pager Number\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.faxNumber\" \nng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"13\" validate=\"false\" ng-blur=\"vm.checkNotify()\" \nng-change=\"vm.reformatPhone(vm.Model.homePhone, \'faxNumber\')\" ng-keydown=\"vm.getKeyCode($event)\" id=\"faxNumber\" \nng-model-options=\"{allowInvalid: true}\" aria-label=\"Fax Number\"></md-input-container></div><md-toolbar><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon \nmd-font-icon=\"icon-account-box-outline\"></md-icon></md-button><h2><span>Spouse Information</span></h2></div>\n</md-toolbar><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><input \naa-field-group=\"vm.Model.spelastname\" ng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"28\" \nng-blur=\"vm.checkNotify()\" aria-label=\"Spouse Last Name\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><input aa-field-group=\"vm.Model.spefirstname\" ng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"28\" \nng-blur=\"vm.checkNotify()\" aria-label=\"Spouse First Name\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.spemidname\" \nng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"28\" ng-blur=\"vm.checkNotify()\" aria-label=\"Spouse Middle Name\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.spenamesuf\" \nng-disabled=\"!accountProfileForm.$editMode\" ng-blur=\"vm.checkNotify()\" aria-label=\"Spouse Suffix Name\">\n</md-input-container></div></div><div flex layout-padding><md-toolbar><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-compass-outline\"></md-icon></md-button><h2><span>\nBilling Address</span></h2></div></md-toolbar><div layout-gt-sm=\"row\"><md-input-container ng-if=\"POBoxExist\" \nclass=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.streetnbr\" ng-disabled=\"!accountProfileForm.$editMode\" \nid=\"streetNumber\" maxlength=\"15\" ng-blur=\"vm.checkNotify()\" ng-model-options=\"{allowInvalid: true}\" \naria-label=\"Street Number\"></md-input-container><md-input-container ng-if=\"!POBoxExist\" class=\"md-block\" flex-gt-sm>\n<input aa-field-group=\"vm.Model.streetnbr\" ng-disabled=\"!accountProfileForm.$editMode\" id=\"streetNumber\" required \nmaxlength=\"15\" ng-blur=\"vm.checkNotify()\" ng-model-options=\"{allowInvalid: true}\" aria-label=\"Street Number\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.dirpref\" \nid=\"dirpref\" ng-disabled=\"!accountProfileForm.$editMode\" \nng-click=\"vm.checkNotify(); vm.getAbbrev(vm.Model.dirpref, \'dirpref\')\" aria-label=\"Direction Prefix\">\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><input \naa-field-group=\"vm.Model.street\" ng-keyup=\"vm.checkStrNo(vm.Model.street)\" ng-disabled=\"!accountProfileForm.$editMode\" \nid=\"streetField\" required maxlength=\"28\" ng-blur=\"vm.checkNotify()\" ng-model-options=\"{allowInvalid: true}\" \naria-label=\"Street / P.O. Box\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><input aa-field-group=\"vm.Model.streetsuf\" ng-disabled=\"!accountProfileForm.$editMode\" maxlength=\"6\" \nng-blur=\"vm.checkNotify()\" aria-label=\"Street Suffix\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><input aa-field-group=\"vm.Model.dirsuf\" id=\"dirsuf\" ng-disabled=\"!accountProfileForm.$editMode\" \nng-click=\"vm.checkNotify(); vm.getAbbrev(vm.Model.dirsuf, \'dirsuf\')\" aria-label=\"Direction Suffix\">\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><input \naa-field-group=\"vm.Model.address2\" ng-disabled=\"!accountProfileForm.$editMode\" id=\"address2\" \nng-blur=\"vm.checkNotify()\" ng-model-options=\"{allowInvalid: true}\" aria-label=\"Address 2\"></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.city\" \nng-disabled=\"!accountProfileForm.$editMode\" id=\"cityField\" required maxlength=\"28\" ng-blur=\"vm.checkNotify()\" \nng-model-options=\"{allowInvalid: true}\" aria-label=\"City\"></md-input-container><md-input-container id=\"stateField\" \ntabindex=\"-1\" class=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.state\" id=\"state\" \nng-disabled=\"!accountProfileForm.$editMode\" ng-click=\"vm.checkState(); vm.getAbbrev(vm.Model.state, \'state\')\" required \nmaxlength=\"2\" aria-label=\"State\"><div \nng-if=\"!vm.Model.state && accountProfileForm.$editMode && stateCounter > 0 || (!vm.Model.state && saveCounter > 0)\">\n<span class=\"validation-error\">State is required.</span></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.zip\" \nng-disabled=\"!accountProfileForm.$editMode\" validate=\"false\" required maxlength=\"10\" ng-blur=\"vm.checkNotify()\" \nng-change=\"vm.reformatZipCode(vm.Model.homePhone, \'zipCode\')\" ng-keydown=\"vm.getKeyCode($event)\" id=\"zipCode\" \nng-model-options=\"{allowInvalid: true}\" aria-label=\"Zip Code\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><input aa-field-group=\"vm.Model.inCareOf\" ng-disabled=\"!accountProfileForm.$editMode\" \nng-blur=\"vm.checkNotify()\" maxlength=\"28\" aria-label=\"In care of\"></md-input-container></div></div></div><div \nlayout-gt-sm=\"row\"><div flex layout-padding></div></div></div>");
$templateCache.put("app/main/msportal/views/usage/usage.html","<div style=\"height:95% !important;min-height:600px !important\"><div layout-gt-sm=\"row\" layout=\"column\"><div \nflex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\">\n<md-icon md-font-icon=\"icon-folder-outline\"></md-icon></md-button><h2><span>\nBilling History -- Account Number {{MemberNo}}</span></h2></div></md-toolbar><md-content><md-list flex><md-list-item \nclass=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><div layout=\"row\" layout-xs=\"column\" align=\"left\"><div\n flex><md-input-container class=\"md-block\" flex-gt-sm><label>Start Date</label><md-datepicker md-open-on-focus \nng-model=\"StartDate\" md-current-view=\"year\" md-date-locale=\"dateLocale\" md-mode=\"month\" md-max-date=\"getMaxDate\" \nonkeydown=\"return false\"></md-datepicker></md-input-container></div><div flex><md-input-container class=\"md-block\" \nflex-gt-sm><label>End Date</label><md-datepicker md-open-on-focus ng-model=\"EndDate\" md-current-view=\"year\" \nmd-date-locale=\"dateLocale\" md-mode=\"month\" md-max-date=\"getMaxDate\" onkeydown=\"return false\"></md-datepicker>\n</md-input-container></div><div flex><md-button class=\"md-raised md-primary\" \nng-click=\"LoadRecordsByDateRangeBills(StartDate,EndDate)\">Filter</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"ReloadRecords()\">Clear Filter</md-button></div></div></div><md-divider></md-divider></md-list-item></md-list>\n</md-content></div></div><div class=\"content fullpage-datatable\" layout=\"column\" layout-gt-sm=\"row\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\" \nng-hide=\"IsPPM\"><div class=\"table-header\" ng-if=\"!IsPPM\"><span class=\"column-title\">View PDF</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Bill Date</span></div></th><th \nclass=\"secondary-text\" ng-hide=\"IsPPM\"><div class=\"table-header\" ng-if=\"!IsPPM\"><span class=\"column-title\">Due Date\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><div class=\"column-title numeric\" \nstyle=\"width: {{balanceWidth}}px\">Balance</div></div></th></tr></thead><tbody><tr ng-repeat=\"b in BillHistory\"><td \nng-hide=\"IsPPM\"><div ng-if=\"!IsPPM\"><md-button style=\"right:10px\" class=\"edit-button md-icon-button\" \nng-click=\"ViewPDF(b.BillDate,\'\')\"><md-icon title=\"Billing Statement\" md-font-icon=\"icon-file-pdf\" class=\"s16\">\n</md-icon></md-button><md-button style=\"right:15px\" class=\"edit-button md-icon-button\" \nng-if=\"EDelinquentEnabled == \'1\'\" ng-show=\"b.HasDelinquent\" ng-click=\"ViewPDF(b.BillDate,\'D\')\"><md-icon \ntitle=\"Delinquent Notice\" md-font-icon=\"icon-file-pdf\" class=\"s16 md-warn\"></md-icon></md-button></div></td><td>\n{{b.BillDate}}</td><td ng-hide=\"IsPPM\"><span ng-if=\"!IsPPM\">{{b.DueDate}}</span></td><td><div class=\"numeric\" \nstyle=\"width: {{balanceWidth}}px\">{{ b.Balance | currency }}</div></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/msportal/views/service_details/service_details.html","<style>h4 span:first-child {\r\n    font-weight: 500;\r\n  }</style><div ng-controller=\"ServiceDetailsController as vm\" \nstyle=\"height:95% !important;min-height:600px !important\"><div ng-init=\"vm.LoadRecordsServ()\"></div><div ng-cloak \nlayout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon></md-button><h2><span>\nService Details -- Account Number {{vm.MemberNo}}</span></h2></div></md-toolbar><md-content><md-list flex><md-list-item\n class=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><div layout=\"row\" layout-xs=\"column\" align=\"left\">\n<div flex><h4><span>Account No.:</span> {{vm.MemberNo}}</h4></div><div flex><h4><span>Account Status:</span>\n {{vm.Service.Status}}</h4></div><div flex><h4><span>Svc Address:</span> {{vm.Service.ServiceAddress}}</h4></div></div>\n<div layout=\"row\" layout-xs=\"column\" align=\"left\"><div flex=\"33\"><h4><span>Account Name:</span>\n {{vm.Service.AccountName}}</h4></div><div flex=\"33\" ng-if=\"!vm.IsPPM\"><h4><span>Pay by:</span> {{vm.Service.DueDate}}\n</h4></div><div flex=\"33\" ng-if=\"vm.IsPPM && vm.Service.Balance > 0\"><h4><span>Account Balance:</span>\n -${{vm.Service.Balance | number:2}}</h4></div><div flex=\"33\" ng-if=\"vm.IsPPM && vm.Service.Balance <= 0\"><h4><span>\nAccount Balance:</span> ${{vm.Service.Balance * -1 | number:2}}</h4></div><div flex=\"33\" \nng-if=\"vm.IsPPM && vm.Service.ppmMinPayment > 0\"><h4 style=\"color:red\"><span>{{vm.ppmLabel}} </span>\n{{vm.Service.ppmMinPayment | currency}}</h4></div><div flex=\"33\" ng-if=\"!vm.IsPPM\"><p></p><h4><span>Amount Due:</span> \n<span class=\"item-note\">{{ vm.Service.Balance | currency }}</span></h4><p></p></div></div><div layout=\"row\" \nlayout-xs=\"column\" align=\"left\" ng-show=\"param98\"><div flex><h4><md-icon ng-if=\"!vm.roundupBill\" \nclass=\"help-button roundup-cursor-pointertype\" ng-click=\"vm.roundupBillingProcess()\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><md-icon ng-if=\"vm.roundupBill\" \nclass=\"help-button roundup-cursor-pointertype\" ng-click=\"vm.roundupBillingProcess()\" \nmd-font-icon=\"icon-close-circle-outline\"></md-icon><span ng-click=\"vm.roundupBillingProcess()\" class=\"roundup-color\">\n{{ vm.roundupBillContent }}</span><md-icon class=\"help-button roundup-color roundup-cursor-pointertype\" \nng-click=\"vm.displayMessage(\'Round Up Billing Information\', roundupInformation, \'CLOSE\')\" \nmd-font-icon=\"icon-information\"></md-icon></h4></div></div></div><md-divider></md-divider></md-list-item></md-list>\n</md-content></div></div><div ng-cloak layout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex><md-toolbar><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon md-font-icon=\"icon-cube-outline\">\n</md-icon></md-button><h2><span>Services</span></h2></div></md-toolbar><div \nclass=\"content-card content fullpage-datatable\" layout=\"column\" layout-gt-sm=\"row\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Service ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.PastDueOn && !vm.IsPPM  && !vm.BudgetLevelized\"><div class=\"table-header\"><div class=\"column-title numeric\" \nstyle=\"width: {{ pastDueWidth }}px\">Past Due</div></div></th><th class=\"secondary-text\" ng-if=\"!vm.IsPPM\"><div \nclass=\"table-header\"><div class=\"column-title numeric\" style=\"width: {{ balanceWidth }}px\" ng-if=\"!vm.IsPPM\">Balance\n</div></div></th></tr></thead><tbody><tr ng-repeat=\"s in vm.Service.Services\"><td><span class=\"md-subhead\">\n{{s.MemberSep.replace(s.MemberNo, s.MemberNo + \"-\")}}</span></td><td><span class=\"md-subhead\"><md-icon \nmd-font-icon=\"icon-water\" ng-if=\"(s.Description | uppercase) === \'WATER\'\" alt=\"Water\"></md-icon><md-icon \nmd-font-icon=\"icon-flash\" ng-if=\"(s.Description | uppercase) === \'ELECTRIC\'\" alt=\"Electric\"></md-icon><md-icon \nmd-font-icon=\"icon-water-pump\" ng-if=\"(s.Description | uppercase) === \'SEWER\'\" alt=\"Sewer\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.Description | uppercase) === \'REFUSE\'\" alt=\"Refuse\"></md-icon><md-icon \nmd-font-icon=\"icon-fire\" ng-if=\"(s.Description | uppercase) === \'GAS\'\" alt=\"Gas\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.Description | uppercase) === \'SANITATION\'\" alt=\"Sanitation\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(s.Description | uppercase) === \'GARBAGE\'\" alt=\"Garbage\"></md-icon><md-icon \nmd-font-icon=\"icon-speedometer\" ng-if=\"(s.Description | uppercase) === \'OTH METERED\'\" alt=\"Oth Metered\"></md-icon>\n<md-icon md-font-icon=\"icon-bookmark-remove\" ng-if=\"(s.Description | uppercase) === \'NON METERED\'\" alt=\"Non Metered\">\n</md-icon>{{s.Description}}</span></td><td><span class=\"md-subhead\"><md-icon md-font-icon=\"icon-brightness-1 s16\" \nclass=\"status-{{s.Status[0]}}\"></md-icon>{{s.Status}}</span></td><td \nng-if=\"vm.PastDueOn && !vm.IsPPM && !vm.BudgetLevelized\"><div class=\"numeric\" style=\"width: {{ pastDueWidth }}px\">\n{{ s.PastDue | currency }}</div></td><td ng-if=\"!vm.IsPPM\"><div ng-if=\"!vm.IsPPM\" class=\"numeric\" \nstyle=\"width: {{ balanceWidth }}px\">{{ s.Balance | currency }}</div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/msportal/views/services/services.html","<div ng-init=\"vm.GetSettings()\"><div id=\"msportal-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div \nclass=\"content\"><md-tabs md-dynamic-height md-selected=\"vm.tabIndex\"><md-tab ng-if=\"vm.PaymentHistStat == 1\">\n<md-tab-label><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Payment History</span></md-tab-label>\n<md-tab-body><md-content><div ng-include=\"\'app/main/msportal/views/payment_history/payment_history.html\'\"></div>\n</md-content></md-tab-body></md-tab><md-tab ui-sref=\"app.msportal.accounts.detail.payment\"><md-tab-label><md-icon \nmd-font-icon=\"icon-credit-card\"></md-icon><span>Payment</span></md-tab-label><md-tab-body><md-content><div \nui-view=\"payment\"></div></md-content></md-tab-body></md-tab><md-tab ng-if=\"vm.EbillEnabled == 1\"><md-tab-label><md-icon\n md-font-icon=\"icon-email\"></md-icon><span>E-Bill</span></md-tab-label><md-tab-body><md-content><div \nng-include=\"\'app/main/msportal/views/bill_preference/bill_preference.html\'\"></div></md-content></md-tab-body></md-tab>\n<md-tab ng-if=\"vm.EDelinquentEnabled == 1\"><md-tab-label><md-icon md-font-icon=\"icon-email\"></md-icon><span>\nE-Delinquent</span></md-tab-label><md-tab-body><md-content><div \nng-include=\"\'app/main/msportal/views/delinquent/delinquent.html\'\"></div></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.CCDraftsEnabled == 1 || vm.BankDraftsEnabled == 1\" ui-sref=\"app.msportal.accounts.detail.draft\">\n<md-tab-label><md-icon md-font-icon=\"icon-file-multiple\"></md-icon><span>Payment Drafts</span></md-tab-label>\n<md-tab-body><md-content><div ui-view=\"draft\"></div></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.BudgetBillEnabled == 1 || vm.LevelizedBillEnabled == 1\" \nui-sref=\"app.msportal.accounts.detail.budgetlevelized\"><md-tab-label><md-icon md-font-icon=\"icon-chart-bar\"></md-icon>\n<span>Budget/Levelized Billing</span></md-tab-label><md-tab-body><md-content><div ui-view=\"budgetLevelized\"></div>\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"vm.UsageGraphStat == 1\"><md-tab-label><md-icon \nmd-font-icon=\"icon-chart-areaspline\"></md-icon><span>Usage Charts</span></md-tab-label><md-tab-body><md-content><div \nng-include=\"\'app/main/msportal/views/usage_charts/usagecharts.html\'\"></div></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.AlertsEnabled == 1 && (hasAlert || accountStatus != \'Inactive\')\"><md-tab-label><md-icon \nmd-font-icon=\"icon-bell\"></md-icon><span>Alerts & Reminders</span></md-tab-label><md-tab-body><md-content><div \nng-include=\"\'app/main/msportal/views/alerts/alerts.html\'\"></div></md-content></md-tab-body></md-tab></md-tabs></div>\n</div></div>");
$templateCache.put("app/main/msportal/views/usage_charts/navbar.html","<md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Icon\"><md-icon \nmd-font-icon=\"icon-chart-line\"></md-icon></md-button><h2><span>Usage Summary</span></h2></div></md-toolbar><md-divider>\n</md-divider><md-nav-bar md-selected-nav-item=\"vm.selectedItem\"><md-nav-item md-nav-click=\"vm.switchItem(item)\" \nname=\"{{ item }}\" ng-repeat=\"item in vm.menuItems\">{{ item }}</md-nav-item></md-nav-bar>");
$templateCache.put("app/main/msportal/views/usage_charts/usagecharts.html","<div ng-controller=\"UsagechartsController as vm\" ng-form name=\"usagecharts\" id=\"msportal-charts\" class=\"\" layout=\"row\">\n<div class=\"center\" layout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex><div \nng-include=\"\'app/main/msportal/views/usage_charts/navbar.html\'\"></div><div ng-switch on=\"vm.selectedItem\"><div \nng-switch-when=\"Daily\"><div ng-include=\"\'app/main/msportal/views/usage_charts/daily/usageDaily.html\'\"></div></div><div \nng-switch-when=\"Monthly\"><div ng-include=\"\'app/main/msportal/views/usage_charts/monthly/usagemonthly.html\'\"></div>\n</div><div ng-switch-when=\"Interval\"><div \nng-include=\"\'app/main/msportal/views/usage_charts/interval/usageinterval.html\'\"></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/main/msportal/views/usage_charts/daily/usageDaily.html","<div ng-controller=\"UsagechartdailyController as vm\" ng-init=\"vm.getServiceDetails()\"><div ng-cloak layout-gt-sm=\"row\" \nlayout=\"column\"><div flex-gt-sm=\"100\" flex><md-progress-linear class=\"md-warn\" md-mode=\"query\" \nng-show=\"vm.flipped && vm.progress.activated\"></md-progress-linear><md-content><md-list flex><md-list-item \nclass=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><div layout=\"row\" layout-xs=\"column\" align=\"left\">\n<div><md-input-container class=\"md-block\" flex-gt-sm><label>Start Date</label><md-datepicker \nng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\" md-date-locale=\"vm.dateLocale\" md-min-date=\"minDate\" \nmd-max-date=\"vm.maxDate\" onkeydown=\"return false\"></md-datepicker></md-input-container></div><div><md-input-container \nclass=\"md-block\" flex-gt-sm><label>End Date</label><md-datepicker ng-model=\"vm.calendarEvent.end\" \nmd-placeholder=\"End Date\" md-date-locale=\"vm.dateLocale\" md-min-date=\"minDate\" md-max-date=\"vm.maxDate\" \nonkeydown=\"return false\"></md-datepicker></md-input-container></div><div flex><form name=\"serviceList\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>Service Selected</label><md-select class=\"search search-input\" \nrequired placeholder=\"Select a Service\" ng-model=\"vm.searchServices\" ng-model-options=\"{trackBy: \'$value.MemberSep\'}\">\n<md-option ng-value=\"opt\" ng-repeat=\"opt in vm.services\"><div class=\"md-subhead\"><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'green\'}\" ng-if=\"opt.Status==\'Active\'\"></md-icon><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'red\'}\" ng-if=\"opt.Status==\'Inactive\'\"></md-icon><md-icon \nmd-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'blue\'}\" ng-if=\"opt.Status==\'New\'\"></md-icon><md-icon \nmd-font-icon=\"icon-water\" ng-if=\"(opt.Description | uppercase)===\'WATER\'\"></md-icon><md-icon md-font-icon=\"icon-flash\" \nng-if=\"(opt.Description | uppercase)===\'ELECTRIC\'\"></md-icon><md-icon md-font-icon=\"icon-water-pump\" \nng-if=\"(opt.Description | uppercase)===\'SEWER\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(opt.Description | uppercase)===\'REFUSE\'\"></md-icon><md-icon md-font-icon=\"icon-fire\" \nng-if=\"(opt.Description | uppercase)===\'GAS\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(opt.Description | uppercase)===\'SANITATION\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(opt.Description | uppercase)===\'GARBAGE\'\"></md-icon><md-icon md-font-icon=\"icon-speedometer\" \nng-if=\"(opt.Description | uppercase)===\'OTH METERED\'\"></md-icon><md-icon md-font-icon=\"icon-bookmark-remove\" \nng-if=\"(opt.Description | uppercase)===\'NON METERED\'\"></md-icon>{{opt.MemberSep}}</div></md-option></md-select><div \nng-messages=\"serviceList.services.$error\" md-auto-hide=\"false\" multiple=\"multiple\"><div ng-message=\"required\">\nPlease select a service.</div></div></md-input-container></form></div><div><md-button class=\"md-raised md-primary\" \nng-click=\"vm.ReloadChart()\">View Usage</md-button></div></div></div></md-list-item></md-list><h2 \nstyle=\"text-align: center\" ng-if=\"vm.searchServices.MemberSep === undefined\">Please select a service.</h2><div \nclass=\"p-16 ng-scope\" ng-if=\"vm.searchServices.MemberSep !== undefined && vm.isClicked\"><nvd3 id=\"chart\" \noptions=\"vm.chart.options\" data=\"vm.chart.data\" api=\"vm.chart.api\" config=\"{refreshDataOnly: true}\"></nvd3></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/msportal/views/payment/receipt/payment_receipt.html","<md-dialog aria-label=\"GateWayForm\" flex=\"60\" ng-cloak style=\"min-height:60%!important; max-height:80% !important\" \nclass=\"modal-set-max-width\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Payment Receipt</h2><span flex></span><a \nhref=\"app/main/msportal/views/service_details/service_details.html\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><img src=\"assets/images/icons/close.png\" aria-label=\"Close dialog\" \nstyle=\"pointer-events: none\"></md-button></a></div></md-toolbar><md-dialog-content style=\"padding-top: 0px\">\n<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"vm.detail.activated\"></md-backdrop><md-progress-linear class=\"md-warn\" md-mode=\"query\" \nng-show=\"vm.detail.activated\"></md-progress-linear><div><div class=\"bar bar-header bar-positive\" align=\"center\"><h1 \nstyle=\"font-weight: bold\"><md-icon md-font-icon=\"icon-check-circle\" \nng-style=\"{color: \'green\',\'font-size\': \'60px\', height: \'20px\', width: \'60px\'}\"></md-icon></h1><h1 class=\"title\" \nstyle=\"font-weight: bold\">Payment Complete</h1></div><div class=\"card\"><div \nclass=\"item item-text-wrap custom-item-text-wrap\" align=\"center\"><p>Thank you for your payment.</p><p>\nThis page serves as your receipt and provides you with a Confirmation number.</p><p>\nPlease save this information for your records.</p><h3 style=\"font-weight: bold\">\nConfirmation Number: {{vm.detail.title}}</h3></div><div class=\"item item-text-wrap custom-item-text-wrap\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex style=\"margin-top: 20px; margin-bottom: 20px\"><table \nclass=\"dataTable row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th ng-if=\"vm.detail.isByService\" \nstyle=\"text-align:center\">Service</th><th ng-if=\"!vm.detail.isByService\" style=\"text-align:center\">Account</th><th \nstyle=\"text-align:center\">Amount</th></tr></thead><tbody style=\"text-align:center\"><tr flex=\"100\" \nng-repeat=\"account in vm.detail.AccountDetails\"><td nowrap=\"nowrap\" class=\"col col-33 col-align\">{{account.Account}}\n</td><td nowrap=\"nowrap\" class=\"col col-33 col-align\"><span>${{account.Amount | number:2}}</span></td></tr></tbody>\n</table></div><div class=\"content fullpage-datatable\" layout=\"column\" flex \nstyle=\"margin-top: 20px; margin-bottom: 20px\"><table class=\"dataTable\" dt-options=\"vm.dtOptions\" \nstyle=\"width:40%; background-color:rgb(245,245,245)\"><tbody style=\"background-color:rgb(245,245,245)\"><tr flex=\"100\" \nstyle=\"background-color:rgb(245,245,245)\"><td nowrap=\"nowrap\" class=\"col col-33 col-align\" \nstyle=\"text-align:left;padding:4px 4px;font-weight: bold\"><span>Total:</span></td><td nowrap=\"nowrap\" \nclass=\"col col-33 col-align\" style=\"text-align:left;padding:4px 4px\"><span>\n${{vm.detail.PaymentDetails.totalAmount| number:2}}</span></td></tr><tr flex=\"100\" \nstyle=\"background-color:rgb(245,245,245)\" ng-show=\"vm.detail.PaymentDetails.convenienceFee != 0\"><td nowrap=\"nowrap\" \nclass=\"col col-33 col-align\" style=\"text-align:left;padding:4px 4px;font-weight: bold\"><span>Convenience Fee:</span>\n</td><td nowrap=\"nowrap\" class=\"col col-33 col-align\" style=\"text-align:left;padding:4px 4px\"><span>\n${{vm.detail.PaymentDetails.convenienceFee| number:2}}</span></td></tr><tr flex=\"100\" \nstyle=\"background-color:rgb(245,245,245)\"><td nowrap=\"nowrap\" class=\"col col-33 col-align\" \nstyle=\"text-align:left;padding:4px 4px;font-weight: bold\"><span>Total Payment Amount:</span></td><td nowrap=\"nowrap\" \nclass=\"col col-33 col-align\" style=\"text-align:left;padding:4px 4px\"><span>\n${{vm.detail.PaymentDetails.totalPaymentAmount| number:2}}</span></td></tr></tbody></table></div></div></div></div>\n<style>\n@media screen and (min-width:800px) {\r\n                .modal-set-max-width {\r\n                    max-width: 785px !important;\r\n                }\r\n            }\n</style></md-dialog-content></md-dialog>");
$templateCache.put("app/main/msportal/views/payment/detail/payment_detail.html","<md-dialog aria-label=\"GateWayForm\" flex=\"60\" ng-cloak ng-init=\"paymentDetail.loadForm()\" \nstyle=\"min-height:60%!important; max-height:80% !important\" class=\"modal-set-max-width\"><treasure-overlay-spinner \nactive=\"paymentDetail.model.paymentDetailLoading\"><div layout=\"column\" layout-fill style=\"display:block!important\"><div\n flex-gt-sm=\"100\" flex><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{paymentDetail.title}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"paymentDetail.closeDialog()\"><img src=\"assets/images/icons/close.png\" \naria-label=\"Close dialog\" style=\"pointer-events: none\"></md-button></div></md-toolbar></div><md-dialog-content>\n<md-backdrop class=\"_md-dialog-backdrop md-opaque ng-scope md-default-theme\" style=\"position: fixed\" \naria-hidden=\"true\" ng-show=\"paymentDetail.activated\"></md-backdrop><md-progress-linear class=\"md-warn\" md-mode=\"query\" \nng-show=\"paymentDetail.activated\"></md-progress-linear><div class=\"content-card\" layout=\"column\" \nstyle=\"display:block!important\" ng-if=\"!paymentDetail.IsPPM\"><div class=\"content fullpage-datatable\" layout=\"column\" \nlayout-gt-sm=\"row\" style=\"display:block!important\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"paymentDetail.dtOptions\"><thead><tr><th>Service</th><th \nng-if=\"!paymentDetail.AccountServices.isByService && paymentDetail.PastDueOn && !paymentDetail.IsPPM && !paymentDetail.BudgetLevelized\">\n<div><div class=\"numeric\" style=\"width: {{ paymentDetail.pastDueWidth }}px\">Past Due</div></div></th><th><div><div \nclass=\"numeric\" style=\"width: {{ paymentDetail.balanceWidth }}px\">Balance</div></div></th><th \nclass=\"mdl-data-table__cell-numeric\" \nng-if=\"(!paymentDetail.AccountServices.isByService && (!paymentDetail.PastDueOn || paymentDetail.BudgetLevelized || paymentDetail.IsPPM)) || (paymentDetail.AccountServices.isByService)\">\n<div><span class=\"column-title\">Payment Amount</span></div></th></tr></thead><tbody><tr \nclass=\"demo-select-all-checkboxes\" flex=\"100\" ng-repeat=\"account in paymentDetail.AccountServices\"><td nowrap=\"nowrap\">\n<span class=\"mdl-data-table__cell-numeric\">{{ account.MemberSep }}</span></td><td nowrap=\"nowrap\" \nng-if=\"!paymentDetail.AccountServices.isByService && paymentDetail.PastDueOn && !paymentDetail.IsPPM && !paymentDetail.BudgetLevelized\">\n<div class=\"numeric\" style=\"width: {{ paymentDetail.pastDueWidth }}px\">{{ account.PastDue | currency }}</div></td><td \nnowrap=\"nowrap\"><div class=\"numeric\" style=\"width: {{ paymentDetail.balanceWidth }}px\" \nng-if=\"account.Status !== \'Active PPM\' && account.Status !== \'Inactive PPM\'\">{{ account.Balance | currency }}</div><div\n class=\"numeric\" style=\"width: {{ paymentDetail.balanceWidth }}px\" \nng-if=\"account.Status === \'Active PPM\' || account.Status === \'Inactive PPM\'\">{{ account.Balance * -1 | currency }}\n</div></td><td class=\"mdl-data-table__cell-numeric\" \nng-if=\"(!paymentDetail.AccountServices.isByService && (!paymentDetail.PastDueOn || paymentDetail.BudgetLevelized || paymentDetail.IsPPM)) || (paymentDetail.AccountServices.isByService)\">\n<div class=\"col col-33 col-align\"><input name=\"byService\" ui-number-mask min=\"0.00\" maxlength=\"14\" \nng-disabled=\"!paymentDetail.AccountServices.isByService\" ng-model=\"account.SubTotal\" \nng-blur=\"paymentDetail.reCalculateConvFee();\" ng-keydown=\"paymentDetail.validateKey($event, 0);\" \nng-focus=\"paymentDetail.model.isCalculating = true\"></div></td></tr></tbody></table></div></div><div \nstyle=\"margin-left: 10px; display:block !important\" layout=\"column\"><div \nng-if=\"!paymentDetail.AccountServices.isByService && paymentDetail.PastDueOn && !paymentDetail.IsPPM && !paymentDetail.BudgetLevelized\">\n<h4>Past Due Amount: {{paymentDetail.AccountServices.PaymentDetails.totalPastDueDisplay | currency}}</h4></div><div><h4\n \nng-if=\"(!paymentDetail.AccountServices.isByService && (!paymentDetail.PastDueOn || paymentDetail.BudgetLevelized || paymentDetail.IsPPM)) || (paymentDetail.AccountServices.isByService)\">\nTotal: <input name=\"byAccount\" ui-number-mask maxlength=\"14\" ng-disabled=\"paymentDetail.AccountServices.isByService\" \nng-model=\"paymentDetail.AccountServices.PaymentDetails.totalAmount\" ng-blur=\"paymentDetail.reCalculateConvFee();\" \nng-keydown=\"paymentDetail.validateKey($event, 1);\" ng-focus=\"paymentDetail.model.isCalculating = true\"></h4><h4 \nng-if=\"!paymentDetail.AccountServices.isByService && paymentDetail.PastDueOn && !paymentDetail.IsPPM && !paymentDetail.BudgetLevelized\">\nPayment Amount: <input name=\"byAccount\" ui-number-mask maxlength=\"14\" \nng-model=\"paymentDetail.AccountServices.PaymentDetails.totalAmount\" ng-blur=\"paymentDetail.reCalculateConvFee();\" \nng-keydown=\"paymentDetail.validateKey($event, 1);\" ng-focus=\"paymentDetail.model.isCalculating = true\"></h4></div><div \nng-show=\"!paymentDetail.IsPPM && paymentDetail.showNote\"><h4 style=\"color:red\"><strong>\nNote: \'Total\' amount does not include any credit balances. Payment amount can be edited.</strong></h4></div><div \nng-show=\"paymentDetail.AccountServices.PaymentDetails.convenienceFee != 0\"><h4>\nConvenience Fee: {{paymentDetail.AccountServices.PaymentDetails.convenienceFee | currency}}</h4></div><div><h4>\nTotal Payment Amount: {{paymentDetail.AccountServices.PaymentDetails.totalPaymentAmount | currency}}</h4></div><div \nng-include=\"\'app/main/msportal/views/payment/profile/\' + paymentDetail.profileURL\"></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" ng-class=\"{\'disabled\': paymentDetail.model.isCalculating}\"><h4 \nng-show=\"paymentDetail.model.isCalculating\">Calculating...</h4><span flex></span><md-button class=\"md-raised\" \nng-click=\"paymentDetail.closeDialog()\">Cancel</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"paymentDetail.payBill()\" layout-align=\"center\" \nng-disabled=\"!paymentDetail.isValid() || paymentDetail.isPaymentProcessing\">{{ paymentDetail.paymentLabel }}\n</md-button></md-dialog-actions></div></treasure-overlay-spinner><style>\n@media screen and (min-width:800px) {\r\n            .modal-set-max-width{\r\n                max-width: 785px !important;\r\n            }\r\n        }\n</style></md-dialog>");
$templateCache.put("app/main/msportal/views/payment/profile/creditCard.html","<div class=\"md-accordion\" ng-controller=\"PaymentProfileController as vm\" ng-init=\"vm.PopulateProfile()\"><form \nname=\"editableForm\" aa-configured-form editable-form novalidate validation-config=\"vm.CCValidators\" \nng-blur=\"data.expanded = true; paymentDetail.model.paymentDetailLoading = false; paymentDetail.model.isCalculating = false; vm.SaveProfile(\'TDC\', vm.validateErrorForm(editableForm));\" \nprevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\"><div ng-init=\"data.expanded = true\" \nlayout-gt-sm=\"row\" ng-show=\"!editableForm.$visible\" ng-click=\"data.expanded = true;\" \nclass=\"preview md-grey-700-bg layout-align-center-stretch layout-column flex-100\"><span class=\"text-boxed-light\" \nstyle=\"font-size:15px\">Credit Card Number: {{vm.CCNumberMasked || \'NO CC NUMBER\'}}</span></div><input \nname=\"hidePaymentLoading\" type=\"checkbox\" hidden \nng-blur=\"paymentDetail.model.paymentDetailLoading = false; paymentDetail.model.isCalculating = false;\"><md-card \nmd-theme=\"dark-grey\" md-theme-watch ng-class=\"{dataContent:true, activeContent:data.expanded}\" \nstyle=\"padding-left: 0px; padding-right: 0px; margin-left: 0px; margin-right: 0px; background-color:white\">\n<md-card-content><div layout-gt-sm=\"column\"><div layout-gt-sm=\"row\" layout-align-gt-sm=\"space-around center\">\n<md-input-container flex=\"100\" style=\"font-size: 1.3rem\"><input name=\"cardname\" \nng-model=\"vm.CreditCardProfile.CardName\" required maxlength=\"28\" placeholder=\"Name\" \nng-change=\"vm.SaveProfile(\'TDC\', vm.validateErrorForm(editableForm))\"><div ng-messages=\"editableForm.cardname.$error\" \nng-show=\"editableForm.cardname.$dirty\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nCredit card name is a required field</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-around center\"><md-input-container flex=\"100\" style=\"font-size: 1.3rem\"><label><span \nclass=\"no-filter drinkcard-cc {{vm.CreditCardProfile.CardType}}\"><span>Credit Card Number</span></span></label><input \nname=\"creditcard\" ng-model=\"vm.CreditCardProfile.CCNumber\" required payments-validate=\"card\" payments-format=\"card\" \npayments-type-model=\"vm.CreditCardProfile.CardType\" masked-value=\"vm.CCNumberMasked\" \npayments-type-model-valid=\"{{vm.Parameters.InternetParameters}}\" \nng-change=\"vm.SaveProfile(\'TDC\', vm.validateErrorForm(editableForm))\"><div \nng-messages=\"editableForm.creditcard.$error\" ng-show=\"editableForm.creditcard.$dirty\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"cardType\"><span>\nWe no longer accept {{vm.GetCCTypeDesc(vm.CreditCardProfile.CardType)}}. Please use one of the following cards:</span>\n<br><span class=\"no-filter drinkcard-cc visa\" ng-if=\"vm.Parameters.InternetParameters.INT_COOPPARM_1 > 0\" \nstyle=\"width:40px\">&nbsp;</span> <span class=\"no-filter drinkcard-cc mastercard\" \nng-if=\"vm.Parameters.InternetParameters.INT_COOPPARM_2 > 0\" style=\"width:40px\">&nbsp;</span> <span \nclass=\"no-filter drinkcard-cc discover\" ng-if=\"vm.Parameters.InternetParameters.INT_COOPPARM_3 > 0\" style=\"width:40px\">\n&nbsp;</span> <span class=\"no-filter drinkcard-cc amex\" ng-if=\"vm.Parameters.InternetParameters.INT_COOPPARM_4 > 0\" \nstyle=\"width:40px\">&nbsp;</span></div><div ng-message=\"card\"><span>Credit Card is not valid</span></div><div \nng-message=\"required\"><span>Credit Card is a required field!</span></div></div></md-input-container><md-input-container\n style=\"font-size: 1.3rem\"><label>Card Security Code</label><input name=\"cardsecurity\" \nng-model=\"vm.CreditCardProfile.CCVerifCode\" payments-type-model=\"vm.CreditCardProfile.CardType\" \npayments-validate=\"cvc\" ng-change=\"vm.SaveProfile(\'TDC\', vm.validateErrorForm(editableForm))\" required><div \nng-messages=\"editableForm.cardsecurity.$error\" ng-show=\"editableForm.cardsecurity.$dirty\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"cvc\"><span>Card Security Code is not valid</span></div><div ng-message=\"required\">\n<span>Card Security Code is a required field!</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-around center\"><md-input-container flex=\"100\" style=\"font-size: 1.3rem\"><label>\nExpiration Date</label><md-datepicker md-open-on-focus=\"true\" id=\"expdate\" name=\"expdate\" md-mode=\"month\" \nng-model=\"vm.CreditCardProfile.ExpirationDate\" md-current-view=\"year\" md-date-locale=\"vm.dateLocale\" \npayments-validate=\"expiry\" ng-change=\"vm.SaveProfile(\'TDC\', vm.validateErrorForm(editableForm))\" \nonkeydown=\"return false\"></md-datepicker><div ng-messages=\"editableForm.expdate.$error\" \nng-show=\"editableForm.expdate.$dirty\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"expiry\"><span>\nExpiration Date must be greater than the date today</span></div></div></md-input-container><md-input-container \nstyle=\"font-size: 1.3rem\"><label>Zip</label><div ng-model=\"vm.tempCardProfile.ZipCode\" mask=\"99999-9999\" \nng-hide=\"true\"></div><input name=\"TempZip\" ng-model=\"vm.CreditCardProfile.ZipCode\" \ndata-ng-pattern=\"/^(?!00000)\\d{5}(?:-(?!0000)\\d{4})?$/\" \nng-change=\"vm.SaveProfile(\'TDC\', vm.validateErrorForm(editableForm))\" required mask=\"99999-9999\" clean=\"false\" \nrestrict=\"reject\" limit=\"true\" validate=\"false\"><div ng-messages=\"editableForm.TempZip.$error\" \nng-show=\"editableForm.TempZip.$dirty\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nZip Code is not valid</span></div><div ng-message=\"required\"><span>Zip Code is a required field!</span></div></div>\n</md-input-container></div>\n<!--[if !IE]>    <md-input-container flex=\"100\" style=\"margin-top:0px; margin-bottom:5px;\"> <![endif]-->\n<!--[if IE]>    <md-input-container flex=\"100\" style=\"margin-top:0px; margin-bottom:5px; padding-bottom:5px;\"> <![endif]-->\n<md-checkbox ng-model=\"vm.CreditCardProfile.UpdateProfile\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nng-change=\"vm.SaveProfile(\'TDC\', vm.validateErrorForm(editableForm))\" ng-disabled=\"!hasChanges\" \nng-show=\"saveProfileEnabled\" id=\"custom-checkbox\" [attr.aria-label]=\"vm.getSaveProfileLabel()\">\n{{ vm.getSaveProfileLabel() }}</md-checkbox><div class=\"flex ie-mb-20 payment-profile-controls\" \nng-if=\"hasPaymentProfile\"><md-button class=\"md-raised md-warn delete-payment-profile\" \nng-click=\"vm.deleteProfile(\'CC\')\">Delete Credit Card Info</md-button></div></div></md-card-content></md-card></form>\n<md-card style=\"margin: 0px; margin-top: 8px; background-color:white; text-align:center\"><md-card-content><span \nstyle=\"font-size:15px;color:red\"><strong>\nPlease do not click \"Pay Now\" more than once or you may be charged multiple times.</strong></span></md-card-content>\n</md-card></div>");
$templateCache.put("app/main/msportal/views/payment/profile/eCheck.html","<div class=\"md-accordion\" ng-controller=\"PaymentProfileController as vm\" ng-init=\"vm.PopulateProfile()\"><form \nname=\"editableForm\" aa-configured-form editable-form novalidate validation-config=\"vm.ECValidators\" \nng-blur=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm)); data.expanded = true; paymentDetail.model.paymentDetailLoading = false; paymentDetail.model.isCalculating = false;\" \nprevent-leaving-unsaved on-navigate-away-strategy=\"defaultStrategy\"><!--[if !IE]>    <div> <![endif]-->\n<!--[if IE]>    <div style=\"height: 100px;\"> <![endif]--><div ng-init=\"data.expanded = true\" layout-gt-sm=\"row\" \nng-show=\"!editableForm.$visible\" ng-click=\"data.expanded = true;\" \nclass=\"preview md-grey-700-bg layout-align-center-stretch layout-column flex-100\"><div class=\"text-boxed-light\"><label \nstyle=\"font-size:15px\" text name=\"bankAccount\">Bank Account: {{vm.BankAccountNumberMasked || \'NO DATA\'}}</label></div>\n</div><!--[if !IE]>    </div> <![endif]--><!--[if IE]>    </div> <![endif]--> <input name=\"hidePaymentLoading\" \ntype=\"checkbox\" hidden \nng-blur=\"paymentDetail.model.paymentDetailLoading = false; paymentDetail.model.isCalculating = false;\"><md-card \nmd-theme=\"dark-grey\" md-theme-watch ng-class=\"{dataContent:true, activeContent:data.expanded}\" \nstyle=\"padding-left: 0px; padding-right: 0px; margin-left: 0px; margin-right: 0px; background-color:white\">\n<md-card-content><div layout-gt-sm=\"column\"><md-input-container style=\"font-size: 1.6rem\"><label><font color=\"#555555\">\nName on Bank Account</font></label><input name=\"acctName\" ng-model=\"vm.ECheckProfile.AccountName\" ng-disabled=\"true\">\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align-gt-sm=\"space-around center\"><md-input-container \nstyle=\"font-size: 1.3rem\" class=\"md-block\" flex-gt-sm=\"\" flex=\"100\"><label>First Name</label><input name=\"firstName\" \nng-model=\"vm.ECheckProfile.FirstName\" maxlength=\"28\" \nng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm)); vm.UpdateBankAccountName()\"><div \nng-messages=\"editableForm.firstName.$error\" role=\"alert\" multiple=\"multiple\"></div></md-input-container>\n<md-input-container style=\"font-size: 1.3rem\" class=\"md-block\" flex-gt-sm=\"\" flex=\"100\"><label>Middle Name</label>\n<input name=\"middleName\" ng-model=\"vm.ECheckProfile.MiddleName\" maxlength=\"28\" \nng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm)); vm.UpdateBankAccountName()\"><div \nng-messages=\"editableForm.middleName.$error\" role=\"alert\" multiple=\"multiple\"></div></md-input-container>\n<md-input-container style=\"font-size: 1.3rem\" class=\"md-block\" flex-gt-sm=\"\" flex=\"100\"><label>Last Name</label><input \nname=\"lastName\" ng-model=\"vm.ECheckProfile.LastName\" required maxlength=\"28\" \nng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm)); vm.UpdateBankAccountName()\"><div \nng-messages=\"editableForm.lastName.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter your last name.</span></div></div></md-input-container><md-input-container \nstyle=\"font-size: 1.3rem;margin-bottom:42px\" class=\"md-block\" flex-gt-sm=\"\" flex=\"100\"><label>Suffix</label><md-select \nng-model=\"vm.ECheckProfile.Suffix\" \nng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm)); vm.UpdateBankAccountName()\"><md-option \nng-repeat=\"s in vm.ECheckProfile.NameSuffixes\" value=\"{{s.Id}}\">{{s.Name}}</md-option></md-select></md-input-container>\n</div><div layout-gt-sm=\"column\"><md-input-container style=\"font-size: 1.3rem\" \nng-class=\"{\'pr-2\' : !vm.isAdmin || !hasPaymentProfile}\"><label>Bank Routing Number</label><input name=\"routing\" \nid=\"routing\" ng-pattern=\"vm.RoutingNumberPattern\" ng-model=\"vm.ECheckProfile.RoutingNumber\" \nmasked-value=\"vm.RoutingNumberMasked\" required maxlength=\"9\" \nng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm))\" ng-disabled=\"vm.isAdmin && hasPaymentProfile\" \nng-blur=\"vm.blurInput(\'routing\')\"><md-icon class=\"icon icon-pencil fs-24\" ng-click=\"vm.editInput(\'routing\')\" \nng-if=\"vm.isAdmin && hasPaymentProfile\"></md-icon><div ng-messages=\"editableForm.routing.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Please select a Bank Routing Number.</span></div><div \nng-message=\"pattern\"><span>Invalid Format.</span></div></div></md-input-container><md-input-container \nstyle=\"font-size: 1.3rem\" ng-class=\"{\'pr-2\' : !vm.isAdmin || !hasPaymentProfile}\"><label>Bank Account Number</label>\n<input name=\"bankAccount\" id=\"bankAccount\" ng-model=\"vm.ECheckProfile.BankAccountNumber\" \nmasked-value=\"vm.BankAccountNumberMasked\" required maxlength=\"17\" \nng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm))\" ng-disabled=\"vm.isAdmin && hasPaymentProfile\" \nautocomplete=\"off\" ng-blur=\"vm.blurInput(\'bankAccount\')\"><md-icon class=\"icon icon-pencil fs-24\" \nng-click=\"vm.editInput(\'bankAccount\')\" ng-if=\"vm.isAdmin && hasPaymentProfile\"></md-icon><div \nng-messages=\"editableForm.bankAccount.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease Select a Bank Account Number</span></div></div></md-input-container><md-input-container \nstyle=\"font-size: 1.3rem\"><label>Confirm Bank Account Number</label><input name=\"confirmBankAccount\" \nng-model=\"vm.ECheckProfile.ConfirmBankAccountNumber\" masked-value=\"vm.ConfirmBankAccountNumberMasked\" required \nmatch-field=\"vm.ECheckProfile.BankAccountNumber\" autocomplete=\"off\" \nmatch-value=\"{{vm.ECheckProfile.BankAccountNumber}}\" maxlength=\"17\" \nng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm))\"><div \nng-messages=\"editableForm.confirmBankAccount.$error\" role=\"alert\"><div ng-message=\"match\"><span>\nBank Account Number does not match</span></div></div></md-input-container><div id=\"echeck-account-type-section\"><label>\nAccount Type</label><md-input-container style=\"font-size: 1.3rem\"><md-radio-group name=\"accountType\" \nng-model=\"vm.ECheckProfile.AccountType\" ng-required=\"true\" \nng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm))\"><md-radio-button class=\"md-block\" flex-gt-sm \nng-value=\'\"S\"\' ng-required>Savings</md-radio-button><md-radio-button class=\"md-block\" flex-gt-sm ng-value=\'\"C\"\' \nng-required>Checking</md-radio-button></md-radio-group><div ng-messages=\"editableForm.accountType.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Please select an Account Type</span></div></div>\n</md-input-container></div>\n<!--[if !IE]>    <md-input-container flex=\"100\" style=\"margin-top:0px; margin-bottom:5px;\"> <![endif]-->\n<!--[if IE]>    <md-input-container flex=\"100\" style=\"margin-top:0px; margin-bottom:5px; padding-bottom:5px;\"> <![endif]-->\n<md-checkbox ng-model=\"vm.ECheckProfile.UpdateProfile\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nng-change=\"vm.SaveProfile(\'ECard\', vm.validateErrorForm(editableForm))\" ng-show=\"saveProfileEnabled\" \nid=\"custom-checkbox\" [attr.aria-label]=\"vm.getSaveProfileLabel()\">{{ vm.getSaveProfileLabel() }}</md-checkbox></div>\n<div class=\"flex payment-profile-controls\" ng-if=\"hasPaymentProfile\"><md-button \nclass=\"md-raised md-warn delete-payment-profile\" ng-click=\"vm.deleteProfile(\'EC\')\">Delete ECheck Info</md-button></div>\n</md-card-content></md-card><md-card ng-show=\"vm.ECheckProfile.isValid\" \nstyle=\"margin: 0px; margin-top: 8px; background-color:white; text-align:center\"><md-card-content><p><b>\nDebit Authorization Agreement</b></p><h4>I, <b>{{vm.ECheckProfile.AccountName}}</b>\n, authorize SEDC to process this single electronic ACH transaction to debit my bank account number <b>\n{{vm.BankAccountNumberMasked}}</b> and routing number <b>{{vm.RoutingNumberMasked}}</b> in the amount of <b>\n{{paymentDetail.AccountServices.PaymentDetails.totalPaymentAmount | currency}}</b>, payable to SEDC</h4>\n</md-card-content></md-card></form><md-card \nstyle=\"margin: 0px; margin-top: 8px; background-color:white; text-align:center\"><md-card-content><span \nstyle=\"font-size:15px;color:red\"><strong>\nPlease do not click \"Pay Now\" more than once or you may be charged multiple times.</strong></span></md-card-content>\n</md-card></div>");
$templateCache.put("app/main/msportal/views/usage_charts/monthly/usagemonthly.html","<div ng-controller=\"UsagechartmonthlyController as vm\" ng-init=\"vm.getServiceDetails()\"><div ng-cloak \nlayout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex><md-progress-linear class=\"md-warn\" md-mode=\"query\" \nng-show=\"vm.flipped && vm.progress.activated\"></md-progress-linear><md-content><md-list flex><md-list-item \nclass=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><div layout=\"row\" layout-xs=\"column\" align=\"left\">\n<div><md-input-container class=\"md-block\" flex-gt-sm><label>Start Date</label><md-datepicker \nng-model=\"vm.calendarEvent.start\" md-date-locale=\"vm.dateLocale\" md-placeholder=\"Start Date\" md-mode=\"month\" \nmd-current-view=\"year\" md-min-date=\"minDate\" md-max-date=\"vm.maxDate\" onkeydown=\"return false\"></md-datepicker>\n</md-input-container></div><div><md-input-container class=\"md-block\" flex-gt-sm><label>End Date</label><md-datepicker \nng-model=\"vm.calendarEvent.end\" md-date-locale=\"vm.dateLocale\" md-placeholder=\"End Date\" md-mode=\"month\" \nmd-current-view=\"year\" md-min-date=\"minDate\" md-max-date=\"vm.maxDate\" onkeydown=\"return false\"></md-datepicker>\n</md-input-container></div><div flex><form name=\"serviceList\"><md-input-container class=\"md-block\" flex-gt-sm><label>\nService Selected</label><md-select class=\"search search-input\" required placeholder=\"Select a Service\" \nng-model=\"vm.searchServices\" ng-model-options=\"{trackBy: \'$value.MemberSep\'}\"><md-option ng-value=\"opt\" \nng-repeat=\"opt in vm.services\"><div class=\"md-subhead\"><md-icon md-font-icon=\"icon-brightness-1 s16\" \nng-style=\"{color: \'green\'}\" ng-if=\"opt.Status==\'Active\'\"></md-icon><md-icon md-font-icon=\"icon-brightness-1 s16\" \nng-style=\"{color: \'red\'}\" ng-if=\"opt.Status==\'Inactive\'\"></md-icon><md-icon md-font-icon=\"icon-brightness-1 s16\" \nng-style=\"{color: \'blue\'}\" ng-if=\"opt.Status==\'New\'\"></md-icon><md-icon md-font-icon=\"icon-water\" \nng-if=\"(opt.Description | uppercase)===\'WATER\'\"></md-icon><md-icon md-font-icon=\"icon-flash\" \nng-if=\"(opt.Description | uppercase)===\'ELECTRIC\'\"></md-icon><md-icon md-font-icon=\"icon-water-pump\" \nng-if=\"(opt.Description | uppercase)===\'SEWER\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(opt.Description | uppercase)===\'REFUSE\'\"></md-icon><md-icon md-font-icon=\"icon-fire\" \nng-if=\"(opt.Description | uppercase)===\'GAS\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(opt.Description | uppercase)===\'SANITATION\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(opt.Description | uppercase)===\'GARBAGE\'\"></md-icon><md-icon md-font-icon=\"icon-speedometer\" \nng-if=\"(opt.Description | uppercase)===\'OTH METERED\'\"></md-icon><md-icon md-font-icon=\"icon-bookmark-remove\" \nng-if=\"(opt.Description | uppercase)===\'NON METERED\'\"></md-icon>{{opt.MemberSep}}</div></md-option></md-select><div \nng-messages=\"serviceList.services.$error\" md-auto-hide=\"false\" multiple=\"multiple\"><div ng-message=\"required\">\nPlease select a service.</div></div></md-input-container></form></div><div><md-button class=\"md-raised md-primary\" \nng-click=\"vm.ReloadChart()\">View Usage</md-button></div></div></div></md-list-item></md-list><h2 \nstyle=\"text-align: center\" ng-if=\"vm.searchServices.MemberSep === undefined\">Please select a service.</h2><div \nclass=\"p-16 ng-scope\" ng-if=\"vm.searchServices.MemberSep !== undefined && vm.isClicked\"><nvd3 id=\"chart\" \noptions=\"vm.chart.options\" data=\"vm.chart.data\" api=\"vm.chart.api\" config=\"{refreshDataOnly: true}\"></nvd3></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/msportal/views/usage_charts/interval/usageinterval.html","<div ng-controller=\"UsagechartintervalController as vm\" ng-init=\"vm.getServiceDetails()\"><div ng-cloak \nlayout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"100\" flex><md-progress-linear class=\"md-warn\" md-mode=\"query\" \nng-show=\"vm.flipped && vm.progress.activated\"></md-progress-linear><md-content><md-list flex><md-list-item \nclass=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><div layout=\"row\" layout-xs=\"column\" align=\"left\">\n<div><md-input-container class=\"md-block\" flex-gt-sm><label>Usage Date</label><md-datepicker \nng-model=\"vm.calendarEvent.start\" md-date-locale=\"vm.dateLocale\" md-placeholder=\"Usage Date\" md-min-date=\"minDate\" \nmd-max-date=\"vm.maxDate\" onkeydown=\"return false\"></md-datepicker></md-input-container></div><div flex><form \nname=\"serviceList\"><md-input-container class=\"md-block\" flex-gt-sm><label>Service Selected</label><md-select \nclass=\"search search-input\" required placeholder=\"Select a Service\" ng-model=\"vm.searchServices\" \nng-model-options=\"{trackBy: \'$value.MemberSep\'}\"><md-option ng-value=\"opt\" ng-repeat=\"opt in vm.services\"><div \nclass=\"md-subhead\"><md-icon md-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'green\'}\" \nng-if=\"opt.Status==\'Active\'\"></md-icon><md-icon md-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'red\'}\" \nng-if=\"opt.Status==\'Inactive\'\"></md-icon><md-icon md-font-icon=\"icon-brightness-1 s16\" ng-style=\"{color: \'blue\'}\" \nng-if=\"opt.Status==\'New\'\"></md-icon><md-icon md-font-icon=\"icon-water\" ng-if=\"(opt.Description | uppercase)===\'WATER\'\">\n</md-icon><md-icon md-font-icon=\"icon-flash\" ng-if=\"(opt.Description | uppercase)===\'ELECTRIC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-water-pump\" ng-if=\"(opt.Description | uppercase)===\'SEWER\'\"></md-icon><md-icon \nmd-font-icon=\"icon-delete\" ng-if=\"(opt.Description | uppercase)===\'REFUSE\'\"></md-icon><md-icon \nmd-font-icon=\"icon-fire\" ng-if=\"(opt.Description | uppercase)===\'GAS\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(opt.Description | uppercase)===\'SANITATION\'\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nng-if=\"(opt.Description | uppercase)===\'GARBAGE\'\"></md-icon><md-icon md-font-icon=\"icon-speedometer\" \nng-if=\"(opt.Description | uppercase)===\'OTH METERED\'\"></md-icon><md-icon md-font-icon=\"icon-bookmark-remove\" \nng-if=\"(opt.Description | uppercase)===\'NON METERED\'\"></md-icon>{{opt.MemberSep}}</div></md-option></md-select><div \nng-messages=\"serviceList.services.$error\" md-auto-hide=\"false\" multiple=\"multiple\"><div ng-message=\"required\">\nPlease select a service.</div></div></md-input-container></form></div><div><md-button class=\"md-raised md-primary\" \nng-click=\"vm.ReloadChart()\">View Usage</md-button></div></div></div></md-list-item></md-list><h2 \nstyle=\"text-align: center\" ng-if=\"vm.searchServices.MemberSep === undefined\">Please select a service.</h2><div \nclass=\"p-16 ng-scope\" ng-if=\"vm.searchServices.MemberSep !== undefined && vm.isClicked\"><nvd3 id=\"chart\" \noptions=\"vm.chart.options\" data=\"vm.chart.data\" api=\"vm.chart.api\" config=\"{refreshDataOnly: true}\"></nvd3></div>\n</md-content></div></div></div>");}]);